//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

// @ts-nocheck

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAccountApiClient {
    listV2(request: GetAccountListV2Request): Promise<GetListResponseOfAccountListResponse>;
    get(accountId: number): Promise<AccountDetailResponse>;
}

export class AccountApiClient implements IAccountApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetAccountListV2Request, cancelToken?: CancelToken): Promise<GetListResponseOfAccountListResponse> {
        let url_ = this.baseUrl + "/Account/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfAccountListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAccountListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAccountListResponse>(null as any);
    }

    get(accountId: number, cancelToken?: CancelToken): Promise<AccountDetailResponse> {
        let url_ = this.baseUrl + "/Account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AccountDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AccountDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDetailResponse>(null as any);
    }
}

export interface IActionApiClient {
    get(id: number): Promise<TaskBlendedResponse>;
}

export class ActionApiClient implements IActionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: number, cancelToken?: CancelToken): Promise<TaskBlendedResponse> {
        let url_ = this.baseUrl + "/action/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TaskBlendedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskBlendedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskBlendedResponse>(null as any);
    }
}

export interface IAdminApiClient {
    throwException(): Promise<FileResponse | null>;
    throwValidationErrorException(): Promise<FileResponse | null>;
    offlineEcho(model: OfflineEchoRequest): Promise<OfflineEchoResponse>;
}

export class AdminApiClient implements IAdminApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    throwException( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Admin/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThrowException(_response);
        });
    }

    protected processThrowException(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    throwValidationErrorException( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Admin/exception/validation-errors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThrowValidationErrorException(_response);
        });
    }

    protected processThrowValidationErrorException(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    offlineEcho(model: OfflineEchoRequest, cancelToken?: CancelToken): Promise<OfflineEchoResponse> {
        let url_ = this.baseUrl + "/Admin/offline-echo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOfflineEcho(_response);
        });
    }

    protected processOfflineEcho(response: AxiosResponse): Promise<OfflineEchoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OfflineEchoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfflineEchoResponse>(null as any);
    }
}

export interface IAssetApiClient {
    list(request: GetAssetListRequest): Promise<GetListResponseOfAssetSimpleResponse>;
    listV2(request: GetAssetListRequestV2): Promise<GetListResponseOfAssetSimpleResponse>;
    listSelectOptions(request: GetAssetListRequest): Promise<GetListResponseOfSelectOption>;
    tree(request: GetAssetTreeRequest): Promise<TreeResponse[]>;
    getRelatedFormsListV2(request: GetAssetRelatedFormsListRequestV2): Promise<GetListResponseOfAssetRelatedFormSimpleResponse>;
    get(id: number): Promise<AssetResponse>;
    getAssetPath(id: number): Promise<AssetPathResponse>;
    update(model: AssetRequest): Promise<AssetResponse>;
    create(model: AssetRequest): Promise<AssetResponse>;
    getImportTemplate(): Promise<FileResponse | null>;
    export(parentAssetId: number): Promise<FileResponse | null>;
    import(request: AssetImportRequest): Promise<string>;
    move(model: AssetMoveRequest): Promise<AssetResponse>;
}

export class AssetApiClient implements IAssetApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetAssetListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfAssetSimpleResponse> {
        let url_ = this.baseUrl + "/Asset/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfAssetSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAssetSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAssetSimpleResponse>(null as any);
    }

    listV2(request: GetAssetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfAssetSimpleResponse> {
        let url_ = this.baseUrl + "/Asset/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfAssetSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAssetSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAssetSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetAssetListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/Asset/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    tree(request: GetAssetTreeRequest, cancelToken?: CancelToken): Promise<TreeResponse[]> {
        let url_ = this.baseUrl + "/Asset/list/tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<TreeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TreeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeResponse[]>(null as any);
    }

    getRelatedFormsListV2(request: GetAssetRelatedFormsListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfAssetRelatedFormSimpleResponse> {
        let url_ = this.baseUrl + "/Asset/list/related-forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRelatedFormsListV2(_response);
        });
    }

    protected processGetRelatedFormsListV2(response: AxiosResponse): Promise<GetListResponseOfAssetRelatedFormSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAssetRelatedFormSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAssetRelatedFormSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AssetResponse> {
        let url_ = this.baseUrl + "/Asset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AssetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetResponse>(null as any);
    }

    getAssetPath(id: number, cancelToken?: CancelToken): Promise<AssetPathResponse> {
        let url_ = this.baseUrl + "/Asset/{id}/path";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetPath(_response);
        });
    }

    protected processGetAssetPath(response: AxiosResponse): Promise<AssetPathResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssetPathResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetPathResponse>(null as any);
    }

    update(model: AssetRequest, cancelToken?: CancelToken): Promise<AssetResponse> {
        let url_ = this.baseUrl + "/Asset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AssetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetResponse>(null as any);
    }

    create(model: AssetRequest, cancelToken?: CancelToken): Promise<AssetResponse> {
        let url_ = this.baseUrl + "/Asset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AssetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetResponse>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Asset/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    export(parentAssetId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Asset/export/{parentAssetId}";
        if (parentAssetId === undefined || parentAssetId === null)
            throw new Error("The parameter 'parentAssetId' must be defined.");
        url_ = url_.replace("{parentAssetId}", encodeURIComponent("" + parentAssetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(request: AssetImportRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Asset/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    move(model: AssetMoveRequest, cancelToken?: CancelToken): Promise<AssetResponse> {
        let url_ = this.baseUrl + "/Asset/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<AssetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetResponse>(null as any);
    }
}

export interface IAssistantControlCenterApiClient {
    overview(): Promise<AssistantUsageOverviewResponse>;
    usageSeries(days: number | undefined): Promise<AssistantUsageSeriesRowResponse[]>;
    users(days: number | undefined): Promise<AssistantUserUsageResponse[]>;
    toolStats(days: number | undefined, userId: number | null | undefined): Promise<AssistantToolStatsResponse>;
    userMemory(userId: number): Promise<AssistantMemoryResponse[]>;
    deleteUserMemory(userId: number, id: number): Promise<FileResponse | null>;
    listConversations(request: AssistantConversationListRequest): Promise<GetListResponseOfAssistantConversationSummaryResponse>;
    transcript(id: number): Promise<AssistantConversationTranscriptResponse>;
    listFeedback(request: AssistantFeedbackListRequest): Promise<AssistantFeedbackListResponse>;
    exportFeedback(request: AssistantFeedbackFilterRequest): Promise<FileResponse | null>;
}

export class AssistantControlCenterApiClient implements IAssistantControlCenterApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    overview( cancelToken?: CancelToken): Promise<AssistantUsageOverviewResponse> {
        let url_ = this.baseUrl + "/assistant/control-center/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverview(_response);
        });
    }

    protected processOverview(response: AxiosResponse): Promise<AssistantUsageOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUsageOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUsageOverviewResponse>(null as any);
    }

    usageSeries(days: number | undefined, cancelToken?: CancelToken): Promise<AssistantUsageSeriesRowResponse[]> {
        let url_ = this.baseUrl + "/assistant/control-center/usage-series?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsageSeries(_response);
        });
    }

    protected processUsageSeries(response: AxiosResponse): Promise<AssistantUsageSeriesRowResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUsageSeriesRowResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUsageSeriesRowResponse[]>(null as any);
    }

    users(days: number | undefined, cancelToken?: CancelToken): Promise<AssistantUserUsageResponse[]> {
        let url_ = this.baseUrl + "/assistant/control-center/users?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: AxiosResponse): Promise<AssistantUserUsageResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUserUsageResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUserUsageResponse[]>(null as any);
    }

    toolStats(days: number | undefined, userId: number | null | undefined, cancelToken?: CancelToken): Promise<AssistantToolStatsResponse> {
        let url_ = this.baseUrl + "/assistant/control-center/tool-stats?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToolStats(_response);
        });
    }

    protected processToolStats(response: AxiosResponse): Promise<AssistantToolStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantToolStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantToolStatsResponse>(null as any);
    }

    userMemory(userId: number, cancelToken?: CancelToken): Promise<AssistantMemoryResponse[]> {
        let url_ = this.baseUrl + "/assistant/control-center/users/{userId}/memory";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserMemory(_response);
        });
    }

    protected processUserMemory(response: AxiosResponse): Promise<AssistantMemoryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMemoryResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMemoryResponse[]>(null as any);
    }

    deleteUserMemory(userId: number, id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/control-center/users/{userId}/memory/{id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserMemory(_response);
        });
    }

    protected processDeleteUserMemory(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listConversations(request: AssistantConversationListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfAssistantConversationSummaryResponse> {
        let url_ = this.baseUrl + "/assistant/control-center/conversations/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListConversations(_response);
        });
    }

    protected processListConversations(response: AxiosResponse): Promise<GetListResponseOfAssistantConversationSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAssistantConversationSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAssistantConversationSummaryResponse>(null as any);
    }

    transcript(id: number, cancelToken?: CancelToken): Promise<AssistantConversationTranscriptResponse> {
        let url_ = this.baseUrl + "/assistant/control-center/conversations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscript(_response);
        });
    }

    protected processTranscript(response: AxiosResponse): Promise<AssistantConversationTranscriptResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantConversationTranscriptResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantConversationTranscriptResponse>(null as any);
    }

    listFeedback(request: AssistantFeedbackListRequest, cancelToken?: CancelToken): Promise<AssistantFeedbackListResponse> {
        let url_ = this.baseUrl + "/assistant/control-center/feedback/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFeedback(_response);
        });
    }

    protected processListFeedback(response: AxiosResponse): Promise<AssistantFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantFeedbackListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantFeedbackListResponse>(null as any);
    }

    exportFeedback(request: AssistantFeedbackFilterRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/control-center/feedback/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportFeedback(_response);
        });
    }

    protected processExportFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IAssistantApiClient {
    getUsage(): Promise<AssistantUsageResponse>;
    createConversation(request: CreateConversationRequest): Promise<ConversationResponse>;
    listConversations(): Promise<ConversationResponse[]>;
    getMessages(id: number): Promise<MessageResponse[]>;
    postMessage(id: number, request: PostMessageRequest): Promise<void>;
    exportQueryCsv(conversationId: number, toolUseId: string): Promise<FileResponse | null>;
    deleteConversation(id: number): Promise<FileResponse | null>;
    setMessageFeedback(id: number, request: SetMessageFeedbackRequest): Promise<AssistantMessageFeedbackResponse>;
    deleteMessageFeedback(id: number): Promise<FileResponse | null>;
    getMemory(): Promise<AssistantMemoryListResponse>;
    createMemory(request: SaveAssistantMemoryRequest): Promise<AssistantMemoryResponse>;
    deleteAllMemory(): Promise<FileResponse | null>;
    setMemoryEnabled(request: SetAssistantMemoryEnabledRequest): Promise<FileResponse | null>;
    updateMemory(id: number, request: SaveAssistantMemoryRequest): Promise<AssistantMemoryResponse>;
    deleteMemory(id: number): Promise<FileResponse | null>;
    acceptMemory(id: number): Promise<AssistantMemoryResponse>;
}

export class AssistantApiClient implements IAssistantApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUsage( cancelToken?: CancelToken): Promise<AssistantUsageResponse> {
        let url_ = this.baseUrl + "/assistant/usage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsage(_response);
        });
    }

    protected processGetUsage(response: AxiosResponse): Promise<AssistantUsageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUsageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUsageResponse>(null as any);
    }

    createConversation(request: CreateConversationRequest, cancelToken?: CancelToken): Promise<ConversationResponse> {
        let url_ = this.baseUrl + "/assistant/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConversation(_response);
        });
    }

    protected processCreateConversation(response: AxiosResponse): Promise<ConversationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConversationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationResponse>(null as any);
    }

    listConversations( cancelToken?: CancelToken): Promise<ConversationResponse[]> {
        let url_ = this.baseUrl + "/assistant/conversations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListConversations(_response);
        });
    }

    protected processListConversations(response: AxiosResponse): Promise<ConversationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConversationResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationResponse[]>(null as any);
    }

    getMessages(id: number, cancelToken?: CancelToken): Promise<MessageResponse[]> {
        let url_ = this.baseUrl + "/assistant/conversations/{id}/messages";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: AxiosResponse): Promise<MessageResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MessageResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageResponse[]>(null as any);
    }

    postMessage(id: number, request: PostMessageRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/assistant/conversations/{id}/messages";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostMessage(_response);
        });
    }

    protected processPostMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportQueryCsv(conversationId: number, toolUseId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/conversations/{conversationId}/queries/{toolUseId}/csv";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        if (toolUseId === undefined || toolUseId === null)
            throw new Error("The parameter 'toolUseId' must be defined.");
        url_ = url_.replace("{toolUseId}", encodeURIComponent("" + toolUseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportQueryCsv(_response);
        });
    }

    protected processExportQueryCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteConversation(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/conversations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConversation(_response);
        });
    }

    protected processDeleteConversation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setMessageFeedback(id: number, request: SetMessageFeedbackRequest, cancelToken?: CancelToken): Promise<AssistantMessageFeedbackResponse> {
        let url_ = this.baseUrl + "/assistant/messages/{id}/feedback";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMessageFeedback(_response);
        });
    }

    protected processSetMessageFeedback(response: AxiosResponse): Promise<AssistantMessageFeedbackResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMessageFeedbackResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMessageFeedbackResponse>(null as any);
    }

    deleteMessageFeedback(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/messages/{id}/feedback";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMessageFeedback(_response);
        });
    }

    protected processDeleteMessageFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getMemory( cancelToken?: CancelToken): Promise<AssistantMemoryListResponse> {
        let url_ = this.baseUrl + "/assistant/memory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemory(_response);
        });
    }

    protected processGetMemory(response: AxiosResponse): Promise<AssistantMemoryListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMemoryListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMemoryListResponse>(null as any);
    }

    createMemory(request: SaveAssistantMemoryRequest, cancelToken?: CancelToken): Promise<AssistantMemoryResponse> {
        let url_ = this.baseUrl + "/assistant/memory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemory(_response);
        });
    }

    protected processCreateMemory(response: AxiosResponse): Promise<AssistantMemoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMemoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMemoryResponse>(null as any);
    }

    deleteAllMemory( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/memory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllMemory(_response);
        });
    }

    protected processDeleteAllMemory(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setMemoryEnabled(request: SetAssistantMemoryEnabledRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/memory/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMemoryEnabled(_response);
        });
    }

    protected processSetMemoryEnabled(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateMemory(id: number, request: SaveAssistantMemoryRequest, cancelToken?: CancelToken): Promise<AssistantMemoryResponse> {
        let url_ = this.baseUrl + "/assistant/memory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemory(_response);
        });
    }

    protected processUpdateMemory(response: AxiosResponse): Promise<AssistantMemoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMemoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMemoryResponse>(null as any);
    }

    deleteMemory(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/assistant/memory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemory(_response);
        });
    }

    protected processDeleteMemory(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    acceptMemory(id: number, cancelToken?: CancelToken): Promise<AssistantMemoryResponse> {
        let url_ = this.baseUrl + "/assistant/memory/{id}/accept";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptMemory(_response);
        });
    }

    protected processAcceptMemory(response: AxiosResponse): Promise<AssistantMemoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantMemoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantMemoryResponse>(null as any);
    }
}

export interface IAttachmentClassificationApiClient {
    create(model: AttachmentClassificationRequest): Promise<AttachmentClassificationResponse>;
    update(model: AttachmentClassificationRequest): Promise<AttachmentClassificationResponse>;
    list(request: GetAttachmentClassificationListRequest): Promise<GetListResponseOfAttachmentClassificationResponse>;
    get(id: number): Promise<AttachmentClassificationResponse>;
    delete(id: number): Promise<FileResponse | null>;
}

export class AttachmentClassificationApiClient implements IAttachmentClassificationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: AttachmentClassificationRequest, cancelToken?: CancelToken): Promise<AttachmentClassificationResponse> {
        let url_ = this.baseUrl + "/attachment-classification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AttachmentClassificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentClassificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentClassificationResponse>(null as any);
    }

    update(model: AttachmentClassificationRequest, cancelToken?: CancelToken): Promise<AttachmentClassificationResponse> {
        let url_ = this.baseUrl + "/attachment-classification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AttachmentClassificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentClassificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentClassificationResponse>(null as any);
    }

    list(request: GetAttachmentClassificationListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfAttachmentClassificationResponse> {
        let url_ = this.baseUrl + "/attachment-classification/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfAttachmentClassificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAttachmentClassificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAttachmentClassificationResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AttachmentClassificationResponse> {
        let url_ = this.baseUrl + "/attachment-classification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AttachmentClassificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentClassificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentClassificationResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/attachment-classification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IAttachmentApiClient {
    list(request: GetAttachmentListRequest): Promise<GetListResponseOfAttachmentSimpleResponse>;
    get(id: number, entityId: number): Promise<AttachmentResponse>;
    delete(id: number, entityId: number): Promise<FileResponse | null>;
    create(model: AttachmentRequest): Promise<boolean>;
    update(model: AttachmentRequest): Promise<boolean>;
    listForUser(request: GetUserRelatedAttachmentsRequest): Promise<GetListResponseOfUserRelatedAttachmentResponse>;
}

export class AttachmentApiClient implements IAttachmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetAttachmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfAttachmentSimpleResponse> {
        let url_ = this.baseUrl + "/Attachment/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfAttachmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAttachmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAttachmentSimpleResponse>(null as any);
    }

    get(id: number, entityId: number, cancelToken?: CancelToken): Promise<AttachmentResponse> {
        let url_ = this.baseUrl + "/Attachment/{id}/{entityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AttachmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentResponse>(null as any);
    }

    delete(id: number, entityId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Attachment/{id}/{entityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(model: AttachmentRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(model: AttachmentRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    listForUser(request: GetUserRelatedAttachmentsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfUserRelatedAttachmentResponse> {
        let url_ = this.baseUrl + "/Attachment/list-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForUser(_response);
        });
    }

    protected processListForUser(response: AxiosResponse): Promise<GetListResponseOfUserRelatedAttachmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserRelatedAttachmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserRelatedAttachmentResponse>(null as any);
    }
}

export interface IAuditLogApiClient {
    listV2(request: GetAuditLogListRequestV2): Promise<GetListResponseOfAuditLogSimpleResponse>;
    get(id: number): Promise<AuditLogResponse>;
    listEntityNameSelectOptions(): Promise<GetListResponseOfSelectOption>;
    listEntityFieldSelectOptions(entityName: string | undefined): Promise<GetListResponseOfSelectOption>;
}

export class AuditLogApiClient implements IAuditLogApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetAuditLogListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfAuditLogSimpleResponse> {
        let url_ = this.baseUrl + "/audit-log/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfAuditLogSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAuditLogSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAuditLogSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AuditLogResponse> {
        let url_ = this.baseUrl + "/audit-log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AuditLogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuditLogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditLogResponse>(null as any);
    }

    listEntityNameSelectOptions( cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/audit-log/list/entity-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEntityNameSelectOptions(_response);
        });
    }

    protected processListEntityNameSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    listEntityFieldSelectOptions(entityName: string | undefined, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/audit-log/list/entity-fields?";
        if (entityName === null)
            throw new Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEntityFieldSelectOptions(_response);
        });
    }

    protected processListEntityFieldSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }
}

export interface IBadgeTemplateApiClient {
    list(request: GetBadgeTemplateListRequest): Promise<GetListResponseOfBadgeTemplateSimpleResponse>;
    get(id: number, instanceId: number | undefined): Promise<BadgeTemplateResponse>;
    delete(id: number, instanceId: number | undefined): Promise<FileResponse | null>;
    getVersionHistory(id: number, instanceId: number | undefined): Promise<BadgeTemplateSimpleResponse[]>;
    create(model: BadgeTemplateRequest): Promise<BadgeTemplateResponse>;
    update(model: BadgeTemplateRequest): Promise<BadgeTemplateResponse>;
    preview(request: BadgeTemplatePreviewRequest): Promise<BadgeTemplatePreviewResponse>;
}

export class BadgeTemplateApiClient implements IBadgeTemplateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetBadgeTemplateListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfBadgeTemplateSimpleResponse> {
        let url_ = this.baseUrl + "/BadgeTemplate/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfBadgeTemplateSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfBadgeTemplateSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfBadgeTemplateSimpleResponse>(null as any);
    }

    get(id: number, instanceId: number | undefined, cancelToken?: CancelToken): Promise<BadgeTemplateResponse> {
        let url_ = this.baseUrl + "/BadgeTemplate/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BadgeTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BadgeTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeTemplateResponse>(null as any);
    }

    delete(id: number, instanceId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/BadgeTemplate/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getVersionHistory(id: number, instanceId: number | undefined, cancelToken?: CancelToken): Promise<BadgeTemplateSimpleResponse[]> {
        let url_ = this.baseUrl + "/BadgeTemplate/{id}/versions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersionHistory(_response);
        });
    }

    protected processGetVersionHistory(response: AxiosResponse): Promise<BadgeTemplateSimpleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BadgeTemplateSimpleResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeTemplateSimpleResponse[]>(null as any);
    }

    create(model: BadgeTemplateRequest, cancelToken?: CancelToken): Promise<BadgeTemplateResponse> {
        let url_ = this.baseUrl + "/BadgeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<BadgeTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BadgeTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeTemplateResponse>(null as any);
    }

    update(model: BadgeTemplateRequest, cancelToken?: CancelToken): Promise<BadgeTemplateResponse> {
        let url_ = this.baseUrl + "/BadgeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<BadgeTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BadgeTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeTemplateResponse>(null as any);
    }

    preview(request: BadgeTemplatePreviewRequest, cancelToken?: CancelToken): Promise<BadgeTemplatePreviewResponse> {
        let url_ = this.baseUrl + "/BadgeTemplate/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<BadgeTemplatePreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BadgeTemplatePreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BadgeTemplatePreviewResponse>(null as any);
    }
}

export interface IBulletinApiClient {
    listV2(request: GetBulletinListRequestV2): Promise<GetListResponseOfBulletinSimpleResponse>;
    getActive(): Promise<BulletinResponse>;
    get(id: number): Promise<BulletinResponse>;
    delete(id: number): Promise<FileResponse | null>;
    create(model: BulletinRequest): Promise<BulletinResponse>;
    update(model: BulletinRequest): Promise<BulletinResponse>;
}

export class BulletinApiClient implements IBulletinApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetBulletinListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfBulletinSimpleResponse> {
        let url_ = this.baseUrl + "/bulletin/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfBulletinSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfBulletinSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfBulletinSimpleResponse>(null as any);
    }

    getActive( cancelToken?: CancelToken): Promise<BulletinResponse> {
        let url_ = this.baseUrl + "/bulletin/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActive(_response);
        });
    }

    protected processGetActive(response: AxiosResponse): Promise<BulletinResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BulletinResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulletinResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<BulletinResponse> {
        let url_ = this.baseUrl + "/bulletin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BulletinResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BulletinResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulletinResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/bulletin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(model: BulletinRequest, cancelToken?: CancelToken): Promise<BulletinResponse> {
        let url_ = this.baseUrl + "/bulletin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<BulletinResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BulletinResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulletinResponse>(null as any);
    }

    update(model: BulletinRequest, cancelToken?: CancelToken): Promise<BulletinResponse> {
        let url_ = this.baseUrl + "/bulletin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<BulletinResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BulletinResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulletinResponse>(null as any);
    }
}

export interface IClientApiClient {
    create(model: ClientRequest): Promise<ClientResponse>;
    update(model: ClientRequest): Promise<ClientResponse>;
    listV2(request: GetListRequestV2): Promise<GetListResponseOfClientSimpleResponse>;
    listSelectOptions(request: GetListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<ClientResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<ClientResponse>;
}

export class ClientApiClient implements IClientApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: ClientRequest, cancelToken?: CancelToken): Promise<ClientResponse> {
        let url_ = this.baseUrl + "/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientResponse>(null as any);
    }

    update(model: ClientRequest, cancelToken?: CancelToken): Promise<ClientResponse> {
        let url_ = this.baseUrl + "/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientResponse>(null as any);
    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfClientSimpleResponse> {
        let url_ = this.baseUrl + "/client/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfClientSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfClientSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfClientSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/client/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ClientResponse> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<ClientResponse> {
        let url_ = this.baseUrl + "/client/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<ClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientResponse>(null as any);
    }
}

export interface ICloudWatchApiClient {
    alarms(): Promise<CloudWatchAlarmsResponse>;
    metrics(hours: number | undefined): Promise<CloudWatchMetricsResponse>;
    logGroups(): Promise<CloudWatchLogGroupResponse[]>;
    logs(group: string | null | undefined, start: Date | null | undefined, end: Date | null | undefined, text: string | null | undefined, level: CloudWatchLogLevel | undefined, limit: number | undefined, nextToken: string | null | undefined): Promise<CloudWatchLogPageResponse>;
}

export class CloudWatchApiClient implements ICloudWatchApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    alarms( cancelToken?: CancelToken): Promise<CloudWatchAlarmsResponse> {
        let url_ = this.baseUrl + "/CloudWatch/alarms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarms(_response);
        });
    }

    protected processAlarms(response: AxiosResponse): Promise<CloudWatchAlarmsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CloudWatchAlarmsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudWatchAlarmsResponse>(null as any);
    }

    metrics(hours: number | undefined, cancelToken?: CancelToken): Promise<CloudWatchMetricsResponse> {
        let url_ = this.baseUrl + "/CloudWatch/metrics?";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMetrics(_response);
        });
    }

    protected processMetrics(response: AxiosResponse): Promise<CloudWatchMetricsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CloudWatchMetricsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudWatchMetricsResponse>(null as any);
    }

    logGroups( cancelToken?: CancelToken): Promise<CloudWatchLogGroupResponse[]> {
        let url_ = this.baseUrl + "/CloudWatch/logs/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogGroups(_response);
        });
    }

    protected processLogGroups(response: AxiosResponse): Promise<CloudWatchLogGroupResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CloudWatchLogGroupResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudWatchLogGroupResponse[]>(null as any);
    }

    logs(group: string | null | undefined, start: Date | null | undefined, end: Date | null | undefined, text: string | null | undefined, level: CloudWatchLogLevel | undefined, limit: number | undefined, nextToken: string | null | undefined, cancelToken?: CancelToken): Promise<CloudWatchLogPageResponse> {
        let url_ = this.baseUrl + "/CloudWatch/logs?";
        if (group !== undefined && group !== null)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (start !== undefined && start !== null)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (level === null)
            throw new Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (nextToken !== undefined && nextToken !== null)
            url_ += "NextToken=" + encodeURIComponent("" + nextToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<CloudWatchLogPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CloudWatchLogPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudWatchLogPageResponse>(null as any);
    }
}

export interface IComplianceEventApiClient {
    getEventTimeSeriesReport(request: GetEventTimeSeriesReportRequest): Promise<GetListResponseOfGetReportResponse>;
    getEventList(request: GetComplianceEventListRequest): Promise<GetListResponseOfComplianceEventResponse>;
    getEvent(id: number): Promise<ComplianceEventResponse>;
    issueTaskAndTransition(request: ComplianceEventIssueTaskAndTransitionRequest, id: string): Promise<ComplianceEventResponse>;
    transition(id: number, request: TransitionRequest): Promise<ComplianceEventResponse>;
    getStateMachine(): Promise<IStateMachineOfComplianceEventStateEnum>;
}

export class ComplianceEventApiClient implements IComplianceEventApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEventTimeSeriesReport(request: GetEventTimeSeriesReportRequest, cancelToken?: CancelToken): Promise<GetListResponseOfGetReportResponse> {
        let url_ = this.baseUrl + "/compliance-event/time-series-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventTimeSeriesReport(_response);
        });
    }

    protected processGetEventTimeSeriesReport(response: AxiosResponse): Promise<GetListResponseOfGetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfGetReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfGetReportResponse>(null as any);
    }

    getEventList(request: GetComplianceEventListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceEventResponse> {
        let url_ = this.baseUrl + "/compliance-event/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventList(_response);
        });
    }

    protected processGetEventList(response: AxiosResponse): Promise<GetListResponseOfComplianceEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceEventResponse>(null as any);
    }

    getEvent(id: number, cancelToken?: CancelToken): Promise<ComplianceEventResponse> {
        let url_ = this.baseUrl + "/compliance-event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvent(_response);
        });
    }

    protected processGetEvent(response: AxiosResponse): Promise<ComplianceEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceEventResponse>(null as any);
    }

    issueTaskAndTransition(request: ComplianceEventIssueTaskAndTransitionRequest, id: string, cancelToken?: CancelToken): Promise<ComplianceEventResponse> {
        let url_ = this.baseUrl + "/compliance-event/{id}/transition/issue-task";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTaskAndTransition(_response);
        });
    }

    protected processIssueTaskAndTransition(response: AxiosResponse): Promise<ComplianceEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceEventResponse>(null as any);
    }

    transition(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<ComplianceEventResponse> {
        let url_ = this.baseUrl + "/compliance-event/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<ComplianceEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceEventResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfComplianceEventStateEnum> {
        let url_ = this.baseUrl + "/compliance-event/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfComplianceEventStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfComplianceEventStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfComplianceEventStateEnum>(null as any);
    }
}

export interface IComplianceStandardApiClient {
    listComplianceStandard(request: GetComplianceStandardsListRequest): Promise<GetListResponseOfComplianceStandardResponse>;
    listComplianceStandardV2(request: GetComplianceStandardsListRequestV2): Promise<GetListResponseOfComplianceStandardResponse>;
    listSelectOptions(request: GetComplianceStandardsListRequest): Promise<GetListResponseOfSelectOption>;
    getComplianceStandard(id: number): Promise<ComplianceStandardResponse>;
    listCustomComplianceStandard(request: GetComplianceStandardsListRequest): Promise<GetListResponseOfComplianceStandardResponse>;
    listCustomComplianceStandardV2(request: GetComplianceStandardsListRequestV2): Promise<GetListResponseOfComplianceStandardResponse>;
    listCustomComplianceStandardTree(request: GetComplianceStandardsListRequestV2): Promise<TreeResponse[]>;
    getCustomComplianceStandard(id: number): Promise<ComplianceStandardResponse>;
    createCustomComplianceStandard(request: CustomComplianceStandardRequest): Promise<ComplianceStandardResponse>;
    updateCustomComplianceStandard(request: CustomComplianceStandardRequest): Promise<ComplianceStandardResponse>;
    getImportTemplate(): Promise<FileResponse | null>;
    import(key: string): Promise<string>;
}

export class ComplianceStandardApiClient implements IComplianceStandardApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listComplianceStandard(request: GetComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListComplianceStandard(_response);
        });
    }

    protected processListComplianceStandard(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listComplianceStandardV2(request: GetComplianceStandardsListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListComplianceStandardV2(_response);
        });
    }

    protected processListComplianceStandardV2(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listSelectOptions(request: GetComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/compliance-standard/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    getComplianceStandard(id: number, cancelToken?: CancelToken): Promise<ComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplianceStandard(_response);
        });
    }

    protected processGetComplianceStandard(response: AxiosResponse): Promise<ComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceStandardResponse>(null as any);
    }

    listCustomComplianceStandard(request: GetComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/custom/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCustomComplianceStandard(_response);
        });
    }

    protected processListCustomComplianceStandard(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listCustomComplianceStandardV2(request: GetComplianceStandardsListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/custom/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCustomComplianceStandardV2(_response);
        });
    }

    protected processListCustomComplianceStandardV2(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listCustomComplianceStandardTree(request: GetComplianceStandardsListRequestV2, cancelToken?: CancelToken): Promise<TreeResponse[]> {
        let url_ = this.baseUrl + "/compliance-standard/custom/list/tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCustomComplianceStandardTree(_response);
        });
    }

    protected processListCustomComplianceStandardTree(response: AxiosResponse): Promise<TreeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TreeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeResponse[]>(null as any);
    }

    getCustomComplianceStandard(id: number, cancelToken?: CancelToken): Promise<ComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/custom/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomComplianceStandard(_response);
        });
    }

    protected processGetCustomComplianceStandard(response: AxiosResponse): Promise<ComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceStandardResponse>(null as any);
    }

    createCustomComplianceStandard(request: CustomComplianceStandardRequest, cancelToken?: CancelToken): Promise<ComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomComplianceStandard(_response);
        });
    }

    protected processCreateCustomComplianceStandard(response: AxiosResponse): Promise<ComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceStandardResponse>(null as any);
    }

    updateCustomComplianceStandard(request: CustomComplianceStandardRequest, cancelToken?: CancelToken): Promise<ComplianceStandardResponse> {
        let url_ = this.baseUrl + "/compliance-standard/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomComplianceStandard(_response);
        });
    }

    protected processUpdateCustomComplianceStandard(response: AxiosResponse): Promise<ComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceStandardResponse>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/compliance-standard/custom/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(key: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/compliance-standard/custom/import/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICourseAssignmentApiClient {
    list(request: GetCourseAssignmentListRequest): Promise<GetListResponseOfCourseAssignmentSimpleResponse>;
    listV2(request: GetCourseAssignmentListRequestV2): Promise<GetListResponseOfCourseAssignmentSimpleResponse>;
    listPotentialCandidates(request: GetListPotentialCandidatesRequest): Promise<GetListResponseOfPersonnelSimpleResponse>;
    listSelectOptions(request: GetCourseAssignmentListRequest): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<CourseAssignmentResponse>;
    delete(id: number): Promise<boolean>;
    update(model: CourseAssignmentRequest): Promise<CourseAssignmentResponse>;
    create(model: CourseAssignmentRequest): Promise<CourseAssignmentResponse>;
    getActiveSession(assignmentId: number): Promise<CourseSessionTrackerResponse>;
    startSession(assignmentId: number, language: string | null | undefined): Promise<CourseSessionTrackerResponse>;
    transitionState(id: number, state: CourseAssignmentStateEnum): Promise<CourseAssignmentResponse>;
    batchUpdate(request: BatchCourseAssignmentUpdateRequest): Promise<number>;
    export(request: GetCourseAssignmentListRequestV2): Promise<FileResponse | null>;
    aggregate(request: GetCourseAssignmentAggregateRequest): Promise<CourseAssignmentAggregateResponse>;
    bulkRemind(request: CourseAssignmentBulkActionRequest): Promise<CourseAssignmentBulkActionEnqueueResponse>;
    bulkExtend(request: CourseAssignmentBulkExtendRequest): Promise<CourseAssignmentBulkActionEnqueueResponse>;
    bulkWaive(request: CourseAssignmentBulkWaiveRequest): Promise<CourseAssignmentBulkActionEnqueueResponse>;
}

export class CourseAssignmentApiClient implements ICourseAssignmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetCourseAssignmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfCourseAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/course-assignment/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfCourseAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseAssignmentSimpleResponse>(null as any);
    }

    listV2(request: GetCourseAssignmentListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfCourseAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/course-assignment/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfCourseAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseAssignmentSimpleResponse>(null as any);
    }

    listPotentialCandidates(request: GetListPotentialCandidatesRequest, cancelToken?: CancelToken): Promise<GetListResponseOfPersonnelSimpleResponse> {
        let url_ = this.baseUrl + "/course-assignment/list/candidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPotentialCandidates(_response);
        });
    }

    protected processListPotentialCandidates(response: AxiosResponse): Promise<GetListResponseOfPersonnelSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetCourseAssignmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/course-assignment/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseAssignmentResponse> {
        let url_ = this.baseUrl + "/course-assignment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/course-assignment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(model: CourseAssignmentRequest, cancelToken?: CancelToken): Promise<CourseAssignmentResponse> {
        let url_ = this.baseUrl + "/course-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentResponse>(null as any);
    }

    create(model: CourseAssignmentRequest, cancelToken?: CancelToken): Promise<CourseAssignmentResponse> {
        let url_ = this.baseUrl + "/course-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CourseAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentResponse>(null as any);
    }

    getActiveSession(assignmentId: number, cancelToken?: CancelToken): Promise<CourseSessionTrackerResponse> {
        let url_ = this.baseUrl + "/course-assignment/{assignmentId}/get-session";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSession(_response);
        });
    }

    protected processGetActiveSession(response: AxiosResponse): Promise<CourseSessionTrackerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionTrackerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionTrackerResponse>(null as any);
    }

    startSession(assignmentId: number, language: string | null | undefined, cancelToken?: CancelToken): Promise<CourseSessionTrackerResponse> {
        let url_ = this.baseUrl + "/course-assignment/{assignmentId}/start-session?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartSession(_response);
        });
    }

    protected processStartSession(response: AxiosResponse): Promise<CourseSessionTrackerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionTrackerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionTrackerResponse>(null as any);
    }

    transitionState(id: number, state: CourseAssignmentStateEnum, cancelToken?: CancelToken): Promise<CourseAssignmentResponse> {
        let url_ = this.baseUrl + "/course-assignment/{id}/state/{state}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransitionState(_response);
        });
    }

    protected processTransitionState(response: AxiosResponse): Promise<CourseAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentResponse>(null as any);
    }

    batchUpdate(request: BatchCourseAssignmentUpdateRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/course-assignment/batch-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdate(_response);
        });
    }

    protected processBatchUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    export(request: GetCourseAssignmentListRequestV2, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-assignment/list/v2/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    aggregate(request: GetCourseAssignmentAggregateRequest, cancelToken?: CancelToken): Promise<CourseAssignmentAggregateResponse> {
        let url_ = this.baseUrl + "/course-assignment/aggregate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAggregate(_response);
        });
    }

    protected processAggregate(response: AxiosResponse): Promise<CourseAssignmentAggregateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentAggregateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentAggregateResponse>(null as any);
    }

    bulkRemind(request: CourseAssignmentBulkActionRequest, cancelToken?: CancelToken): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        let url_ = this.baseUrl + "/course-assignment/bulk-remind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkRemind(_response);
        });
    }

    protected processBulkRemind(response: AxiosResponse): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(null as any);
    }

    bulkExtend(request: CourseAssignmentBulkExtendRequest, cancelToken?: CancelToken): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        let url_ = this.baseUrl + "/course-assignment/bulk-extend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkExtend(_response);
        });
    }

    protected processBulkExtend(response: AxiosResponse): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(null as any);
    }

    bulkWaive(request: CourseAssignmentBulkWaiveRequest, cancelToken?: CancelToken): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        let url_ = this.baseUrl + "/course-assignment/bulk-waive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkWaive(_response);
        });
    }

    protected processBulkWaive(response: AxiosResponse): Promise<CourseAssignmentBulkActionEnqueueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentBulkActionEnqueueResponse>(null as any);
    }
}

export interface ICourseAssignmentRuleApiClient {
    listByCourse(courseDefinitionId: number): Promise<CourseAssignmentRuleResponse[]>;
    recalculate(courseDefinitionId: number): Promise<boolean>;
    get(id: number): Promise<CourseAssignmentRuleResponse>;
    delete(id: number): Promise<FileResponse | null>;
    create(request: CourseAssignmentRuleCreateRequest): Promise<CourseAssignmentRuleResponse>;
    update(request: CourseAssignmentRuleUpdateRequest): Promise<CourseAssignmentRuleResponse>;
    preview(request: CourseAssignmentRulePreviewRequest): Promise<CourseAssignmentRulePreviewResponse>;
    listExceptions(ruleId: number): Promise<CourseAssignmentRuleExceptionResponse[]>;
    addException(request: CourseAssignmentRuleExceptionCreateRequest): Promise<CourseAssignmentRuleExceptionResponse>;
    removeException(id: number): Promise<FileResponse | null>;
}

export class CourseAssignmentRuleApiClient implements ICourseAssignmentRuleApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listByCourse(courseDefinitionId: number, cancelToken?: CancelToken): Promise<CourseAssignmentRuleResponse[]> {
        let url_ = this.baseUrl + "/course-assignment-rule/course/{courseDefinitionId}";
        if (courseDefinitionId === undefined || courseDefinitionId === null)
            throw new Error("The parameter 'courseDefinitionId' must be defined.");
        url_ = url_.replace("{courseDefinitionId}", encodeURIComponent("" + courseDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListByCourse(_response);
        });
    }

    protected processListByCourse(response: AxiosResponse): Promise<CourseAssignmentRuleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleResponse[]>(null as any);
    }

    recalculate(courseDefinitionId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/course-assignment-rule/course/{courseDefinitionId}/recalculate";
        if (courseDefinitionId === undefined || courseDefinitionId === null)
            throw new Error("The parameter 'courseDefinitionId' must be defined.");
        url_ = url_.replace("{courseDefinitionId}", encodeURIComponent("" + courseDefinitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculate(_response);
        });
    }

    protected processRecalculate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/course-assignment-rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-assignment-rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(request: CourseAssignmentRuleCreateRequest, cancelToken?: CancelToken): Promise<CourseAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/course-assignment-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CourseAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleResponse>(null as any);
    }

    update(request: CourseAssignmentRuleUpdateRequest, cancelToken?: CancelToken): Promise<CourseAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/course-assignment-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleResponse>(null as any);
    }

    preview(request: CourseAssignmentRulePreviewRequest, cancelToken?: CancelToken): Promise<CourseAssignmentRulePreviewResponse> {
        let url_ = this.baseUrl + "/course-assignment-rule/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<CourseAssignmentRulePreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRulePreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRulePreviewResponse>(null as any);
    }

    listExceptions(ruleId: number, cancelToken?: CancelToken): Promise<CourseAssignmentRuleExceptionResponse[]> {
        let url_ = this.baseUrl + "/course-assignment-rule/{ruleId}/exceptions";
        if (ruleId === undefined || ruleId === null)
            throw new Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListExceptions(_response);
        });
    }

    protected processListExceptions(response: AxiosResponse): Promise<CourseAssignmentRuleExceptionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleExceptionResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleExceptionResponse[]>(null as any);
    }

    addException(request: CourseAssignmentRuleExceptionCreateRequest, cancelToken?: CancelToken): Promise<CourseAssignmentRuleExceptionResponse> {
        let url_ = this.baseUrl + "/course-assignment-rule/exception";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddException(_response);
        });
    }

    protected processAddException(response: AxiosResponse): Promise<CourseAssignmentRuleExceptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseAssignmentRuleExceptionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseAssignmentRuleExceptionResponse>(null as any);
    }

    removeException(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-assignment-rule/exception/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveException(_response);
        });
    }

    protected processRemoveException(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ICourseClassroomApiClient {
    list(request: GetCourseClassroomListRequest): Promise<GetListResponseOfCourseClassroomSimpleResponse>;
    listV2(request: GetCourseClassroomListRequestV2): Promise<GetListResponseOfCourseClassroomSimpleResponse>;
    get(id: number): Promise<CourseClassroomResponse>;
    update(model: CourseClassroomRequest): Promise<CourseClassroomResponse>;
    create(model: CourseClassroomRequest): Promise<CourseClassroomResponse>;
    transition(id: number, request: TransitionRequest): Promise<CourseClassroomResponse>;
    getStateMachine(): Promise<IStateMachineOfCourseClassroomStateEnum>;
    getRoster(id: number): Promise<CourseClassroomAttendeeRosterRowResponse[]>;
    addAttendee(request: CourseClassroomAttendeeAddRequest): Promise<CourseClassroomAttendeeResponse>;
    updateAttendee(request: CourseClassroomAttendeeUpdateRequest): Promise<CourseClassroomAttendeeResponse>;
    addAttendeeBatch(request: CourseClassroomAttendeeAddBatchRequest): Promise<CourseClassroomAttendeeResponse[]>;
    updateAttendeeBatch(request: CourseClassroomAttendeeBatchUpdateRequest): Promise<CourseClassroomAttendeeResponse[]>;
    removeAttendee(attendeeId: number): Promise<FileResponse | null>;
    getCloseoutPreview(id: number): Promise<CourseClassroomCloseoutPreviewResponse>;
    closeOut(id: number): Promise<CourseClassroomCloseoutReceipt>;
    undoCloseout(id: number): Promise<CourseClassroomUndoCloseoutReceipt>;
    issueCertificates(id: number): Promise<CourseCertificateBulkIssueResponse>;
}

export class CourseClassroomApiClient implements ICourseClassroomApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetCourseClassroomListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfCourseClassroomSimpleResponse> {
        let url_ = this.baseUrl + "/course-classroom/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfCourseClassroomSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseClassroomSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseClassroomSimpleResponse>(null as any);
    }

    listV2(request: GetCourseClassroomListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfCourseClassroomSimpleResponse> {
        let url_ = this.baseUrl + "/course-classroom/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfCourseClassroomSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseClassroomSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseClassroomSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseClassroomResponse> {
        let url_ = this.baseUrl + "/course-classroom/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseClassroomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomResponse>(null as any);
    }

    update(model: CourseClassroomRequest, cancelToken?: CancelToken): Promise<CourseClassroomResponse> {
        let url_ = this.baseUrl + "/course-classroom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseClassroomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomResponse>(null as any);
    }

    create(model: CourseClassroomRequest, cancelToken?: CancelToken): Promise<CourseClassroomResponse> {
        let url_ = this.baseUrl + "/course-classroom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CourseClassroomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomResponse>(null as any);
    }

    transition(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<CourseClassroomResponse> {
        let url_ = this.baseUrl + "/course-classroom/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<CourseClassroomResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfCourseClassroomStateEnum> {
        let url_ = this.baseUrl + "/course-classroom/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfCourseClassroomStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfCourseClassroomStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfCourseClassroomStateEnum>(null as any);
    }

    getRoster(id: number, cancelToken?: CancelToken): Promise<CourseClassroomAttendeeRosterRowResponse[]> {
        let url_ = this.baseUrl + "/course-classroom/{id}/roster";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoster(_response);
        });
    }

    protected processGetRoster(response: AxiosResponse): Promise<CourseClassroomAttendeeRosterRowResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomAttendeeRosterRowResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomAttendeeRosterRowResponse[]>(null as any);
    }

    addAttendee(request: CourseClassroomAttendeeAddRequest, cancelToken?: CancelToken): Promise<CourseClassroomAttendeeResponse> {
        let url_ = this.baseUrl + "/course-classroom/attendee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAttendee(_response);
        });
    }

    protected processAddAttendee(response: AxiosResponse): Promise<CourseClassroomAttendeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomAttendeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomAttendeeResponse>(null as any);
    }

    updateAttendee(request: CourseClassroomAttendeeUpdateRequest, cancelToken?: CancelToken): Promise<CourseClassroomAttendeeResponse> {
        let url_ = this.baseUrl + "/course-classroom/attendee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAttendee(_response);
        });
    }

    protected processUpdateAttendee(response: AxiosResponse): Promise<CourseClassroomAttendeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomAttendeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomAttendeeResponse>(null as any);
    }

    addAttendeeBatch(request: CourseClassroomAttendeeAddBatchRequest, cancelToken?: CancelToken): Promise<CourseClassroomAttendeeResponse[]> {
        let url_ = this.baseUrl + "/course-classroom/attendee/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAttendeeBatch(_response);
        });
    }

    protected processAddAttendeeBatch(response: AxiosResponse): Promise<CourseClassroomAttendeeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomAttendeeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomAttendeeResponse[]>(null as any);
    }

    updateAttendeeBatch(request: CourseClassroomAttendeeBatchUpdateRequest, cancelToken?: CancelToken): Promise<CourseClassroomAttendeeResponse[]> {
        let url_ = this.baseUrl + "/course-classroom/attendee/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAttendeeBatch(_response);
        });
    }

    protected processUpdateAttendeeBatch(response: AxiosResponse): Promise<CourseClassroomAttendeeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomAttendeeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomAttendeeResponse[]>(null as any);
    }

    removeAttendee(attendeeId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-classroom/attendee/{attendeeId}";
        if (attendeeId === undefined || attendeeId === null)
            throw new Error("The parameter 'attendeeId' must be defined.");
        url_ = url_.replace("{attendeeId}", encodeURIComponent("" + attendeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAttendee(_response);
        });
    }

    protected processRemoveAttendee(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCloseoutPreview(id: number, cancelToken?: CancelToken): Promise<CourseClassroomCloseoutPreviewResponse> {
        let url_ = this.baseUrl + "/course-classroom/{id}/closeout-preview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloseoutPreview(_response);
        });
    }

    protected processGetCloseoutPreview(response: AxiosResponse): Promise<CourseClassroomCloseoutPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomCloseoutPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomCloseoutPreviewResponse>(null as any);
    }

    closeOut(id: number, cancelToken?: CancelToken): Promise<CourseClassroomCloseoutReceipt> {
        let url_ = this.baseUrl + "/course-classroom/{id}/close-out";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseOut(_response);
        });
    }

    protected processCloseOut(response: AxiosResponse): Promise<CourseClassroomCloseoutReceipt> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomCloseoutReceipt>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomCloseoutReceipt>(null as any);
    }

    undoCloseout(id: number, cancelToken?: CancelToken): Promise<CourseClassroomUndoCloseoutReceipt> {
        let url_ = this.baseUrl + "/course-classroom/{id}/undo-closeout";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndoCloseout(_response);
        });
    }

    protected processUndoCloseout(response: AxiosResponse): Promise<CourseClassroomUndoCloseoutReceipt> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseClassroomUndoCloseoutReceipt>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassroomUndoCloseoutReceipt>(null as any);
    }

    issueCertificates(id: number, cancelToken?: CancelToken): Promise<CourseCertificateBulkIssueResponse> {
        let url_ = this.baseUrl + "/course-classroom/{id}/certificates/issue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueCertificates(_response);
        });
    }

    protected processIssueCertificates(response: AxiosResponse): Promise<CourseCertificateBulkIssueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseCertificateBulkIssueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseCertificateBulkIssueResponse>(null as any);
    }
}

export interface ICourseDefinitionApiClient {
    list(request: GetCourseDefinitionListRequest): Promise<GetListResponseOfCourseDefinitionSimpleResponse>;
    listV2(request: GetCourseDefinitionListRequestV2): Promise<GetListResponseOfCourseDefinitionSimpleResponse>;
    listSelectOptions(request: GetCourseDefinitionListRequest): Promise<GetListResponseOfSelectOption>;
    listContentSelectOptions(request: GetCourseDefinitionContentListRequest): Promise<GetListResponseOfSelectOptionInvariant>;
    getVersion(id: number, version: number): Promise<CourseDefinitionResponse>;
    get(id: number): Promise<CourseDefinitionResponse>;
    getVersions(id: number): Promise<CourseDefinitionVersionResponse[]>;
    getSaveImpact(id: number): Promise<CourseDefinitionSaveImpactResponse>;
    getQuizStatistics(id: number, language: string | undefined, fromUtc: Date | null | undefined, toUtc: Date | null | undefined): Promise<CourseQuizStatisticsResponse>;
    update(model: CourseDefinitionRequest): Promise<CourseDefinitionResponse>;
    create(model: CourseDefinitionRequest): Promise<CourseDefinitionResponse>;
    clone(id: number): Promise<CourseDefinitionResponse>;
    bulkSetActive(request: BulkSetCourseDefinitionActiveRequest): Promise<number>;
}

export class CourseDefinitionApiClient implements ICourseDefinitionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetCourseDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfCourseDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/course-definition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfCourseDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseDefinitionSimpleResponse>(null as any);
    }

    listV2(request: GetCourseDefinitionListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfCourseDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/course-definition/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfCourseDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseDefinitionSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetCourseDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/course-definition/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    listContentSelectOptions(request: GetCourseDefinitionContentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOptionInvariant> {
        let url_ = this.baseUrl + "/course-definition/content/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListContentSelectOptions(_response);
        });
    }

    protected processListContentSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOptionInvariant> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOptionInvariant>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOptionInvariant>(null as any);
    }

    getVersion(id: number, version: number, cancelToken?: CancelToken): Promise<CourseDefinitionResponse> {
        let url_ = this.baseUrl + "/course-definition/{id}/{version}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<CourseDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseDefinitionResponse> {
        let url_ = this.baseUrl + "/course-definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionResponse>(null as any);
    }

    getVersions(id: number, cancelToken?: CancelToken): Promise<CourseDefinitionVersionResponse[]> {
        let url_ = this.baseUrl + "/course-definition/{id}/versions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersions(_response);
        });
    }

    protected processGetVersions(response: AxiosResponse): Promise<CourseDefinitionVersionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionVersionResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionVersionResponse[]>(null as any);
    }

    getSaveImpact(id: number, cancelToken?: CancelToken): Promise<CourseDefinitionSaveImpactResponse> {
        let url_ = this.baseUrl + "/course-definition/{id}/save-impact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaveImpact(_response);
        });
    }

    protected processGetSaveImpact(response: AxiosResponse): Promise<CourseDefinitionSaveImpactResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionSaveImpactResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionSaveImpactResponse>(null as any);
    }

    getQuizStatistics(id: number, language: string | undefined, fromUtc: Date | null | undefined, toUtc: Date | null | undefined, cancelToken?: CancelToken): Promise<CourseQuizStatisticsResponse> {
        let url_ = this.baseUrl + "/course-definition/{id}/quiz-statistics?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (fromUtc !== undefined && fromUtc !== null)
            url_ += "fromUtc=" + encodeURIComponent(fromUtc ? "" + fromUtc.toISOString() : "") + "&";
        if (toUtc !== undefined && toUtc !== null)
            url_ += "toUtc=" + encodeURIComponent(toUtc ? "" + toUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuizStatistics(_response);
        });
    }

    protected processGetQuizStatistics(response: AxiosResponse): Promise<CourseQuizStatisticsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseQuizStatisticsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseQuizStatisticsResponse>(null as any);
    }

    update(model: CourseDefinitionRequest, cancelToken?: CancelToken): Promise<CourseDefinitionResponse> {
        let url_ = this.baseUrl + "/course-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionResponse>(null as any);
    }

    create(model: CourseDefinitionRequest, cancelToken?: CancelToken): Promise<CourseDefinitionResponse> {
        let url_ = this.baseUrl + "/course-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CourseDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionResponse>(null as any);
    }

    clone(id: number, cancelToken?: CancelToken): Promise<CourseDefinitionResponse> {
        let url_ = this.baseUrl + "/course-definition/{id}/clone";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: AxiosResponse): Promise<CourseDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDefinitionResponse>(null as any);
    }

    bulkSetActive(request: BulkSetCourseDefinitionActiveRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/course-definition/bulk/active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkSetActive(_response);
        });
    }

    protected processBulkSetActive(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseSessionApiClient {
    list(request: GetCourseSessionListRequest): Promise<GetListResponseOfCourseSessionSimpleResponse>;
    update(model: CourseSessionRequest): Promise<CourseSessionBlendedResponse>;
    get(id: number): Promise<CourseSessionBlendedResponse>;
    getSessionCertificate(id: number): Promise<CourseSessionCertificateResponse>;
    getSessionCertificatePdf(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    getSessionContentCertificatePdf(id: number, contentId: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    getSessionContentCertificate(id: number, contentId: number): Promise<CourseSessionCertificateResponse>;
    getCurrentSessionContent(sessionId: number): Promise<CourseSessionCurrentContentResponse>;
    updateSessionContentTimeout(request: UpdateCurrentSessionContentRequest): Promise<boolean>;
    updateCurrentSessionLessonContent(request: UpdateCurrentSessionLessonContentRequest): Promise<boolean>;
    closeCurrentSessionLessonContent(request: CloseCurrentSessionLessonContentRequest): Promise<CourseSessionCurrentContentResponse>;
    closeCurrentSessionQuizContent(request: CloseCurrentSessionQuizContentRequest): Promise<CourseSessionContentQuizCompleteResponse>;
    getDemonstrationSummary(request: GetDemonstrationSummaryRequest): Promise<CourseSessionBlendedResponse>;
    getDemonstrationContext(request: GetDemonstrationSummaryRequest): Promise<CourseDemonstrationContextResponse>;
}

export class CourseSessionApiClient implements ICourseSessionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetCourseSessionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfCourseSessionSimpleResponse> {
        let url_ = this.baseUrl + "/course-session/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfCourseSessionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseSessionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseSessionSimpleResponse>(null as any);
    }

    update(model: CourseSessionRequest, cancelToken?: CancelToken): Promise<CourseSessionBlendedResponse> {
        let url_ = this.baseUrl + "/course-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseSessionBlendedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionBlendedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionBlendedResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseSessionBlendedResponse> {
        let url_ = this.baseUrl + "/course-session/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseSessionBlendedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionBlendedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionBlendedResponse>(null as any);
    }

    getSessionCertificate(id: number, cancelToken?: CancelToken): Promise<CourseSessionCertificateResponse> {
        let url_ = this.baseUrl + "/course-session/{id}/certificate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionCertificate(_response);
        });
    }

    protected processGetSessionCertificate(response: AxiosResponse): Promise<CourseSessionCertificateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionCertificateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionCertificateResponse>(null as any);
    }

    getSessionCertificatePdf(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-session/{id}/certificate/pdf?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionCertificatePdf(_response);
        });
    }

    protected processGetSessionCertificatePdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSessionContentCertificatePdf(id: number, contentId: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/course-session/{id}/content/{contentId}/certificate/pdf?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contentId === undefined || contentId === null)
            throw new Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionContentCertificatePdf(_response);
        });
    }

    protected processGetSessionContentCertificatePdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSessionContentCertificate(id: number, contentId: number, cancelToken?: CancelToken): Promise<CourseSessionCertificateResponse> {
        let url_ = this.baseUrl + "/course-session/{id}/certificate/{contentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contentId === undefined || contentId === null)
            throw new Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionContentCertificate(_response);
        });
    }

    protected processGetSessionContentCertificate(response: AxiosResponse): Promise<CourseSessionCertificateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionCertificateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionCertificateResponse>(null as any);
    }

    getCurrentSessionContent(sessionId: number, cancelToken?: CancelToken): Promise<CourseSessionCurrentContentResponse> {
        let url_ = this.baseUrl + "/course-session/tracker/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentSessionContent(_response);
        });
    }

    protected processGetCurrentSessionContent(response: AxiosResponse): Promise<CourseSessionCurrentContentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionCurrentContentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionCurrentContentResponse>(null as any);
    }

    updateSessionContentTimeout(request: UpdateCurrentSessionContentRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/course-session/tracker/time-out";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSessionContentTimeout(_response);
        });
    }

    protected processUpdateSessionContentTimeout(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateCurrentSessionLessonContent(request: UpdateCurrentSessionLessonContentRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/course-session/tracker/lesson/update-progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCurrentSessionLessonContent(_response);
        });
    }

    protected processUpdateCurrentSessionLessonContent(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    closeCurrentSessionLessonContent(request: CloseCurrentSessionLessonContentRequest, cancelToken?: CancelToken): Promise<CourseSessionCurrentContentResponse> {
        let url_ = this.baseUrl + "/course-session/tracker/lesson/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseCurrentSessionLessonContent(_response);
        });
    }

    protected processCloseCurrentSessionLessonContent(response: AxiosResponse): Promise<CourseSessionCurrentContentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionCurrentContentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionCurrentContentResponse>(null as any);
    }

    closeCurrentSessionQuizContent(request: CloseCurrentSessionQuizContentRequest, cancelToken?: CancelToken): Promise<CourseSessionContentQuizCompleteResponse> {
        let url_ = this.baseUrl + "/course-session/tracker/quiz/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseCurrentSessionQuizContent(_response);
        });
    }

    protected processCloseCurrentSessionQuizContent(response: AxiosResponse): Promise<CourseSessionContentQuizCompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionContentQuizCompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionContentQuizCompleteResponse>(null as any);
    }

    getDemonstrationSummary(request: GetDemonstrationSummaryRequest, cancelToken?: CancelToken): Promise<CourseSessionBlendedResponse> {
        let url_ = this.baseUrl + "/course-session/tracker/demonstration/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDemonstrationSummary(_response);
        });
    }

    protected processGetDemonstrationSummary(response: AxiosResponse): Promise<CourseSessionBlendedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseSessionBlendedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSessionBlendedResponse>(null as any);
    }

    getDemonstrationContext(request: GetDemonstrationSummaryRequest, cancelToken?: CancelToken): Promise<CourseDemonstrationContextResponse> {
        let url_ = this.baseUrl + "/course-session/tracker/demonstration/context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDemonstrationContext(_response);
        });
    }

    protected processGetDemonstrationContext(response: AxiosResponse): Promise<CourseDemonstrationContextResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseDemonstrationContextResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDemonstrationContextResponse>(null as any);
    }
}

export interface ICourseVideoApiClient {
    listV2(request: GetCourseVideoListRequestV2): Promise<GetListResponseOfCourseVideoResponse>;
    listSelectOptions(request: GetCourseVideoListRequest): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<CourseVideoResponse>;
    update(model: CourseVideoRequest): Promise<CourseVideoResponse>;
    create(model: CourseVideoRequest): Promise<CourseVideoResponse>;
    getVideoUrl(id: number): Promise<CourseVideoUrlResponse>;
}

export class CourseVideoApiClient implements ICourseVideoApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetCourseVideoListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfCourseVideoResponse> {
        let url_ = this.baseUrl + "/course-video/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfCourseVideoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCourseVideoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCourseVideoResponse>(null as any);
    }

    listSelectOptions(request: GetCourseVideoListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/course-video/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CourseVideoResponse> {
        let url_ = this.baseUrl + "/course-video/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CourseVideoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseVideoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseVideoResponse>(null as any);
    }

    update(model: CourseVideoRequest, cancelToken?: CancelToken): Promise<CourseVideoResponse> {
        let url_ = this.baseUrl + "/course-video";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CourseVideoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseVideoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseVideoResponse>(null as any);
    }

    create(model: CourseVideoRequest, cancelToken?: CancelToken): Promise<CourseVideoResponse> {
        let url_ = this.baseUrl + "/course-video";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CourseVideoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseVideoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseVideoResponse>(null as any);
    }

    getVideoUrl(id: number, cancelToken?: CancelToken): Promise<CourseVideoUrlResponse> {
        let url_ = this.baseUrl + "/course-video/{id}/video-url";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoUrl(_response);
        });
    }

    protected processGetVideoUrl(response: AxiosResponse): Promise<CourseVideoUrlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CourseVideoUrlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseVideoUrlResponse>(null as any);
    }
}

export interface IDepartmentApiClient {
    listDepartments(request: GetDepartmentListRequest): Promise<GetListResponseOfDepartmentResponse>;
    listSelectOptions(request: GetDepartmentListRequest): Promise<GetListResponseOfSelectOption>;
}

export class DepartmentApiClient implements IDepartmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listDepartments(request: GetDepartmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfDepartmentResponse> {
        let url_ = this.baseUrl + "/Department/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDepartments(_response);
        });
    }

    protected processListDepartments(response: AxiosResponse): Promise<GetListResponseOfDepartmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDepartmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDepartmentResponse>(null as any);
    }

    listSelectOptions(request: GetDepartmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/Department/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }
}

export interface IDeviceApiClient {
    create(model: DeviceRequest): Promise<DeviceResponse>;
    update(model: DeviceRequest): Promise<DeviceResponse>;
    listV2(request: GetDeviceListRequestV2): Promise<GetListResponseOfDeviceSimpleResponse>;
    listSelectOptions(request: GetDeviceListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<DeviceResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<DeviceResponse>;
    verify(id: number): Promise<DeviceResponse>;
    getImportTemplate(): Promise<FileResponse | null>;
    import(request: DeviceImportRequest): Promise<string>;
}

export class DeviceApiClient implements IDeviceApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: DeviceRequest, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    update(model: DeviceRequest, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    listV2(request: GetDeviceListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfDeviceSimpleResponse> {
        let url_ = this.baseUrl + "/device/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfDeviceSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDeviceSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDeviceSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetDeviceListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/device/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/device/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/device/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/device/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    verify(id: number, cancelToken?: CancelToken): Promise<DeviceResponse> {
        let url_ = this.baseUrl + "/device/{id}/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<DeviceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeviceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponse>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/device/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(request: DeviceImportRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/device/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IDocumentApiClient {
    get(id: number | undefined, version: number | null | undefined): Promise<DocumentResponse>;
    update(request: DocumentUpdateRequest): Promise<DocumentResponse>;
    getDocumentHistory(request: GetDocumentHistoryRequest): Promise<GetListResponseOfDocumentResponse>;
    getDocumentHistoryV2(request: GetDocumentHistoryRequestV2): Promise<GetListResponseOfDocumentResponse>;
    list(request: GetDocumentListRequest): Promise<DocumentFolderResponse>;
    tree(request: GetDocumentTreeRequest): Promise<TreeResponse[]>;
    createNewDocumentNode(createRequest: DocumentCreateRequest): Promise<DocumentResponse>;
    move(model: DocumentMoveRequest): Promise<DocumentResponse>;
    delete(nodeId: number): Promise<FileResponse | null>;
}

export class DocumentApiClient implements IDocumentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: number | undefined, version: number | null | undefined, cancelToken?: CancelToken): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/Document?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    update(request: DocumentUpdateRequest, cancelToken?: CancelToken): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/Document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    getDocumentHistory(request: GetDocumentHistoryRequest, cancelToken?: CancelToken): Promise<GetListResponseOfDocumentResponse> {
        let url_ = this.baseUrl + "/Document/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentHistory(_response);
        });
    }

    protected processGetDocumentHistory(response: AxiosResponse): Promise<GetListResponseOfDocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDocumentResponse>(null as any);
    }

    getDocumentHistoryV2(request: GetDocumentHistoryRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfDocumentResponse> {
        let url_ = this.baseUrl + "/Document/history/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentHistoryV2(_response);
        });
    }

    protected processGetDocumentHistoryV2(response: AxiosResponse): Promise<GetListResponseOfDocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDocumentResponse>(null as any);
    }

    list(request: GetDocumentListRequest, cancelToken?: CancelToken): Promise<DocumentFolderResponse> {
        let url_ = this.baseUrl + "/Document/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DocumentFolderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentFolderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentFolderResponse>(null as any);
    }

    tree(request: GetDocumentTreeRequest, cancelToken?: CancelToken): Promise<TreeResponse[]> {
        let url_ = this.baseUrl + "/Document/list/tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTree(_response);
        });
    }

    protected processTree(response: AxiosResponse): Promise<TreeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TreeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeResponse[]>(null as any);
    }

    createNewDocumentNode(createRequest: DocumentCreateRequest, cancelToken?: CancelToken): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/Document/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewDocumentNode(_response);
        });
    }

    protected processCreateNewDocumentNode(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    move(model: DocumentMoveRequest, cancelToken?: CancelToken): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/Document/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    delete(nodeId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Document/{nodeId}";
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IDocumentReviewApiClient {
    getRulesForFolder(folderId: number): Promise<DocumentReviewEffectiveRulesResponse>;
    createRule(request: DocumentReviewRuleCreateRequest): Promise<DocumentReviewRuleResponse>;
    updateRule(request: DocumentReviewRuleUpdateRequest): Promise<DocumentReviewRuleResponse>;
    deleteRule(id: number): Promise<FileResponse | null>;
    getRequests(request: DocumentReviewRequestsListRequest): Promise<DocumentReviewRoundResponse[]>;
    getRequestsList(request: DocumentReviewRoundsListRequest): Promise<GetListResponseOfDocumentReviewRoundListItemResponse>;
    reRequestReview(request: DocumentReviewReRequestRequest): Promise<DocumentReviewRoundResponse>;
}

export class DocumentReviewApiClient implements IDocumentReviewApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRulesForFolder(folderId: number, cancelToken?: CancelToken): Promise<DocumentReviewEffectiveRulesResponse> {
        let url_ = this.baseUrl + "/document-review/rules/folder/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRulesForFolder(_response);
        });
    }

    protected processGetRulesForFolder(response: AxiosResponse): Promise<DocumentReviewEffectiveRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentReviewEffectiveRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReviewEffectiveRulesResponse>(null as any);
    }

    createRule(request: DocumentReviewRuleCreateRequest, cancelToken?: CancelToken): Promise<DocumentReviewRuleResponse> {
        let url_ = this.baseUrl + "/document-review/rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRule(_response);
        });
    }

    protected processCreateRule(response: AxiosResponse): Promise<DocumentReviewRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentReviewRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReviewRuleResponse>(null as any);
    }

    updateRule(request: DocumentReviewRuleUpdateRequest, cancelToken?: CancelToken): Promise<DocumentReviewRuleResponse> {
        let url_ = this.baseUrl + "/document-review/rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRule(_response);
        });
    }

    protected processUpdateRule(response: AxiosResponse): Promise<DocumentReviewRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentReviewRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReviewRuleResponse>(null as any);
    }

    deleteRule(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/document-review/rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRule(_response);
        });
    }

    protected processDeleteRule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getRequests(request: DocumentReviewRequestsListRequest, cancelToken?: CancelToken): Promise<DocumentReviewRoundResponse[]> {
        let url_ = this.baseUrl + "/document-review/requests/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequests(_response);
        });
    }

    protected processGetRequests(response: AxiosResponse): Promise<DocumentReviewRoundResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentReviewRoundResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReviewRoundResponse[]>(null as any);
    }

    getRequestsList(request: DocumentReviewRoundsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfDocumentReviewRoundListItemResponse> {
        let url_ = this.baseUrl + "/document-review/requests/list-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestsList(_response);
        });
    }

    protected processGetRequestsList(response: AxiosResponse): Promise<GetListResponseOfDocumentReviewRoundListItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDocumentReviewRoundListItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDocumentReviewRoundListItemResponse>(null as any);
    }

    reRequestReview(request: DocumentReviewReRequestRequest, cancelToken?: CancelToken): Promise<DocumentReviewRoundResponse> {
        let url_ = this.baseUrl + "/document-review/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReRequestReview(_response);
        });
    }

    protected processReRequestReview(response: AxiosResponse): Promise<DocumentReviewRoundResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentReviewRoundResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReviewRoundResponse>(null as any);
    }
}

export interface IEmailApiClient {
    unsubscribe(token: string): Promise<FileResponse | null>;
}

export class EmailApiClient implements IEmailApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    unsubscribe(token: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Email/unsubscribe/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IEquipmentTypeApiClient {
    create(model: EquipmentTypeRequest): Promise<EquipmentTypeResponse>;
    update(model: EquipmentTypeRequest): Promise<EquipmentTypeResponse>;
    listV2(request: GetListRequestV2): Promise<GetListResponseOfEquipmentTypeSimpleResponse>;
    listSelectOptions(request: GetListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<EquipmentTypeResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<EquipmentTypeResponse>;
    getFields(id: number): Promise<FormFieldResponse[]>;
    saveFields(id: number, fields: FormFieldRequest[]): Promise<FormFieldResponse[]>;
    getImportTemplate(): Promise<FileResponse | null>;
    import(request: EquipmentTypeImportRequest): Promise<string>;
}

export class EquipmentTypeApiClient implements IEquipmentTypeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: EquipmentTypeRequest, cancelToken?: CancelToken): Promise<EquipmentTypeResponse> {
        let url_ = this.baseUrl + "/equipment-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EquipmentTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EquipmentTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeResponse>(null as any);
    }

    update(model: EquipmentTypeRequest, cancelToken?: CancelToken): Promise<EquipmentTypeResponse> {
        let url_ = this.baseUrl + "/equipment-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EquipmentTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EquipmentTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeResponse>(null as any);
    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfEquipmentTypeSimpleResponse> {
        let url_ = this.baseUrl + "/equipment-type/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfEquipmentTypeSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfEquipmentTypeSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfEquipmentTypeSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/equipment-type/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<EquipmentTypeResponse> {
        let url_ = this.baseUrl + "/equipment-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<EquipmentTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EquipmentTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/equipment-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<EquipmentTypeResponse> {
        let url_ = this.baseUrl + "/equipment-type/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<EquipmentTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EquipmentTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeResponse>(null as any);
    }

    getFields(id: number, cancelToken?: CancelToken): Promise<FormFieldResponse[]> {
        let url_ = this.baseUrl + "/equipment-type/{id}/fields";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFields(_response);
        });
    }

    protected processGetFields(response: AxiosResponse): Promise<FormFieldResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormFieldResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormFieldResponse[]>(null as any);
    }

    saveFields(id: number, fields: FormFieldRequest[], cancelToken?: CancelToken): Promise<FormFieldResponse[]> {
        let url_ = this.baseUrl + "/equipment-type/{id}/fields";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveFields(_response);
        });
    }

    protected processSaveFields(response: AxiosResponse): Promise<FormFieldResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormFieldResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormFieldResponse[]>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/equipment-type/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(request: EquipmentTypeImportRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/equipment-type/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IFileApiClient {
    upload(request: UploadPreSignedFileRequest): Promise<UploadResponse>;
    download(filename: string, separator: string, partition: string): Promise<FileResponse | null>;
}

export class FileApiClient implements IFileApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    upload(request: UploadPreSignedFileRequest, cancelToken?: CancelToken): Promise<UploadResponse> {
        let url_ = this.baseUrl + "/File";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<UploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadResponse>(null as any);
    }

    download(filename: string, separator: string, partition: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/File/{partition}/{separator}/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (separator === undefined || separator === null)
            throw new Error("The parameter 'separator' must be defined.");
        url_ = url_.replace("{separator}", encodeURIComponent("" + separator));
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IFormCategoryApiClient {
    listV2(request: GetListRequestV2): Promise<GetListResponseOfFormCategorySimpleResponse>;
    listSelectOptions(): Promise<SelectOption[]>;
    create(model: FormCategoryRequest): Promise<FormCategorySimpleResponse>;
    update(model: FormCategoryRequest): Promise<FormCategorySimpleResponse>;
    delete(id: number): Promise<boolean>;
}

export class FormCategoryApiClient implements IFormCategoryApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfFormCategorySimpleResponse> {
        let url_ = this.baseUrl + "/form-category/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfFormCategorySimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormCategorySimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormCategorySimpleResponse>(null as any);
    }

    listSelectOptions( cancelToken?: CancelToken): Promise<SelectOption[]> {
        let url_ = this.baseUrl + "/form-category/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<SelectOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SelectOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectOption[]>(null as any);
    }

    create(model: FormCategoryRequest, cancelToken?: CancelToken): Promise<FormCategorySimpleResponse> {
        let url_ = this.baseUrl + "/form-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FormCategorySimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormCategorySimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormCategorySimpleResponse>(null as any);
    }

    update(model: FormCategoryRequest, cancelToken?: CancelToken): Promise<FormCategorySimpleResponse> {
        let url_ = this.baseUrl + "/form-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FormCategorySimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormCategorySimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormCategorySimpleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/form-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IFormApiClient {
    list(request: GetFormListRequest): Promise<GetListResponseOfFormSimpleResponse>;
    listV2(request: GetFormListRequestV2): Promise<GetListResponseOfFormSimpleResponse>;
    listRelatedTasksV2(request: GetFormRelatedTasksListRequestV2): Promise<GetListResponseOfFormRelatedTaskSimpleResponse>;
    get(id: number): Promise<FormResponse>;
    getPdf(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    update(model: FormRequest): Promise<FormResponse>;
    create(model: FormRequest): Promise<FormResponse>;
    transition(id: number, request: TransitionRequest): Promise<FormResponse>;
    getStateMachine(): Promise<IStateMachineOfFormStateEnum>;
    getUserReferencedFormsV2(request: UserReferencedFormsRequest): Promise<GetListResponseOfUserReferencedFormResponse>;
    exportSubmissions(request: FormSubmissionExportRequest): Promise<FileResponse | null>;
    getPackageManifest(id: number): Promise<FormPackageManifestResponse>;
    buildPackage(id: number, request: FormPackageRequest, timeZone: string | null | undefined): Promise<FileResponse | null>;
}

export class FormApiClient implements IFormApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetFormListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfFormSimpleResponse> {
        let url_ = this.baseUrl + "/Form/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfFormSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormSimpleResponse>(null as any);
    }

    listV2(request: GetFormListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfFormSimpleResponse> {
        let url_ = this.baseUrl + "/Form/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfFormSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormSimpleResponse>(null as any);
    }

    listRelatedTasksV2(request: GetFormRelatedTasksListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfFormRelatedTaskSimpleResponse> {
        let url_ = this.baseUrl + "/Form/list/related-tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRelatedTasksV2(_response);
        });
    }

    protected processListRelatedTasksV2(response: AxiosResponse): Promise<GetListResponseOfFormRelatedTaskSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormRelatedTaskSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormRelatedTaskSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<FormResponse> {
        let url_ = this.baseUrl + "/Form/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    getPdf(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/{id}/pdf?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    update(model: FormRequest, cancelToken?: CancelToken): Promise<FormResponse> {
        let url_ = this.baseUrl + "/Form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    create(model: FormRequest, cancelToken?: CancelToken): Promise<FormResponse> {
        let url_ = this.baseUrl + "/Form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    transition(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<FormResponse> {
        let url_ = this.baseUrl + "/Form/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfFormStateEnum> {
        let url_ = this.baseUrl + "/Form/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfFormStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfFormStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfFormStateEnum>(null as any);
    }

    getUserReferencedFormsV2(request: UserReferencedFormsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfUserReferencedFormResponse> {
        let url_ = this.baseUrl + "/Form/list/user-referenced/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserReferencedFormsV2(_response);
        });
    }

    protected processGetUserReferencedFormsV2(response: AxiosResponse): Promise<GetListResponseOfUserReferencedFormResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserReferencedFormResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserReferencedFormResponse>(null as any);
    }

    exportSubmissions(request: FormSubmissionExportRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/submissions/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSubmissions(_response);
        });
    }

    protected processExportSubmissions(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPackageManifest(id: number, cancelToken?: CancelToken): Promise<FormPackageManifestResponse> {
        let url_ = this.baseUrl + "/Form/{id}/package/manifest";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPackageManifest(_response);
        });
    }

    protected processGetPackageManifest(response: AxiosResponse): Promise<FormPackageManifestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormPackageManifestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormPackageManifestResponse>(null as any);
    }

    buildPackage(id: number, request: FormPackageRequest, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/{id}/package?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildPackage(_response);
        });
    }

    protected processBuildPackage(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IFormDefinitionApiClient {
    list(request: GetFormDefinitionListRequest): Promise<GetListResponseOfFormDefinitionSimpleResponse>;
    listV2(request: GetFormDefinitionListRequestV2): Promise<GetListResponseOfFormDefinitionSimpleResponse>;
    listSelectOptions(request: GetFormDefinitionListRequest): Promise<GetListResponseOfSelectOption>;
    listFormFields(request: GetFormDefinitionFormFieldListRequest): Promise<GetListResponseOfFormFieldSimpleResponse>;
    listCategoryCounts(): Promise<FormDefinitionCategoryCountsResponse>;
    listNavigation(): Promise<FormDefinitionNavigationResponse[]>;
    getOfflineBundle(): Promise<FormDefinitionOfflineBundleResponse>;
    get(id: number): Promise<FormDefinitionResponse>;
    delete(id: number): Promise<FileResponse | null>;
    getFlattened(id: number, flattenSubform: boolean): Promise<FormDefinitionResponse>;
    getVersion(id: number, version: number): Promise<FormDefinitionResponse>;
    getFlattenedVersion(id: number, version: number, flattenSubform: boolean): Promise<FormDefinitionResponse>;
    update(model: FormDefinitionRequest): Promise<FormDefinitionResponse>;
    create(model: FormDefinitionRequest): Promise<FormDefinitionResponse>;
    getDependencies(id: number): Promise<FormDefinitionDependenciesResponse>;
}

export class FormDefinitionApiClient implements IFormDefinitionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetFormDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfFormDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/FormDefinition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfFormDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormDefinitionSimpleResponse>(null as any);
    }

    listV2(request: GetFormDefinitionListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfFormDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/FormDefinition/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfFormDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormDefinitionSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetFormDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/FormDefinition/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    listFormFields(request: GetFormDefinitionFormFieldListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfFormFieldSimpleResponse> {
        let url_ = this.baseUrl + "/FormDefinition/list/form-fields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFormFields(_response);
        });
    }

    protected processListFormFields(response: AxiosResponse): Promise<GetListResponseOfFormFieldSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfFormFieldSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfFormFieldSimpleResponse>(null as any);
    }

    listCategoryCounts( cancelToken?: CancelToken): Promise<FormDefinitionCategoryCountsResponse> {
        let url_ = this.baseUrl + "/FormDefinition/list/category-counts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCategoryCounts(_response);
        });
    }

    protected processListCategoryCounts(response: AxiosResponse): Promise<FormDefinitionCategoryCountsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionCategoryCountsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionCategoryCountsResponse>(null as any);
    }

    listNavigation( cancelToken?: CancelToken): Promise<FormDefinitionNavigationResponse[]> {
        let url_ = this.baseUrl + "/FormDefinition/list/navigation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListNavigation(_response);
        });
    }

    protected processListNavigation(response: AxiosResponse): Promise<FormDefinitionNavigationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionNavigationResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionNavigationResponse[]>(null as any);
    }

    getOfflineBundle( cancelToken?: CancelToken): Promise<FormDefinitionOfflineBundleResponse> {
        let url_ = this.baseUrl + "/FormDefinition/offline-bundle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfflineBundle(_response);
        });
    }

    protected processGetOfflineBundle(response: AxiosResponse): Promise<FormDefinitionOfflineBundleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionOfflineBundleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionOfflineBundleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FormDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFlattened(id: number, flattenSubform: boolean, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition/{id}/flatten/{flattenSubform}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (flattenSubform === undefined || flattenSubform === null)
            throw new Error("The parameter 'flattenSubform' must be defined.");
        url_ = url_.replace("{flattenSubform}", encodeURIComponent("" + flattenSubform));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlattened(_response);
        });
    }

    protected processGetFlattened(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    getVersion(id: number, version: number, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition/{id}/{version}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    getFlattenedVersion(id: number, version: number, flattenSubform: boolean, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition/{id}/{version}/flatten/{flattenSubform}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (flattenSubform === undefined || flattenSubform === null)
            throw new Error("The parameter 'flattenSubform' must be defined.");
        url_ = url_.replace("{flattenSubform}", encodeURIComponent("" + flattenSubform));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlattenedVersion(_response);
        });
    }

    protected processGetFlattenedVersion(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    update(model: FormDefinitionRequest, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    create(model: FormDefinitionRequest, cancelToken?: CancelToken): Promise<FormDefinitionResponse> {
        let url_ = this.baseUrl + "/FormDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionResponse>(null as any);
    }

    getDependencies(id: number, cancelToken?: CancelToken): Promise<FormDefinitionDependenciesResponse> {
        let url_ = this.baseUrl + "/FormDefinition/{id}/dependencies";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDependencies(_response);
        });
    }

    protected processGetDependencies(response: AxiosResponse): Promise<FormDefinitionDependenciesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FormDefinitionDependenciesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormDefinitionDependenciesResponse>(null as any);
    }
}

export interface IGlobalAssistantControlCenterApiClient {
    overview(): Promise<AssistantUsageOverviewResponse>;
    usageSeries(days: number | undefined, instanceId: number | null | undefined): Promise<AssistantUsageSeriesRowResponse[]>;
    users(days: number | undefined, instanceId: number | null | undefined): Promise<AssistantUserUsageResponse[]>;
    listConversations(request: AssistantConversationListRequest): Promise<GetListResponseOfAssistantConversationSummaryResponse>;
    transcript(id: number): Promise<AssistantConversationTranscriptResponse>;
    listFeedback(request: AssistantFeedbackListRequest): Promise<AssistantFeedbackListResponse>;
    exportFeedback(request: AssistantFeedbackFilterRequest): Promise<FileResponse | null>;
}

export class GlobalAssistantControlCenterApiClient implements IGlobalAssistantControlCenterApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    overview( cancelToken?: CancelToken): Promise<AssistantUsageOverviewResponse> {
        let url_ = this.baseUrl + "/global/assistant/control-center/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverview(_response);
        });
    }

    protected processOverview(response: AxiosResponse): Promise<AssistantUsageOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUsageOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUsageOverviewResponse>(null as any);
    }

    usageSeries(days: number | undefined, instanceId: number | null | undefined, cancelToken?: CancelToken): Promise<AssistantUsageSeriesRowResponse[]> {
        let url_ = this.baseUrl + "/global/assistant/control-center/usage-series?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (instanceId !== undefined && instanceId !== null)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsageSeries(_response);
        });
    }

    protected processUsageSeries(response: AxiosResponse): Promise<AssistantUsageSeriesRowResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUsageSeriesRowResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUsageSeriesRowResponse[]>(null as any);
    }

    users(days: number | undefined, instanceId: number | null | undefined, cancelToken?: CancelToken): Promise<AssistantUserUsageResponse[]> {
        let url_ = this.baseUrl + "/global/assistant/control-center/users?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (instanceId !== undefined && instanceId !== null)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: AxiosResponse): Promise<AssistantUserUsageResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantUserUsageResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantUserUsageResponse[]>(null as any);
    }

    listConversations(request: AssistantConversationListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfAssistantConversationSummaryResponse> {
        let url_ = this.baseUrl + "/global/assistant/control-center/conversations/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListConversations(_response);
        });
    }

    protected processListConversations(response: AxiosResponse): Promise<GetListResponseOfAssistantConversationSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfAssistantConversationSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfAssistantConversationSummaryResponse>(null as any);
    }

    transcript(id: number, cancelToken?: CancelToken): Promise<AssistantConversationTranscriptResponse> {
        let url_ = this.baseUrl + "/global/assistant/control-center/conversations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscript(_response);
        });
    }

    protected processTranscript(response: AxiosResponse): Promise<AssistantConversationTranscriptResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantConversationTranscriptResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantConversationTranscriptResponse>(null as any);
    }

    listFeedback(request: AssistantFeedbackListRequest, cancelToken?: CancelToken): Promise<AssistantFeedbackListResponse> {
        let url_ = this.baseUrl + "/global/assistant/control-center/feedback/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFeedback(_response);
        });
    }

    protected processListFeedback(response: AxiosResponse): Promise<AssistantFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AssistantFeedbackListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantFeedbackListResponse>(null as any);
    }

    exportFeedback(request: AssistantFeedbackFilterRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/global/assistant/control-center/feedback/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportFeedback(_response);
        });
    }

    protected processExportFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IHealthcheckApiClient {
    healthCheck(): Promise<FileResponse | null>;
    heartbeat(): Promise<FileResponse | null>;
    testBackgroundJob(): Promise<string>;
    testEmailNotification(model: TestEmailNotificationModel): Promise<FileResponse | null>;
    testEmailNotificationPlaintext(model: TestEmailNotificationModel): Promise<FileResponse | null>;
}

export class HealthcheckApiClient implements IHealthcheckApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    healthCheck( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Healthcheck/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    heartbeat( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Healthcheck/heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHeartbeat(_response);
        });
    }

    protected processHeartbeat(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    testBackgroundJob( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Healthcheck/enqueue-background-job";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestBackgroundJob(_response);
        });
    }

    protected processTestBackgroundJob(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    testEmailNotification(model: TestEmailNotificationModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Healthcheck/test-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEmailNotification(_response);
        });
    }

    protected processTestEmailNotification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    testEmailNotificationPlaintext(model: TestEmailNotificationModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Healthcheck/test-email/plaintext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEmailNotificationPlaintext(_response);
        });
    }

    protected processTestEmailNotificationPlaintext(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IInspectionApiClient {
    create(model: InspectionRequest): Promise<InspectionResponse>;
    update(model: InspectionRequest): Promise<InspectionResponse>;
    listV2(request: GetInspectionListRequestV2): Promise<GetInspectionListResponse>;
    get(id: number): Promise<InspectionResponse>;
    delete(id: number): Promise<boolean>;
    assign(id: number, request: InspectionAssignRequest): Promise<InspectionResponse>;
    unassign(id: number): Promise<InspectionResponse>;
    getAssigneeCandidates(): Promise<InspectionAssigneeCandidateResponse[]>;
    transition(id: number, request: InspectionTransitionRequest): Promise<InspectionResponse>;
    getStateMachine(): Promise<IStateMachineOfInspectionStateEnum>;
    getDevices(id: number): Promise<InspectionScopeDeviceResponse[]>;
    addCustomDevice(id: number, request: DeviceRequest): Promise<InspectionDeviceEntryResponse>;
    getOfflineBundle(id: number): Promise<InspectionOfflineBundleResponse>;
    getDeviceEntry(id: number, deviceId: number): Promise<InspectionDeviceEntryResponse>;
    recordDevice(id: number, deviceId: number, request: InspectionDeviceRecordRequest): Promise<InspectionDeviceEntryResponse>;
    addDeviceAttachment(id: number, deviceId: number, request: InspectionDeviceAttachmentRequest): Promise<AttachmentResponse>;
    getDeviceHistory(deviceId: number): Promise<InspectionDeviceHistoryEntryResponse[]>;
    getInspectionDeficiencies(id: number, inspectionId: number | null | undefined, statuses: DeficiencyStatusEnum[] | null | undefined, start: number | undefined, length: number | undefined): Promise<GetListResponseOfDeficiencyResponse>;
    getDeficiencies(inspectionId: number | null | undefined, statuses: DeficiencyStatusEnum[] | null | undefined, start: number | undefined, length: number | undefined): Promise<GetListResponseOfDeficiencyResponse>;
    getLetterDraft(id: number): Promise<ComplianceLetterDraftResponse>;
    generateLetter(id: number, request: ComplianceLetterGenerateRequest, timeZone: string | null | undefined): Promise<FileResponse | null>;
    generateForm(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    resolveDeficiency(id: number, request: DeficiencyResolveRequest): Promise<DeficiencyResponse>;
}

export class InspectionApiClient implements IInspectionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: InspectionRequest, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    update(model: InspectionRequest, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    listV2(request: GetInspectionListRequestV2, cancelToken?: CancelToken): Promise<GetInspectionListResponse> {
        let url_ = this.baseUrl + "/inspection/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetInspectionListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetInspectionListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInspectionListResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/inspection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    assign(id: number, request: InspectionAssignRequest, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/assign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssign(_response);
        });
    }

    protected processAssign(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    unassign(id: number, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/assign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassign(_response);
        });
    }

    protected processUnassign(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    getAssigneeCandidates( cancelToken?: CancelToken): Promise<InspectionAssigneeCandidateResponse[]> {
        let url_ = this.baseUrl + "/inspection/assignee-candidates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssigneeCandidates(_response);
        });
    }

    protected processGetAssigneeCandidates(response: AxiosResponse): Promise<InspectionAssigneeCandidateResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionAssigneeCandidateResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionAssigneeCandidateResponse[]>(null as any);
    }

    transition(id: number, request: InspectionTransitionRequest, cancelToken?: CancelToken): Promise<InspectionResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<InspectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfInspectionStateEnum> {
        let url_ = this.baseUrl + "/inspection/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfInspectionStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfInspectionStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfInspectionStateEnum>(null as any);
    }

    getDevices(id: number, cancelToken?: CancelToken): Promise<InspectionScopeDeviceResponse[]> {
        let url_ = this.baseUrl + "/inspection/{id}/devices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: AxiosResponse): Promise<InspectionScopeDeviceResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScopeDeviceResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScopeDeviceResponse[]>(null as any);
    }

    addCustomDevice(id: number, request: DeviceRequest, cancelToken?: CancelToken): Promise<InspectionDeviceEntryResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/devices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCustomDevice(_response);
        });
    }

    protected processAddCustomDevice(response: AxiosResponse): Promise<InspectionDeviceEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionDeviceEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDeviceEntryResponse>(null as any);
    }

    getOfflineBundle(id: number, cancelToken?: CancelToken): Promise<InspectionOfflineBundleResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/offline-bundle";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfflineBundle(_response);
        });
    }

    protected processGetOfflineBundle(response: AxiosResponse): Promise<InspectionOfflineBundleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionOfflineBundleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionOfflineBundleResponse>(null as any);
    }

    getDeviceEntry(id: number, deviceId: number, cancelToken?: CancelToken): Promise<InspectionDeviceEntryResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/devices/{deviceId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceEntry(_response);
        });
    }

    protected processGetDeviceEntry(response: AxiosResponse): Promise<InspectionDeviceEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionDeviceEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDeviceEntryResponse>(null as any);
    }

    recordDevice(id: number, deviceId: number, request: InspectionDeviceRecordRequest, cancelToken?: CancelToken): Promise<InspectionDeviceEntryResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/devices/{deviceId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordDevice(_response);
        });
    }

    protected processRecordDevice(response: AxiosResponse): Promise<InspectionDeviceEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionDeviceEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDeviceEntryResponse>(null as any);
    }

    addDeviceAttachment(id: number, deviceId: number, request: InspectionDeviceAttachmentRequest, cancelToken?: CancelToken): Promise<AttachmentResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/devices/{deviceId}/attachments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeviceAttachment(_response);
        });
    }

    protected processAddDeviceAttachment(response: AxiosResponse): Promise<AttachmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AttachmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentResponse>(null as any);
    }

    getDeviceHistory(deviceId: number, cancelToken?: CancelToken): Promise<InspectionDeviceHistoryEntryResponse[]> {
        let url_ = this.baseUrl + "/inspection/device/{deviceId}/history";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceHistory(_response);
        });
    }

    protected processGetDeviceHistory(response: AxiosResponse): Promise<InspectionDeviceHistoryEntryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionDeviceHistoryEntryResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDeviceHistoryEntryResponse[]>(null as any);
    }

    getInspectionDeficiencies(id: number, inspectionId: number | null | undefined, statuses: DeficiencyStatusEnum[] | null | undefined, start: number | undefined, length: number | undefined, cancelToken?: CancelToken): Promise<GetListResponseOfDeficiencyResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/deficiencies?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (inspectionId !== undefined && inspectionId !== null)
            url_ += "InspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "Length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInspectionDeficiencies(_response);
        });
    }

    protected processGetInspectionDeficiencies(response: AxiosResponse): Promise<GetListResponseOfDeficiencyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDeficiencyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDeficiencyResponse>(null as any);
    }

    getDeficiencies(inspectionId: number | null | undefined, statuses: DeficiencyStatusEnum[] | null | undefined, start: number | undefined, length: number | undefined, cancelToken?: CancelToken): Promise<GetListResponseOfDeficiencyResponse> {
        let url_ = this.baseUrl + "/inspection/deficiencies?";
        if (inspectionId !== undefined && inspectionId !== null)
            url_ += "InspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "Length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeficiencies(_response);
        });
    }

    protected processGetDeficiencies(response: AxiosResponse): Promise<GetListResponseOfDeficiencyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfDeficiencyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfDeficiencyResponse>(null as any);
    }

    getLetterDraft(id: number, cancelToken?: CancelToken): Promise<ComplianceLetterDraftResponse> {
        let url_ = this.baseUrl + "/inspection/{id}/documents/letter-draft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLetterDraft(_response);
        });
    }

    protected processGetLetterDraft(response: AxiosResponse): Promise<ComplianceLetterDraftResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ComplianceLetterDraftResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplianceLetterDraftResponse>(null as any);
    }

    generateLetter(id: number, request: ComplianceLetterGenerateRequest, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/inspection/{id}/documents/letter?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateLetter(_response);
        });
    }

    protected processGenerateLetter(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    generateForm(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/inspection/{id}/documents/form?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateForm(_response);
        });
    }

    protected processGenerateForm(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    resolveDeficiency(id: number, request: DeficiencyResolveRequest, cancelToken?: CancelToken): Promise<DeficiencyResponse> {
        let url_ = this.baseUrl + "/inspection/deficiencies/{id}/resolve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveDeficiency(_response);
        });
    }

    protected processResolveDeficiency(response: AxiosResponse): Promise<DeficiencyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeficiencyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeficiencyResponse>(null as any);
    }
}

export interface IInspectionDispatchApiClient {
    getBoard(request: InspectionDispatchBoardRequest): Promise<InspectionDispatchBoardResponse>;
    commit(request: InspectionDispatchCommitRequest): Promise<FileResponse | null>;
}

export class InspectionDispatchApiClient implements IInspectionDispatchApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getBoard(request: InspectionDispatchBoardRequest, cancelToken?: CancelToken): Promise<InspectionDispatchBoardResponse> {
        let url_ = this.baseUrl + "/inspection/dispatch/board";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoard(_response);
        });
    }

    protected processGetBoard(response: AxiosResponse): Promise<InspectionDispatchBoardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionDispatchBoardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionDispatchBoardResponse>(null as any);
    }

    commit(request: InspectionDispatchCommitRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/inspection/dispatch/commit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommit(_response);
        });
    }

    protected processCommit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IInspectionScheduleApiClient {
    listV2(request: GetInspectionScheduleListRequestV2): Promise<GetListResponseOfInspectionScheduleResponse>;
    listBySite(siteId: number): Promise<InspectionScheduleResponse[]>;
    get(id: number): Promise<InspectionScheduleResponse>;
    delete(id: number): Promise<boolean>;
    create(model: InspectionScheduleRequest): Promise<InspectionScheduleResponse>;
    update(model: InspectionScheduleRequest): Promise<InspectionScheduleResponse>;
    setActive(id: number, active: boolean): Promise<InspectionScheduleResponse>;
    bulkSetActive(request: BulkSetInspectionScheduleActiveRequest): Promise<number>;
}

export class InspectionScheduleApiClient implements IInspectionScheduleApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetInspectionScheduleListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfInspectionScheduleResponse> {
        let url_ = this.baseUrl + "/inspection-schedule/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfInspectionScheduleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfInspectionScheduleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfInspectionScheduleResponse>(null as any);
    }

    listBySite(siteId: number, cancelToken?: CancelToken): Promise<InspectionScheduleResponse[]> {
        let url_ = this.baseUrl + "/inspection-schedule/site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListBySite(_response);
        });
    }

    protected processListBySite(response: AxiosResponse): Promise<InspectionScheduleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScheduleResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScheduleResponse[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<InspectionScheduleResponse> {
        let url_ = this.baseUrl + "/inspection-schedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<InspectionScheduleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScheduleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScheduleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/inspection-schedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(model: InspectionScheduleRequest, cancelToken?: CancelToken): Promise<InspectionScheduleResponse> {
        let url_ = this.baseUrl + "/inspection-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InspectionScheduleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScheduleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScheduleResponse>(null as any);
    }

    update(model: InspectionScheduleRequest, cancelToken?: CancelToken): Promise<InspectionScheduleResponse> {
        let url_ = this.baseUrl + "/inspection-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<InspectionScheduleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScheduleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScheduleResponse>(null as any);
    }

    setActive(id: number, active: boolean, cancelToken?: CancelToken): Promise<InspectionScheduleResponse> {
        let url_ = this.baseUrl + "/inspection-schedule/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActive(_response);
        });
    }

    protected processSetActive(response: AxiosResponse): Promise<InspectionScheduleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionScheduleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionScheduleResponse>(null as any);
    }

    bulkSetActive(request: BulkSetInspectionScheduleActiveRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/inspection-schedule/bulk/active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkSetActive(_response);
        });
    }

    protected processBulkSetActive(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IInspectionTypeApiClient {
    create(model: InspectionTypeRequest): Promise<InspectionTypeResponse>;
    update(model: InspectionTypeRequest): Promise<InspectionTypeResponse>;
    listV2(request: GetListRequestV2): Promise<GetListResponseOfInspectionTypeSimpleResponse>;
    listSelectOptions(request: GetListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<InspectionTypeResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<InspectionTypeResponse>;
    getEquipmentTypes(id: number): Promise<InspectionTypeEquipmentTypeResponse[]>;
}

export class InspectionTypeApiClient implements IInspectionTypeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: InspectionTypeRequest, cancelToken?: CancelToken): Promise<InspectionTypeResponse> {
        let url_ = this.baseUrl + "/inspection-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InspectionTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionTypeResponse>(null as any);
    }

    update(model: InspectionTypeRequest, cancelToken?: CancelToken): Promise<InspectionTypeResponse> {
        let url_ = this.baseUrl + "/inspection-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<InspectionTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionTypeResponse>(null as any);
    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfInspectionTypeSimpleResponse> {
        let url_ = this.baseUrl + "/inspection-type/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfInspectionTypeSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfInspectionTypeSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfInspectionTypeSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/inspection-type/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<InspectionTypeResponse> {
        let url_ = this.baseUrl + "/inspection-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<InspectionTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionTypeResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/inspection-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<InspectionTypeResponse> {
        let url_ = this.baseUrl + "/inspection-type/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<InspectionTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionTypeResponse>(null as any);
    }

    getEquipmentTypes(id: number, cancelToken?: CancelToken): Promise<InspectionTypeEquipmentTypeResponse[]> {
        let url_ = this.baseUrl + "/inspection-type/{id}/equipment-types";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEquipmentTypes(_response);
        });
    }

    protected processGetEquipmentTypes(response: AxiosResponse): Promise<InspectionTypeEquipmentTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InspectionTypeEquipmentTypeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionTypeEquipmentTypeResponse[]>(null as any);
    }
}

export interface IInstanceComplianceStandardApiClient {
    listComplianceStandard(request: GetInstanceComplianceStandardsListRequest): Promise<GetListResponseOfComplianceStandardResponse>;
    listComplianceStandardV2(request: GetInstanceComplianceStandardsListRequestV2): Promise<GetListResponseOfComplianceStandardResponse>;
    listComplianceStandardTree(request: GetInstanceComplianceStandardsListRequestV2): Promise<TreeResponse[]>;
    listSelectOptions(request: GetInstanceComplianceStandardsListRequest): Promise<GetListResponseOfSelectOption>;
    listSimpleComplianceStandard(request: GetInstanceComplianceStandardsListRequest): Promise<GetListResponseOfSimpleInclusiveListResponse>;
    bulkActivateComplianceStandard(request: BulkActivateInstanceComplianceStandardsRequest): Promise<number>;
    getComplianceStandard(id: number): Promise<InstanceComplianceStandardResponse>;
    createComplianceStandard(request: InstanceComplianceStandardRequest): Promise<InstanceComplianceStandardResponse>;
    updateComplianceStandard(request: InstanceComplianceStandardRequest): Promise<InstanceComplianceStandardResponse>;
}

export class InstanceComplianceStandardApiClient implements IInstanceComplianceStandardApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listComplianceStandard(request: GetInstanceComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListComplianceStandard(_response);
        });
    }

    protected processListComplianceStandard(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listComplianceStandardV2(request: GetInstanceComplianceStandardsListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceStandardResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListComplianceStandardV2(_response);
        });
    }

    protected processListComplianceStandardV2(response: AxiosResponse): Promise<GetListResponseOfComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceStandardResponse>(null as any);
    }

    listComplianceStandardTree(request: GetInstanceComplianceStandardsListRequestV2, cancelToken?: CancelToken): Promise<TreeResponse[]> {
        let url_ = this.baseUrl + "/instance-compliance-standard/list/tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListComplianceStandardTree(_response);
        });
    }

    protected processListComplianceStandardTree(response: AxiosResponse): Promise<TreeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TreeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TreeResponse[]>(null as any);
    }

    listSelectOptions(request: GetInstanceComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/instance-compliance-standard/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    listSimpleComplianceStandard(request: GetInstanceComplianceStandardsListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSimpleInclusiveListResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard/list/simple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSimpleComplianceStandard(_response);
        });
    }

    protected processListSimpleComplianceStandard(response: AxiosResponse): Promise<GetListResponseOfSimpleInclusiveListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSimpleInclusiveListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSimpleInclusiveListResponse>(null as any);
    }

    bulkActivateComplianceStandard(request: BulkActivateInstanceComplianceStandardsRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/instance-compliance-standard/bulk-activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkActivateComplianceStandard(_response);
        });
    }

    protected processBulkActivateComplianceStandard(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getComplianceStandard(id: number, cancelToken?: CancelToken): Promise<InstanceComplianceStandardResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplianceStandard(_response);
        });
    }

    protected processGetComplianceStandard(response: AxiosResponse): Promise<InstanceComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceComplianceStandardResponse>(null as any);
    }

    createComplianceStandard(request: InstanceComplianceStandardRequest, cancelToken?: CancelToken): Promise<InstanceComplianceStandardResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComplianceStandard(_response);
        });
    }

    protected processCreateComplianceStandard(response: AxiosResponse): Promise<InstanceComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceComplianceStandardResponse>(null as any);
    }

    updateComplianceStandard(request: InstanceComplianceStandardRequest, cancelToken?: CancelToken): Promise<InstanceComplianceStandardResponse> {
        let url_ = this.baseUrl + "/instance-compliance-standard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComplianceStandard(_response);
        });
    }

    protected processUpdateComplianceStandard(response: AxiosResponse): Promise<InstanceComplianceStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceComplianceStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceComplianceStandardResponse>(null as any);
    }
}

export interface IInstanceApiClient {
    list(request: GetInstanceListRequest): Promise<GetListResponseOfInstanceResponse>;
    listV2(request: GetInstanceListV2Request): Promise<GetListResponseOfInstanceResponse>;
    get(instanceId: number): Promise<InstanceResponse>;
    update(model: InstanceRequest): Promise<InstanceResponse>;
    create(model: InstanceRequest): Promise<InstanceResponse>;
    delete(model: InstanceDeleteRequest): Promise<FileResponse | null>;
    clone(model: InstanceCloneRequest): Promise<string>;
}

export class InstanceApiClient implements IInstanceApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetInstanceListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfInstanceResponse> {
        let url_ = this.baseUrl + "/Instance/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfInstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfInstanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfInstanceResponse>(null as any);
    }

    listV2(request: GetInstanceListV2Request, cancelToken?: CancelToken): Promise<GetListResponseOfInstanceResponse> {
        let url_ = this.baseUrl + "/Instance/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfInstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfInstanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfInstanceResponse>(null as any);
    }

    get(instanceId: number, cancelToken?: CancelToken): Promise<InstanceResponse> {
        let url_ = this.baseUrl + "/Instance/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<InstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceResponse>(null as any);
    }

    update(model: InstanceRequest, cancelToken?: CancelToken): Promise<InstanceResponse> {
        let url_ = this.baseUrl + "/Instance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<InstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceResponse>(null as any);
    }

    create(model: InstanceRequest, cancelToken?: CancelToken): Promise<InstanceResponse> {
        let url_ = this.baseUrl + "/Instance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<InstanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceResponse>(null as any);
    }

    delete(model: InstanceDeleteRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Instance/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    clone(model: InstanceCloneRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Instance/clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IInstanceSsoApiClient {
    getSsoProvider(instanceId: number): Promise<InstanceSsoProviderResponse>;
    deleteSsoProvider(instanceId: number): Promise<FileResponse | null>;
    createSsoProvider(request: InstanceSsoProviderRequest): Promise<InstanceSsoProviderResponse>;
    updateSsoProvider(request: InstanceSsoProviderRequest): Promise<InstanceSsoProviderResponse>;
    adoptSsoProvider(instanceId: number): Promise<InstanceSsoProviderResponse>;
}

export class InstanceSsoApiClient implements IInstanceSsoApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSsoProvider(instanceId: number, cancelToken?: CancelToken): Promise<InstanceSsoProviderResponse> {
        let url_ = this.baseUrl + "/instance/sso/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSsoProvider(_response);
        });
    }

    protected processGetSsoProvider(response: AxiosResponse): Promise<InstanceSsoProviderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSsoProviderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSsoProviderResponse>(null as any);
    }

    deleteSsoProvider(instanceId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/instance/sso/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSsoProvider(_response);
        });
    }

    protected processDeleteSsoProvider(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createSsoProvider(request: InstanceSsoProviderRequest, cancelToken?: CancelToken): Promise<InstanceSsoProviderResponse> {
        let url_ = this.baseUrl + "/instance/sso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSsoProvider(_response);
        });
    }

    protected processCreateSsoProvider(response: AxiosResponse): Promise<InstanceSsoProviderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSsoProviderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSsoProviderResponse>(null as any);
    }

    updateSsoProvider(request: InstanceSsoProviderRequest, cancelToken?: CancelToken): Promise<InstanceSsoProviderResponse> {
        let url_ = this.baseUrl + "/instance/sso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSsoProvider(_response);
        });
    }

    protected processUpdateSsoProvider(response: AxiosResponse): Promise<InstanceSsoProviderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSsoProviderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSsoProviderResponse>(null as any);
    }

    adoptSsoProvider(instanceId: number, cancelToken?: CancelToken): Promise<InstanceSsoProviderResponse> {
        let url_ = this.baseUrl + "/instance/sso/{instanceId}/adopt";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdoptSsoProvider(_response);
        });
    }

    protected processAdoptSsoProvider(response: AxiosResponse): Promise<InstanceSsoProviderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSsoProviderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSsoProviderResponse>(null as any);
    }
}

export interface IIntegrationInspectionsApiClient {
    listInspections(assigneeEmail: string | null | undefined, completedSince: Date | null | undefined): Promise<IntegrationInspectionListResponse>;
}

export class IntegrationInspectionsApiClient implements IIntegrationInspectionsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listInspections(assigneeEmail: string | null | undefined, completedSince: Date | null | undefined, cancelToken?: CancelToken): Promise<IntegrationInspectionListResponse> {
        let url_ = this.baseUrl + "/integration/v1/inspections?";
        if (assigneeEmail !== undefined && assigneeEmail !== null)
            url_ += "assigneeEmail=" + encodeURIComponent("" + assigneeEmail) + "&";
        if (completedSince !== undefined && completedSince !== null)
            url_ += "completedSince=" + encodeURIComponent(completedSince ? "" + completedSince.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListInspections(_response);
        });
    }

    protected processListInspections(response: AxiosResponse): Promise<IntegrationInspectionListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IntegrationInspectionListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationInspectionListResponse>(null as any);
    }
}

export interface IIntegrationTokenAdminApiClient {
    listTokens(instanceId: number | undefined): Promise<IntegrationTokenResponse[]>;
    createToken(request: IntegrationTokenCreateRequest): Promise<IntegrationTokenCreateResponse>;
    getToken(id: number, instanceId: number | undefined): Promise<IntegrationTokenResponse>;
    revokeToken(id: number, instanceId: number | undefined): Promise<FileResponse | null>;
}

export class IntegrationTokenAdminApiClient implements IIntegrationTokenAdminApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listTokens(instanceId: number | undefined, cancelToken?: CancelToken): Promise<IntegrationTokenResponse[]> {
        let url_ = this.baseUrl + "/integration/admin/tokens?";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTokens(_response);
        });
    }

    protected processListTokens(response: AxiosResponse): Promise<IntegrationTokenResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IntegrationTokenResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationTokenResponse[]>(null as any);
    }

    createToken(request: IntegrationTokenCreateRequest, cancelToken?: CancelToken): Promise<IntegrationTokenCreateResponse> {
        let url_ = this.baseUrl + "/integration/admin/tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateToken(_response);
        });
    }

    protected processCreateToken(response: AxiosResponse): Promise<IntegrationTokenCreateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IntegrationTokenCreateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationTokenCreateResponse>(null as any);
    }

    getToken(id: number, instanceId: number | undefined, cancelToken?: CancelToken): Promise<IntegrationTokenResponse> {
        let url_ = this.baseUrl + "/integration/admin/tokens/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToken(_response);
        });
    }

    protected processGetToken(response: AxiosResponse): Promise<IntegrationTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IntegrationTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationTokenResponse>(null as any);
    }

    revokeToken(id: number, instanceId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/integration/admin/tokens/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeToken(_response);
        });
    }

    protected processRevokeToken(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IItemAssignmentApiClient {
    list(request: GetItemAssignmentListRequest): Promise<GetListResponseOfItemAssignmentSimpleResponse>;
    listV2(request: GetItemAssignmentListRequestV2): Promise<GetListResponseOfItemAssignmentSimpleResponse>;
    processEmployeeRequestForItems(model: ProcessEmployeeRequestForItemsRequest): Promise<ProcessEmployeeRequestForItemsResponse>;
    create(model: ItemAssignmentRequest): Promise<ItemAssignmentResponse>;
    update(model: ItemAssignmentRequest): Promise<ItemAssignmentResponse>;
    delete(id: number): Promise<boolean>;
    get(id: number): Promise<ItemAssignmentResponse>;
    transitionAssignment(id: number, request: TransitionRequest): Promise<ItemAssignmentResponse>;
    getIssuanceCertificatePdf(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    getAssignmentStateMachine(): Promise<IStateMachineOfItemAssignmentStateEnum>;
    downloadZfGlassesVoucher(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
    downloadZfBootsVoucher(id: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
}

export class ItemAssignmentApiClient implements IItemAssignmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetItemAssignmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfItemAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/item-assignment/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfItemAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfItemAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfItemAssignmentSimpleResponse>(null as any);
    }

    listV2(request: GetItemAssignmentListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfItemAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/item-assignment/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfItemAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfItemAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfItemAssignmentSimpleResponse>(null as any);
    }

    processEmployeeRequestForItems(model: ProcessEmployeeRequestForItemsRequest, cancelToken?: CancelToken): Promise<ProcessEmployeeRequestForItemsResponse> {
        let url_ = this.baseUrl + "/item-assignment/employee-request-for-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessEmployeeRequestForItems(_response);
        });
    }

    protected processProcessEmployeeRequestForItems(response: AxiosResponse): Promise<ProcessEmployeeRequestForItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessEmployeeRequestForItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessEmployeeRequestForItemsResponse>(null as any);
    }

    create(model: ItemAssignmentRequest, cancelToken?: CancelToken): Promise<ItemAssignmentResponse> {
        let url_ = this.baseUrl + "/item-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ItemAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemAssignmentResponse>(null as any);
    }

    update(model: ItemAssignmentRequest, cancelToken?: CancelToken): Promise<ItemAssignmentResponse> {
        let url_ = this.baseUrl + "/item-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ItemAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemAssignmentResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/item-assignment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ItemAssignmentResponse> {
        let url_ = this.baseUrl + "/item-assignment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ItemAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemAssignmentResponse>(null as any);
    }

    transitionAssignment(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<ItemAssignmentResponse> {
        let url_ = this.baseUrl + "/item-assignment/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransitionAssignment(_response);
        });
    }

    protected processTransitionAssignment(response: AxiosResponse): Promise<ItemAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemAssignmentResponse>(null as any);
    }

    getIssuanceCertificatePdf(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/item-assignment/{id}/certificate/pdf?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssuanceCertificatePdf(_response);
        });
    }

    protected processGetIssuanceCertificatePdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAssignmentStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfItemAssignmentStateEnum> {
        let url_ = this.baseUrl + "/item-assignment/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignmentStateMachine(_response);
        });
    }

    protected processGetAssignmentStateMachine(response: AxiosResponse): Promise<IStateMachineOfItemAssignmentStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfItemAssignmentStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfItemAssignmentStateEnum>(null as any);
    }

    downloadZfGlassesVoucher(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/item-assignment/{id}/zf-glasses/voucher?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadZfGlassesVoucher(_response);
        });
    }

    protected processDownloadZfGlassesVoucher(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    downloadZfBootsVoucher(id: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/item-assignment/{id}/zf-boots/voucher?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadZfBootsVoucher(_response);
        });
    }

    protected processDownloadZfBootsVoucher(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IItemDefinitionApiClient {
    list(request: GetItemDefinitionListRequest): Promise<GetListResponseOfItemDefinitionSimpleResponse>;
    listV2(request: GetItemDefinitionListRequestV2): Promise<GetListResponseOfItemDefinitionSimpleResponse>;
    listSelectOptions(request: GetItemDefinitionListRequest): Promise<GetListResponseOfSelectOption>;
    create(model: ItemDefinitionRequest): Promise<ItemDefinitionResponse>;
    update(model: ItemDefinitionRequest): Promise<ItemDefinitionResponse>;
    delete(id: number): Promise<boolean>;
    details(id: number): Promise<ItemDefinitionResponse>;
    exportItemStatusReport(request: ExportItemStatusReportRequest): Promise<FileResponse | null>;
}

export class ItemDefinitionApiClient implements IItemDefinitionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetItemDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfItemDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/item-definition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfItemDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfItemDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfItemDefinitionSimpleResponse>(null as any);
    }

    listV2(request: GetItemDefinitionListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfItemDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/item-definition/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfItemDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfItemDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfItemDefinitionSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetItemDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/item-definition/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    create(model: ItemDefinitionRequest, cancelToken?: CancelToken): Promise<ItemDefinitionResponse> {
        let url_ = this.baseUrl + "/item-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ItemDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDefinitionResponse>(null as any);
    }

    update(model: ItemDefinitionRequest, cancelToken?: CancelToken): Promise<ItemDefinitionResponse> {
        let url_ = this.baseUrl + "/item-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ItemDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDefinitionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/item-definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    details(id: number, cancelToken?: CancelToken): Promise<ItemDefinitionResponse> {
        let url_ = this.baseUrl + "/item-definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<ItemDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDefinitionResponse>(null as any);
    }

    exportItemStatusReport(request: ExportItemStatusReportRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/item-definition/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportItemStatusReport(_response);
        });
    }

    protected processExportItemStatusReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IJobApiClient {
    processSchedules(): Promise<FileResponse | null>;
    hangfireOverview(): Promise<HangfireOverviewResponse>;
    hangfireServers(): Promise<HangfireServerResponse[]>;
    hangfireJobs(state: HangfireJobState | undefined, page: number | undefined, size: number | undefined, queue: string | null | undefined): Promise<GetListResponseOfHangfireJobSummary>;
    hangfireJobDetail(id: string): Promise<HangfireJobDetailResponse>;
    hangfireRecurring(): Promise<HangfireRecurringJobResponse[]>;
    hangfireRequeue(id: string): Promise<FileResponse | null>;
    hangfireDelete(id: string): Promise<FileResponse | null>;
    hangfireTrigger(id: string): Promise<FileResponse | null>;
}

export class JobApiClient implements IJobApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    processSchedules( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Job/process/scheduled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessSchedules(_response);
        });
    }

    protected processProcessSchedules(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    hangfireOverview( cancelToken?: CancelToken): Promise<HangfireOverviewResponse> {
        let url_ = this.baseUrl + "/Job/hangfire/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireOverview(_response);
        });
    }

    protected processHangfireOverview(response: AxiosResponse): Promise<HangfireOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HangfireOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HangfireOverviewResponse>(null as any);
    }

    hangfireServers( cancelToken?: CancelToken): Promise<HangfireServerResponse[]> {
        let url_ = this.baseUrl + "/Job/hangfire/servers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireServers(_response);
        });
    }

    protected processHangfireServers(response: AxiosResponse): Promise<HangfireServerResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HangfireServerResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HangfireServerResponse[]>(null as any);
    }

    hangfireJobs(state: HangfireJobState | undefined, page: number | undefined, size: number | undefined, queue: string | null | undefined, cancelToken?: CancelToken): Promise<GetListResponseOfHangfireJobSummary> {
        let url_ = this.baseUrl + "/Job/hangfire/jobs?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (queue !== undefined && queue !== null)
            url_ += "Queue=" + encodeURIComponent("" + queue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireJobs(_response);
        });
    }

    protected processHangfireJobs(response: AxiosResponse): Promise<GetListResponseOfHangfireJobSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfHangfireJobSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfHangfireJobSummary>(null as any);
    }

    hangfireJobDetail(id: string, cancelToken?: CancelToken): Promise<HangfireJobDetailResponse> {
        let url_ = this.baseUrl + "/Job/hangfire/jobs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireJobDetail(_response);
        });
    }

    protected processHangfireJobDetail(response: AxiosResponse): Promise<HangfireJobDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HangfireJobDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HangfireJobDetailResponse>(null as any);
    }

    hangfireRecurring( cancelToken?: CancelToken): Promise<HangfireRecurringJobResponse[]> {
        let url_ = this.baseUrl + "/Job/hangfire/recurring";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireRecurring(_response);
        });
    }

    protected processHangfireRecurring(response: AxiosResponse): Promise<HangfireRecurringJobResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HangfireRecurringJobResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HangfireRecurringJobResponse[]>(null as any);
    }

    hangfireRequeue(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Job/hangfire/jobs/{id}/requeue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireRequeue(_response);
        });
    }

    protected processHangfireRequeue(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    hangfireDelete(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Job/hangfire/jobs/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireDelete(_response);
        });
    }

    protected processHangfireDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    hangfireTrigger(id: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Job/hangfire/recurring/{id}/trigger";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHangfireTrigger(_response);
        });
    }

    protected processHangfireTrigger(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IJobHazardAnalysisApiClient {
    create(model: JobHazardAnalysisRequest): Promise<JobHazardAnalysisResponse>;
    update(model: JobHazardAnalysisRequest): Promise<JobHazardAnalysisResponse>;
    getList(request: GetJobHazardAnalysisListRequest): Promise<GetListResponseOfJobHazardAnalysisSimpleResponse>;
    delete(id: number): Promise<FileResponse | null>;
    get(id: number): Promise<JobHazardAnalysisResponse>;
    transition(id: number, request: TransitionRequest): Promise<JobHazardAnalysisResponse>;
    getStateMachine(): Promise<IStateMachineOfJobHazardAnalysisStateEnum>;
}

export class JobHazardAnalysisApiClient implements IJobHazardAnalysisApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: JobHazardAnalysisRequest, cancelToken?: CancelToken): Promise<JobHazardAnalysisResponse> {
        let url_ = this.baseUrl + "/job-hazard-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<JobHazardAnalysisResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobHazardAnalysisResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobHazardAnalysisResponse>(null as any);
    }

    update(model: JobHazardAnalysisRequest, cancelToken?: CancelToken): Promise<JobHazardAnalysisResponse> {
        let url_ = this.baseUrl + "/job-hazard-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<JobHazardAnalysisResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobHazardAnalysisResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobHazardAnalysisResponse>(null as any);
    }

    getList(request: GetJobHazardAnalysisListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfJobHazardAnalysisSimpleResponse> {
        let url_ = this.baseUrl + "/job-hazard-analysis/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<GetListResponseOfJobHazardAnalysisSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfJobHazardAnalysisSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfJobHazardAnalysisSimpleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/job-hazard-analysis/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<JobHazardAnalysisResponse> {
        let url_ = this.baseUrl + "/job-hazard-analysis/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<JobHazardAnalysisResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobHazardAnalysisResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobHazardAnalysisResponse>(null as any);
    }

    transition(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<JobHazardAnalysisResponse> {
        let url_ = this.baseUrl + "/job-hazard-analysis/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<JobHazardAnalysisResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JobHazardAnalysisResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobHazardAnalysisResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfJobHazardAnalysisStateEnum> {
        let url_ = this.baseUrl + "/job-hazard-analysis/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfJobHazardAnalysisStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfJobHazardAnalysisStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfJobHazardAnalysisStateEnum>(null as any);
    }
}

export interface IKnowledgeBaseApiClient {
    listV2(request: GetKnowledgeArticleListRequestV2): Promise<GetListResponseOfKnowledgeArticleSimpleResponse>;
    get(id: number): Promise<KnowledgeArticleResponse>;
    delete(id: number): Promise<FileResponse | null>;
    create(model: KnowledgeArticleRequest): Promise<KnowledgeArticleResponse>;
    update(model: KnowledgeArticleRequest): Promise<KnowledgeArticleResponse>;
}

export class KnowledgeBaseApiClient implements IKnowledgeBaseApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetKnowledgeArticleListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfKnowledgeArticleSimpleResponse> {
        let url_ = this.baseUrl + "/knowledge-base/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfKnowledgeArticleSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfKnowledgeArticleSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfKnowledgeArticleSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<KnowledgeArticleResponse> {
        let url_ = this.baseUrl + "/knowledge-base/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<KnowledgeArticleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/knowledge-base/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(model: KnowledgeArticleRequest, cancelToken?: CancelToken): Promise<KnowledgeArticleResponse> {
        let url_ = this.baseUrl + "/knowledge-base";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<KnowledgeArticleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleResponse>(null as any);
    }

    update(model: KnowledgeArticleRequest, cancelToken?: CancelToken): Promise<KnowledgeArticleResponse> {
        let url_ = this.baseUrl + "/knowledge-base";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<KnowledgeArticleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<KnowledgeArticleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeArticleResponse>(null as any);
    }
}

export interface ILockApiClient {
    isLocked(id: number, type: EntityIdentifierEnum): Promise<boolean>;
}

export class LockApiClient implements ILockApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isLocked(id: number, type: EntityIdentifierEnum, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/lock/{id}/{type}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsLocked(_response);
        });
    }

    protected processIsLocked(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IModuleExtensionApiClient {
    getSettings(): Promise<InstanceSettingsResponse>;
    updateSettings(model: InstanceSettingsRequest): Promise<InstanceSettingsResponse>;
    createFormTab(model: ModuleExtensionFormTabRequest): Promise<ModuleExtensionFormTabResponse>;
    updateFormTab(model: ModuleExtensionFormTabRequest): Promise<ModuleExtensionFormTabResponse>;
    deleteFormTab(id: number): Promise<FileResponse | null>;
    getFormTab(id: number): Promise<ModuleExtensionFormTabResponse>;
    listFormTabs(request: GetModuleExtensionFormTabListRequest): Promise<GetListResponseOfModuleExtensionFormTabResponse>;
    getActiveExtensions(): Promise<ModuleExtensionActiveResponse>;
    getFormTabSubmissions(request: ExtensionFormTabSubmissionsRequest): Promise<GetListResponseOfExtensionFormTabSubmissionResponse>;
}

export class ModuleExtensionApiClient implements IModuleExtensionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSettings( cancelToken?: CancelToken): Promise<InstanceSettingsResponse> {
        let url_ = this.baseUrl + "/module-extension/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<InstanceSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSettingsResponse>(null as any);
    }

    updateSettings(model: InstanceSettingsRequest, cancelToken?: CancelToken): Promise<InstanceSettingsResponse> {
        let url_ = this.baseUrl + "/module-extension/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSettings(_response);
        });
    }

    protected processUpdateSettings(response: AxiosResponse): Promise<InstanceSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSettingsResponse>(null as any);
    }

    createFormTab(model: ModuleExtensionFormTabRequest, cancelToken?: CancelToken): Promise<ModuleExtensionFormTabResponse> {
        let url_ = this.baseUrl + "/module-extension/form-tab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFormTab(_response);
        });
    }

    protected processCreateFormTab(response: AxiosResponse): Promise<ModuleExtensionFormTabResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ModuleExtensionFormTabResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExtensionFormTabResponse>(null as any);
    }

    updateFormTab(model: ModuleExtensionFormTabRequest, cancelToken?: CancelToken): Promise<ModuleExtensionFormTabResponse> {
        let url_ = this.baseUrl + "/module-extension/form-tab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFormTab(_response);
        });
    }

    protected processUpdateFormTab(response: AxiosResponse): Promise<ModuleExtensionFormTabResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ModuleExtensionFormTabResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExtensionFormTabResponse>(null as any);
    }

    deleteFormTab(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/module-extension/form-tab/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFormTab(_response);
        });
    }

    protected processDeleteFormTab(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFormTab(id: number, cancelToken?: CancelToken): Promise<ModuleExtensionFormTabResponse> {
        let url_ = this.baseUrl + "/module-extension/form-tab/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormTab(_response);
        });
    }

    protected processGetFormTab(response: AxiosResponse): Promise<ModuleExtensionFormTabResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ModuleExtensionFormTabResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExtensionFormTabResponse>(null as any);
    }

    listFormTabs(request: GetModuleExtensionFormTabListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfModuleExtensionFormTabResponse> {
        let url_ = this.baseUrl + "/module-extension/form-tab/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFormTabs(_response);
        });
    }

    protected processListFormTabs(response: AxiosResponse): Promise<GetListResponseOfModuleExtensionFormTabResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfModuleExtensionFormTabResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfModuleExtensionFormTabResponse>(null as any);
    }

    getActiveExtensions( cancelToken?: CancelToken): Promise<ModuleExtensionActiveResponse> {
        let url_ = this.baseUrl + "/module-extension/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveExtensions(_response);
        });
    }

    protected processGetActiveExtensions(response: AxiosResponse): Promise<ModuleExtensionActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ModuleExtensionActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExtensionActiveResponse>(null as any);
    }

    getFormTabSubmissions(request: ExtensionFormTabSubmissionsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfExtensionFormTabSubmissionResponse> {
        let url_ = this.baseUrl + "/module-extension/form-tab/submissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormTabSubmissions(_response);
        });
    }

    protected processGetFormTabSubmissions(response: AxiosResponse): Promise<GetListResponseOfExtensionFormTabSubmissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfExtensionFormTabSubmissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfExtensionFormTabSubmissionResponse>(null as any);
    }
}

export interface INoteApiClient {
    list(request: GetNoteListRequest): Promise<GetListResponseOfNoteSimpleResponse>;
    get(id: number, entityId: number): Promise<NoteResponse>;
    delete(id: number, entityId: number): Promise<FileResponse | null>;
    create(model: NoteRequest): Promise<boolean>;
    update(model: NoteRequest): Promise<boolean>;
}

export class NoteApiClient implements INoteApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetNoteListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfNoteSimpleResponse> {
        let url_ = this.baseUrl + "/Note/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfNoteSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNoteSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNoteSimpleResponse>(null as any);
    }

    get(id: number, entityId: number, cancelToken?: CancelToken): Promise<NoteResponse> {
        let url_ = this.baseUrl + "/Note/{id}/{entityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NoteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NoteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteResponse>(null as any);
    }

    delete(id: number, entityId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Note/{id}/{entityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(model: NoteRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(model: NoteRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface INotificationApiClient {
    list(request: GetNotificationListRequest): Promise<GetListResponseOfNotificationSimpleResponse>;
    get(id: number, entityId: number): Promise<NotificationResponse>;
}

export class NotificationApiClient implements INotificationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetNotificationListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfNotificationSimpleResponse> {
        let url_ = this.baseUrl + "/Notification/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfNotificationSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNotificationSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNotificationSimpleResponse>(null as any);
    }

    get(id: number, entityId: number, cancelToken?: CancelToken): Promise<NotificationResponse> {
        let url_ = this.baseUrl + "/Notification/{id}/{entityId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NotificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationResponse>(null as any);
    }
}

export interface INotificationRecipientApiClient {
    list(request: GetNotificationRecipientListRequest): Promise<GetListResponseOfNotificationRecipientSimpleResponse>;
    get(id: number): Promise<NotificationRecipientResponse>;
}

export class NotificationRecipientApiClient implements INotificationRecipientApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetNotificationRecipientListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfNotificationRecipientSimpleResponse> {
        let url_ = this.baseUrl + "/NotificationRecipient/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfNotificationRecipientSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNotificationRecipientSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNotificationRecipientSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<NotificationRecipientResponse> {
        let url_ = this.baseUrl + "/NotificationRecipient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NotificationRecipientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationRecipientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRecipientResponse>(null as any);
    }
}

export interface INotificationRuleApiClient {
    create(model: NotificationRuleRequest): Promise<NotificationRuleResponse>;
    update(model: NotificationRuleRequest): Promise<NotificationRuleResponse>;
    list(request: GetNotificationRuleListRequest): Promise<GetListResponseOfNotificationRuleSimpleResponse>;
    listV2(request: GetNotificationRuleListRequestV2): Promise<GetListResponseOfNotificationRuleSimpleResponse>;
    get(id: number): Promise<NotificationRuleResponse>;
    delete(id: number): Promise<FileResponse | null>;
    getNotificationVariables(request: GetNotificationVariablesRequest): Promise<GetNotificationVariablesResponse>;
}

export class NotificationRuleApiClient implements INotificationRuleApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: NotificationRuleRequest, cancelToken?: CancelToken): Promise<NotificationRuleResponse> {
        let url_ = this.baseUrl + "/notification-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<NotificationRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRuleResponse>(null as any);
    }

    update(model: NotificationRuleRequest, cancelToken?: CancelToken): Promise<NotificationRuleResponse> {
        let url_ = this.baseUrl + "/notification-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<NotificationRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRuleResponse>(null as any);
    }

    list(request: GetNotificationRuleListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfNotificationRuleSimpleResponse> {
        let url_ = this.baseUrl + "/notification-rule/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfNotificationRuleSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNotificationRuleSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNotificationRuleSimpleResponse>(null as any);
    }

    listV2(request: GetNotificationRuleListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfNotificationRuleSimpleResponse> {
        let url_ = this.baseUrl + "/notification-rule/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfNotificationRuleSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNotificationRuleSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNotificationRuleSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<NotificationRuleResponse> {
        let url_ = this.baseUrl + "/notification-rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NotificationRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NotificationRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRuleResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/notification-rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getNotificationVariables(request: GetNotificationVariablesRequest, cancelToken?: CancelToken): Promise<GetNotificationVariablesResponse> {
        let url_ = this.baseUrl + "/notification-rule/variables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationVariables(_response);
        });
    }

    protected processGetNotificationVariables(response: AxiosResponse): Promise<GetNotificationVariablesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetNotificationVariablesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNotificationVariablesResponse>(null as any);
    }
}

export interface IOshaApiClient {
    getSummary(projectId: number, year: number): Promise<OshaSummaryResponse>;
    getEstablishmentInformation(projectId: number): Promise<OshaEstablishmentInformationResponse>;
    getEmploymentInformation(projectId: number, year: number): Promise<OshaEmploymentInformationResponse>;
    updateEmploymentInformation(model: OshaEmploymentInformationRequest): Promise<OshaEmploymentInformationResponse>;
    getPdf(projectId: number, year: number, timeZone: string | null | undefined): Promise<FileResponse | null>;
}

export class OshaApiClient implements IOshaApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSummary(projectId: number, year: number, cancelToken?: CancelToken): Promise<OshaSummaryResponse> {
        let url_ = this.baseUrl + "/osha/projects/{projectId}/summary/{year}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<OshaSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OshaSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OshaSummaryResponse>(null as any);
    }

    getEstablishmentInformation(projectId: number, cancelToken?: CancelToken): Promise<OshaEstablishmentInformationResponse> {
        let url_ = this.baseUrl + "/osha/projects/{projectId}/establishment-information";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEstablishmentInformation(_response);
        });
    }

    protected processGetEstablishmentInformation(response: AxiosResponse): Promise<OshaEstablishmentInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OshaEstablishmentInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OshaEstablishmentInformationResponse>(null as any);
    }

    getEmploymentInformation(projectId: number, year: number, cancelToken?: CancelToken): Promise<OshaEmploymentInformationResponse> {
        let url_ = this.baseUrl + "/osha/projects/{projectId}/employment-information/{year}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmploymentInformation(_response);
        });
    }

    protected processGetEmploymentInformation(response: AxiosResponse): Promise<OshaEmploymentInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OshaEmploymentInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OshaEmploymentInformationResponse>(null as any);
    }

    updateEmploymentInformation(model: OshaEmploymentInformationRequest, cancelToken?: CancelToken): Promise<OshaEmploymentInformationResponse> {
        let url_ = this.baseUrl + "/osha/employment-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmploymentInformation(_response);
        });
    }

    protected processUpdateEmploymentInformation(response: AxiosResponse): Promise<OshaEmploymentInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OshaEmploymentInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OshaEmploymentInformationResponse>(null as any);
    }

    getPdf(projectId: number, year: number, timeZone: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/osha/projects/{projectId}/pdf/{year}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IPersonnelApiClient {
    getPermissions(id: number): Promise<PersonnelPermissionResponse>;
    details(id: number): Promise<PersonnelResponse>;
    update(id: number, model: PersonnelRequest): Promise<PersonnelResponse>;
    delete(id: number): Promise<boolean>;
    list(request: GetPersonnelListRequest): Promise<GetListResponseOfPersonnelSimpleResponse>;
    listV2(request: GetPersonnelListRequestV2): Promise<GetListResponseOfPersonnelSimpleResponse>;
    listSelectOptions(request: GetPersonnelSelectOptionsRequest): Promise<GetListResponseOfSelectOption>;
    create(model: PersonnelRequest): Promise<PersonnelResponse>;
    syncCognitoUser(id: number): Promise<boolean>;
    resolveEmailMismatch(id: number): Promise<PersonnelResponse>;
    disableMfa(id: number): Promise<boolean>;
    convertUserType(id: number, model: ConvertUserTypeRequest): Promise<PersonnelResponse>;
    extendBadgeExpiration(id: number, model: ExtendBadgeExpirationRequest): Promise<PersonnelResponse>;
    setBadgeExpiration(id: number, model: SetBadgeExpirationRequest): Promise<PersonnelResponse>;
    generateBadge(id: number, model: GenerateBadgeRequest): Promise<PersonnelBadgeResponse>;
    getBadgeHistory(id: number): Promise<PersonnelBadgeSimpleResponse[]>;
    getBadge(id: number, badgeId: number): Promise<PersonnelBadgeDetailResponse>;
    activateUser(id: number): Promise<PersonnelResponse>;
    bulkActivateUser(request: BulkActivateUserRequest): Promise<boolean>;
    lockUser(id: number): Promise<PersonnelResponse>;
    deactivateUser(id: number): Promise<PersonnelResponse>;
    getSesSuppressionStatus(id: number): Promise<SesSuppressionResponse>;
    removeSesSuppression(id: number): Promise<boolean>;
    enableNotificationEmails(id: number): Promise<PersonnelResponse>;
    disableNotificationEmails(id: number): Promise<PersonnelResponse>;
    getImportTemplate(): Promise<FileResponse | null>;
    getImportColumns(): Promise<PersonnelImportColumnResponse[]>;
    previewImport(request: PersonnelImportPreviewRequest): Promise<PersonnelImportPreviewResponse>;
    import(request: PersonnelImportRequest): Promise<string>;
    export(request: GetPersonnelListRequestV2): Promise<FileResponse | null>;
}

export class PersonnelApiClient implements IPersonnelApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPermissions(id: number, cancelToken?: CancelToken): Promise<PersonnelPermissionResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PersonnelPermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelPermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelPermissionResponse>(null as any);
    }

    details(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    update(id: number, model: PersonnelRequest, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Personnel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    list(request: GetPersonnelListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfPersonnelSimpleResponse> {
        let url_ = this.baseUrl + "/Personnel/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfPersonnelSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(null as any);
    }

    listV2(request: GetPersonnelListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfPersonnelSimpleResponse> {
        let url_ = this.baseUrl + "/Personnel/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfPersonnelSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetPersonnelSelectOptionsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/Personnel/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    create(model: PersonnelRequest, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    syncCognitoUser(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Personnel/{id}/sync-cognito";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCognitoUser(_response);
        });
    }

    protected processSyncCognitoUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    resolveEmailMismatch(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/resolve-email-mismatch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveEmailMismatch(_response);
        });
    }

    protected processResolveEmailMismatch(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    disableMfa(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Personnel/{id}/disable-mfa";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableMfa(_response);
        });
    }

    protected processDisableMfa(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    convertUserType(id: number, model: ConvertUserTypeRequest, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/convert-type";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConvertUserType(_response);
        });
    }

    protected processConvertUserType(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    extendBadgeExpiration(id: number, model: ExtendBadgeExpirationRequest, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/badge-expiration/extend";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtendBadgeExpiration(_response);
        });
    }

    protected processExtendBadgeExpiration(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    setBadgeExpiration(id: number, model: SetBadgeExpirationRequest, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/badge-expiration";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBadgeExpiration(_response);
        });
    }

    protected processSetBadgeExpiration(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    generateBadge(id: number, model: GenerateBadgeRequest, cancelToken?: CancelToken): Promise<PersonnelBadgeResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/badges";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateBadge(_response);
        });
    }

    protected processGenerateBadge(response: AxiosResponse): Promise<PersonnelBadgeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelBadgeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelBadgeResponse>(null as any);
    }

    getBadgeHistory(id: number, cancelToken?: CancelToken): Promise<PersonnelBadgeSimpleResponse[]> {
        let url_ = this.baseUrl + "/Personnel/{id}/badges";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBadgeHistory(_response);
        });
    }

    protected processGetBadgeHistory(response: AxiosResponse): Promise<PersonnelBadgeSimpleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelBadgeSimpleResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelBadgeSimpleResponse[]>(null as any);
    }

    getBadge(id: number, badgeId: number, cancelToken?: CancelToken): Promise<PersonnelBadgeDetailResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/badges/{badgeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (badgeId === undefined || badgeId === null)
            throw new Error("The parameter 'badgeId' must be defined.");
        url_ = url_.replace("{badgeId}", encodeURIComponent("" + badgeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBadge(_response);
        });
    }

    protected processGetBadge(response: AxiosResponse): Promise<PersonnelBadgeDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelBadgeDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelBadgeDetailResponse>(null as any);
    }

    activateUser(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    bulkActivateUser(request: BulkActivateUserRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Personnel/bulk/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkActivateUser(_response);
        });
    }

    protected processBulkActivateUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    lockUser(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/lock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLockUser(_response);
        });
    }

    protected processLockUser(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    deactivateUser(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    getSesSuppressionStatus(id: number, cancelToken?: CancelToken): Promise<SesSuppressionResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/ses-suppression";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSesSuppressionStatus(_response);
        });
    }

    protected processGetSesSuppressionStatus(response: AxiosResponse): Promise<SesSuppressionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SesSuppressionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SesSuppressionResponse>(null as any);
    }

    removeSesSuppression(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Personnel/{id}/ses-suppression";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSesSuppression(_response);
        });
    }

    protected processRemoveSesSuppression(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    enableNotificationEmails(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/notification-emails/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableNotificationEmails(_response);
        });
    }

    protected processEnableNotificationEmails(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    disableNotificationEmails(id: number, cancelToken?: CancelToken): Promise<PersonnelResponse> {
        let url_ = this.baseUrl + "/Personnel/{id}/notification-emails/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableNotificationEmails(_response);
        });
    }

    protected processDisableNotificationEmails(response: AxiosResponse): Promise<PersonnelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelResponse>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Personnel/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getImportColumns( cancelToken?: CancelToken): Promise<PersonnelImportColumnResponse[]> {
        let url_ = this.baseUrl + "/Personnel/import/columns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportColumns(_response);
        });
    }

    protected processGetImportColumns(response: AxiosResponse): Promise<PersonnelImportColumnResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelImportColumnResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelImportColumnResponse[]>(null as any);
    }

    previewImport(request: PersonnelImportPreviewRequest, cancelToken?: CancelToken): Promise<PersonnelImportPreviewResponse> {
        let url_ = this.baseUrl + "/Personnel/import/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewImport(_response);
        });
    }

    protected processPreviewImport(response: AxiosResponse): Promise<PersonnelImportPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PersonnelImportPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelImportPreviewResponse>(null as any);
    }

    import(request: PersonnelImportRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Personnel/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    export(request: GetPersonnelListRequestV2, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Personnel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IProjectApiClient {
    create(model: ProjectRequest): Promise<ProjectResponse>;
    update(model: ProjectRequest): Promise<ProjectResponse>;
    list(request: GetProjectListRequest): Promise<GetListResponseOfProjectSimpleResponse>;
    listV2(request: GetProjectListRequestV2): Promise<GetListResponseOfProjectSimpleResponse>;
    listSelectOptions(request: GetProjectListRequest): Promise<GetListResponseOfSelectOption>;
    getScopeOptions(): Promise<SelectOption[]>;
    get(id: number): Promise<ProjectResponse>;
    delete(id: number): Promise<FileResponse | null>;
    listRules(projectId: number): Promise<ProjectAssignmentRuleResponse[]>;
    listAssignments(projectId: number): Promise<ProjectAssignmentResponse[]>;
    getRosterList(projectId: number, request: GetListRequestV2): Promise<GetListResponseOfProjectRosterRowResponse>;
    getRule(id: number): Promise<ProjectAssignmentRuleResponse>;
    deleteRule(id: number): Promise<FileResponse | null>;
    createRule(request: ProjectAssignmentRuleCreateRequest): Promise<ProjectAssignmentRuleResponse>;
    updateRule(request: ProjectAssignmentRuleUpdateRequest): Promise<ProjectAssignmentRuleResponse>;
    previewRule(request: ProjectAssignmentRulePreviewRequest): Promise<ProjectAssignmentRulePreviewResponse>;
    listExceptions(ruleId: number): Promise<ProjectAssignmentRuleExceptionResponse[]>;
    addException(request: ProjectAssignmentRuleExceptionCreateRequest): Promise<ProjectAssignmentRuleExceptionResponse>;
    removeException(id: number): Promise<FileResponse | null>;
}

export class ProjectApiClient implements IProjectApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: ProjectRequest, cancelToken?: CancelToken): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    update(model: ProjectRequest, cancelToken?: CancelToken): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    list(request: GetProjectListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfProjectSimpleResponse> {
        let url_ = this.baseUrl + "/project/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfProjectSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfProjectSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfProjectSimpleResponse>(null as any);
    }

    listV2(request: GetProjectListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfProjectSimpleResponse> {
        let url_ = this.baseUrl + "/project/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfProjectSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfProjectSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfProjectSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetProjectListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/project/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    getScopeOptions( cancelToken?: CancelToken): Promise<SelectOption[]> {
        let url_ = this.baseUrl + "/project/scope-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScopeOptions(_response);
        });
    }

    protected processGetScopeOptions(response: AxiosResponse): Promise<SelectOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SelectOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectOption[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listRules(projectId: number, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleResponse[]> {
        let url_ = this.baseUrl + "/project/{projectId}/rules";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRules(_response);
        });
    }

    protected processListRules(response: AxiosResponse): Promise<ProjectAssignmentRuleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleResponse[]>(null as any);
    }

    listAssignments(projectId: number, cancelToken?: CancelToken): Promise<ProjectAssignmentResponse[]> {
        let url_ = this.baseUrl + "/project/{projectId}/assignments";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAssignments(_response);
        });
    }

    protected processListAssignments(response: AxiosResponse): Promise<ProjectAssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentResponse[]>(null as any);
    }

    getRosterList(projectId: number, request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfProjectRosterRowResponse> {
        let url_ = this.baseUrl + "/project/{projectId}/roster/list";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRosterList(_response);
        });
    }

    protected processGetRosterList(response: AxiosResponse): Promise<GetListResponseOfProjectRosterRowResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfProjectRosterRowResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfProjectRosterRowResponse>(null as any);
    }

    getRule(id: number, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/project/rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRule(_response);
        });
    }

    protected processGetRule(response: AxiosResponse): Promise<ProjectAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleResponse>(null as any);
    }

    deleteRule(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/project/rule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRule(_response);
        });
    }

    protected processDeleteRule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createRule(request: ProjectAssignmentRuleCreateRequest, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/project/rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRule(_response);
        });
    }

    protected processCreateRule(response: AxiosResponse): Promise<ProjectAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleResponse>(null as any);
    }

    updateRule(request: ProjectAssignmentRuleUpdateRequest, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleResponse> {
        let url_ = this.baseUrl + "/project/rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRule(_response);
        });
    }

    protected processUpdateRule(response: AxiosResponse): Promise<ProjectAssignmentRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleResponse>(null as any);
    }

    previewRule(request: ProjectAssignmentRulePreviewRequest, cancelToken?: CancelToken): Promise<ProjectAssignmentRulePreviewResponse> {
        let url_ = this.baseUrl + "/project/rule/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewRule(_response);
        });
    }

    protected processPreviewRule(response: AxiosResponse): Promise<ProjectAssignmentRulePreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRulePreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRulePreviewResponse>(null as any);
    }

    listExceptions(ruleId: number, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleExceptionResponse[]> {
        let url_ = this.baseUrl + "/project/rule/{ruleId}/exceptions";
        if (ruleId === undefined || ruleId === null)
            throw new Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListExceptions(_response);
        });
    }

    protected processListExceptions(response: AxiosResponse): Promise<ProjectAssignmentRuleExceptionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleExceptionResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleExceptionResponse[]>(null as any);
    }

    addException(request: ProjectAssignmentRuleExceptionCreateRequest, cancelToken?: CancelToken): Promise<ProjectAssignmentRuleExceptionResponse> {
        let url_ = this.baseUrl + "/project/rule/exception";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddException(_response);
        });
    }

    protected processAddException(response: AxiosResponse): Promise<ProjectAssignmentRuleExceptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProjectAssignmentRuleExceptionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssignmentRuleExceptionResponse>(null as any);
    }

    removeException(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/project/rule/exception/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveException(_response);
        });
    }

    protected processRemoveException(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IRegionApiClient {
    create(model: RegionRequest): Promise<RegionResponse>;
    update(model: RegionRequest): Promise<RegionResponse>;
    listV2(request: GetRegionListRequestV2): Promise<GetListResponseOfRegionSimpleResponse>;
    listSelectOptions(request: GetRegionListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<RegionResponse>;
    delete(id: number): Promise<boolean>;
}

export class RegionApiClient implements IRegionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: RegionRequest, cancelToken?: CancelToken): Promise<RegionResponse> {
        let url_ = this.baseUrl + "/region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RegionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionResponse>(null as any);
    }

    update(model: RegionRequest, cancelToken?: CancelToken): Promise<RegionResponse> {
        let url_ = this.baseUrl + "/region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RegionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionResponse>(null as any);
    }

    listV2(request: GetRegionListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfRegionSimpleResponse> {
        let url_ = this.baseUrl + "/region/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfRegionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfRegionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfRegionSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetRegionListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/region/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<RegionResponse> {
        let url_ = this.baseUrl + "/region/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RegionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RegionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/region/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IReportApiClient {
    listReports(request: GetListReportRequest): Promise<GetListResponseOfReportSimpleResponse>;
    getEmbeddedUrl(id: string): Promise<string>;
}

export class ReportApiClient implements IReportApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listReports(request: GetListReportRequest, cancelToken?: CancelToken): Promise<GetListResponseOfReportSimpleResponse> {
        let url_ = this.baseUrl + "/report/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReports(_response);
        });
    }

    protected processListReports(response: AxiosResponse): Promise<GetListResponseOfReportSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfReportSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfReportSimpleResponse>(null as any);
    }

    getEmbeddedUrl(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/report/url/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmbeddedUrl(_response);
        });
    }

    protected processGetEmbeddedUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IReportingComplianceApiClient {
    getFindingsReport(request: GetFindingsReportListRequest): Promise<GetListResponseOfGetReportResponse>;
    getFindingsReportV2(request: GetFindingsReportListRequestV2): Promise<GetListResponseOfGetReportResponse>;
    getFindingsDetailReport(request: GetFindingsDetailReportListRequest): Promise<GetListResponseOfComplianceEventFlattenedResponse>;
    getCommunicationReport(request: GetCommunicationReportListRequest): Promise<GetListResponseOfGetReportResponse>;
    getCommunicationDetailReport(request: GetCommunicationDetailReportListRequest): Promise<GetListResponseOfCommunicationReportEventFlattenedResponse>;
    getPlanReport(request: GetPlanReportListRequest): Promise<GetListResponseOfGetReportResponse>;
    getPlanDetailReport(request: GetPlanDetailReportListRequest): Promise<GetListResponseOfPlanReportEventFlattenedResponse>;
}

export class ReportingComplianceApiClient implements IReportingComplianceApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFindingsReport(request: GetFindingsReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfGetReportResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/findings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFindingsReport(_response);
        });
    }

    protected processGetFindingsReport(response: AxiosResponse): Promise<GetListResponseOfGetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfGetReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfGetReportResponse>(null as any);
    }

    getFindingsReportV2(request: GetFindingsReportListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfGetReportResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/findings/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFindingsReportV2(_response);
        });
    }

    protected processGetFindingsReportV2(response: AxiosResponse): Promise<GetListResponseOfGetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfGetReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfGetReportResponse>(null as any);
    }

    getFindingsDetailReport(request: GetFindingsDetailReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfComplianceEventFlattenedResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/findings/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFindingsDetailReport(_response);
        });
    }

    protected processGetFindingsDetailReport(response: AxiosResponse): Promise<GetListResponseOfComplianceEventFlattenedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfComplianceEventFlattenedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfComplianceEventFlattenedResponse>(null as any);
    }

    getCommunicationReport(request: GetCommunicationReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfGetReportResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/communication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationReport(_response);
        });
    }

    protected processGetCommunicationReport(response: AxiosResponse): Promise<GetListResponseOfGetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfGetReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfGetReportResponse>(null as any);
    }

    getCommunicationDetailReport(request: GetCommunicationDetailReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfCommunicationReportEventFlattenedResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/communication/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationDetailReport(_response);
        });
    }

    protected processGetCommunicationDetailReport(response: AxiosResponse): Promise<GetListResponseOfCommunicationReportEventFlattenedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfCommunicationReportEventFlattenedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfCommunicationReportEventFlattenedResponse>(null as any);
    }

    getPlanReport(request: GetPlanReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfGetReportResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlanReport(_response);
        });
    }

    protected processGetPlanReport(response: AxiosResponse): Promise<GetListResponseOfGetReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfGetReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfGetReportResponse>(null as any);
    }

    getPlanDetailReport(request: GetPlanDetailReportListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfPlanReportEventFlattenedResponse> {
        let url_ = this.baseUrl + "/reporting/compliance/plan/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlanDetailReport(_response);
        });
    }

    protected processGetPlanDetailReport(response: AxiosResponse): Promise<GetListResponseOfPlanReportEventFlattenedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfPlanReportEventFlattenedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfPlanReportEventFlattenedResponse>(null as any);
    }
}

export interface IReportingTaskApiClient {
    getDepartmentTaskParticipation(request: TaskParticipationRequest): Promise<TaskParticipationResponse[]>;
}

export class ReportingTaskApiClient implements IReportingTaskApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDepartmentTaskParticipation(request: TaskParticipationRequest, cancelToken?: CancelToken): Promise<TaskParticipationResponse[]> {
        let url_ = this.baseUrl + "/reporting/task/department-task-participation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDepartmentTaskParticipation(_response);
        });
    }

    protected processGetDepartmentTaskParticipation(response: AxiosResponse): Promise<TaskParticipationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskParticipationResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskParticipationResponse[]>(null as any);
    }
}

export interface IReportInstanceApiClient {
    list(request: GetReportInstanceMembershipListRequest): Promise<GetListResponseOfReportInstanceMembershipResponse>;
    listPotentialReports(request: GetListPossibleReportOptionsRequest): Promise<GetListResponseOfSelectOption>;
    mergeMemberships(request: MergeMembershipsRequest): Promise<GetListResponseOfBoolean>;
    create(model: ReportInstanceMembershipRequest): Promise<ReportInstanceMembershipResponse>;
    get(id: number): Promise<ReportInstanceMembershipResponse>;
    delete(id: number): Promise<FileResponse | null>;
}

export class ReportInstanceApiClient implements IReportInstanceApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetReportInstanceMembershipListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfReportInstanceMembershipResponse> {
        let url_ = this.baseUrl + "/report-instance/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfReportInstanceMembershipResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfReportInstanceMembershipResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfReportInstanceMembershipResponse>(null as any);
    }

    listPotentialReports(request: GetListPossibleReportOptionsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/report-instance/list/options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPotentialReports(_response);
        });
    }

    protected processListPotentialReports(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    mergeMemberships(request: MergeMembershipsRequest, cancelToken?: CancelToken): Promise<GetListResponseOfBoolean> {
        let url_ = this.baseUrl + "/report-instance/merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMergeMemberships(_response);
        });
    }

    protected processMergeMemberships(response: AxiosResponse): Promise<GetListResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfBoolean>(null as any);
    }

    create(model: ReportInstanceMembershipRequest, cancelToken?: CancelToken): Promise<ReportInstanceMembershipResponse> {
        let url_ = this.baseUrl + "/report-instance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ReportInstanceMembershipResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ReportInstanceMembershipResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportInstanceMembershipResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ReportInstanceMembershipResponse> {
        let url_ = this.baseUrl + "/report-instance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ReportInstanceMembershipResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ReportInstanceMembershipResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportInstanceMembershipResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/report-instance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IRiskAssessmentCodeApiClient {
    create(model: RiskAssessmentCodeRequest): Promise<RiskAssessmentCodeResponse>;
    update(model: RiskAssessmentCodeRequest): Promise<RiskAssessmentCodeResponse>;
    listV2(request: GetListRequestV2): Promise<GetListResponseOfRiskAssessmentCodeResponse>;
    get(id: number): Promise<RiskAssessmentCodeResponse>;
    delete(id: number): Promise<FileResponse | null>;
    getByArea(id: RiskAssessmentCodeAreaEnum): Promise<RiskAssessmentCodeResponse>;
}

export class RiskAssessmentCodeApiClient implements IRiskAssessmentCodeApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: RiskAssessmentCodeRequest, cancelToken?: CancelToken): Promise<RiskAssessmentCodeResponse> {
        let url_ = this.baseUrl + "/risk-assessment-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RiskAssessmentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentCodeResponse>(null as any);
    }

    update(model: RiskAssessmentCodeRequest, cancelToken?: CancelToken): Promise<RiskAssessmentCodeResponse> {
        let url_ = this.baseUrl + "/risk-assessment-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RiskAssessmentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentCodeResponse>(null as any);
    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfRiskAssessmentCodeResponse> {
        let url_ = this.baseUrl + "/risk-assessment-code/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfRiskAssessmentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfRiskAssessmentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfRiskAssessmentCodeResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<RiskAssessmentCodeResponse> {
        let url_ = this.baseUrl + "/risk-assessment-code/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RiskAssessmentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentCodeResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/risk-assessment-code/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getByArea(id: RiskAssessmentCodeAreaEnum, cancelToken?: CancelToken): Promise<RiskAssessmentCodeResponse> {
        let url_ = this.baseUrl + "/risk-assessment-code/area/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByArea(_response);
        });
    }

    protected processGetByArea(response: AxiosResponse): Promise<RiskAssessmentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentCodeResponse>(null as any);
    }
}

export interface ISafetyEventApiClient {
    listV2(request: GetSafetyEventListRequestV2): Promise<GetListResponseOfSafetyEventSimpleResponse>;
    get(id: number): Promise<SafetyEventResponse>;
    delete(id: number): Promise<boolean>;
    update(model: SafetyEventRequest): Promise<SafetyEventResponse>;
    create(model: SafetyEventRequest): Promise<SafetyEventResponse>;
    transition(id: number, request: TransitionRequest): Promise<SafetyEventResponse>;
    getStateMachine(): Promise<IStateMachineOfSafetyEventStateEnum>;
    getFieldValues(): Promise<FieldSet[]>;
    export(request: GetSafetyEventListRequestV2): Promise<FileResponse | null>;
    getEventCounts(request: SafetyEventCountRequest): Promise<SafetyEventCountResponse[]>;
}

export class SafetyEventApiClient implements ISafetyEventApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listV2(request: GetSafetyEventListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSafetyEventSimpleResponse> {
        let url_ = this.baseUrl + "/safety-event/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfSafetyEventSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSafetyEventSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSafetyEventSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<SafetyEventResponse> {
        let url_ = this.baseUrl + "/safety-event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SafetyEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SafetyEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyEventResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/safety-event/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(model: SafetyEventRequest, cancelToken?: CancelToken): Promise<SafetyEventResponse> {
        let url_ = this.baseUrl + "/safety-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SafetyEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SafetyEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyEventResponse>(null as any);
    }

    create(model: SafetyEventRequest, cancelToken?: CancelToken): Promise<SafetyEventResponse> {
        let url_ = this.baseUrl + "/safety-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SafetyEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SafetyEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyEventResponse>(null as any);
    }

    transition(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<SafetyEventResponse> {
        let url_ = this.baseUrl + "/safety-event/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransition(_response);
        });
    }

    protected processTransition(response: AxiosResponse): Promise<SafetyEventResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SafetyEventResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyEventResponse>(null as any);
    }

    getStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfSafetyEventStateEnum> {
        let url_ = this.baseUrl + "/safety-event/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMachine(_response);
        });
    }

    protected processGetStateMachine(response: AxiosResponse): Promise<IStateMachineOfSafetyEventStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfSafetyEventStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfSafetyEventStateEnum>(null as any);
    }

    getFieldValues( cancelToken?: CancelToken): Promise<FieldSet[]> {
        let url_ = this.baseUrl + "/safety-event/field-values";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFieldValues(_response);
        });
    }

    protected processGetFieldValues(response: AxiosResponse): Promise<FieldSet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FieldSet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FieldSet[]>(null as any);
    }

    export(request: GetSafetyEventListRequestV2, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/safety-event/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEventCounts(request: SafetyEventCountRequest, cancelToken?: CancelToken): Promise<SafetyEventCountResponse[]> {
        let url_ = this.baseUrl + "/safety-event/counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventCounts(_response);
        });
    }

    protected processGetEventCounts(response: AxiosResponse): Promise<SafetyEventCountResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SafetyEventCountResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyEventCountResponse[]>(null as any);
    }
}

export interface IScimApiClient {
    createUser(resource: ScimUserResource): Promise<FileResponse | null>;
    listUsers(filter: string | null | undefined, startIndex: number | undefined, count: number | undefined): Promise<FileResponse | null>;
    getUser(id: number): Promise<FileResponse | null>;
    replaceUser(id: number, resource: ScimUserResource): Promise<FileResponse | null>;
    patchUser(id: number, patch: ScimPatchRequest): Promise<FileResponse | null>;
    deleteUser(id: number): Promise<FileResponse | null>;
}

export class ScimApiClient implements IScimApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createUser(resource: ScimUserResource, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resource);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listUsers(filter: string | null | undefined, startIndex: number | undefined, count: number | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (startIndex === null)
            throw new Error("The parameter 'startIndex' cannot be null.");
        else if (startIndex !== undefined)
            url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUsers(_response);
        });
    }

    protected processListUsers(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUser(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    replaceUser(id: number, resource: ScimUserResource, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resource);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceUser(_response);
        });
    }

    protected processReplaceUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    patchUser(id: number, patch: ScimPatchRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchUser(_response);
        });
    }

    protected processPatchUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteUser(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IScimDiscoveryApiClient {
    getServiceProviderConfig(): Promise<FileResponse | null>;
    getResourceTypes(): Promise<FileResponse | null>;
    getSchemas(): Promise<FileResponse | null>;
}

export class ScimDiscoveryApiClient implements IScimDiscoveryApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getServiceProviderConfig( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/ServiceProviderConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceProviderConfig(_response);
        });
    }

    protected processGetServiceProviderConfig(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getResourceTypes( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/ResourceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceTypes(_response);
        });
    }

    protected processGetResourceTypes(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSchemas( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Schemas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchemas(_response);
        });
    }

    protected processGetSchemas(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IScimGroupApiClient {
    createGroup(resource: ScimGroupResource): Promise<FileResponse | null>;
    listGroups(filter: string | null | undefined, excludedAttributes: string | null | undefined, startIndex: number | undefined, count: number | undefined): Promise<FileResponse | null>;
    getGroup(id: number, excludedAttributes: string | null | undefined): Promise<FileResponse | null>;
    replaceGroup(id: number, resource: ScimGroupResource): Promise<FileResponse | null>;
    patchGroup(id: number, patch: ScimPatchRequest): Promise<FileResponse | null>;
    deleteGroup(id: number): Promise<FileResponse | null>;
}

export class ScimGroupApiClient implements IScimGroupApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createGroup(resource: ScimGroupResource, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resource);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listGroups(filter: string | null | undefined, excludedAttributes: string | null | undefined, startIndex: number | undefined, count: number | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (excludedAttributes !== undefined && excludedAttributes !== null)
            url_ += "excludedAttributes=" + encodeURIComponent("" + excludedAttributes) + "&";
        if (startIndex === null)
            throw new Error("The parameter 'startIndex' cannot be null.");
        else if (startIndex !== undefined)
            url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGroups(_response);
        });
    }

    protected processListGroups(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getGroup(id: number, excludedAttributes: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (excludedAttributes !== undefined && excludedAttributes !== null)
            url_ += "excludedAttributes=" + encodeURIComponent("" + excludedAttributes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroup(_response);
        });
    }

    protected processGetGroup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    replaceGroup(id: number, resource: ScimGroupResource, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resource);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceGroup(_response);
        });
    }

    protected processReplaceGroup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    patchGroup(id: number, patch: ScimPatchRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchGroup(_response);
        });
    }

    protected processPatchGroup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteGroup(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/scim/v2/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroup(_response);
        });
    }

    protected processDeleteGroup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ISearchApiClient {
    search(request: GlobalSearchRequest): Promise<GlobalSearchResponse>;
}

export class SearchApiClient implements ISearchApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    search(request: GlobalSearchRequest, cancelToken?: CancelToken): Promise<GlobalSearchResponse> {
        let url_ = this.baseUrl + "/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<GlobalSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GlobalSearchResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GlobalSearchResponse>(null as any);
    }
}

export interface ISiteApiClient {
    create(model: SiteRequest): Promise<SiteResponse>;
    update(model: SiteRequest): Promise<SiteResponse>;
    listV2(request: GetSiteListRequestV2): Promise<GetListResponseOfSiteSimpleResponse>;
    listSelectOptions(request: GetSiteListRequestV2): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<SiteResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<SiteResponse>;
}

export class SiteApiClient implements ISiteApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: SiteRequest, cancelToken?: CancelToken): Promise<SiteResponse> {
        let url_ = this.baseUrl + "/site";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SiteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SiteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteResponse>(null as any);
    }

    update(model: SiteRequest, cancelToken?: CancelToken): Promise<SiteResponse> {
        let url_ = this.baseUrl + "/site";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SiteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SiteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteResponse>(null as any);
    }

    listV2(request: GetSiteListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSiteSimpleResponse> {
        let url_ = this.baseUrl + "/site/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfSiteSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSiteSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSiteSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetSiteListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/site/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<SiteResponse> {
        let url_ = this.baseUrl + "/site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SiteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SiteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<SiteResponse> {
        let url_ = this.baseUrl + "/site/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<SiteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SiteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteResponse>(null as any);
    }
}

export interface ISkillApiClient {
    getList(request: GetListRequest): Promise<GetListResponseOfSkillResponse>;
    get(id: number): Promise<SkillResponse>;
    delete(id: number): Promise<FileResponse | null>;
    create(request: SkillCreateRequest): Promise<SkillResponse>;
    update(request: SkillUpdateRequest): Promise<SkillResponse>;
}

export class SkillApiClient implements ISkillApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getList(request: GetListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSkillResponse> {
        let url_ = this.baseUrl + "/skill/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<GetListResponseOfSkillResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSkillResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSkillResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<SkillResponse> {
        let url_ = this.baseUrl + "/skill/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SkillResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/skill/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(request: SkillCreateRequest, cancelToken?: CancelToken): Promise<SkillResponse> {
        let url_ = this.baseUrl + "/skill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SkillResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillResponse>(null as any);
    }

    update(request: SkillUpdateRequest, cancelToken?: CancelToken): Promise<SkillResponse> {
        let url_ = this.baseUrl + "/skill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SkillResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillResponse>(null as any);
    }
}

export interface ISkillSignOffApiClient {
    getInbox(request: SkillSignOffListRequest): Promise<SkillSignOffPendingResponse[]>;
    getOversight(request: SkillSignOffListRequest): Promise<SkillSignOffPendingResponse[]>;
    get(id: number): Promise<SkillSignOffResponse>;
    cancel(id: number): Promise<FileResponse | null>;
    create(request: SkillSignOffCreateRequest): Promise<SkillSignOffResponse>;
    evaluate(request: SkillSignOffEvaluateRequest): Promise<SkillSignOffResponse>;
    getMatrix(request: SkillMatrixRequest): Promise<SkillMatrixResponse>;
    getMySkills(request: MySkillsRequest): Promise<MySkillStatusResponse[]>;
    getMyHistory(request: SkillSignOffMyHistoryRequest): Promise<SkillSignOffResponse[]>;
    getRecords(request: SkillSignOffListRequest): Promise<SkillSignOffResponse[]>;
}

export class SkillSignOffApiClient implements ISkillSignOffApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInbox(request: SkillSignOffListRequest, cancelToken?: CancelToken): Promise<SkillSignOffPendingResponse[]> {
        let url_ = this.baseUrl + "/skill-sign-off/inbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInbox(_response);
        });
    }

    protected processGetInbox(response: AxiosResponse): Promise<SkillSignOffPendingResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffPendingResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffPendingResponse[]>(null as any);
    }

    getOversight(request: SkillSignOffListRequest, cancelToken?: CancelToken): Promise<SkillSignOffPendingResponse[]> {
        let url_ = this.baseUrl + "/skill-sign-off/oversight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOversight(_response);
        });
    }

    protected processGetOversight(response: AxiosResponse): Promise<SkillSignOffPendingResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffPendingResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffPendingResponse[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<SkillSignOffResponse> {
        let url_ = this.baseUrl + "/skill-sign-off/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SkillSignOffResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffResponse>(null as any);
    }

    cancel(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/skill-sign-off/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(request: SkillSignOffCreateRequest, cancelToken?: CancelToken): Promise<SkillSignOffResponse> {
        let url_ = this.baseUrl + "/skill-sign-off";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SkillSignOffResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffResponse>(null as any);
    }

    evaluate(request: SkillSignOffEvaluateRequest, cancelToken?: CancelToken): Promise<SkillSignOffResponse> {
        let url_ = this.baseUrl + "/skill-sign-off/evaluate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvaluate(_response);
        });
    }

    protected processEvaluate(response: AxiosResponse): Promise<SkillSignOffResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffResponse>(null as any);
    }

    getMatrix(request: SkillMatrixRequest, cancelToken?: CancelToken): Promise<SkillMatrixResponse> {
        let url_ = this.baseUrl + "/skill-sign-off/matrix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMatrix(_response);
        });
    }

    protected processGetMatrix(response: AxiosResponse): Promise<SkillMatrixResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillMatrixResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillMatrixResponse>(null as any);
    }

    getMySkills(request: MySkillsRequest, cancelToken?: CancelToken): Promise<MySkillStatusResponse[]> {
        let url_ = this.baseUrl + "/skill-sign-off/my-skills";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMySkills(_response);
        });
    }

    protected processGetMySkills(response: AxiosResponse): Promise<MySkillStatusResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MySkillStatusResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MySkillStatusResponse[]>(null as any);
    }

    getMyHistory(request: SkillSignOffMyHistoryRequest, cancelToken?: CancelToken): Promise<SkillSignOffResponse[]> {
        let url_ = this.baseUrl + "/skill-sign-off/my-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyHistory(_response);
        });
    }

    protected processGetMyHistory(response: AxiosResponse): Promise<SkillSignOffResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffResponse[]>(null as any);
    }

    getRecords(request: SkillSignOffListRequest, cancelToken?: CancelToken): Promise<SkillSignOffResponse[]> {
        let url_ = this.baseUrl + "/skill-sign-off/records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecords(_response);
        });
    }

    protected processGetRecords(response: AxiosResponse): Promise<SkillSignOffResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SkillSignOffResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillSignOffResponse[]>(null as any);
    }
}

export interface ITaskAssignmentApiClient {
    getTaskAssignmentsList(request: GetTaskAssignmentListRequest): Promise<GetListResponseOfTaskAssignmentSimpleResponse>;
    getTaskAssignmentsListV2(request: GetTaskAssignmentListRequestV2): Promise<GetListResponseOfTaskAssignmentSimpleResponse>;
    getTaskAssignmentView(request: GetTaskAssignmentListRequest): Promise<TaskAssignmentViewResponse>;
    postBatchStatusUpdateByTask(request: TaskAssignmentBatchStatusByTaskUpdateRequest): Promise<FileResponse | null>;
    postBatchStatusUpdateByUser(request: TaskAssignmentBatchStatusByUserUpdateRequest): Promise<FileResponse | null>;
    transitionAssignment(id: number, request: TransitionRequest): Promise<TaskAssignmentResponse>;
    details(id: number): Promise<TaskAssignmentResponse>;
    getOfflineBundle(): Promise<TaskOfflineBundleResponse>;
    getTaskAssignmentsParticipation(userId: number, taskType: TaskTypeEnum): Promise<TaskParticipationStatistics>;
    getAssignmentStateMachine(): Promise<IStateMachineOfTaskAssignmentStateEnum>;
    supervisorApprovalAcknowledgeToolboxTalk(taskId: number, userId: number): Promise<string>;
}

export class TaskAssignmentApiClient implements ITaskAssignmentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTaskAssignmentsList(request: GetTaskAssignmentListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfTaskAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/task-assignment/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskAssignmentsList(_response);
        });
    }

    protected processGetTaskAssignmentsList(response: AxiosResponse): Promise<GetListResponseOfTaskAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfTaskAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfTaskAssignmentSimpleResponse>(null as any);
    }

    getTaskAssignmentsListV2(request: GetTaskAssignmentListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfTaskAssignmentSimpleResponse> {
        let url_ = this.baseUrl + "/task-assignment/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskAssignmentsListV2(_response);
        });
    }

    protected processGetTaskAssignmentsListV2(response: AxiosResponse): Promise<GetListResponseOfTaskAssignmentSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfTaskAssignmentSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfTaskAssignmentSimpleResponse>(null as any);
    }

    getTaskAssignmentView(request: GetTaskAssignmentListRequest, cancelToken?: CancelToken): Promise<TaskAssignmentViewResponse> {
        let url_ = this.baseUrl + "/task-assignment/view";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskAssignmentView(_response);
        });
    }

    protected processGetTaskAssignmentView(response: AxiosResponse): Promise<TaskAssignmentViewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskAssignmentViewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskAssignmentViewResponse>(null as any);
    }

    postBatchStatusUpdateByTask(request: TaskAssignmentBatchStatusByTaskUpdateRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/task-assignment/batch-by-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostBatchStatusUpdateByTask(_response);
        });
    }

    protected processPostBatchStatusUpdateByTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    postBatchStatusUpdateByUser(request: TaskAssignmentBatchStatusByUserUpdateRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/task-assignment/batch-by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostBatchStatusUpdateByUser(_response);
        });
    }

    protected processPostBatchStatusUpdateByUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    transitionAssignment(id: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<TaskAssignmentResponse> {
        let url_ = this.baseUrl + "/task-assignment/{id}/transition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransitionAssignment(_response);
        });
    }

    protected processTransitionAssignment(response: AxiosResponse): Promise<TaskAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskAssignmentResponse>(null as any);
    }

    details(id: number, cancelToken?: CancelToken): Promise<TaskAssignmentResponse> {
        let url_ = this.baseUrl + "/task-assignment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<TaskAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskAssignmentResponse>(null as any);
    }

    getOfflineBundle( cancelToken?: CancelToken): Promise<TaskOfflineBundleResponse> {
        let url_ = this.baseUrl + "/task-assignment/offline-bundle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfflineBundle(_response);
        });
    }

    protected processGetOfflineBundle(response: AxiosResponse): Promise<TaskOfflineBundleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskOfflineBundleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskOfflineBundleResponse>(null as any);
    }

    getTaskAssignmentsParticipation(userId: number, taskType: TaskTypeEnum, cancelToken?: CancelToken): Promise<TaskParticipationStatistics> {
        let url_ = this.baseUrl + "/task-assignment/participation/user/{userId}/type/{taskType}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (taskType === undefined || taskType === null)
            throw new Error("The parameter 'taskType' must be defined.");
        url_ = url_.replace("{taskType}", encodeURIComponent("" + taskType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskAssignmentsParticipation(_response);
        });
    }

    protected processGetTaskAssignmentsParticipation(response: AxiosResponse): Promise<TaskParticipationStatistics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskParticipationStatistics>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskParticipationStatistics>(null as any);
    }

    getAssignmentStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfTaskAssignmentStateEnum> {
        let url_ = this.baseUrl + "/task-assignment/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignmentStateMachine(_response);
        });
    }

    protected processGetAssignmentStateMachine(response: AxiosResponse): Promise<IStateMachineOfTaskAssignmentStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfTaskAssignmentStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfTaskAssignmentStateEnum>(null as any);
    }

    supervisorApprovalAcknowledgeToolboxTalk(taskId: number, userId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/task-assignment/{taskId}/acknowledge-tbt/supervisor-approval/{userId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSupervisorApprovalAcknowledgeToolboxTalk(_response);
        });
    }

    protected processSupervisorApprovalAcknowledgeToolboxTalk(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ITaskDefinitionApiClient {
    list(request: GetTaskListRequest): Promise<GetListResponseOfTaskDefinitionSimpleResponse>;
    listV2(request: GetTaskListRequestV2): Promise<GetListResponseOfTaskDefinitionSimpleResponse>;
    getDetails(taskId: number): Promise<TaskDefinitionResponse>;
    create(model: TaskDefinitionRequest): Promise<TaskDefinitionResponse>;
    update(model: TaskDefinitionRequest): Promise<TaskDefinitionResponse>;
    delete(id: number): Promise<boolean>;
    transitionDefinition(taskId: number, request: TransitionRequest): Promise<TaskDefinitionResponse>;
    getDefinitionStateMachine(): Promise<IStateMachineOfTaskDefinitionStateEnum>;
    exportTaskStatusReport(itemId: number): Promise<FileResponse | null>;
    getTasksSupervisorApprovalList(request: GetTasksSupervisorApprovalListRequest): Promise<GetListResponseOfTaskAssignmentResponse>;
}

export class TaskDefinitionApiClient implements ITaskDefinitionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetTaskListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfTaskDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/task-definition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfTaskDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfTaskDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfTaskDefinitionSimpleResponse>(null as any);
    }

    listV2(request: GetTaskListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfTaskDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/task-definition/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfTaskDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfTaskDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfTaskDefinitionSimpleResponse>(null as any);
    }

    getDetails(taskId: number, cancelToken?: CancelToken): Promise<TaskDefinitionResponse> {
        let url_ = this.baseUrl + "/task-definition/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<TaskDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDefinitionResponse>(null as any);
    }

    create(model: TaskDefinitionRequest, cancelToken?: CancelToken): Promise<TaskDefinitionResponse> {
        let url_ = this.baseUrl + "/task-definition/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TaskDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDefinitionResponse>(null as any);
    }

    update(model: TaskDefinitionRequest, cancelToken?: CancelToken): Promise<TaskDefinitionResponse> {
        let url_ = this.baseUrl + "/task-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TaskDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDefinitionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/task-definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    transitionDefinition(taskId: number, request: TransitionRequest, cancelToken?: CancelToken): Promise<TaskDefinitionResponse> {
        let url_ = this.baseUrl + "/task-definition/{taskId}/transition";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransitionDefinition(_response);
        });
    }

    protected processTransitionDefinition(response: AxiosResponse): Promise<TaskDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaskDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDefinitionResponse>(null as any);
    }

    getDefinitionStateMachine( cancelToken?: CancelToken): Promise<IStateMachineOfTaskDefinitionStateEnum> {
        let url_ = this.baseUrl + "/task-definition/state-machine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefinitionStateMachine(_response);
        });
    }

    protected processGetDefinitionStateMachine(response: AxiosResponse): Promise<IStateMachineOfTaskDefinitionStateEnum> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IStateMachineOfTaskDefinitionStateEnum>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IStateMachineOfTaskDefinitionStateEnum>(null as any);
    }

    exportTaskStatusReport(itemId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/task-definition/reporting/{itemId}/export";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTaskStatusReport(_response);
        });
    }

    protected processExportTaskStatusReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTasksSupervisorApprovalList(request: GetTasksSupervisorApprovalListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfTaskAssignmentResponse> {
        let url_ = this.baseUrl + "/task-definition/list/supervisor-approval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasksSupervisorApprovalList(_response);
        });
    }

    protected processGetTasksSupervisorApprovalList(response: AxiosResponse): Promise<GetListResponseOfTaskAssignmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfTaskAssignmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfTaskAssignmentResponse>(null as any);
    }
}

export interface IUserActivityApiClient {
    getSummary(request: GetUserActivitySummaryRequest): Promise<GetListResponseOfUserActivitySummaryResponse>;
    getDetail(request: GetUserActivityDetailRequest): Promise<UserActivityDetailResponse>;
}

export class UserActivityApiClient implements IUserActivityApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSummary(request: GetUserActivitySummaryRequest, cancelToken?: CancelToken): Promise<GetListResponseOfUserActivitySummaryResponse> {
        let url_ = this.baseUrl + "/UserActivity/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<GetListResponseOfUserActivitySummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserActivitySummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserActivitySummaryResponse>(null as any);
    }

    getDetail(request: GetUserActivityDetailRequest, cancelToken?: CancelToken): Promise<UserActivityDetailResponse> {
        let url_ = this.baseUrl + "/UserActivity/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: AxiosResponse): Promise<UserActivityDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserActivityDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserActivityDetailResponse>(null as any);
    }
}

export interface IUserApiClient {
    loggedIn(): Promise<FileResponse | null>;
    getAvatarUrl(): Promise<string>;
    updateAvatarUrl(request: AvatarUrlRequest): Promise<boolean>;
    getUserInstances(): Promise<UserInstanceModel[]>;
    getActiveInstance(): Promise<InstanceSimpleResponse>;
    setActiveInstance(instanceId: number): Promise<ValidateSessionResponse>;
    sendMagicLink(request: SendMagicLinkRequest): Promise<SendMagicLinkResponse>;
    validateMagicLink(request: ValidateMagicLinkRequest): Promise<ValidateMagicLinkResponse>;
    enableMfa(): Promise<boolean>;
    disableMfa(): Promise<boolean>;
    validateUserSession(): Promise<ValidateSessionResponse>;
    logout(): Promise<FileResponse | null>;
    checkUserStatus(request: CheckUserStatusRequest): Promise<CheckUserStatusResponse>;
}

export class UserApiClient implements IUserApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loggedIn( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/User/is-loggedin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoggedIn(_response);
        });
    }

    protected processLoggedIn(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAvatarUrl( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/User/account/avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvatarUrl(_response);
        });
    }

    protected processGetAvatarUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateAvatarUrl(request: AvatarUrlRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/User/account/avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAvatarUrl(_response);
        });
    }

    protected processUpdateAvatarUrl(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getUserInstances( cancelToken?: CancelToken): Promise<UserInstanceModel[]> {
        let url_ = this.baseUrl + "/User/instance/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInstances(_response);
        });
    }

    protected processGetUserInstances(response: AxiosResponse): Promise<UserInstanceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserInstanceModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInstanceModel[]>(null as any);
    }

    getActiveInstance( cancelToken?: CancelToken): Promise<InstanceSimpleResponse> {
        let url_ = this.baseUrl + "/User/instance/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveInstance(_response);
        });
    }

    protected processGetActiveInstance(response: AxiosResponse): Promise<InstanceSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InstanceSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstanceSimpleResponse>(null as any);
    }

    setActiveInstance(instanceId: number, cancelToken?: CancelToken): Promise<ValidateSessionResponse> {
        let url_ = this.baseUrl + "/User/instance/active/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveInstance(_response);
        });
    }

    protected processSetActiveInstance(response: AxiosResponse): Promise<ValidateSessionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValidateSessionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateSessionResponse>(null as any);
    }

    sendMagicLink(request: SendMagicLinkRequest, cancelToken?: CancelToken): Promise<SendMagicLinkResponse> {
        let url_ = this.baseUrl + "/User/auth/magic/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMagicLink(_response);
        });
    }

    protected processSendMagicLink(response: AxiosResponse): Promise<SendMagicLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SendMagicLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendMagicLinkResponse>(null as any);
    }

    validateMagicLink(request: ValidateMagicLinkRequest, cancelToken?: CancelToken): Promise<ValidateMagicLinkResponse> {
        let url_ = this.baseUrl + "/User/auth/magic/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateMagicLink(_response);
        });
    }

    protected processValidateMagicLink(response: AxiosResponse): Promise<ValidateMagicLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValidateMagicLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateMagicLinkResponse>(null as any);
    }

    enableMfa( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/User/auth/mfa/enable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableMfa(_response);
        });
    }

    protected processEnableMfa(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    disableMfa( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/User/auth/mfa/disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableMfa(_response);
        });
    }

    protected processDisableMfa(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    validateUserSession( cancelToken?: CancelToken): Promise<ValidateSessionResponse> {
        let url_ = this.baseUrl + "/User/auth/validate-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateUserSession(_response);
        });
    }

    protected processValidateUserSession(response: AxiosResponse): Promise<ValidateSessionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValidateSessionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateSessionResponse>(null as any);
    }

    logout( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/User/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    checkUserStatus(request: CheckUserStatusRequest, cancelToken?: CancelToken): Promise<CheckUserStatusResponse> {
        let url_ = this.baseUrl + "/User/auth/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserStatus(_response);
        });
    }

    protected processCheckUserStatus(response: AxiosResponse): Promise<CheckUserStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CheckUserStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckUserStatusResponse>(null as any);
    }
}

export interface IUserGroupApiClient {
    create(model: UserGroupRequest): Promise<UserGroupResponse>;
    update(model: UserGroupRequest): Promise<UserGroupResponse>;
    list(request: GetUserGroupListRequest): Promise<GetListResponseOfUserGroupSimpleResponse>;
    listV2(request: GetUserGroupListRequestV2): Promise<GetListResponseOfUserGroupSimpleResponse>;
    listSelectOptions(request: GetUserGroupListRequest): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<UserGroupResponse>;
    delete(id: number): Promise<FileResponse | null>;
}

export class UserGroupApiClient implements IUserGroupApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: UserGroupRequest, cancelToken?: CancelToken): Promise<UserGroupResponse> {
        let url_ = this.baseUrl + "/user-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupResponse>(null as any);
    }

    update(model: UserGroupRequest, cancelToken?: CancelToken): Promise<UserGroupResponse> {
        let url_ = this.baseUrl + "/user-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupResponse>(null as any);
    }

    list(request: GetUserGroupListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfUserGroupSimpleResponse> {
        let url_ = this.baseUrl + "/user-group/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfUserGroupSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserGroupSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserGroupSimpleResponse>(null as any);
    }

    listV2(request: GetUserGroupListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfUserGroupSimpleResponse> {
        let url_ = this.baseUrl + "/user-group/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfUserGroupSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserGroupSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserGroupSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetUserGroupListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/user-group/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<UserGroupResponse> {
        let url_ = this.baseUrl + "/user-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user-group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IUserGroupPermissionApiClient {
    getModulePermissionSchema(): Promise<UserGroupModulePermissionSchemaResponse>;
    getObjectPermissionSchema(): Promise<UserGroupObjectPermissionSchemaResponse>;
    create(model: UserGroupModulePermissionRequest): Promise<UserGroupModulePermissionResponse>;
    update(model: UserGroupModulePermissionRequest): Promise<UserGroupModulePermissionResponse>;
    list(request: GetUserGroupPermissionListRequest): Promise<GetListResponseOfUserGroupModulePermissionResponse>;
    get(id: number): Promise<UserGroupModulePermissionResponse>;
    delete(id: number): Promise<FileResponse | null>;
}

export class UserGroupPermissionApiClient implements IUserGroupPermissionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getModulePermissionSchema( cancelToken?: CancelToken): Promise<UserGroupModulePermissionSchemaResponse> {
        let url_ = this.baseUrl + "/user-group-permission/module-schema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModulePermissionSchema(_response);
        });
    }

    protected processGetModulePermissionSchema(response: AxiosResponse): Promise<UserGroupModulePermissionSchemaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupModulePermissionSchemaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupModulePermissionSchemaResponse>(null as any);
    }

    getObjectPermissionSchema( cancelToken?: CancelToken): Promise<UserGroupObjectPermissionSchemaResponse> {
        let url_ = this.baseUrl + "/user-group-permission/object-schema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObjectPermissionSchema(_response);
        });
    }

    protected processGetObjectPermissionSchema(response: AxiosResponse): Promise<UserGroupObjectPermissionSchemaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupObjectPermissionSchemaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupObjectPermissionSchemaResponse>(null as any);
    }

    create(model: UserGroupModulePermissionRequest, cancelToken?: CancelToken): Promise<UserGroupModulePermissionResponse> {
        let url_ = this.baseUrl + "/user-group-permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserGroupModulePermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupModulePermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupModulePermissionResponse>(null as any);
    }

    update(model: UserGroupModulePermissionRequest, cancelToken?: CancelToken): Promise<UserGroupModulePermissionResponse> {
        let url_ = this.baseUrl + "/user-group-permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserGroupModulePermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupModulePermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupModulePermissionResponse>(null as any);
    }

    list(request: GetUserGroupPermissionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfUserGroupModulePermissionResponse> {
        let url_ = this.baseUrl + "/user-group-permission/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfUserGroupModulePermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfUserGroupModulePermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfUserGroupModulePermissionResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<UserGroupModulePermissionResponse> {
        let url_ = this.baseUrl + "/user-group-permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserGroupModulePermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGroupModulePermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupModulePermissionResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user-group-permission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IUserInstanceApiClient {
    getAccountMemberships(accountId: number): Promise<AccountMembershipResponse[]>;
    transferPrimary(request: TransferPrimaryRequest): Promise<FileResponse | null>;
    listSuperAdmins(): Promise<SuperAdminResponse[]>;
    promoteSuperAdmin(request: PromoteSuperAdminRequest): Promise<SuperAdminResponse>;
    demoteSuperAdmin(request: DemoteSuperAdminRequest): Promise<FileResponse | null>;
    changePrimaryInstance(request: ChangePrimaryInstanceRequest): Promise<SuperAdminResponse>;
}

export class UserInstanceApiClient implements IUserInstanceApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAccountMemberships(accountId: number, cancelToken?: CancelToken): Promise<AccountMembershipResponse[]> {
        let url_ = this.baseUrl + "/user-instance/account/{accountId}/account-memberships";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountMemberships(_response);
        });
    }

    protected processGetAccountMemberships(response: AxiosResponse): Promise<AccountMembershipResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AccountMembershipResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountMembershipResponse[]>(null as any);
    }

    transferPrimary(request: TransferPrimaryRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user-instance/transfer-primary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferPrimary(_response);
        });
    }

    protected processTransferPrimary(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    listSuperAdmins( cancelToken?: CancelToken): Promise<SuperAdminResponse[]> {
        let url_ = this.baseUrl + "/user-instance/super-admins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSuperAdmins(_response);
        });
    }

    protected processListSuperAdmins(response: AxiosResponse): Promise<SuperAdminResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuperAdminResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuperAdminResponse[]>(null as any);
    }

    promoteSuperAdmin(request: PromoteSuperAdminRequest, cancelToken?: CancelToken): Promise<SuperAdminResponse> {
        let url_ = this.baseUrl + "/user-instance/super-admins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPromoteSuperAdmin(_response);
        });
    }

    protected processPromoteSuperAdmin(response: AxiosResponse): Promise<SuperAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuperAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuperAdminResponse>(null as any);
    }

    demoteSuperAdmin(request: DemoteSuperAdminRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/user-instance/super-admins/demote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDemoteSuperAdmin(_response);
        });
    }

    protected processDemoteSuperAdmin(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    changePrimaryInstance(request: ChangePrimaryInstanceRequest, cancelToken?: CancelToken): Promise<SuperAdminResponse> {
        let url_ = this.baseUrl + "/user-instance/super-admins/change-primary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePrimaryInstance(_response);
        });
    }

    protected processChangePrimaryInstance(response: AxiosResponse): Promise<SuperAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuperAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuperAdminResponse>(null as any);
    }
}

export interface IVendorApiClient {
    create(model: VendorRequest): Promise<VendorResponse>;
    update(model: VendorRequest): Promise<VendorResponse>;
    list(request: GetVendorListRequest): Promise<GetListResponseOfVendorSimpleResponse>;
    listV2(request: GetListRequestV2): Promise<GetListResponseOfVendorSimpleResponse>;
    listPersonnelV2(request: GetListRequestV2): Promise<GetListResponseOfPersonnelSimpleResponse>;
    listSelectOptions(request: GetVendorListRequest): Promise<GetListResponseOfSelectOption>;
    get(id: number): Promise<VendorResponse>;
    delete(id: number): Promise<boolean>;
    updateActiveStatus(id: number, active: boolean): Promise<VendorResponse>;
    getImportTemplate(): Promise<FileResponse | null>;
    import(key: string): Promise<string>;
    export(): Promise<FileResponse | null>;
}

export class VendorApiClient implements IVendorApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(model: VendorRequest, cancelToken?: CancelToken): Promise<VendorResponse> {
        let url_ = this.baseUrl + "/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VendorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VendorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorResponse>(null as any);
    }

    update(model: VendorRequest, cancelToken?: CancelToken): Promise<VendorResponse> {
        let url_ = this.baseUrl + "/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VendorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VendorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorResponse>(null as any);
    }

    list(request: GetVendorListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfVendorSimpleResponse> {
        let url_ = this.baseUrl + "/vendor/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfVendorSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfVendorSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfVendorSimpleResponse>(null as any);
    }

    listV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfVendorSimpleResponse> {
        let url_ = this.baseUrl + "/vendor/list/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListV2(_response);
        });
    }

    protected processListV2(response: AxiosResponse): Promise<GetListResponseOfVendorSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfVendorSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfVendorSimpleResponse>(null as any);
    }

    listPersonnelV2(request: GetListRequestV2, cancelToken?: CancelToken): Promise<GetListResponseOfPersonnelSimpleResponse> {
        let url_ = this.baseUrl + "/vendor/list-personnel/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPersonnelV2(_response);
        });
    }

    protected processListPersonnelV2(response: AxiosResponse): Promise<GetListResponseOfPersonnelSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfPersonnelSimpleResponse>(null as any);
    }

    listSelectOptions(request: GetVendorListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfSelectOption> {
        let url_ = this.baseUrl + "/vendor/list/select-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSelectOptions(_response);
        });
    }

    protected processListSelectOptions(response: AxiosResponse): Promise<GetListResponseOfSelectOption> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfSelectOption>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfSelectOption>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<VendorResponse> {
        let url_ = this.baseUrl + "/vendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VendorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VendorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorResponse>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/vendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateActiveStatus(id: number, active: boolean, cancelToken?: CancelToken): Promise<VendorResponse> {
        let url_ = this.baseUrl + "/vendor/{id}/active/{active}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActiveStatus(_response);
        });
    }

    protected processUpdateActiveStatus(response: AxiosResponse): Promise<VendorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VendorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorResponse>(null as any);
    }

    getImportTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/vendor/import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportTemplate(_response);
        });
    }

    protected processGetImportTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(key: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/vendor/import/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    export( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/vendor/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IVendorSignupApiClient {
    isSignupCodeValid(code: string): Promise<boolean>;
    signupUser(request: VendorSignupRequest): Promise<VendorSignupResponse>;
}

export class VendorSignupApiClient implements IVendorSignupApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isSignupCodeValid(code: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/vendor-signup/is-valid/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsSignupCodeValid(_response);
        });
    }

    protected processIsSignupCodeValid(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    signupUser(request: VendorSignupRequest, cancelToken?: CancelToken): Promise<VendorSignupResponse> {
        let url_ = this.baseUrl + "/vendor-signup/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupUser(_response);
        });
    }

    protected processSignupUser(response: AxiosResponse): Promise<VendorSignupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VendorSignupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorSignupResponse>(null as any);
    }
}

export interface IWorkflowApiClient {
    list(request: GetWorkflowListRequest): Promise<GetListResponseOfWorkflowSimpleResponse>;
    get(id: number): Promise<WorkflowResponse>;
    reprocess(id: number): Promise<FileResponse | null>;
}

export class WorkflowApiClient implements IWorkflowApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetWorkflowListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfWorkflowSimpleResponse> {
        let url_ = this.baseUrl + "/workflow/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfWorkflowSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfWorkflowSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfWorkflowSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<WorkflowResponse> {
        let url_ = this.baseUrl + "/workflow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<WorkflowResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowResponse>(null as any);
    }

    reprocess(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/workflow/{id}/reprocess";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReprocess(_response);
        });
    }

    protected processReprocess(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IWorkflowDefinitionApiClient {
    list(request: GetWorkflowDefinitionListRequest): Promise<GetListResponseOfWorkflowDefinitionSimpleResponse>;
    get(id: number): Promise<WorkflowDefinitionResponse>;
    getVersion(id: number, version: number): Promise<WorkflowDefinitionResponse>;
    update(model: WorkflowDefinitionRequest): Promise<WorkflowDefinitionResponse>;
    create(model: WorkflowDefinitionRequest): Promise<WorkflowDefinitionResponse>;
}

export class WorkflowDefinitionApiClient implements IWorkflowDefinitionApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list(request: GetWorkflowDefinitionListRequest, cancelToken?: CancelToken): Promise<GetListResponseOfWorkflowDefinitionSimpleResponse> {
        let url_ = this.baseUrl + "/workflow-definition/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<GetListResponseOfWorkflowDefinitionSimpleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfWorkflowDefinitionSimpleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfWorkflowDefinitionSimpleResponse>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<WorkflowDefinitionResponse> {
        let url_ = this.baseUrl + "/workflow-definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<WorkflowDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDefinitionResponse>(null as any);
    }

    getVersion(id: number, version: number, cancelToken?: CancelToken): Promise<WorkflowDefinitionResponse> {
        let url_ = this.baseUrl + "/workflow-definition/{id}/{version}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<WorkflowDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDefinitionResponse>(null as any);
    }

    update(model: WorkflowDefinitionRequest, cancelToken?: CancelToken): Promise<WorkflowDefinitionResponse> {
        let url_ = this.baseUrl + "/workflow-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<WorkflowDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDefinitionResponse>(null as any);
    }

    create(model: WorkflowDefinitionRequest, cancelToken?: CancelToken): Promise<WorkflowDefinitionResponse> {
        let url_ = this.baseUrl + "/workflow-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<WorkflowDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDefinitionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDefinitionResponse>(null as any);
    }
}

export interface IWorkflowNexusApiClient {
    graph(request: NexusGraphRequest): Promise<NexusGraphResponse>;
    inFlight(request: NexusInFlightRequest): Promise<GetListResponseOfNexusInFlightResponse>;
}

export class WorkflowNexusApiClient implements IWorkflowNexusApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    graph(request: NexusGraphRequest, cancelToken?: CancelToken): Promise<NexusGraphResponse> {
        let url_ = this.baseUrl + "/workflow-nexus/graph";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGraph(_response);
        });
    }

    protected processGraph(response: AxiosResponse): Promise<NexusGraphResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<NexusGraphResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NexusGraphResponse>(null as any);
    }

    inFlight(request: NexusInFlightRequest, cancelToken?: CancelToken): Promise<GetListResponseOfNexusInFlightResponse> {
        let url_ = this.baseUrl + "/workflow-nexus/in-flight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInFlight(_response);
        });
    }

    protected processInFlight(response: AxiosResponse): Promise<GetListResponseOfNexusInFlightResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetListResponseOfNexusInFlightResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListResponseOfNexusInFlightResponse>(null as any);
    }
}

export interface GetListResponseOfAccountListResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AccountListResponse[] | undefined;
}

export interface AccountListResponse {
    id: number;
    email: string;
    displayName?: string | undefined;
    isSuperAdmin: boolean;
    primaryInstanceId: number;
    primaryInstanceName?: string | undefined;
    membershipCount: number;
    createdAt?: Date | undefined;
    lastActiveAt?: Date | undefined;
}

export interface GetListRequestV2 {
    start: number;
    length: number;
    filters: GetListRequestV2Filter[];
    filterFns: GetListRequestV2FilterFn[];
    sorting: GetListRequestV2Sort[];
}

export interface GetAccountListV2Request extends GetListRequestV2 {
}

export interface GetListRequestV2Filter {
    id: string;
    values: string[];
}

export interface GetListRequestV2FilterFn {
    id: string;
    value: string;
}

export interface GetListRequestV2Sort {
    id: string;
    desc: boolean;
}

export interface AccountDetailResponse {
    id: number;
    email: string;
    isSuperAdmin: boolean;
    primaryInstanceId: number;
    primaryInstanceName?: string | undefined;
    currentInstanceId: number;
    emailVerifiedAt?: Date | undefined;
    lastActiveAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface TaskBlendedResponse {
    definition: TaskDefinitionResponse;
    assignment?: TaskAssignmentResponse | undefined;
}

export interface TaskDefinitionResponse {
    id: number;
    internalIdentifier?: string | undefined;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    taskType: TaskTypeEnum;
    completionType: TaskCompletionTypeEnum;
    approvalFlowType: TaskApprovalFlowTypeEnum;
    subject: string;
    content: string;
    contentPdfUrl?: string | undefined;
    issue?: string | undefined;
    solution?: string | undefined;
    dueInDays?: number | undefined;
    dueAt?: Date | undefined;
    parentId?: number | undefined;
    state: TaskDefinitionStateEnum;
    version: number;
    active: boolean;
    refresh: boolean;
    formDefinitionId?: number | undefined;
    assetId?: number | undefined;
    demonstrationId?: number | undefined;
    documentId?: number | undefined;
    documentVersion?: number | undefined;
    documentName?: string | undefined;
    complianceStandardIds?: SelectOption[] | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    sourceFormId?: number | undefined;
    sourceFormIdentifier?: string | undefined;
    sourceFormDescription?: string | undefined;
    sourceFormDefinitionId?: number | undefined;
    approvalState?: TaskAssignmentStateEnum | undefined;
    workflowId?: number | undefined;
    workflowActionId?: number | undefined;
    metadata?: TaskDefinitionMetadata | undefined;
    participation?: TaskParticipationStatistics | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    sourceEntities: TaskSourceEntityResponse[];
    locked: boolean;
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export enum TaskTypeEnum {
    Invalid = 0,
    Actions = 1,
    ToolboxTalk = 2,
    REMOVED = 3,
    Form = 4,
    Approval = 5,
}

export enum TaskCompletionTypeEnum {
    Invalid = 0,
    Standard = 1,
    MutuallyExclusive = 2,
}

export enum TaskApprovalFlowTypeEnum {
    Invalid = 0,
    Passthrough = 1,
    Required = 2,
}

export enum TaskDefinitionStateEnum {
    Invalid = 0,
    Draft = 1,
    Published = 2,
    Completed = 3,
}

export interface SelectOption {
    id: number;
    label?: string | undefined;
}

export enum TaskAssignmentStateEnum {
    Invalid = 0,
    Assigned = 1,
    Viewed = 2,
    Completed = 3,
    Submitted = 4,
    Cancelled = 5,
    Rejected = 6,
}

export interface TaskDefinitionMetadata {
    selectAllEntityType?: EntityTypeEnum | undefined;
    targetingAttributes?: NotificationAttributeEnum[] | undefined;
    targetingAttributeSourceEntityId?: number | undefined;
    inlineAttachments?: string | undefined;
    primaryProjectFilter?: PrimaryProjectFilter | undefined;
}

export enum EntityTypeEnum {
    Invalid = 0,
    Employee = 1,
    Manager = 2,
    Department = 3,
    Group = 4,
    Attribute = 5,
    Vendor = 6,
    Project = 7,
}

export enum NotificationAttributeEnum {
    Invalid = 0,
    Assignee = 1,
    Supervisor = 2,
    SuperSupervisor = 3,
}

export interface PrimaryProjectFilter {
    projectId?: number | undefined;
}

export interface TaskParticipationStatistics {
    completed: number;
    pendingReview: number;
    incomplete: number;
    total: number;
}

export interface PersonnelSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    email: string;
    phoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name: string;
    avatarUrl?: string | undefined;
    jobCode?: string | undefined;
    jobTitle?: string | undefined;
    isSuspended: boolean;
    isLeaveOfAbsence: boolean;
    isEligible: boolean;
    isBannedOnProperty: boolean;
    userType: UserTypeEnum;
    active: UserStatusEnum;
    employeeId?: string | undefined;
    departmentId?: number | undefined;
    department?: DepartmentSimpleResponse | undefined;
    supervisorId?: number | undefined;
    supervisor?: SupervisorSimpleResponse | undefined;
    vendorId?: number | undefined;
    vendor?: VendorSimpleResponse | undefined;
    primaryProjectId?: number | undefined;
    primaryProject?: ProjectSimpleResponse | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    hasOpenTraining: boolean;
    badgeExpirationAt?: Date | undefined;
}

export enum UserTypeEnum {
    Invalid = 0,
    Employee = 1,
    Contractor = 2,
}

export enum UserStatusEnum {
    Inactive = 0,
    Active = 1,
    Pending = 2,
}

export interface DepartmentSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export interface SupervisorSimpleResponse extends PersonnelSimpleResponse {
}

export interface VendorSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    active: boolean;
    name?: string | undefined;
    certificateOfInsuranceExpiresAt?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    managerId?: number | undefined;
    manager?: SupervisorSimpleResponse | undefined;
}

export interface ProjectSimpleResponse {
    id: number;
    name: string;
    code?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    active: boolean;
    region?: RegionSimpleResponse | undefined;
}

export interface RegionSimpleResponse {
    id: number;
    name?: string | undefined;
    notes?: string | undefined;
}

export interface TaskSourceEntityResponse {
    id: number;
    label: string;
    entityId: number;
    entityType: EntityTypeEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface TaskAssignmentResponse {
    id: number;
    internalIdentifier?: string | undefined;
    taskId: number;
    sourceEntityId: number;
    assignedToUserId: number;
    state: TaskAssignmentStateEnum;
    formSubmissionId?: number | undefined;
    formSubmissionState?: FormStateEnum | undefined;
    viewedAt?: Date | undefined;
    completedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    taskDefinition: TaskDefinitionResponse;
    assignedToUser: PersonnelSimpleResponse;
}

export enum FormStateEnum {
    Invalid = 0,
    Draft = 1,
    Published = 2,
    Failed = 3,
}

export interface OfflineEchoResponse {
    clientSubmissionId: string;
    message?: string | undefined;
    receivedAtUtc: Date;
}

export interface OfflineEchoRequest {
    clientSubmissionId: string;
    message?: string | undefined;
    simulateFailure: boolean;
}

export interface GetListResponseOfAssetSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AssetSimpleResponse[] | undefined;
}

export interface AssetSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    name: string;
    active: boolean;
    isLeaf: boolean;
    project?: ProjectSimpleResponse | undefined;
}

export interface GetListRequest {
    start: number;
    length: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    search?: string | undefined;
}

export interface GetAssetListRequest extends GetListRequest {
    parentId?: number | undefined;
    activeStates: boolean[];
    isLeaf?: boolean | undefined;
}

export interface GetAssetListRequestV2 extends GetListRequestV2 {
    parentId?: number | undefined;
}

export interface GetListResponseOfSelectOption {
    filteredRecords: number;
    totalRecords: number;
    data?: SelectOption[] | undefined;
}

export interface TreeResponse {
    value: string;
    label: string;
    kind?: string | undefined;
    count?: number | undefined;
    children: TreeResponse[];
}

export interface GetAssetTreeRequest {
    parentId?: number | undefined;
    activeStates: boolean[];
    isLeaf?: boolean | undefined;
}

export interface GetListResponseOfAssetRelatedFormSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AssetRelatedFormSimpleResponse[] | undefined;
}

export interface AssetRelatedFormSimpleResponse {
    formDefinitionId: number;
    formSubmissionId: number;
    formName?: string | undefined;
    fieldLabel?: string | undefined;
    internalIdentifier?: string | undefined;
    shortDescription?: string | undefined;
    creatorName: string;
    state: FormStateEnum;
    createdAt: Date;
    updatedAt?: Date | undefined;
    project?: string | undefined;
    publishedAt?: Date | undefined;
    formVersion: number;
}

export interface GetAssetRelatedFormsListRequestV2 extends GetListRequestV2 {
    assetId: number;
}

export interface AssetResponse {
    id: number;
    internalIdentifier?: string | undefined;
    name: string;
    isLeaf: boolean;
    active: boolean;
    path?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    creatorId?: number | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    parentId?: number | undefined;
    parent?: AssetSimpleResponse | undefined;
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export interface AssetPathResponse {
    id: number;
    name: string;
    path: string;
}

export interface AssetRequest {
    id?: number | undefined;
    name: string;
    active: boolean;
    isLeaf: boolean;
    parentId?: number | undefined;
    projectId?: number | undefined;
}

export interface AssetImportRequest {
    key: string;
    parentAssetId?: number | undefined;
}

export interface AssetMoveRequest {
    id: number;
    newParentId: number;
}

export interface AssistantUsageOverviewResponse {
    today: AssistantTokenUsage;
    last30Days: AssistantTokenUsage;
    todayMessageCount: number;
    last30MessageCount: number;
    todayConversationCount: number;
    last30ConversationCount: number;
    todayActiveUsers: number;
    last30ActiveUsers: number;
    feedback: AssistantFeedbackTallyResponse;
    todayInstanceBudgetPercent?: number | undefined;
    instances?: AssistantInstanceUsageResponse[] | undefined;
}

export interface AssistantTokenUsage {
    inputTokens: number;
    outputTokens: number;
    cacheReadTokens: number;
    cacheCreationTokens: number;
    totalTokens: number;
    estimatedCostUsd?: number | undefined;
}

export interface AssistantFeedbackTallyResponse {
    positiveCount: number;
    negativeCount: number;
    reasonCounts: AssistantFeedbackReasonCountResponse[];
}

export interface AssistantFeedbackReasonCountResponse {
    reason: AssistantFeedbackReasonEnum;
    count: number;
}

export enum AssistantFeedbackReasonEnum {
    WrongData = 1,
    MissingData = 2,
    Misunderstood = 3,
    TooSlow = 4,
    Other = 5,
}

export interface AssistantInstanceUsageResponse {
    instanceId: number;
    instanceName?: string | undefined;
    assistantEnabled: boolean;
    today: AssistantTokenUsage;
    last30Days: AssistantTokenUsage;
    last30ConversationCount: number;
    last30ActiveUsers: number;
    todayInstanceBudgetPercent: number;
}

export interface AssistantUsageSeriesRowResponse {
    date: Date;
    tokens: AssistantTokenUsage;
    messageCount: number;
    activeUsers: number;
}

export interface AssistantUserUsageResponse {
    userId: number;
    userName?: string | undefined;
    conversationCount: number;
    messageCount: number;
    tokens: AssistantTokenUsage;
    lastActivityAtUtc?: Date | undefined;
    todayUserBudgetPercent: number;
}

export interface AssistantToolStatsResponse {
    repliesWithTools: number;
    averageRoundsPerReply: number;
    toolLimitPercent: number;
    totalCalls: number;
    duplicateCalls: number;
    cappedCalls: number;
    tools: AssistantToolStatRowResponse[];
}

export interface AssistantToolStatRowResponse {
    toolName: string;
    calls: number;
    errors: number;
    errorRatePercent: number;
    averageDurationMs: number;
    p95DurationMs: number;
    averageResultChars: number;
}

export interface AssistantMemoryResponse {
    id: number;
    kind: AssistantMemoryKindEnum;
    text: string;
    status: AssistantMemoryStatusEnum;
    source: AssistantMemorySourceEnum;
    sourceConversationId?: number | undefined;
    sourceMessageId?: number | undefined;
    useCount: number;
    lastUsedAt?: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export enum AssistantMemoryKindEnum {
    Preference = 1,
    Focus = 2,
    Alias = 3,
    Default = 4,
}

export enum AssistantMemoryStatusEnum {
    Proposed = 1,
    Active = 2,
}

export enum AssistantMemorySourceEnum {
    UserRequest = 1,
    Suggestion = 2,
    Manual = 3,
}

export interface GetListResponseOfAssistantConversationSummaryResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AssistantConversationSummaryResponse[] | undefined;
}

export interface AssistantConversationSummaryResponse {
    id: number;
    instanceId: number;
    instanceName?: string | undefined;
    creatorId?: number | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    createdAt: Date;
    lastActivityAt: Date;
    messageCount: number;
    negativeFeedbackCount: number;
    tokens: AssistantTokenUsage;
}

export interface AssistantConversationListRequest {
    start: number;
    length: number;
    instanceId?: number | undefined;
    userId?: number | undefined;
    fromUtc?: Date | undefined;
    toUtc?: Date | undefined;
    hasNegativeFeedback?: boolean | undefined;
}

export interface AssistantConversationTranscriptResponse {
    id: number;
    instanceId: number;
    instanceName?: string | undefined;
    creatorId?: number | undefined;
    userName?: string | undefined;
    title?: string | undefined;
    createdAt: Date;
    lastActivityAt: Date;
    tokens: AssistantTokenUsage;
    messages: AssistantTranscriptMessageResponse[];
}

export interface AssistantTranscriptMessageResponse {
    id: number;
    role: string;
    content?: string | undefined;
    toolCalls?: string | undefined;
    inputTokens?: number | undefined;
    outputTokens?: number | undefined;
    cacheReadInputTokens?: number | undefined;
    cacheCreationInputTokens?: number | undefined;
    truncated: boolean;
    stopReason?: AssistantStopReasonEnum | undefined;
    effort?: string | undefined;
    thinkHarder: boolean;
    createdAt: Date;
    feedback?: AssistantMessageFeedbackResponse | undefined;
    charts: AssistantChartResponse[];
    tables: AssistantTableResponse[];
}

export enum AssistantStopReasonEnum {
    Completed = 1,
    MaxTokens = 2,
    ToolLimit = 3,
    Refused = 4,
    Aborted = 5,
    Error = 6,
}

export interface AssistantMessageFeedbackResponse {
    rating: AssistantFeedbackRatingEnum;
    reason?: AssistantFeedbackReasonEnum | undefined;
    comment?: string | undefined;
}

export enum AssistantFeedbackRatingEnum {
    Up = 1,
    Down = 2,
}

export interface AssistantChartResponse {
    type: AssistantChartTypeEnum;
    title: string;
    xLabel: string;
    unit: AssistantChartUnitEnum;
    series: AssistantChartSeriesResponse[];
    points: AssistantChartPointResponse[];
}

export enum AssistantChartTypeEnum {
    Bar = 1,
    Line = 2,
    Area = 3,
    Pie = 4,
    StackedBar = 5,
}

export enum AssistantChartUnitEnum {
    Number = 1,
    Count = 2,
    Hours = 3,
    Currency = 4,
    Percent = 5,
}

export interface AssistantChartSeriesResponse {
    label: string;
}

export interface AssistantChartPointResponse {
    x: string;
    values: number[];
}

export interface AssistantTableResponse {
    title?: string | undefined;
    columns: AssistantTableColumnResponse[];
    rows: string[][];
    truncated: boolean;
    queryToolUseId?: string | undefined;
}

export interface AssistantTableColumnResponse {
    label: string;
    format: AssistantTableColumnFormatEnum;
}

export enum AssistantTableColumnFormatEnum {
    Number = 1,
    Count = 2,
    Hours = 3,
    Currency = 4,
    Percent = 5,
    Text = 6,
    Date = 7,
}

export interface GetListResponseOfAssistantFeedbackItemResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AssistantFeedbackItemResponse[] | undefined;
}

export interface AssistantFeedbackListResponse extends GetListResponseOfAssistantFeedbackItemResponse {
    upCount: number;
    downCount: number;
    reasonCounts: AssistantFeedbackReasonCountResponse[];
}

export interface AssistantFeedbackItemResponse {
    messageId: number;
    conversationId: number;
    conversationTitle?: string | undefined;
    instanceId: number;
    instanceName?: string | undefined;
    userId?: number | undefined;
    userName?: string | undefined;
    rating: AssistantFeedbackRatingEnum;
    reason?: AssistantFeedbackReasonEnum | undefined;
    comment?: string | undefined;
    votedAt: Date;
    question?: string | undefined;
    answer?: string | undefined;
}

export interface AssistantFeedbackFilterRequest {
    instanceId?: number | undefined;
    userId?: number | undefined;
    fromUtc?: Date | undefined;
    toUtc?: Date | undefined;
    search?: string | undefined;
    rating?: AssistantFeedbackRatingEnum | undefined;
    reasons?: AssistantFeedbackReasonEnum[] | undefined;
}

export interface AssistantFeedbackListRequest extends AssistantFeedbackFilterRequest {
    start: number;
    length: number;
}

export interface AssistantUsageResponse {
    userUsedPercent: number;
    instanceUsedPercent: number;
}

export interface ConversationResponse {
    id: number;
    title?: string | undefined;
    memoryOff: boolean;
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateConversationRequest {
    title?: string | undefined;
    memoryOff: boolean;
}

export interface MessageResponse {
    id: number;
    role: string;
    content?: string | undefined;
    toolCalls: AssistantToolCallResponse[];
    truncated: boolean;
    stopReason?: AssistantStopReasonEnum | undefined;
    thinkHarder: boolean;
    effort?: string | undefined;
    createdAt: Date;
    feedback?: AssistantMessageFeedbackResponse | undefined;
    charts: AssistantChartResponse[];
    tables: AssistantTableResponse[];
    memories: AssistantMemoryResponse[];
    usedMemories: AssistantUsedMemoryResponse[];
}

export interface AssistantToolCallResponse {
    id: string;
    name: string;
}

export interface AssistantUsedMemoryResponse {
    id: number;
    text: string;
}

export interface SetMessageFeedbackRequest {
    rating: AssistantFeedbackRatingEnum;
    reason?: AssistantFeedbackReasonEnum | undefined;
    comment?: string | undefined;
}

export interface AssistantMemoryListResponse {
    enabled: boolean;
    notes: AssistantMemoryResponse[];
}

export interface SetAssistantMemoryEnabledRequest {
    enabled: boolean;
}

export interface SaveAssistantMemoryRequest {
    kind: AssistantMemoryKindEnum;
    text: string;
}

export interface PostMessageRequest {
    content: string;
    thinkHarder: boolean;
}

export interface AttachmentClassificationResponse {
    id: number;
    instanceId: number;
    name: string;
    description?: string | undefined;
}

export interface AttachmentClassificationRequest {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface GetListResponseOfAttachmentClassificationResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AttachmentClassificationResponse[] | undefined;
}

export interface GetAttachmentClassificationListRequest extends GetListRequest {
}

export interface GetListResponseOfAttachmentSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AttachmentSimpleResponse[] | undefined;
}

export interface AttachmentSimpleResponse {
    id: number;
    name: string;
    description?: string | undefined;
    expiresAt?: Date | undefined;
    contentUrl: string;
    key: string;
    isEditable: boolean;
    attachmentLinkId: number;
    attachmentType: string;
    creatorName: string;
    creatorAvatarUrl?: string | undefined;
    classificationId?: number | undefined;
    classificationName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export interface GetAttachmentListRequest extends GetListRequest {
    entityId: number;
    attachmentType: AttachmentModuleEnum;
}

export enum AttachmentModuleEnum {
    Invalid = 0,
    User = 1,
    Vendor = 2,
    CourseClassroom = 3,
    TaskDefinition = 4,
    ItemDefinition = 5,
    ItemAssignment = 6,
    SafetyEvent = 7,
    Asset = 8,
    CourseAssignment = 9,
    InspectionDevice = 10,
}

export interface AttachmentResponse extends AttachmentSimpleResponse {
}

export interface AttachmentRequest {
    id?: number | undefined;
    attachmentType: AttachmentModuleEnum;
    entityId: number;
    name: string;
    description?: string | undefined;
    expiresAt?: Date | undefined;
    contentUrl: string;
    key: string;
    classificationId?: number | undefined;
    clientSubmissionId?: string | undefined;
}

export interface GetListResponseOfUserRelatedAttachmentResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: UserRelatedAttachmentResponse[] | undefined;
}

export interface UserRelatedAttachmentResponse {
    id: number;
    sourceType: AttachmentModuleEnum;
    sourceLabel: string;
    sourceEntityId: number;
    name: string;
    description?: string | undefined;
    expiresAt?: Date | undefined;
    contentUrl: string;
    key: string;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    creatorAvatarUrl?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export interface GetUserRelatedAttachmentsRequest extends GetListRequest {
    userId: number;
}

export interface GetListResponseOfAuditLogSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: AuditLogSimpleResponse[] | undefined;
}

export interface AuditLogSimpleResponse {
    id: number;
    entityId?: string | undefined;
    entityName: string;
    actionType: string;
    changes: string;
    instanceId: number;
    creatorId?: number | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    createdAt: Date;
    /** Populated only for entity audit rows with a registered IAuditChildChangeEnricher
(e.g. Form field-level changes, UserGroup permission changes). Null for all other
entity types — no behavior change for existing callers. */
    childChanges?: AuditChildChangeResponse[] | undefined;
}

/** Represents a single child-entity-level change rolled up into a parent entity's AuditLog row (e.g. a Form's FormFieldValue edits, or a UserGroup's permission grants), returned as part of AuditLogResponse.ChildChanges. ChildChanges is null for entity audits with no registered IAuditChildChangeEnricher — zero behavior change for unrelated callers. */
export interface AuditChildChangeResponse {
    /** Stable identifier for the changed child, e.g. "FormField:{id}" or the raw permission FieldName. */
    key: string;
    /** Resolved at read time so renames don't corrupt history. */
    label: string;
    /** Section header for grouping in the UI, e.g. "Form Fields" / "Module Permissions" / "Object Permissions". */
    group: string;
    /** Set for Form field changes only; null for other child change types. */
    fieldType?: FormFieldTypeEnum | undefined;
    /** Display order, when applicable (e.g. FormField.Order); null otherwise. */
    order?: number | undefined;
    original?: string | undefined;
    current?: string | undefined;
}

export enum FormFieldTypeEnum {
    Invalid = 0,
    Text = 1,
    Date = 2,
    Time = 3,
    DateTime = 4,
    DropdownSingle = 5,
    RichText = 7,
    FileUpload = 9,
    Paragraph = 10,
    Divider = 11,
    Subform = 12,
    Scale = 13,
    Heading = 14,
    DropdownSingleAutocomplete = 15,
    DropdownMultiModal = 16,
    DropdownMultiPersonnelModal = 17,
    Signature = 19,
    PhoneNumber = 20,
    AssetModal = 21,
    DropdownSinglePersonnel = 22,
    Switch = 23,
    Number = 24,
    VideoSelect = 25,
    DrawingPad = 26,
    ProjectSelect = 27,
    Measurement = 28,
}

export interface GetAuditLogListRequestV2 extends GetListRequestV2 {
    entityId?: string | undefined;
    entityType?: EntityIdentifierEnum | undefined;
    changesField?: string | undefined;
    changesFieldValue?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum EntityIdentifierEnum {
    Invalid = 0,
    Asset = 1,
    AssetType = 2,
    Compliance = 3,
    Course = 4,
    Department = 5,
    Form = 6,
    FormDefinition = 7,
    Instance = 8,
    JobHazardAnalysis = 9,
    Lesson = 10,
    RiskAssessmentCode = 11,
    Action = 12,
    ToolboxTalk = 13,
    User = 14,
    Workflow = 15,
    WorkflowDefinition = 16,
    Training = 17,
    AssignedForm = 18,
    SafetyEvent = 19,
    Vendor = 20,
    CourseDefinition = 21,
    Document = 22,
    CourseSession = 23,
    ItemDefinition = 24,
    ItemAssignment = 25,
    CourseClassroom = 26,
    Approval = 27,
    CourseAssignment = 28,
    TaskDefinition = 29,
    NotificationRule = 30,
    UserGroup = 31,
    Bulletin = 32,
    CourseVideo = 33,
    BackgroundJob = 34,
    CourseCertificate = 35,
}

export interface AuditLogResponse extends AuditLogSimpleResponse {
    updatedAt: Date;
}

export interface GetListResponseOfBadgeTemplateSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: BadgeTemplateSimpleResponse[] | undefined;
}

export interface BadgeTemplateSimpleResponse {
    id: number;
    uniqueIdentifier: string;
    version: number;
    activeVersion: boolean;
    name: string;
    description?: string | undefined;
    targetingMetadata: BadgeTemplateTargeting;
    creatorId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface BadgeTemplateTargeting {
    userTypes: UserTypeEnum[];
}

export interface GetBadgeTemplateListRequest extends GetListRequest {
    instanceId: number;
    userType?: UserTypeEnum | undefined;
}

export interface BadgeTemplateResponse {
    id: number;
    uniqueIdentifier: string;
    version: number;
    activeVersion: boolean;
    name: string;
    description?: string | undefined;
    htmlContent: string;
    targetingMetadata: BadgeTemplateTargeting;
    creatorId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    validationWarnings: string[];
}

export interface BadgeTemplateRequest {
    id?: number | undefined;
    instanceId: number;
    version?: number | undefined;
    name: string;
    description?: string | undefined;
    htmlContent: string;
    targetingMetadata?: BadgeTemplateTargeting | undefined;
}

export interface BadgeTemplatePreviewResponse {
    html: string;
    mergeWarnings: string[];
    validationErrors: string[];
    validationWarnings: string[];
}

export interface BadgeTemplatePreviewRequest {
    htmlContent: string;
}

export interface GetListResponseOfBulletinSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: BulletinSimpleResponse[] | undefined;
}

export interface BulletinSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    creatorId?: number | undefined;
    title: string;
    active: boolean;
    updatedAt?: Date | undefined;
    creator?: PersonnelSimpleResponse | undefined;
}

export interface GetBulletinListRequestV2 extends GetListRequestV2 {
}

export interface BulletinResponse extends BulletinSimpleResponse {
    instanceId?: number | undefined;
    content: string;
    contentPdfUrl?: string | undefined;
    createdAt?: Date | undefined;
}

export interface BulletinRequest {
    id?: number | undefined;
    internalIdentifier?: string | undefined;
    title: string;
    content: string;
    contentPdfUrl?: string | undefined;
    active: boolean;
}

export interface ClientRequest {
    id?: number | undefined;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    contacts?: ContactRequest[] | undefined;
}

export interface ClientResponse extends ClientRequest {
    id: number;
    active: boolean;
    instanceId: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    contacts?: ContactResponse[] | undefined;
}

export interface ContactResponse {
    id: number;
    name?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface ContactRequest {
    id?: number | undefined;
    name?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface GetListResponseOfClientSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ClientSimpleResponse[] | undefined;
}

export interface ClientSimpleResponse {
    id: number;
    name?: string | undefined;
    active: boolean;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
}

export interface CloudWatchAlarmsResponse {
    environment: string;
    alarms: CloudWatchAlarmResponse[];
}

export interface CloudWatchAlarmResponse {
    name: string;
    label: string;
    description?: string | undefined;
    state: CloudWatchAlarmState;
    stateReason?: string | undefined;
    stateUpdatedAt?: Date | undefined;
    namespace?: string | undefined;
    metricName?: string | undefined;
    statistic?: string | undefined;
    unit?: string | undefined;
    periodSeconds?: number | undefined;
    threshold?: number | undefined;
    comparisonOperator?: string | undefined;
    evaluationPeriods?: number | undefined;
    dimensions: CloudWatchMetricDimensionResponse[];
}

export enum CloudWatchAlarmState {
    Ok = 0,
    Alarm = 1,
    InsufficientData = 2,
}

export interface CloudWatchMetricDimensionResponse {
    name: string;
    value: string;
}

export interface CloudWatchMetricsResponse {
    environment: string;
    from: Date;
    to: Date;
    periodSeconds: number;
    series: CloudWatchMetricSeriesResponse[];
}

export interface CloudWatchMetricSeriesResponse {
    alarmName: string;
    label: string;
    namespace: string;
    metricName: string;
    statistic?: string | undefined;
    unit?: string | undefined;
    threshold?: number | undefined;
    comparisonOperator?: string | undefined;
    state: CloudWatchAlarmState;
    dimensions: CloudWatchMetricDimensionResponse[];
    points: CloudWatchMetricPointResponse[];
}

export interface CloudWatchMetricPointResponse {
    timestamp: Date;
    value: number;
}

export interface CloudWatchLogGroupResponse {
    name: string;
    label: string;
    retentionDays?: number | undefined;
    storedBytes?: number | undefined;
}

export interface CloudWatchLogPageResponse {
    events: CloudWatchLogEventResponse[];
    nextToken?: string | undefined;
}

export interface CloudWatchLogEventResponse {
    id?: string | undefined;
    timestamp: Date;
    logStream?: string | undefined;
    level: CloudWatchLogLevel;
    message: string;
    exception?: string | undefined;
    correlationId?: string | undefined;
    userId?: string | undefined;
    instanceId?: string | undefined;
    raw: string;
}

export enum CloudWatchLogLevel {
    All = 0,
    Error = 1,
    Warning = 2,
    Information = 3,
    Debug = 4,
}

export interface GetListResponseOfGetReportResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: GetReportResponse[] | undefined;
}

export interface GetReportResponse {
    id: number;
    label: string;
    value: number;
}

export interface GetEventTimeSeriesReportRequest {
    type: ComplianceEventTypeEnum;
    filterDepartmentId?: number | undefined;
    filterSupervisorId?: number | undefined;
}

export enum ComplianceEventTypeEnum {
    Invalid = 0,
    Finding = 1,
    Plan = 2,
}

export interface GetListResponseOfComplianceEventResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ComplianceEventResponse[] | undefined;
}

export interface ComplianceEventResponse {
    id: number;
    type: ComplianceEventTypeEnum;
    state: ComplianceEventStateEnum;
    instanceComplianceStandardId?: number | undefined;
    standardId?: number | undefined;
    standardLabel?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    formId?: number | undefined;
    formName?: string | undefined;
    formFieldId?: number | undefined;
    formFieldName?: string | undefined;
    formFieldValueId?: number | undefined;
    formFieldValueName?: string | undefined;
    active: boolean;
    metadata: ComplianceEventMetadata;
    createdAt: Date;
    updatedAt: Date;
    riskSeverity?: string | undefined;
    riskProbability?: string | undefined;
    riskScore?: string | undefined;
    departments: DepartmentSimpleResponse[];
    departmentsString?: string | undefined;
}

export enum ComplianceEventStateEnum {
    Invalid = 0,
    Unreviewed = 1,
    NoAction = 2,
    Assigned = 3,
    PendingApproval = 4,
    Completed = 5,
}

export interface ComplianceEventMetadata {
}

export interface GetComplianceEventListRequest extends GetListRequest {
    departmentId?: number | undefined;
    supervisorId?: number | undefined;
    creatorId?: number | undefined;
}

export interface TaskDefinitionRequest {
    id?: number | undefined;
    clientSubmissionId?: string | undefined;
    instanceId?: number | undefined;
    taskType?: TaskTypeEnum | undefined;
    completionType?: TaskCompletionTypeEnum | undefined;
    approvalFlowType?: TaskApprovalFlowTypeEnum | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    contentPdfUrl?: string | undefined;
    issue?: string | undefined;
    solution?: string | undefined;
    dueInDays?: number | undefined;
    dueAt?: Date | undefined;
    refresh?: boolean | undefined;
    version?: number | undefined;
    active?: boolean | undefined;
    formDefinitionId?: number | undefined;
    targetComplianceStandardIds?: number[] | undefined;
    targetSourceEntityRequest?: SourceEntityRequest | undefined;
    assetId?: number | undefined;
    demonstrationId?: number | undefined;
    documentId?: number | undefined;
    documentVersion?: number | undefined;
    sourceFormId?: number | undefined;
    inlineAttachments?: string | undefined;
    workflowId?: number | undefined;
    workflowActionId?: number | undefined;
    projectId?: number | undefined;
    skipOnUpdatedSideEffect?: boolean | undefined;
}

export interface TaskMetadata extends TaskDefinitionRequest {
    stopWorkflowOnApprovalRejection?: boolean | undefined;
    formFieldPersonnelTargets?: WorkflowFormFieldPersonnelTarget[] | undefined;
    filterByTriggererPrimaryProject?: boolean | undefined;
}

export interface ComplianceEventIssueTaskAndTransitionRequest extends TaskMetadata {
    complianceEventId: number;
}

export interface WorkflowFormFieldPersonnelTarget {
    formFieldInvariantId: string;
    attributes: NotificationAttributeEnum[];
}

export interface SourceEntityRequest {
    entities: SourceEntityRecord[];
    selectAllEntitiesType?: EntityTypeEnum | undefined;
    targetingAttributes?: NotificationAttributeEnum[] | undefined;
    targetingAttributeSourceEntityId?: number | undefined;
    primaryProjectFilter?: PrimaryProjectFilter | undefined;
}

export interface SourceEntityRecord {
    entityType: EntityTypeEnum;
    entityId: number;
}

export interface TransitionRequest {
    transition: string;
    note?: string | undefined;
    occurredAt?: Date | undefined;
}

export interface IStateMachineOfComplianceEventStateEnum {
    states: StateOfComplianceEventStateEnum[];
    transitions: TransitionOfComplianceEventStateEnum[];
}

export interface StateOfComplianceEventStateEnum {
    id: ComplianceEventStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfComplianceEventStateEnum {
    name: string;
    from: ComplianceEventStateEnum[];
    to: ComplianceEventStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export enum PermissionOperationEnum {
    Invalid = 0,
    Create = 2,
    Update = 3,
    Delete = 4,
    View = 5,
    Custom = 6,
    Import = 7,
    Export = 8,
    Archive = 9,
}

/** Defines a contextual (entity-level) permission requirement. Multiple definitions can be combined with AND/OR logic. */
export interface ContextualPermissionDef {
    /** The type of predicate to evaluate. */
    predicate: ContextualPredicateType;
    /** For HasRole predicate: the roles that satisfy this permission. */
    requiredRoles?: RoleEnum[] | undefined;
    /** For InUserGroup predicate: the user group IDs that satisfy this permission. */
    userGroupIds?: number[] | undefined;
    /** For Custom predicate: the name of the custom evaluator to use. */
    customEvaluatorName?: string | undefined;
    /** Human-readable description of this permission requirement. */
    description?: string | undefined;
}

/** Defines the types of contextual predicates that can be used to evaluate entity-level permissions. */
export enum ContextualPredicateType {
    IsCreator = 0,
    IsSupervisorOfCreator = 1,
    IsAssignee = 2,
    IsSupervisorOfAssignee = 3,
    HasRole = 4,
    SameDepartment = 5,
    InUserGroup = 6,
    Custom = 7,
}

export enum RoleEnum {
    GlobalAdmin = 1,
    InstanceAdmin = 2,
    InstanceUser = 3,
    InstanceObserver = 4,
    InstanceSupervisor = 5,
    SafetyRepresentative = 6,
    NotificationOnly = 7,
}

export interface GetListResponseOfComplianceStandardResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ComplianceStandardResponse[] | undefined;
}

export interface ComplianceStandardResponse {
    id: number;
    instanceId?: number | undefined;
    type: ComplianceStandardTypeEnum;
    titleNumberValue: string;
    titleNumberLabel: string;
    subtitleValue?: string | undefined;
    subtitleLabel?: string | undefined;
    chapterValue?: string | undefined;
    chapterLabel?: string | undefined;
    partValue?: string | undefined;
    partLabel?: string | undefined;
    subpartValue?: string | undefined;
    subpartLabel?: string | undefined;
    sectionValue: string;
    sectionLabel: string;
    renderUrl: string;
    issuedAt: Date;
    updatedAt: Date;
    content?: string | undefined;
    internalIdentifier?: string | undefined;
    instanceComplianceStandards?: InstanceComplianceStandardResponse[] | undefined;
}

export enum ComplianceStandardTypeEnum {
    Invalid = 0,
    EPA = 1,
    OSHA = 2,
    Custom = 3,
}

export interface InstanceComplianceStandardResponse {
    id: number;
    complianceStandardId: number;
    active: boolean;
    summary?: string | undefined;
    note?: string | undefined;
    files?: string | undefined;
    riskAssessmentProbability?: number | undefined;
    riskAssessmentSeverity?: number | undefined;
    riskScore?: number | undefined;
    departmentIds?: SelectOption[] | undefined;
    createdAt: Date;
    updatedAt: Date;
    standard: ComplianceStandardResponse;
    departments: InstanceComplianceStandardDepartmentResponse[];
}

export interface InstanceComplianceStandardDepartmentResponse {
    id: number;
    instanceComplianceStandardId: number;
    departmentId: number;
    active: boolean;
    metadata: InstanceComplianceStandardDepartmentMetadata;
    createdAt: Date;
    updatedAt: Date;
    department?: DepartmentSimpleResponse | undefined;
}

export interface InstanceComplianceStandardDepartmentMetadata {
}

export interface GetComplianceStandardsListRequest extends GetListRequest {
    types?: ComplianceStandardTypeEnum[] | undefined;
}

export interface GetComplianceStandardsListRequestV2 extends GetListRequestV2 {
    types?: ComplianceStandardTypeEnum[] | undefined;
}

export interface CustomComplianceStandardRequest {
    id?: number | undefined;
    subtitleLabel?: string | undefined;
    titleNumberLabel?: string | undefined;
    chapterLabel?: string | undefined;
    partLabel?: string | undefined;
    subpartLabel?: string | undefined;
    sectionLabel?: string | undefined;
    content?: string | undefined;
}

export interface GetListResponseOfCourseAssignmentSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CourseAssignmentSimpleResponse[] | undefined;
}

export interface CourseAssignmentSimpleResponse {
    id?: number | undefined;
    active?: boolean | undefined;
    state?: CourseAssignmentStateEnum | undefined;
    isRenewal: boolean;
    /** The assigned course version has no contents, so only classroom close-out completes it. In-memory
Map callers must load CourseDefinition.Contents; ProjectTo computes it in SQL. */
    isClassroomOnly: boolean;
    dueAt?: Date | undefined;
    expectedExpirationAt?: Date | undefined;
    expectedUnlockAt?: Date | undefined;
    completedAt?: Date | undefined;
    assignedAt?: Date | undefined;
    /** Days past DueAt (positive when overdue, negative when not yet due, null when no DueAt is
set). Computed post-query - see CourseAssignmentLatenessRules.ComputeDaysPastDue.
Sorting is supported via ApplyDaysPastDueSort, which lifts the sort id out of the
request before the dynamic engine runs. */
    daysPastDue?: number | undefined;
    assignedTo?: PersonnelSimpleResponse | undefined;
    courseDefinition?: CourseDefinitionSimpleResponse | undefined;
}

export enum CourseAssignmentStateEnum {
    Invalid = 0,
    Open = 1,
    Complete = 2,
    Locked = 3,
    Pending = 4,
}

export interface CourseDefinitionSimpleResponse {
    id: number;
    version: number;
    internalIdentifier?: string | undefined;
    name: string;
    active: boolean;
    dueInDays?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    project?: ProjectSimpleResponse | undefined;
    assignedCount: number;
    completedCount: number;
    overdueCount: number;
    completionPercentage: number;
}

export interface GetCourseAssignmentListRequest extends GetListRequest {
    activeStates?: boolean[] | undefined;
    states?: CourseAssignmentStateEnum[] | undefined;
    courseDefinitionId?: number | undefined;
    sessionUserId?: number | undefined;
    viewCurrentUserOnly?: boolean | undefined;
    userActiveStates?: UserStatusEnum[] | undefined;
    supervisorId?: number | undefined;
    departmentId?: number | undefined;
}

export interface GetCourseAssignmentListRequestV2 extends GetListRequestV2 {
    courseDefinitionId?: number | undefined;
    /** Cross-course listing: multi-valued CourseDefinitionId. Omit both to list all courses. */
    courseDefinitionIds?: number[] | undefined;
    supervisorId?: number | undefined;
    departmentId?: number | undefined;
    vendorId?: number | undefined;
    projectId?: number | undefined;
    userTypes?: UserTypeEnum[] | undefined;
    /** Narrows the grid to one StatCard bucket. Flows through ToFilter so
            list, aggregate, and bulk-action jobs share the same predicate. */
    latenessBucket?: CourseAssignmentLatenessBucketEnum | undefined;
    viewCurrentUserOnly?: boolean | undefined;
    activeStates?: boolean[] | undefined;
    states?: CourseAssignmentStateEnum[] | undefined;
    sessionUserId?: number | undefined;
    userActiveStates?: UserStatusEnum[] | undefined;
}

/** Compliance-cockpit lateness buckets, aligned with the four StatCards on the assignment list. */
export enum CourseAssignmentLatenessBucketEnum {
    Invalid = 0,
    Overdue = 1,
    DueInSevenDays = 2,
    ExpiringInThirtyDays = 3,
    LockedOut = 4,
}

export interface GetListResponseOfPersonnelSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: PersonnelSimpleResponse[] | undefined;
}

export interface GetListPotentialCandidatesRequest extends GetListRequest {
    courseDefinitionId: number;
}

export interface CourseAssignmentResponse {
    id?: number | undefined;
    active?: boolean | undefined;
    state?: CourseAssignmentStateEnum | undefined;
    dueAt?: Date | undefined;
    expectedExpirationAt?: Date | undefined;
    expectedUnlockAt?: Date | undefined;
    completedAt?: Date | undefined;
    assignedAt?: Date | undefined;
    assignedToId?: number | undefined;
    assignedTo?: PersonnelSimpleResponse | undefined;
    courseSessions?: CourseSessionResponse[] | undefined;
    courseDefinitionId?: number | undefined;
    courseDefinitionVersion?: number | undefined;
    courseDefinition?: CourseDefinitionResponse | undefined;
}

export interface CourseSessionResponse {
    id: number;
    sessionType?: CourseSessionTypeEnum | undefined;
    internalIdentifier?: string | undefined;
    creatorId?: number | undefined;
    assignmentId: number;
    courseDefinitionId: number;
    courseDefinitionVersion: number;
    sessionState: CourseSessionStateEnum;
    language?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    metadata?: CourseSessionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    contents?: CourseSessionContentResponse[] | undefined;
}

export enum CourseSessionTypeEnum {
    Invalid = 0,
    Standard = 1,
    AdministratorSignOff = 2,
}

export enum CourseSessionStateEnum {
    Invalid = 0,
    Pending = 1,
    Completed = 2,
    Expired = 3,
    Cancelled = 4,
    Failed = 5,
    NotStarted = 6,
}

export interface CourseSessionMetadata {
}

export interface CourseSessionContentResponse {
    id?: number | undefined;
    state: CourseSessionContentStateEnum;
    startedAt?: Date | undefined;
    timeLimitAt?: Date | undefined;
    completedAt?: Date | undefined;
    contentDefinitionId: number;
    sessionId: number;
    lessonId?: number | undefined;
    lesson?: CourseSessionLessonResponse | undefined;
    quizId?: number | undefined;
    quiz?: CourseSessionQuizResponse | undefined;
    demonstrationId?: number | undefined;
    demonstration?: CourseSessionDemonstrationResponse | undefined;
}

export enum CourseSessionContentStateEnum {
    Invalid = 0,
    NotStarted = 1,
    Pending = 2,
    Completed = 3,
    Failed = 4,
    Expired = 5,
    Cancelled = 6,
}

export interface CourseSessionLessonResponse {
    id?: number | undefined;
    isCompleted: boolean;
    currentProgressSeconds?: number | undefined;
    courseSessionContentId: number;
}

export interface CourseSessionQuizResponse {
    id?: number | undefined;
    isPassed?: boolean | undefined;
    earnedScore?: number | undefined;
    courseSessionContentId?: number | undefined;
    quizDefinitionId?: number | undefined;
    questions?: CourseSessionQuizQuestionResponse[] | undefined;
}

export interface CourseSessionQuizQuestionResponse {
    id?: number | undefined;
    isAnswersCorrect?: boolean | undefined;
    questionDefinitionId?: number | undefined;
    quizId?: number | undefined;
    answers?: CourseSessionQuizQuestionAnswerResponse[] | undefined;
}

export interface CourseSessionQuizQuestionAnswerResponse {
    id?: number | undefined;
    isSelected?: boolean | undefined;
    isCorrect?: boolean | undefined;
    answerDefinitionId?: number | undefined;
    questionId?: number | undefined;
}

export interface CourseSessionDemonstrationResponse {
    id?: number | undefined;
    state?: CourseSessionDemonstrationEnum | undefined;
    demonstrationAssignmentId?: number | undefined;
    demonstrationFormId?: number | undefined;
    courseSessionContentId: number;
    demonstrationDefinitionId: number;
    skillSignOff?: CourseSessionSkillSignOffResponse | undefined;
}

export enum CourseSessionDemonstrationEnum {
    Invalid = 0,
    Unassigned = 1,
    Assigned = 2,
    Completed = 3,
}

export interface CourseSessionSkillSignOffResponse {
    id: number;
    skillId: number;
    result?: SkillSignOffResultEnum | undefined;
    comment?: string | undefined;
    signedOffById?: number | undefined;
    signedOffByName?: string | undefined;
    signedOffAt?: Date | undefined;
    criterionResults: SkillSignOffCriterionResultResponse[];
}

export enum SkillSignOffResultEnum {
    Invalid = 0,
    SignedOff = 1,
    NotYetCompetent = 2,
}

export interface SkillSignOffCriterionResultResponse {
    criterionId: number;
    criterionText: string;
    criterionEvidenceType: SkillCriterionEvidenceTypeEnum;
    result: SkillSignOffCriterionResultEnum;
    note?: string | undefined;
}

export enum SkillCriterionEvidenceTypeEnum {
    Invalid = 0,
    None = 1,
    Photo = 2,
    Note = 3,
}

export enum SkillSignOffCriterionResultEnum {
    Invalid = 0,
    Pass = 1,
    Fail = 2,
    NotApplicable = 3,
}

export interface CourseDefinitionResponse {
    id?: number | undefined;
    version?: number | undefined;
    internalIdentifier?: string | undefined;
    name: string;
    active?: boolean | undefined;
    dueInDays?: number | undefined;
    isRenewalRequired?: boolean | undefined;
    renewalPeriodDays?: number | undefined;
    fixedRenewalMonth?: number | undefined;
    fixedRenewalDay?: number | undefined;
    isAttemptLimited?: boolean | undefined;
    attemptLimit?: number | undefined;
    attemptLockoutPeriodDays?: number | undefined;
    isCertificateGenerated?: boolean | undefined;
    certificateAdditionalContent?: string | undefined;
    certifyingTrainerName?: string | undefined;
    certifyingTrainerTitle?: string | undefined;
    defaultLanguage: string;
    availableLanguages: string[];
    creatorId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata?: CourseDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    contents?: CourseDefinitionContentResponse[] | undefined;
    sourceEntities: CourseSourceEntityResponse[];
    dependencies?: SelectOption[] | undefined;
    locked: boolean;
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export interface CourseDefinitionMetadata {
    selectAllEntityType?: EntityTypeEnum | undefined;
}

export interface CourseDefinitionContentResponse {
    id?: number | undefined;
    invariantId: string;
    order: number;
    language: string;
    type: CourseDefinitionContentTypeEnum;
    timeLimit: number;
    lessonId?: number | undefined;
    lesson?: CourseDefinitionLessonResponse | undefined;
    quizId?: number | undefined;
    quiz?: CourseDefinitionQuizResponse | undefined;
    demonstrationId?: number | undefined;
    demonstration?: CourseDefinitionDemonstrationResponse | undefined;
}

export enum CourseDefinitionContentTypeEnum {
    Invalid = 0,
    Lesson = 1,
    Quiz = 2,
    Demonstration = 3,
}

export interface CourseDefinitionLessonResponse {
    id?: number | undefined;
    headerText: string;
    bodyText?: string | undefined;
    videoProviderType?: VideoProviderTypeEnum | undefined;
    videoUrl?: string | undefined;
    videoId?: number | undefined;
    video?: CourseVideoResponse | undefined;
    enableVideoActiveScreenMonitoring: boolean;
    enableVideoControls: boolean;
    enableVideoAutostart: boolean;
    enableVideoResume: boolean;
}

export enum VideoProviderTypeEnum {
    Invalid = 0,
    Vimeo = 1,
    Internal = 2,
}

export interface CourseVideoResponse {
    id: number;
    title: string;
    description: string;
    contentKey: string;
    contentUrl: string;
    active?: boolean | undefined;
    createdAt: Date;
    updatedAt: Date;
    creatorId?: number | undefined;
    creator?: PersonnelSimpleResponse | undefined;
}

export interface CourseDefinitionQuizResponse {
    id?: number | undefined;
    headerText: string;
    bodyText?: string | undefined;
    scorePassPercentage: number;
    enableGenerateCertificate: boolean;
    enableShowCorrectAnswersInResults: boolean;
    questions?: CourseDefinitionQuizQuestionResponse[] | undefined;
}

export interface CourseDefinitionQuizQuestionResponse {
    id?: number | undefined;
    order: number;
    labelText: string;
    bodyText?: string | undefined;
    scoreValue: number;
    type?: CourseDefinitionQuizQuestionTypeEnum | undefined;
    answers?: CourseDefinitionQuizQuestionAnswerResponse[] | undefined;
}

export enum CourseDefinitionQuizQuestionTypeEnum {
    Invalid = 0,
    SingleChoice = 1,
    MultiChoice = 2,
}

export interface CourseDefinitionQuizQuestionAnswerResponse {
    id?: number | undefined;
    order: number;
    text: string;
    isCorrect?: boolean | undefined;
}

export interface CourseDefinitionDemonstrationResponse {
    id?: number | undefined;
    headerText?: string | undefined;
    bodyText?: string | undefined;
    assignToUserId?: number | undefined;
    assignToUser?: PersonnelSimpleResponse | undefined;
    assignToUserGroupId?: number | undefined;
    assignToUserGroup?: UserGroupSimpleResponse | undefined;
    demonstrationFormDefinitionId?: number | undefined;
    demonstrationFormDefinitionVersion?: number | undefined;
    skillId?: number | undefined;
    skillName?: string | undefined;
    enableFailOnNotYetCompetent: boolean;
}

export interface UserGroupSimpleResponse {
    id: number;
    active?: boolean | undefined;
    name?: string | undefined;
    isIdpManaged: boolean;
    isNotificationGroup?: boolean | undefined;
    isPermissionGroup?: boolean | undefined;
    isDefaultEmployeeGroup?: boolean | undefined;
    isDefaultContractorGroup?: boolean | undefined;
}

export interface CourseSourceEntityResponse {
    id: number;
    label: string;
    entityId: number;
    entityType: EntityTypeEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface CourseAssignmentRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    courseDefinitionId?: number | undefined;
    courseDefinitionVersion?: number | undefined;
    assignedToId?: number | undefined;
    dueAt?: Date | undefined;
    completedAt?: Date | undefined;
    assignedAt?: Date | undefined;
}

export interface CourseSessionTrackerResponse {
    assignment: CourseAssignmentSimpleResponse;
    hasActiveSession: boolean;
    courseDefinition: CourseDefinitionSafeResponse;
    session?: CourseSessionSimpleResponse | undefined;
    unmetDependencyCourseNames: string[];
    canStartSession: boolean;
    startSessionBlockedReason?: SessionStartBlockedReasonEnum | undefined;
}

export interface CourseDefinitionSafeResponse {
    id: number;
    version: number;
    internalIdentifier?: string | undefined;
    name: string;
    active?: boolean | undefined;
    dueInDays?: number | undefined;
    isRenewalRequired?: boolean | undefined;
    renewalPeriodDays?: number | undefined;
    fixedRenewalMonth?: number | undefined;
    fixedRenewalDay?: number | undefined;
    isAttemptLimited?: boolean | undefined;
    attemptLimit?: number | undefined;
    attemptLockoutPeriodDays?: number | undefined;
    isCertificateGenerated?: boolean | undefined;
    certificateAdditionalContent?: string | undefined;
    certifyingTrainerName?: string | undefined;
    certifyingTrainerTitle?: string | undefined;
    defaultLanguage: string;
    availableLanguages: string[];
    creatorId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata?: CourseDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    contents?: CourseDefinitionContentResponse[] | undefined;
}

export interface CourseSessionSimpleResponse {
    id: number;
    sessionType?: CourseSessionTypeEnum | undefined;
    internalIdentifier?: string | undefined;
    creatorId: number;
    assignmentId: number;
    courseDefinitionId: number;
    courseDefinitionVersion: number;
    sessionState: CourseSessionStateEnum;
    language?: string | undefined;
    traineeName?: string | undefined;
    courseDefinition?: CourseDefinitionSimpleResponse | undefined;
    creator?: PersonnelSimpleResponse | undefined;
}

/** Reason a new course session cannot be started for an assignment. */
export enum SessionStartBlockedReasonEnum {
    ActiveSessionExists = 1,
    AssignmentComplete = 2,
    AssignmentLocked = 3,
    AssignmentInvalid = 4,
    ClassroomOnly = 5,
}

export interface BatchCourseAssignmentUpdateRequest {
    updateType: BatchCourseAssignmentUpdateTypeEnum;
    ids?: number[] | undefined;
    /** Set by classroom close-out when driving a Complete batch — see
CompletionSourceClassroomId. */
    completionSourceClassroomId?: number | undefined;
}

export enum BatchCourseAssignmentUpdateTypeEnum {
    Invalid = 0,
    Reopen = 1,
    Complete = 2,
}

export interface CourseAssignmentAggregateResponse {
    statCards: CourseAssignmentStatCardCounts;
    byPerson: CourseAssignmentPersonPivotItem[];
    byCourse: CourseAssignmentCoursePivotItem[];
}

/** The four StatCards. Overdue/DueInSevenDays/ExpiringInThirtyDays exclude rows with no relevant due/expiration date; LockedOut is state-based and has no such exclusion. */
export interface CourseAssignmentStatCardCounts {
    overdue: number;
    dueInSevenDays: number;
    expiringInThirtyDays: number;
    lockedOut: number;
}

export interface CourseAssignmentPersonPivotItem {
    userId: number;
    userName?: string | undefined;
    employeeId?: string | undefined;
    departmentId?: number | undefined;
    departmentName?: string | undefined;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    vendorId?: number | undefined;
    vendorName?: string | undefined;
    courseCount: number;
    overdueCount: number;
    /** Largest daysPastDue among this person's assignments (null if none are overdue). */
    worstLatenessDays?: number | undefined;
}

export interface CourseAssignmentCoursePivotItem {
    courseDefinitionId: number;
    courseDefinitionName?: string | undefined;
    assignmentCount: number;
    completedCount: number;
    completionPercent: number;
    overdueCount: number;
    firstTimeCount: number;
    renewalCount: number;
}

/** Shared filter surface for cross-course assignment queries - reused by the assignment list (V2), the compliance-cockpit aggregate endpoint, and the bulk-action selection contract (CourseAssignmentBulkActionRequest) so filtering logic lives in exactly one place (CourseAssignmentFilterQueryExtensions).            Includes the lateness bucket (Overdue/DueInSevenDays/...) so bulk actions (e.g. "Remind all Overdue") can express the same StatCard selection as the list grid. Evaluated against UtcNow at the point ApplyFilter runs, which for bulk actions is job-execution time rather than request time - the same predicate, just resolved later. GetCourseAssignmentAggregateRequest inherits this filter but the aggregate endpoint is never sent a bucket value in practice (it computes all four bucket counts itself). */
export interface CourseAssignmentFilter {
    courseDefinitionId?: number | undefined;
    courseDefinitionIds?: number[] | undefined;
    supervisorId?: number | undefined;
    departmentId?: number | undefined;
    vendorId?: number | undefined;
    projectId?: number | undefined;
    userTypes?: UserTypeEnum[] | undefined;
    activeStates?: boolean[] | undefined;
    states?: CourseAssignmentStateEnum[] | undefined;
    userActiveStates?: UserStatusEnum[] | undefined;
    latenessBucket?: CourseAssignmentLatenessBucketEnum | undefined;
}

/** Request for the compliance-cockpit aggregate endpoint: StatCard counts + by-person/by-course pivots, all computed over the same coarse filter used by the assignment list. */
export interface GetCourseAssignmentAggregateRequest extends CourseAssignmentFilter {
}

/** Response for bulk-action endpoints: enqueue is synchronous, resolution/execution is            not - callers poll job status via the Hangfire monitoring API using JobId. */
export interface CourseAssignmentBulkActionEnqueueResponse {
    jobId: string;
}

/** Shared selection contract for bulk assignment actions. Two selection modes: empty (default): selection is every row matching , minus  (explicitly unchecked rows on an otherwise "select all" action). This is Wave 2's original "spans the filter, not the page" behavior. non-empty: selection is exactly those ids, still intersected with the caller's permission/instance/project/company scope and with - an id outside either is silently dropped, not acted on. is still subtracted on top (harmless no-op in this mode, but keeps a single code path in CourseAssignmentFilterQueryExtensions.ApplyBulkActionScope). */
export interface CourseAssignmentBulkActionRequest {
    filter: CourseAssignmentFilter;
    excludedIds: number[];
    /** Explicit row selection (e.g. individually-ticked rows in the cockpit grid). Empty
            means "select all matching Filter" - see class doc comment for full semantics. */
    includedIds: number[];
}

/** Wave 2 bulk Extend contract. Exactly one of ExtendByDays / NewDueAt must be supplied - validated in CourseAssignmentBulkActionService.EnqueueBulkExtend. */
export interface CourseAssignmentBulkExtendRequest extends CourseAssignmentBulkActionRequest {
    /** Adds N days to each matching assignment's existing DueAt. Assignments with no
            DueAt are skipped (nothing to extend from) and reported back as skipped. */
    extendByDays?: number | undefined;
    /** Sets every matching assignment's DueAt to this absolute date, regardless of its
            current value (including assignments with no DueAt). */
    newDueAt?: Date | undefined;
}

/** Wave 3 bulk Waive contract. Creates a CourseAssignmentRuleExceptionEntry for every matched (definition, user) pair on every active rule of that definition currently covering the user - see CourseAssignmentBulkWaiveExecutionService. Deactivation, if any, is left to the rule-recalc job this action enqueues per affected definition, never applied directly here. */
export interface CourseAssignmentBulkWaiveRequest extends CourseAssignmentBulkActionRequest {
    reason: string;
    expiresAt?: Date | undefined;
}

export interface CourseAssignmentRuleResponse {
    id: number;
    courseDefinitionId: number;
    courseDefinitionName?: string | undefined;
    name?: string | undefined;
    active: boolean;
    selectAllEntityType?: EntityTypeEnum | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    sourceEntities: SourceEntityRecord[];
    resolvedCount: number;
}

export interface CourseAssignmentRuleCreateRequest {
    courseDefinitionId: number;
    name?: string | undefined;
    active: boolean;
    selectAllEntityType?: EntityTypeEnum | undefined;
    sourceEntities: SourceEntityRecord[];
}

export interface CourseAssignmentRuleUpdateRequest extends CourseAssignmentRuleCreateRequest {
    id: number;
}

export interface CourseAssignmentRulePreviewResponse {
    count: number;
    users: SelectOption[];
}

export interface CourseAssignmentRulePreviewRequest {
    ruleId?: number | undefined;
    courseDefinitionId?: number | undefined;
    selectAllEntityType?: EntityTypeEnum | undefined;
    sourceEntities?: SourceEntityRecord[] | undefined;
    start: number;
    length: number;
}

export interface CourseAssignmentRuleExceptionResponse {
    id: number;
    ruleId: number;
    userId: number;
    userName?: string | undefined;
    reason: string;
    expiresAt?: Date | undefined;
    createdAt: Date;
}

export interface CourseAssignmentRuleExceptionCreateRequest {
    ruleId: number;
    userId: number;
    reason: string;
    expiresAt?: Date | undefined;
}

export interface GetListResponseOfCourseClassroomSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CourseClassroomSimpleResponse[] | undefined;
}

export interface CourseClassroomSimpleResponse {
    id: number;
    creatorId?: number | undefined;
    internalIdentifier?: string | undefined;
    courseDefinitionId: number;
    courseDefinitionVersion: number;
    state: CourseClassroomStateEnum;
    startedAt?: Date | undefined;
    classroomAt?: Date | undefined;
    completedAt?: Date | undefined;
    startsAt?: Date | undefined;
    endsAt?: Date | undefined;
    location?: string | undefined;
    instructorId?: number | undefined;
    instructor?: PersonnelSimpleResponse | undefined;
    capacity?: number | undefined;
    notes?: string | undefined;
    metadata?: CourseClassroomMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    courseDefinition: CourseDefinitionSimpleResponse;
    attendees: CourseClassroomAttendeeResponse[];
}

export enum CourseClassroomStateEnum {
    Invalid = 0,
    NotStarted = 1,
    InProgress = 2,
    Completed = 3,
    Cancelled = 4,
}

export interface CourseClassroomMetadata {
}

export interface CourseClassroomAttendeeResponse {
    id: number;
    instanceId: number;
    classroomId: number;
    assignmentId: number;
    assignment?: CourseAssignmentSimpleResponse | undefined;
    attendance: CourseClassroomAttendanceEnum;
    result: CourseClassroomAttendeeResultEnum;
    signedOffById?: number | undefined;
    signedOffByName?: string | undefined;
    signedOffAt?: Date | undefined;
    note?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export enum CourseClassroomAttendanceEnum {
    Invalid = 0,
    Registered = 1,
    Present = 2,
    Absent = 3,
    Excused = 4,
}

export enum CourseClassroomAttendeeResultEnum {
    Invalid = 0,
    Pending = 1,
    Passed = 2,
    Failed = 3,
    Waived = 4,
}

export interface GetCourseClassroomListRequest extends GetListRequest {
    states?: CourseClassroomStateEnum[] | undefined;
    courseDefinitionId?: number | undefined;
    courseAssignmentId?: number | undefined;
}

export interface GetCourseClassroomListRequestV2 extends GetListRequestV2 {
    states?: CourseClassroomStateEnum[] | undefined;
    courseDefinitionId?: number | undefined;
    courseAssignmentId?: number | undefined;
    instructorId?: number | undefined;
    startsAfter?: Date | undefined;
    startsBefore?: Date | undefined;
}

export interface CourseClassroomResponse {
    id?: number | undefined;
    creatorId?: number | undefined;
    internalIdentifier?: string | undefined;
    courseDefinitionId: number;
    courseDefinitionVersion?: number | undefined;
    state?: CourseClassroomStateEnum | undefined;
    startedAt?: Date | undefined;
    classroomAt?: Date | undefined;
    completedAt?: Date | undefined;
    closedAt?: Date | undefined;
    closedById?: number | undefined;
    closedByName?: string | undefined;
    startsAt?: Date | undefined;
    endsAt?: Date | undefined;
    location?: string | undefined;
    instructorId?: number | undefined;
    instructor?: PersonnelSimpleResponse | undefined;
    capacity?: number | undefined;
    notes?: string | undefined;
    metadata?: CourseClassroomMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    courseDefinition?: CourseDefinitionSimpleResponse | undefined;
    attendees: SelectOption[];
}

export interface CourseClassroomRequest {
    id?: number | undefined;
    courseDefinitionId: number;
    courseDefinitionVersion?: number | undefined;
    classroomAt?: Date | undefined;
    startsAt?: Date | undefined;
    endsAt?: Date | undefined;
    location?: string | undefined;
    instructorId?: number | undefined;
    capacity?: number | undefined;
    notes?: string | undefined;
    metadata?: CourseClassroomMetadata | undefined;
    assignmentIds: number[];
}

export interface IStateMachineOfCourseClassroomStateEnum {
    states: StateOfCourseClassroomStateEnum[];
    transitions: TransitionOfCourseClassroomStateEnum[];
}

export interface StateOfCourseClassroomStateEnum {
    id: CourseClassroomStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfCourseClassroomStateEnum {
    name: string;
    from: CourseClassroomStateEnum[];
    to: CourseClassroomStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

/** Flat roster row - a dedicated projection (not a graph load through CourseClassroomAttendeeResponse/Assignment/AssignedTo) so the roster endpoint stays batch-safe for large classes. */
export interface CourseClassroomAttendeeRosterRowResponse {
    id: number;
    assignmentId: number;
    assignmentActive: boolean;
    assignmentState: CourseAssignmentStateEnum;
    userId: number;
    userName: string;
    employeeId?: string | undefined;
    departmentId?: number | undefined;
    departmentName?: string | undefined;
    vendorId?: number | undefined;
    vendorName?: string | undefined;
    attendance: CourseClassroomAttendanceEnum;
    result: CourseClassroomAttendeeResultEnum;
    signedOffById?: number | undefined;
    signedOffByName?: string | undefined;
    signedOffAt?: Date | undefined;
    note?: string | undefined;
    /** Set when a CourseCertificate exists for this
attendee's assignment, tied to the session this classroom's close-out created — lets
the roster link directly to the certificate view
(TrainingCourseSessionCertificate(definitionId, assignmentId, certificateSessionId)).
Null when no certificate has been issued yet, or when the certificate has no session
(the certificate view route requires one). */
    certificateSessionId?: number | undefined;
}

export interface CourseClassroomAttendeeAddRequest {
    classroomId: number;
    assignmentId: number;
}

export interface CourseClassroomAttendeeAddBatchRequest {
    classroomId: number;
    assignmentIds: number[];
}

export interface CourseClassroomAttendeeUpdateRequest {
    id: number;
    attendance?: CourseClassroomAttendanceEnum | undefined;
    result?: CourseClassroomAttendeeResultEnum | undefined;
    note?: string | undefined;
}

export interface CourseClassroomAttendeeBatchUpdateRequest {
    updates: CourseClassroomAttendeeUpdateRequest[];
}

/** Server-computed preview shown in the close-out review dialog before the admin confirms. */
export interface CourseClassroomCloseoutPreviewResponse {
    totalAttendees: number;
    /** Present + Passed/Waived, not already complete - will complete on close-out. */
    willCompleteCount: number;
    /** Absent/Excused (or never marked Present) - assignment stays open, untouched. */
    staysOpenCount: number;
    /** Assignment was already Complete before this close-out - skipped, not touched again. */
    alreadyCompletedCount: number;
    /** Present + Failed - session marked Failed, retake/lockout rules apply. */
    failedCount: number;
    /** Present but no Result recorded yet - stays open, flagged so the admin knows to
            resolve it (either now or by closing out again once results are recorded). */
    unresolvedCount: number;
    /** This classroom already signed this attendee off (a sign-off session from this
            classroom exists) - a re-run leaves them untouched. */
    alreadySignedOffCount: number;
    /** Of the attendees who will complete, how many have demonstration content - those
            will get a real pending sign-off task instead of being silently marked complete. */
    demonstrationsPendingCount: number;
    /** Always true today - classroom close-out marks lesson/quiz content complete as
            classroom-administered. Surfaced so the UI can state this explicitly rather than implying
            the trainee took the quiz online. */
    quizzesMarkedCompleteByClassroom: boolean;
}

export interface CourseClassroomCloseoutReceipt {
    classroomId: number;
    processedAt: Date;
    rows: CourseClassroomCloseoutReceiptRow[];
    completedCount: number;
    staysOpenCount: number;
    alreadyCompletedCount: number;
    failedCount: number;
    unresolvedCount: number;
    alreadySignedOffCount: number;
}

export interface CourseClassroomCloseoutReceiptRow {
    attendeeId: number;
    assignmentId: number;
    userId: number;
    userName?: string | undefined;
    outcome: CourseClassroomCloseoutOutcomeEnum;
}

/** Per-attendee outcome recorded for the close-out receipt. */
export enum CourseClassroomCloseoutOutcomeEnum {
    Completed = 1,
    StaysOpen = 2,
    AlreadyCompleted = 3,
    Failed = 4,
    Unresolved = 5,
    AlreadySignedOff = 6,
}

/** Result of an Undo Close-out call. Idempotent - a second call against an already-undone            (or never-closed) classroom returns an empty receipt rather than erroring. */
export interface CourseClassroomUndoCloseoutReceipt {
    classroomId: number;
    revertedAssignmentCount: number;
    deletedSessionCount: number;
}

/** Result of a classroom bulk certificate issuance. Every attendee on the roster is            accounted for by exactly one count, so the UI can explain why a certificate did not appear            instead of reporting a bare skip total. */
export interface CourseCertificateBulkIssueResponse {
    issuedCount: number;
    /** Assignment is not Complete - absent, failed, or awaiting a demonstration sign-off. */
    skippedNotCompleteCount: number;
    /** Assignment is Complete, but from a session outside this classroom - this class did
            not earn the completion, so it does not get to credit its instructor for one. */
    skippedCompletedElsewhereCount: number;
    /** A certificate for this assignment + session already exists. */
    skippedAlreadyIssuedCount: number;
    skippedCount: number;
    issued: CourseCertificateResponse[];
}

export interface CourseCertificateResponse {
    id: number;
    instanceId: number;
    assignmentId: number;
    sessionId?: number | undefined;
    issuedAt: Date;
    issuedById: number;
    issuedByName?: string | undefined;
    instructorId?: number | undefined;
    instructorName?: string | undefined;
    certificateNumber: string;
    additionalContent?: string | undefined;
}

export interface GetListResponseOfCourseDefinitionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CourseDefinitionSimpleResponse[] | undefined;
}

export interface GetCourseDefinitionListRequest extends GetListRequest {
    createdBy?: number | undefined;
    active?: boolean | undefined;
    whitelistIds?: number[] | undefined;
}

export interface GetCourseDefinitionListRequestV2 extends GetListRequestV2 {
    createdBy?: number | undefined;
}

export interface GetListResponseOfSelectOptionInvariant {
    filteredRecords: number;
    totalRecords: number;
    data?: SelectOptionInvariant[] | undefined;
}

export interface SelectOptionInvariant {
    id: string;
    label?: string | undefined;
}

export interface GetCourseDefinitionContentListRequest extends GetListRequest {
    courseDefinitionId?: number | undefined;
}

export interface CourseDefinitionVersionResponse {
    version: number;
    activeVersion: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    creatorName?: string | undefined;
}

/** Counts surfaced by the Wave 5 save-confirmation dialog. Both counts are computed against the definition's current ActiveVersion at request time (before the pending save mints a new version). */
export interface CourseDefinitionSaveImpactResponse {
    /** Assignments with an in-flight session (Open)
pinned to the current Active Version. Sessions pin their version at start
(CourseAssignmentTransitionService), so these learners finish on the current
version regardless of the save. */
    midSessionCount: number;
    /** Assignments that are still incomplete (Open/Pending) with no in-flight session. These will
pick up the new version on the next enrollment-relevant event (e.g. starting a session), since
CourseDefinitionMutationService.ProcessCourseUpdated bumps every assignment below the
new version. */
    openAssignmentCount: number;
}

export interface CourseQuizStatisticsResponse {
    quizzes: CourseQuizStatistic[];
    availableLanguages: string[];
    defaultLanguage: string;
}

export interface CourseQuizStatistic {
    quizId: number;
    quizName: string;
    questions: CourseQuizQuestionStatistic[];
}

export interface CourseQuizQuestionStatistic {
    questionId: number;
    questionText: string;
    correctAnswerCount: number;
    totalAnswerCount: number;
    percentageCorrect: number;
}

export interface CourseDefinitionRequest {
    id?: number | undefined;
    version: number;
    name: string;
    active: boolean;
    dueInDays?: number | undefined;
    isRenewalRequired?: boolean | undefined;
    renewalPeriodDays?: number | undefined;
    fixedRenewalMonth?: number | undefined;
    fixedRenewalDay?: number | undefined;
    isAttemptLimited?: boolean | undefined;
    attemptLimit?: number | undefined;
    attemptLockoutPeriodDays?: number | undefined;
    isCertificateGenerated?: boolean | undefined;
    certificateAdditionalContent?: string | undefined;
    certifyingTrainerName?: string | undefined;
    certifyingTrainerTitle?: string | undefined;
    defaultLanguage?: string | undefined;
    metadata?: CourseDefinitionMetadata | undefined;
    targetSourceEntityRequest: SourceEntityRequest;
    targetContents: CourseDefinitionContentRequest[];
    targetDependencies: number[];
    projectId?: number | undefined;
}

export interface CourseDefinitionContentRequest {
    invariantId: string;
    order: number;
    language: string;
    type: CourseDefinitionContentTypeEnum;
    timeLimit: number;
    lesson?: CourseDefinitionLessonRequest | undefined;
    quiz?: CourseDefinitionQuizRequest | undefined;
    demonstration?: CourseDefinitionDemonstrationRequest | undefined;
}

export interface CourseDefinitionLessonRequest {
    headerText?: string | undefined;
    bodyText?: string | undefined;
    videoProviderType?: VideoProviderTypeEnum | undefined;
    videoId?: number | undefined;
    videoUrl?: string | undefined;
    enableVideoActiveScreenMonitoring?: boolean | undefined;
    enableVideoControls?: boolean | undefined;
    enableVideoAutostart?: boolean | undefined;
    enableVideoResume?: boolean | undefined;
}

export interface CourseDefinitionQuizRequest {
    headerText?: string | undefined;
    bodyText?: string | undefined;
    scorePassPercentage?: number | undefined;
    enableGenerateCertificate: boolean;
    enableShowCorrectAnswersInResults: boolean;
    questions?: CourseDefinitionQuizQuestionRequest[] | undefined;
}

export interface CourseDefinitionQuizQuestionRequest {
    order?: number | undefined;
    labelText?: string | undefined;
    bodyText?: string | undefined;
    scoreValue?: number | undefined;
    type?: CourseDefinitionQuizQuestionTypeEnum | undefined;
    answers?: CourseDefinitionQuizQuestionAnswerRequest[] | undefined;
}

export interface CourseDefinitionQuizQuestionAnswerRequest {
    order?: number | undefined;
    text?: string | undefined;
    isCorrect?: boolean | undefined;
}

export interface CourseDefinitionDemonstrationRequest {
    headerText?: string | undefined;
    bodyText?: string | undefined;
    assignToUserId?: number | undefined;
    assignToUserGroupId?: number | undefined;
    demonstrationFormDefinitionId?: number | undefined;
    demonstrationFormDefinitionVersion?: number | undefined;
    skillId?: number | undefined;
    enableFailOnNotYetCompetent: boolean;
}

export interface BulkSetCourseDefinitionActiveRequest {
    ids?: number[] | undefined;
    active: boolean;
}

export interface GetListResponseOfCourseSessionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CourseSessionSimpleResponse[] | undefined;
}

export interface GetCourseSessionListRequest extends GetListRequest {
    active?: boolean | undefined;
    states?: CourseSessionStateEnum[] | undefined;
    assignmentId?: number | undefined;
    sessionUserId?: number | undefined;
    searchAllUsers?: boolean | undefined;
}

export interface CourseSessionBlendedResponse {
    session: CourseSessionResponse;
    definition: CourseDefinitionResponse;
    assignment: CourseAssignmentSimpleResponse;
}

export interface CourseSessionRequest {
    id?: number | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export interface CourseSessionCertificateResponse {
    type: CourseSessionCertificateTypeEnum;
    awardedToName?: string | undefined;
    courseName?: string | undefined;
    contentTitle?: string | undefined;
    additionalContent?: string | undefined;
    awardedAt?: Date | undefined;
    expiresAt?: Date | undefined;
    certifyingTrainerName?: string | undefined;
    certifyingTrainerTitle?: string | undefined;
    /** Populated when a stored CourseCertificate row exists for
this assignment/session (bulk/manual issuance, or the automatic issuance-on-completion path
for IsCertificateGenerated courses). This projection endpoint keeps working even when no row
exists yet (older completions never got a stored row) - CertificateNumber is simply null. */
    certificateNumber?: string | undefined;
    /** The instructor named on the stored certificate row, if any. Null when no stored row exists. */
    instructorName?: string | undefined;
}

export enum CourseSessionCertificateTypeEnum {
    Course = 1,
    Quiz = 2,
}

export interface CourseSessionCurrentContentResponse {
    hasContentRemaining?: boolean | undefined;
    contentDefinition?: CourseDefinitionContentResponse | undefined;
    contentSession?: CourseSessionContentResponse | undefined;
    currentContextIndex?: number | undefined;
    totalContentLength?: number | undefined;
    sessionId?: number | undefined;
    sessionState?: CourseSessionStateEnum | undefined;
    timeLimitBreached?: boolean | undefined;
}

export interface UpdateCurrentSessionContentRequest {
    sessionId: number;
    sessionContentId: number;
    type: CourseDefinitionContentTypeEnum;
}

export interface UpdateCurrentSessionLessonContentRequest extends UpdateCurrentSessionContentRequest {
    currentProgressSeconds: number;
}

export interface CloseCurrentSessionLessonContentRequest extends UpdateCurrentSessionContentRequest {
    currentProgressSeconds: number;
}

export interface CourseSessionContentQuizCompleteResponse {
    nextContent?: CourseSessionCurrentContentResponse | undefined;
    quizResults?: CourseSessionQuizResponse | undefined;
}

export interface CloseCurrentSessionQuizContentRequest extends UpdateCurrentSessionContentRequest {
    quizSubmission?: CourseSessionQuizRequest | undefined;
}

export interface CourseSessionQuizRequest {
    quizDefinitionId: number;
    questions?: CourseSessionQuizQuestionRequest[] | undefined;
}

export interface CourseSessionQuizQuestionRequest {
    isAnswersCorrect?: boolean | undefined;
    questionDefinitionId: number;
    answers?: CourseSessionQuizQuestionAnswerRequest[] | undefined;
}

export interface CourseSessionQuizQuestionAnswerRequest {
    isSelected?: boolean | undefined;
    answerDefinitionId: number;
}

export interface GetDemonstrationSummaryRequest {
    taskAssignmentId: number;
}

export interface CourseDemonstrationContextResponse {
    traineeName: string;
    courseName: string;
    demonstrationTitle?: string | undefined;
    sessionState: CourseSessionStateEnum;
    courseDefinitionId: number;
    courseAssignmentId: number;
    sessionId: number;
}

export interface GetListResponseOfCourseVideoResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CourseVideoResponse[] | undefined;
}

export interface GetCourseVideoListRequestV2 extends GetListRequestV2 {
    createdBy?: number | undefined;
}

export interface GetCourseVideoListRequest extends GetListRequest {
    createdBy?: number | undefined;
    active?: boolean | undefined;
}

export interface CourseVideoRequest {
    id?: number | undefined;
    title: string;
    description: string;
    contentKey: string;
    contentUrl: string;
    active?: boolean | undefined;
}

export interface CourseVideoUrlResponse {
    videoId: number;
    videoUrl: string;
    createdDate: Date;
    expirationDate: Date;
}

export interface GetListResponseOfDepartmentResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: DepartmentResponse[] | undefined;
}

export interface DepartmentResponse {
    id: number;
    internalIdentifier?: string | undefined;
    instanceId: number;
    code?: string | undefined;
    description?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface GetDepartmentListRequest extends GetListRequest {
    whitelistIds?: number[] | undefined;
}

export interface DeviceRequest {
    id?: number | undefined;
    siteId: number;
    equipmentTypeId: number;
    name?: string | undefined;
    serialNumber?: string | undefined;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    manufacturer?: string | undefined;
    model?: string | undefined;
    installDate?: Date | undefined;
    clientSubmissionId?: string | undefined;
}

export interface DeviceResponse extends DeviceRequest {
    id: number;
    instanceId: number;
    active: boolean;
    isVerified: boolean;
    siteName?: string | undefined;
    equipmentTypeName?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface GetListResponseOfDeviceSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: DeviceSimpleResponse[] | undefined;
}

export interface DeviceSimpleResponse {
    id: number;
    name?: string | undefined;
    serialNumber?: string | undefined;
    siteId: number;
    siteName?: string | undefined;
    equipmentTypeId: number;
    equipmentTypeName?: string | undefined;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    active: boolean;
    isVerified: boolean;
}

export interface GetDeviceListRequestV2 extends GetListRequestV2 {
    siteId?: number | undefined;
    equipmentTypeId?: number | undefined;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    active?: boolean | undefined;
    isVerified?: boolean | undefined;
}

export interface DeviceImportRequest {
    key: string;
    siteId: number;
}

export interface DocumentResponse {
    id: number;
    instanceId: number;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    parentId?: number | undefined;
    name: string;
    attachmentURL?: string | undefined;
    summaryDescription?: string | undefined;
    internalIdentifier?: string | undefined;
    isFolder: boolean;
    version: number;
    createdAt: Date;
    updatedAt: Date;
    path?: string | undefined;
    status: DocumentStatusEnum;
    pendingVersion?: number | undefined;
}

export enum DocumentStatusEnum {
    None = 0,
    PendingReview = 1,
    Approved = 2,
    Rejected = 3,
}

export interface GetListResponseOfDocumentResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: DocumentResponse[] | undefined;
}

export interface GetDocumentHistoryRequest extends GetListRequest {
    documentId?: number | undefined;
}

export interface GetDocumentHistoryRequestV2 extends GetListRequestV2 {
    documentId?: number | undefined;
}

export interface DocumentFolderResponse {
    name: string;
    path?: string | undefined;
    id: number;
    parentId?: number | undefined;
    response: GetListResponseOfDocumentResponse;
}

export interface GetDocumentListRequest extends GetListRequest {
    nodeId?: number | undefined;
}

export interface GetDocumentTreeRequest {
    parentId?: number | undefined;
    isLeaf?: boolean | undefined;
}

export interface DocumentCreateRequest {
    parentId?: number | undefined;
    name: string;
    attachmentURL?: string | undefined;
    summaryDescription?: string | undefined;
    isFolder: boolean;
}

export interface DocumentUpdateRequest {
    id: number;
    version: number;
    name: string;
    attachmentURL?: string | undefined;
    summaryDescription?: string | undefined;
}

export interface DocumentMoveRequest {
    id: number;
    version?: number | undefined;
    newParentId: number;
}

export interface DocumentReviewEffectiveRulesResponse {
    approval?: DocumentReviewEffectiveRuleResponse | undefined;
    acknowledgment?: DocumentReviewEffectiveRuleResponse | undefined;
}

export interface DocumentReviewEffectiveRuleResponse {
    rule: DocumentReviewRuleResponse;
    isInherited: boolean;
    sourceFolderId: number;
    sourceFolderName?: string | undefined;
}

export interface DocumentReviewRuleResponse {
    id: number;
    folderId: number;
    folderName?: string | undefined;
    reviewType: DocumentReviewTypeEnum;
    completionMode: DocumentReviewCompletionModeEnum;
    active: boolean;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    sourceEntities: SourceEntityRecord[];
}

export enum DocumentReviewTypeEnum {
    Invalid = 0,
    Approval = 1,
    Acknowledgment = 2,
}

export enum DocumentReviewCompletionModeEnum {
    Invalid = 0,
    AnyOneApprover = 1,
    AllApprovers = 2,
}

export interface DocumentReviewRuleCreateRequest {
    folderId: number;
    reviewType: DocumentReviewTypeEnum;
    completionMode: DocumentReviewCompletionModeEnum;
    active: boolean;
    sourceEntities: SourceEntityRecord[];
}

export interface DocumentReviewRuleUpdateRequest extends DocumentReviewRuleCreateRequest {
    id: number;
}

export interface DocumentReviewRoundResponse {
    id: number;
    documentId: number;
    documentVersion: number;
    documentReviewRuleId: number;
    reviewType: DocumentReviewTypeEnum;
    state: DocumentReviewRequestStateEnum;
    requestedById?: number | undefined;
    requestedByName?: string | undefined;
    resolvedById?: number | undefined;
    resolvedByName?: string | undefined;
    resolutionComment?: string | undefined;
    resolvedAt?: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
    taskDefinitionId?: number | undefined;
    taskType: TaskTypeEnum;
    participationStatistics?: TaskParticipationStatistics | undefined;
}

export enum DocumentReviewRequestStateEnum {
    Invalid = 0,
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Completed = 4,
    Cancelled = 5,
}

export interface DocumentReviewRequestsListRequest {
    documentId: number;
}

export interface GetListResponseOfDocumentReviewRoundListItemResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: DocumentReviewRoundListItemResponse[] | undefined;
}

export interface DocumentReviewRoundListItemResponse {
    id: number;
    documentId: number;
    documentVersion: number;
    documentName: string;
    reviewType: DocumentReviewTypeEnum;
    state: DocumentReviewRequestStateEnum;
    taskDefinitionId?: number | undefined;
    taskType: TaskTypeEnum;
    requestedById?: number | undefined;
    requestedByName?: string | undefined;
    resolvedById?: number | undefined;
    resolvedByName?: string | undefined;
    resolutionComment?: string | undefined;
    resolvedAt?: Date | undefined;
    createdAt: Date;
    completed: number;
    total: number;
}

export interface DocumentReviewRoundsListRequest extends GetListRequest {
    reviewType: DocumentReviewTypeEnum;
    states?: DocumentReviewRequestStateEnum[] | undefined;
    searchText?: string | undefined;
}

export interface DocumentReviewReRequestRequest {
    documentId: number;
    version: number;
}

export interface EquipmentTypeRequest {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    inspectionTypeIds: number[];
}

export interface EquipmentTypeResponse extends EquipmentTypeRequest {
    id: number;
    instanceId: number;
    active: boolean;
    fieldFormDefinitionId?: number | undefined;
    fieldCount: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface GetListResponseOfEquipmentTypeSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: EquipmentTypeSimpleResponse[] | undefined;
}

export interface EquipmentTypeSimpleResponse {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    fieldCount: number;
}

export interface FormFieldResponse {
    id: number;
    invariantId: string;
    formDefinitionId: number;
    version: number;
    active: boolean;
    formFieldType: FormFieldTypeEnum;
    subFormDefinitionId?: number | undefined;
    subFormType?: SubFormTypeEnum | undefined;
    htmlName: string;
    shortLabel?: string | undefined;
    label: string;
    required: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isComplianceEventField?: boolean | undefined;
    complianceEventTriggerValue?: string | undefined;
    isFailureTriggerField?: boolean | undefined;
    failureTriggerValue?: string | undefined;
    referenceImageKey?: string | undefined;
    referenceImageUrl?: string | undefined;
    description?: string | undefined;
    labelTooltip?: string | undefined;
    defaultValue?: string | undefined;
    order?: number | undefined;
    slug?: string | undefined;
    size?: string | undefined;
    textboxOptions: TextboxOptions;
    switchOptions: SwitchOptions;
    fileUploadOptions: FileUploadOptions;
    assetOptions: AssetOptions;
    personOptions: PersonOptions;
    subFormOptions: SubFormOptions;
    scaleOptions: ScaleOptions;
    validationOptions: ValidationOptions;
    visibilityOptions: VisibilityOptions;
    measurementOptions: MeasurementOptions;
    selectOptions: FormFieldSelectOptions[];
    complianceStandardIds?: SelectOption[] | undefined;
    measurementUnits: string[];
}

export enum SubFormTypeEnum {
    Invalid = 0,
    Internal = 1,
    External = 2,
    Both = 3,
}

export interface TextboxOptions {
    multiline?: boolean | undefined;
    numberOfLines?: number | undefined;
    validationType?: FormFieldTypeValidationEnum | undefined;
}

export enum FormFieldTypeValidationEnum {
    Invalid = 0,
    Name = 1,
    Email = 2,
    Address = 3,
    Phone = 4,
    Number = 5,
    Url = 6,
    Percent = 7,
    Currency = 8,
    DecimalNumber = 9,
    Video = 10,
    Audio = 11,
    Image = 12,
    Time = 13,
}

export interface SwitchOptions {
    positiveText?: string | undefined;
    negativeText?: string | undefined;
    positiveColor?: string | undefined;
    negativeColor?: string | undefined;
}

export interface FileUploadOptions {
    allowMultiple?: boolean | undefined;
    allowedFileTypes?: string | undefined;
    maxFileSize?: number | undefined;
    isHideUploadSuccessEnabled?: boolean | undefined;
    renderUploadsAsImage?: boolean | undefined;
}

export interface AssetOptions {
    rootAssetId?: number | undefined;
    includeLeaves?: boolean | undefined;
    requireLeaf?: boolean | undefined;
    showFullPath?: boolean | undefined;
}

export interface PersonOptions {
    hideSelectAll?: boolean | undefined;
    includeInactive?: boolean | undefined;
}

export interface SubFormOptions {
    subFormDefinitionId?: number | undefined;
    showPreviewComponent?: boolean | undefined;
}

export interface ScaleOptions {
    leastValueText?: string | undefined;
    mostValueText?: string | undefined;
}

export interface ValidationOptions {
    min?: number | undefined;
    max?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;
    patternError?: string | undefined;
    customError?: string | undefined;
}

export interface VisibilityOptions {
    isDefaultHidden?: boolean | undefined;
    rules?: VisibilityRule[] | undefined;
}

export interface VisibilityRule {
    offlineId?: string | undefined;
    targetFieldInvariantId: string;
    fieldValue: string;
    visibility: boolean;
}

export interface MeasurementOptions {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    decimalPlaces?: number | undefined;
}

export interface FormFieldSelectOptions {
    id: string;
    label: string;
    orderId: number;
    color?: string | undefined;
}

export interface FormFieldRequest {
    invariantId?: string | undefined;
    active?: boolean | undefined;
    formFieldType: FormFieldTypeEnum;
    subFormDefinitionId?: number | undefined;
    subFormType?: SubFormTypeEnum | undefined;
    htmlName: string;
    shortLabel?: string | undefined;
    label: string;
    required: boolean;
    isComplianceEventField?: boolean | undefined;
    complianceEventTriggerValue?: string | undefined;
    isFailureTriggerField?: boolean | undefined;
    failureTriggerValue?: string | undefined;
    referenceImageKey?: string | undefined;
    referenceImageUrl?: string | undefined;
    description?: string | undefined;
    labelTooltip?: string | undefined;
    defaultValue?: string | undefined;
    order?: number | undefined;
    slug?: string | undefined;
    size?: string | undefined;
    textboxOptions: TextboxOptions;
    switchOptions: SwitchOptions;
    fileUploadOptions: FileUploadOptions;
    assetOptions: AssetOptions;
    personOptions: PersonOptions;
    subFormOptions: SubFormOptions;
    scaleOptions: ScaleOptions;
    validationOptions: ValidationOptions;
    visibilityOptions: VisibilityOptions;
    measurementOptions: MeasurementOptions;
    selectOptions: FormFieldSelectOptions[];
    targetComplianceStandardIds?: number[] | undefined;
    measurementUnits?: string[] | undefined;
}

export interface EquipmentTypeImportRequest {
    key: string;
}

export interface UploadResponse {
    accessUrl: string;
    key: string;
    uploadUrl: string;
}

export interface UploadPreSignedFileRequest {
    filename: string;
    type: string;
}

export interface GetListResponseOfFormCategorySimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: FormCategorySimpleResponse[] | undefined;
}

export interface FormCategorySimpleResponse {
    id: number;
    name: string;
}

export interface FormCategoryRequest {
    id?: number | undefined;
    name?: string | undefined;
}

export interface GetListResponseOfFormSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: FormSimpleResponse[] | undefined;
}

export interface FormSimpleResponse {
    id: number;
    shortDescription?: string | undefined;
    internalIdentifier?: string | undefined;
    formDefinitionId: number;
    state: FormStateEnum;
    createdAt: Date;
    updatedAt: Date;
    publishedAt?: Date | undefined;
    creator: PersonnelSimpleResponse;
    formDefinition: FormDefinitionSimpleResponse;
    anonymousSubmission: boolean;
}

export interface FormDefinitionSimpleResponse {
    id: number;
    version: number;
    uniqueIdentifier: string;
    active: boolean;
    subformOnly: boolean;
    extensionOnly: boolean;
    failable: boolean;
    name: string;
    title: string;
    description: string;
    metadata?: FormDefinitionMetadata | undefined;
    creator: PersonnelSimpleResponse;
    sensitiveData: boolean;
    accessAllowSupervisors: boolean;
    accessAllowEditAfterPublish: boolean;
    project?: ProjectSimpleResponse | undefined;
    category?: FormCategorySimpleResponse | undefined;
}

export interface FormDefinitionMetadata {
    description?: string | undefined;
    anonymousSubmission?: boolean | undefined;
    cache?: string | undefined;
    enableFormIdentifierField: boolean;
}

export interface GetFormListRequest extends GetListRequest {
    createdBy?: number | undefined;
    formDefinitionId?: number | undefined;
    states?: FormStateEnum[] | undefined;
    complianceValues?: number[] | undefined;
}

export interface GetFormListRequestV2 extends GetListRequestV2 {
    createdBy?: number | undefined;
    formDefinitionId?: number | undefined;
    formFieldFilters?: FormFieldFilterRequest[] | undefined;
}

export interface FormFieldFilterRequest {
    fieldInvariantId: string;
    operand: string;
    value: string;
}

export interface GetListResponseOfFormRelatedTaskSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: FormRelatedTaskSimpleResponse[] | undefined;
}

export interface FormRelatedTaskSimpleResponse {
    id: number;
    formId: number;
    taskDefinitionId: number;
    taskAssignmentId: number;
    assignedTo: string;
    subject: string;
    dueAt?: Date | undefined;
    state: TaskAssignmentStateEnum;
    taskType: TaskTypeEnum;
}

export interface GetFormRelatedTasksListRequestV2 extends GetListRequestV2 {
    formId?: number | undefined;
}

export interface FormResponse {
    id: number;
    internalIdentifier?: string | undefined;
    shortDescription?: string | undefined;
    clientSubmissionId?: string | undefined;
    formDefinitionId: number;
    parentId?: number | undefined;
    subFormType?: SubFormTypeEnum | undefined;
    creatorId?: number | undefined;
    state: FormStateEnum;
    metadata?: FormMetadata | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    parent?: FormSimpleResponse | undefined;
    children?: FormChildResponse[] | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    formDefinition?: FormDefinitionSimpleResponse | undefined;
    fieldValues?: FormFieldValueSimpleResponse[] | undefined;
    analyticSafetyEvents?: SafetyEventSimpleResponse[] | undefined;
    anonymousSubmission: boolean;
}

export interface FormMetadata {
    cache?: string | undefined;
    formFieldId?: string | undefined;
    taskAssignmentId?: number | undefined;
}

export interface FormChildResponse {
    id: number;
    internalIdentifier?: string | undefined;
    formDefinitionId: number;
    parentId?: number | undefined;
    subFormType?: SubFormTypeEnum | undefined;
    creatorId?: number | undefined;
    state: FormStateEnum;
    metadata?: FormMetadata | undefined;
    createdAt: Date;
    updatedAt: Date;
    parent?: FormSimpleResponse | undefined;
    fieldValues?: FormFieldValueSimpleResponse[] | undefined;
    analyticSafetyEvents?: SafetyEventSimpleResponse[] | undefined;
    anonymousSubmission: boolean;
}

export interface FormFieldValueSimpleResponse {
    id: number;
    value?: string | undefined;
    displayValue?: string | undefined;
    subFormFieldId?: number | undefined;
    createdAt: Date;
    metadata: FormFieldValueMetadata;
    formField: FormFieldSimpleResponse;
}

export interface FormFieldValueMetadata {
    entities?: FormFieldValueEntity[] | undefined;
    cache?: string | undefined;
}

export interface FormFieldValueEntity {
    entityType: EntityTypeEnum;
    entityId: number;
}

export interface FormFieldSimpleResponse {
    id: number;
    invariantId: string;
    version: number;
    active: boolean;
    formFieldType: FormFieldTypeEnum;
    subFormDefinitionId?: number | undefined;
    subFormType?: SubFormTypeEnum | undefined;
    subFormFieldId?: number | undefined;
    subFormFieldInvariantId?: string | undefined;
    shortLabel?: string | undefined;
    label: string;
    required: boolean;
    isComplianceEventField?: boolean | undefined;
    complianceEventTriggerValue?: string | undefined;
    isFailureTriggerField?: boolean | undefined;
    failureTriggerValue?: string | undefined;
    referenceImageKey?: string | undefined;
    referenceImageUrl?: string | undefined;
    description?: string | undefined;
    labelTooltip?: string | undefined;
    defaultValue?: string | undefined;
    order?: number | undefined;
    slug?: string | undefined;
    size?: string | undefined;
    textboxOptions: TextboxOptions;
    switchOptions: SwitchOptions;
    fileUploadOptions: FileUploadOptions;
    assetOptions: AssetOptions;
    personOptions: PersonOptions;
    subFormOptions: SubFormOptions;
    scaleOptions: ScaleOptions;
    validationOptions: ValidationOptions;
    visibilityOptions: VisibilityOptions;
    measurementOptions: MeasurementOptions;
    selectOptions: FormFieldSelectOptions[];
    complianceStandardIds?: SelectOption[] | undefined;
    measurementUnits: string[];
}

export interface SafetyEventSimpleResponse {
    id: number;
    shortDescription?: string | undefined;
    internalIdentifier?: string | undefined;
    state: SafetyEventStateEnum;
    jobDescription?: string | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;
    createdAt?: Date | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    safetyReviewer?: PersonnelSimpleResponse | undefined;
}

export enum SafetyEventStateEnum {
    Invalid = 0,
    Assemble = 1,
    Published = 2,
}

export interface FormRequest {
    id?: number | undefined;
    shortDescription?: string | undefined;
    clientSubmissionId?: string | undefined;
    formDefinitionId: number;
    formDefinitionVersion: number;
    formFieldId?: number | undefined;
    subFormType: SubFormTypeEnum;
    metadata?: FormMetadata | undefined;
    targetFieldValues: FormFieldValueRequest[];
    extensionTabId?: number | undefined;
    targetEntityType?: EntityIdentifierEnum | undefined;
    targetEntityId?: number | undefined;
}

export interface FormFieldValueRequest {
    id?: number | undefined;
    formFieldId: number;
    subFormFieldId?: number | undefined;
    value?: string | undefined;
    displayValue?: string | undefined;
    metadata?: FormFieldValueMetadata | undefined;
}

export interface IStateMachineOfFormStateEnum {
    states: StateOfFormStateEnum[];
    transitions: TransitionOfFormStateEnum[];
}

export interface StateOfFormStateEnum {
    id: FormStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfFormStateEnum {
    name: string;
    from: FormStateEnum[];
    to: FormStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface GetListResponseOfUserReferencedFormResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: UserReferencedFormResponse[] | undefined;
}

export interface UserReferencedFormResponse {
    formId: number;
    formName: string;
    formDefinitionId: number;
    formDefinitionVersion: number;
    fieldLabel: string;
    createdAt: Date;
    createdBy: string;
    formStatus: FormStateEnum;
    identifier: string;
    project?: string | undefined;
    publishedAt?: Date | undefined;
    formVersion: number;
}

export interface UserReferencedFormsRequest extends GetListRequestV2 {
    userId: number;
}

/** Start/Length are inherited but deliberately ignored — the export never pages. Only Filters/FilterFns/Sorting from the base GetListRequestV2 are applied, via ApplyListV2. */
export interface FormSubmissionExportRequest extends GetListRequestV2 {
    scope: FormSubmissionScopeEnum;
    formDefinitionId?: number | undefined;
    createdBy?: number | undefined;
    formFieldFilters?: FormFieldFilterRequest[] | undefined;
    moduleExtensionFormTabId?: number | undefined;
    targetEntityId?: number | undefined;
    assetId?: number | undefined;
    userId?: number | undefined;
}

export enum FormSubmissionScopeEnum {
    Submissions = 1,
    ExtensionTab = 2,
    AssetRelated = 3,
    UserReferenced = 4,
}

/** Response from the manifest endpoint — metadata only, no file bytes. */
export interface FormPackageManifestResponse {
    formId: number;
    internalIdentifier?: string | undefined;
    items: FormPackageManifestItem[];
}

/** A single downloadable file entry in the form package manifest. */
export interface FormPackageManifestItem {
    /** Stable selection key — the S3 key for the file. Used as checkbox identifier on the frontend. */
    key: string;
    /** Display name of the file (original filename or attachment name). */
    displayName: string;
    /** The source entity kind — drives zip foldering and group routing in the package builder. */
    sourceKind: PackageSourceKind;
    /** Name of the originating subform or action; null for the root form. Used as the zip folder name. */
    sourceLabel?: string | undefined;
    /** Human-readable group label, derived from SourceKind and SourceLabel.
For display/grouping only — never parsed back into routing logic. */
    sourceGroup: string;
    /** The label of the originating field or the attachment name. */
    originLabel: string;
    /** Whether the underlying file currently exists in storage. Probed at manifest time so the UI can
flag missing files as unavailable and exclude them from selection. Best-effort: availability may
still change before the package is built (the manifest.json in the export is authoritative). */
    available: boolean;
}

/** The kind of entity a packaged file originates from. Drives zip layout and grouping; the human-readable SourceGroup is derived from this, never round-tripped back. */
export enum PackageSourceKind {
    Form = 0,
    Subform = 1,
    Action = 2,
}

/** Request body for the package endpoint. */
export interface FormPackageRequest {
    /** When true, related action attachments are candidates for inclusion.
The SelectedKeys list still controls which files are actually packaged. */
    includeRelatedActions: boolean;
    /** When true, the server renders the form PDF and adds it to the package as form.pdf. */
    includePdf: boolean;
    /** S3 keys of files the user has selected to include.
Only keys present in the server-side manifest are honoured. */
    selectedKeys: string[];
}

export interface GetListResponseOfFormDefinitionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: FormDefinitionSimpleResponse[] | undefined;
}

export interface GetFormDefinitionListRequest extends GetListRequest {
    createdBy?: number | undefined;
    active?: boolean | undefined;
    includeSubforms?: boolean | undefined;
    includeExtensionOnly?: boolean | undefined;
    isRestrictedAccess?: boolean | undefined;
    categoryId?: number | undefined;
    whitelistIds?: number[] | undefined;
}

export interface GetFormDefinitionListRequestV2 extends GetListRequestV2 {
    includeSubforms?: boolean | undefined;
    isRestrictedAccess?: boolean | undefined;
}

export interface GetListResponseOfFormFieldSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: FormFieldSimpleResponse[] | undefined;
}

export interface GetFormDefinitionFormFieldListRequest extends GetListRequest {
    formDefinitionId: number;
    fieldTypes?: FormFieldTypeEnum[] | undefined;
}

export interface FormDefinitionCategoryCountsResponse {
    total: number;
    categories: FormCategoryCountResponse[];
}

export interface FormCategoryCountResponse {
    id: number;
    name: string;
    count: number;
}

export interface FormDefinitionNavigationResponse {
    id: number;
    name: string;
}

export interface FormDefinitionOfflineBundleResponse {
    definitions: FormDefinitionResponse[];
    personnel?: OfflinePersonnelSection | undefined;
    assets?: OfflineAssetSection | undefined;
}

export interface FormDefinitionResponse {
    id: number;
    internalIdentifier?: string | undefined;
    uniqueIdentifier: string;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    version: number;
    active: boolean;
    name: string;
    title: string;
    subformOnly: boolean;
    extensionOnly: boolean;
    triggerAnalyticSafetyEvent: boolean;
    failable: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata?: FormDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    forms: FormSimpleResponse[];
    formFields: FormFieldSimpleResponse[];
    sensitiveData: boolean;
    accessAllowSupervisors: boolean;
    accessAllowEditAfterPublish: boolean;
    accessAllowUserGroups: FormDefinitionAccessUserGroupResponse[];
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
    categoryId?: number | undefined;
    category?: FormCategorySimpleResponse | undefined;
}

export interface FormDefinitionAccessUserGroupResponse {
    id: number;
    formDefinitionId: number;
    formDefinitionVersion: number;
    userGroupId: number;
}

export interface OfflinePersonnelSection {
    scopeProjectId?: number | undefined;
    includesInactive: boolean;
    rows: OfflinePersonnelRow[];
}

export interface OfflinePersonnelRow {
    id: number;
    name: string;
    active: UserStatusEnum;
    userType: UserTypeEnum;
}

export interface OfflineAssetSection {
    scopeProjectId?: number | undefined;
    rows: OfflineAssetRow[];
}

export interface OfflineAssetRow {
    id: number;
    name: string;
    parentId?: number | undefined;
    isLeaf: boolean;
    path: string;
}

export interface FormDefinitionRequest {
    id?: number | undefined;
    version?: number | undefined;
    active: boolean;
    uniqueIdentifier: string;
    name: string;
    title: string;
    subformOnly: boolean;
    extensionOnly: boolean;
    triggerAnalyticSafetyEvent: boolean;
    failable: boolean;
    metadata?: FormDefinitionMetadata | undefined;
    targetFormFields?: FormFieldRequest[] | undefined;
    targetCompliance?: number[] | undefined;
    sensitiveData: boolean;
    accessAllowSupervisors: boolean;
    accessAllowEditAfterPublish: boolean;
    targetAccessUserGroupIds?: number[] | undefined;
    projectId?: number | undefined;
    categoryId?: number | undefined;
}

export interface FormDefinitionDependenciesResponse {
    notificationRules: FormDefinitionDependencyItem[];
    workflowDefinitions: FormDefinitionDependencyItem[];
    parentForms: FormDefinitionDependencyItem[];
    hasDependencies: boolean;
}

export interface FormDefinitionDependencyItem {
    id: number;
    name?: string | undefined;
}

export interface TestEmailNotificationModel {
    subject?: string | undefined;
    text?: string | undefined;
    actionText?: string | undefined;
    url?: string | undefined;
    messages?: string[] | undefined;
}

export interface InspectionResponse {
    id: number;
    siteId: number;
    siteName: string;
    siteNumber?: string | undefined;
    clientId?: number | undefined;
    clientName?: string | undefined;
    inspectionTypeId: number;
    inspectionTypeName: string;
    inspectionTypeStandards?: string | undefined;
    state: InspectionStateEnum;
    assigneeId?: number | undefined;
    assigneeName?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    scheduledStartAt?: Date | undefined;
    dueAt?: Date | undefined;
    completedAt?: Date | undefined;
    startLatitude?: number | undefined;
    startLongitude?: number | undefined;
    startGeoCapturedAt?: Date | undefined;
    startGeoNote?: string | undefined;
    endLatitude?: number | undefined;
    endLongitude?: number | undefined;
    endGeoCapturedAt?: Date | undefined;
    endGeoNote?: string | undefined;
    passCount: number;
    failCount: number;
    noAccessCount: number;
    deficiencyOpenCount: number;
    deficiencyResolvedCount: number;
    remainingCount: number;
    scopedDeviceCount: number;
    buildingCount: number;
    floorCount: number;
    inspectionScheduleId?: number | undefined;
    inspectionScheduleCadence?: InspectionScheduleCadenceEnum | undefined;
    inspectionScheduleIntervalDays?: number | undefined;
    auditEvents: InspectionAuditEventResponse[];
    createdAt: Date;
    updatedAt: Date;
}

export enum InspectionStateEnum {
    Invalid = 0,
    Draft = 1,
    InProgress = 2,
    Completed = 3,
    Scheduled = 4,
}

export enum InspectionScheduleCadenceEnum {
    Invalid = 0,
    Quarterly = 1,
    Annual = 2,
    Custom = 3,
}

export interface InspectionAuditEventResponse {
    eventType: InspectionAuditEventTypeEnum;
    reason: string;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt: Date;
}

export enum InspectionAuditEventTypeEnum {
    Invalid = 0,
    Reopened = 1,
}

export interface InspectionRequest {
    id?: number | undefined;
    siteId: number;
    inspectionTypeId: number;
    dueAt?: Date | undefined;
    assigneeId?: number | undefined;
}

export interface GetListResponseOfInspectionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: InspectionSimpleResponse[] | undefined;
}

export interface GetInspectionListResponse extends GetListResponseOfInspectionSimpleResponse {
    unassignedCount: number;
}

export interface InspectionSimpleResponse {
    id: number;
    siteId: number;
    siteName: string;
    siteNumber?: string | undefined;
    siteAddress?: string | undefined;
    clientId?: number | undefined;
    clientName?: string | undefined;
    inspectionTypeId: number;
    inspectionTypeName: string;
    state: InspectionStateEnum;
    assigneeId?: number | undefined;
    assigneeName?: string | undefined;
    scheduledStartAt?: Date | undefined;
    dueAt?: Date | undefined;
    completedAt?: Date | undefined;
    createdAt: Date;
    inspectionScheduleId?: number | undefined;
    inspectionScheduleCadence?: InspectionScheduleCadenceEnum | undefined;
    inspectionScheduleIntervalDays?: number | undefined;
    scopedDeviceCount: number;
    terminalDeviceCount: number;
}

export interface GetInspectionListRequestV2 extends GetListRequestV2 {
    siteId?: number | undefined;
    clientId?: number | undefined;
    inspectionTypeId?: number | undefined;
    inspectionScheduleId?: number | undefined;
    states?: InspectionStateEnum[] | undefined;
    assigneeId?: number | undefined;
    assignedToAnyone: boolean;
    manageView: boolean;
    hasFailures?: boolean | undefined;
    building?: string | undefined;
    search?: string | undefined;
}

export interface InspectionAssignRequest {
    assigneeId: number;
}

export interface InspectionAssigneeCandidateResponse {
    userId: number;
    name: string;
    openInspectionCount: number;
}

export interface InspectionTransitionRequest {
    transition: string;
    note?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    geoNote?: string | undefined;
}

export interface IStateMachineOfInspectionStateEnum {
    states: StateOfInspectionStateEnum[];
    transitions: TransitionOfInspectionStateEnum[];
}

export interface StateOfInspectionStateEnum {
    id: InspectionStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfInspectionStateEnum {
    name: string;
    from: InspectionStateEnum[];
    to: InspectionStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface InspectionScopeDeviceResponse {
    deviceId: number;
    name?: string | undefined;
    serialNumber?: string | undefined;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    equipmentTypeId: number;
    equipmentTypeName?: string | undefined;
    deviceIsDeleted: boolean;
    isVerified: boolean;
    inspectionDeviceId?: number | undefined;
    complianceState?: ComplianceStateEnum | undefined;
}

export enum ComplianceStateEnum {
    Invalid = 0,
    Pass = 1,
    Fail = 2,
    NoAccess = 3,
}

export interface InspectionOfflineBundleResponse {
    inspection: InspectionResponse;
    devices: InspectionScopeDeviceResponse[];
    fieldSets: InspectionOfflineFieldSetResponse[];
    deviceHistory: InspectionOfflineDeviceHistoryResponse[];
}

export interface InspectionOfflineFieldSetResponse {
    equipmentTypeId: number;
    fieldFormDefinitionId?: number | undefined;
    effectiveVersion?: number | undefined;
    fields: FormFieldResponse[];
}

export interface InspectionOfflineDeviceHistoryResponse {
    deviceId: number;
    entries: InspectionDeviceHistoryEntryResponse[];
}

export interface InspectionDeviceHistoryEntryResponse {
    inspectionId: number;
    inspectionTypeName: string;
    inspectionState: InspectionStateEnum;
    inspectionDate?: Date | undefined;
    complianceState?: ComplianceStateEnum | undefined;
    comments?: string | undefined;
    inspectorName?: string | undefined;
    values: InspectionDeviceHistoryFieldValueResponse[];
    attachments: AttachmentSimpleResponse[];
}

export interface InspectionDeviceHistoryFieldValueResponse {
    formFieldInvariantId: string;
    label: string;
    value?: string | undefined;
    displayValue?: string | undefined;
    unit?: string | undefined;
}

export interface InspectionDeviceEntryResponse {
    inspectionDeviceId?: number | undefined;
    deviceId: number;
    deviceName: string;
    serialNumber?: string | undefined;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    equipmentTypeId: number;
    equipmentTypeName: string;
    complianceState?: ComplianceStateEnum | undefined;
    inspectedAt?: Date | undefined;
    comments?: string | undefined;
    fieldFormDefinitionId?: number | undefined;
    effectiveVersion?: number | undefined;
    fields: FormFieldResponse[];
    values: InspectionDeviceFieldValueResponse[];
    attachments: AttachmentSimpleResponse[];
}

export interface InspectionDeviceFieldValueResponse {
    formFieldId: number;
    formFieldInvariantId: string;
    value?: string | undefined;
    displayValue?: string | undefined;
    unit?: string | undefined;
}

export interface InspectionDeviceRecordRequest {
    effectiveVersion?: number | undefined;
    complianceState?: ComplianceStateEnum | undefined;
    comments?: string | undefined;
    values: InspectionDeviceFieldValueRequest[];
}

export interface InspectionDeviceFieldValueRequest {
    formFieldId: number;
    value?: string | undefined;
    unit?: string | undefined;
}

export interface InspectionDeviceAttachmentRequest {
    name: string;
    description?: string | undefined;
    expiresAt?: Date | undefined;
    contentUrl: string;
    key: string;
    classificationId?: number | undefined;
    clientSubmissionId?: string | undefined;
}

export interface GetListResponseOfDeficiencyResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: DeficiencyResponse[] | undefined;
}

export interface DeficiencyResponse {
    id: number;
    inspectionId: number;
    inspectionTypeName: string;
    siteId: number;
    siteName: string;
    inspectionDeviceId: number;
    deviceId: number;
    deviceName: string;
    serialNumber?: string | undefined;
    equipmentTypeName?: string | undefined;
    deviceIsDeleted: boolean;
    building?: string | undefined;
    floor?: string | undefined;
    room?: string | undefined;
    comments?: string | undefined;
    status: DeficiencyStatusEnum;
    resolutionSource?: DeficiencyResolutionSourceEnum | undefined;
    resolvedAt?: Date | undefined;
    resolvedById?: number | undefined;
    resolvedByName?: string | undefined;
    resolutionNote?: string | undefined;
    attachments: AttachmentSimpleResponse[];
    createdAt: Date;
    updatedAt: Date;
}

export enum DeficiencyStatusEnum {
    Invalid = 0,
    Open = 1,
    Resolved = 2,
}

export enum DeficiencyResolutionSourceEnum {
    Invalid = 0,
    Auto = 1,
    Manual = 2,
    Reverted = 3,
}

export interface ComplianceLetterDraftResponse {
    sections: ComplianceLetterSectionDto[];
}

export interface ComplianceLetterSectionDto {
    key: string;
    title: string;
    body: string;
    style: ComplianceLetterSectionStyle;
}

export enum ComplianceLetterSectionStyle {
    Prose = 0,
    HeadedProse = 1,
    BulletList = 2,
}

export interface ComplianceLetterGenerateRequest {
    sections: ComplianceLetterSectionDto[];
}

export interface DeficiencyResolveRequest {
    note?: string | undefined;
}

export interface InspectionDispatchBoardResponse {
    queue: InspectionDispatchQueueItemResponse[];
    inspectors: InspectionDispatchInspectorResponse[];
    committed: InspectionDispatchCommittedItemResponse[];
}

export interface InspectionDispatchQueueItemResponse {
    id: number;
    siteId: number;
    siteName: string;
    clientId?: number | undefined;
    clientName?: string | undefined;
    inspectionTypeId: number;
    inspectionTypeName: string;
    dueAt?: Date | undefined;
    state: InspectionStateEnum;
}

export interface InspectionDispatchInspectorResponse {
    userId: number;
    name: string;
    openInspectionCount: number;
}

export interface InspectionDispatchCommittedItemResponse {
    id: number;
    assigneeId?: number | undefined;
    assigneeName?: string | undefined;
    scheduledStartAt?: Date | undefined;
    dueAt?: Date | undefined;
    siteId: number;
    siteName: string;
    inspectionTypeId: number;
    inspectionTypeName: string;
    state: InspectionStateEnum;
}

export interface InspectionDispatchBoardRequest {
    fromUtc: Date;
    toUtc: Date;
}

export interface InspectionDispatchCommitRequest {
    placements: InspectionDispatchPlacement[];
    unassign: number[];
}

export interface InspectionDispatchPlacement {
    inspectionId: number;
    assigneeId: number;
    scheduledStartAt: Date;
}

export interface GetListResponseOfInspectionScheduleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: InspectionScheduleResponse[] | undefined;
}

export interface InspectionScheduleResponse {
    id: number;
    siteId: number;
    siteName: string;
    siteTimeZone?: string | undefined;
    clientId?: number | undefined;
    clientName?: string | undefined;
    inspectionTypeId: number;
    inspectionTypeName: string;
    cadence: InspectionScheduleCadenceEnum;
    intervalDays?: number | undefined;
    anchorDate: Date;
    leadTimeDays: number;
    nextDueAt: Date;
    nextGenerationAt: Date;
    active: boolean;
    createdAt: Date;
    updatedAt: Date;
    generatedCount: number;
    latestInspectionState?: InspectionStateEnum | undefined;
    latestInspectionDueAt?: Date | undefined;
    healthIssues: InspectionScheduleHealthIssueEnum[];
}

export enum InspectionScheduleHealthIssueEnum {
    Invalid = 0,
    SiteTimeZoneMissing = 1,
    SiteInactive = 2,
    InspectionTypeInactive = 3,
}

export interface GetInspectionScheduleListRequestV2 extends GetListRequestV2 {
    search?: string | undefined;
}

export interface InspectionScheduleRequest {
    id?: number | undefined;
    siteId: number;
    inspectionTypeId: number;
    cadence: InspectionScheduleCadenceEnum;
    intervalDays?: number | undefined;
    anchorDate: Date;
    leadTimeDays: number;
}

export interface BulkSetInspectionScheduleActiveRequest {
    ids?: number[] | undefined;
    active: boolean;
}

export interface InspectionTypeRequest {
    id?: number | undefined;
    name?: string | undefined;
    standards?: string | undefined;
}

export interface InspectionTypeResponse extends InspectionTypeRequest {
    id: number;
    instanceId: number;
    active: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface GetListResponseOfInspectionTypeSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: InspectionTypeSimpleResponse[] | undefined;
}

export interface InspectionTypeSimpleResponse {
    id: number;
    name?: string | undefined;
    active: boolean;
}

export interface InspectionTypeEquipmentTypeResponse {
    id: number;
    name?: string | undefined;
    deviceCount: number;
    fieldCount: number;
}

export interface GetInstanceComplianceStandardsListRequest extends GetListRequest {
    types?: ComplianceStandardTypeEnum[] | undefined;
    active?: boolean | undefined;
}

export interface GetInstanceComplianceStandardsListRequestV2 extends GetListRequestV2 {
    types?: ComplianceStandardTypeEnum[] | undefined;
    active?: boolean | undefined;
}

export interface GetListResponseOfSimpleInclusiveListResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: SimpleInclusiveListResponse[] | undefined;
}

export interface SimpleInclusiveListResponse {
    id: number;
    label: string;
    type: ComplianceStandardTypeEnum;
}

export interface BulkActivateInstanceComplianceStandardsRequest {
    activateIds?: number[] | undefined;
}

export interface InstanceComplianceStandardRequest {
    id?: number | undefined;
    complianceStandardId: number;
    active: boolean;
    summary?: string | undefined;
    note?: string | undefined;
    files?: string | undefined;
    riskAssessmentProbability?: number | undefined;
    riskAssessmentSeverity?: number | undefined;
    targetDepartmentIds?: number[] | undefined;
}

export interface GetListResponseOfInstanceResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: InstanceResponse[] | undefined;
}

export interface InstanceRequest {
    id: number;
    name: string;
    logoUrl?: string | undefined;
    emailPlaintextOnly?: boolean | undefined;
    isAvatarRequiredEmployees?: boolean | undefined;
    isAvatarRequiredContractors?: boolean | undefined;
    personnelSyncEnabled: boolean;
    personnelSyncType?: PersonnelSyncTypeEnum | undefined;
    personnelSyncSftpUsername?: string | undefined;
    ssoSelfRegistrationEnabled: boolean;
    ssoSelfRegistrationDefaultRole?: RoleEnum | undefined;
    ssoSelfRegistrationDefaultUserType?: UserTypeEnum | undefined;
    ssoSelfRegistrationDefaultUserGroupId?: number | undefined;
    featureFlagsMetadata?: FeatureFlagsMetadata | undefined;
    mfaRequired?: boolean | undefined;
    bannerMessage?: string | undefined;
    isBadgeExpirationEnabled?: boolean | undefined;
    defaultBadgeExpirationDays?: number | undefined;
    badgeExpirationDeactivationNote?: string | undefined;
}

export interface InstanceResponse extends InstanceRequest {
    internalIdentifier?: string | undefined;
    createdBy: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    authenticationType: AuthenticationTypeEnum;
}

export enum AuthenticationTypeEnum {
    JWT = 0,
    SSO = 1,
}

export enum PersonnelSyncTypeEnum {
    Invalid = 0,
    Peoplesoft = 1,
}

export interface FeatureFlagsMetadata {
    enums?: FeatureFlagEnum | undefined;
    auditLogs?: boolean | undefined;
    actions?: boolean | undefined;
    analytics?: boolean | undefined;
    approvals?: boolean | undefined;
    bulletins?: boolean | undefined;
    compliance?: boolean | undefined;
    documentManagement?: boolean | undefined;
    documentReviews?: boolean | undefined;
    itemTracker?: boolean | undefined;
    forms?: boolean | undefined;
    jobHazardAnalysis?: boolean | undefined;
    safetyEvents?: boolean | undefined;
    toolboxTalks?: boolean | undefined;
    training?: boolean | undefined;
    vendors?: boolean | undefined;
    workflows?: boolean | undefined;
    badgePrinting?: boolean | undefined;
    clients?: boolean | undefined;
    inspections?: boolean | undefined;
    assistant?: boolean | undefined;
    knowledgeBase?: boolean | undefined;
    osha?: boolean | undefined;
}

export enum FeatureFlagEnum {
    Invalid = 0,
    Actions = 1,
    Analytics = 2,
    Compliance = 3,
    DocumentManagement = 4,
    Forms = 5,
    JobHazardAnalysis = 6,
    SafetyEvents = 7,
    ToolboxTalks = 8,
    Vendors = 9,
    Workflows = 10,
    Training = 11,
    ItemTracker = 12,
    Approvals = 13,
    AuditLogs = 14,
    Bulletins = 15,
    BadgePrinting = 16,
    Clients = 17,
    DocumentReviews = 18,
    Inspections = 19,
    Assistant = 20,
    KnowledgeBase = 21,
    Osha = 22,
}

export interface GetInstanceListRequest extends GetListRequest {
}

export interface GetInstanceListV2Request extends GetListRequestV2 {
}

export interface InstanceDeleteRequest {
    instanceId: number;
    confirmationName: string;
}

export interface InstanceCloneRequest {
    targetInstanceId: number;
    newInstanceName?: string | undefined;
    entitiesToClone: InstanceCloneEntityTypeEnum[];
}

export enum InstanceCloneEntityTypeEnum {
    Asset = 0,
    CompanyComplianceStandard = 1,
    CourseDefinition = 2,
    Document = 3,
    FormDefinition = 5,
    JobHazardAnalysis = 6,
    RiskAssessmentCode = 7,
    TasksActionDefinition = 8,
    TasksAssignedFormDefinition = 9,
    TasksToolboxTalkDefinition = 10,
    Vendor = 11,
    WorkflowDefinition = 12,
}

export interface InstanceSsoProviderResponse {
    id: number;
    instanceId: number;
    providerName: string;
    providerType: SsoProviderTypeEnum;
    metadataUrl?: string | undefined;
    attributeMappingPreset: SsoAttributeMappingPresetEnum;
    emailClaim: string;
    givenNameClaim: string;
    familyNameClaim: string;
    cognitoAppClientId?: string | undefined;
    /** False while the Cognito resources are still declared in CDK. */
    managedInApp: boolean;
    domains: string[];
    spEntityId: string;
    acsUrl: string;
}

export enum SsoProviderTypeEnum {
    Saml = 1,
}

export enum SsoAttributeMappingPresetEnum {
    EntraId = 1,
    Okta = 2,
    GenericSaml = 3,
}

export interface InstanceSsoProviderRequest {
    instanceId: number;
    providerType: SsoProviderTypeEnum;
    metadataUrl?: string | undefined;
    attributeMappingPreset: SsoAttributeMappingPresetEnum;
    emailClaim?: string | undefined;
    givenNameClaim?: string | undefined;
    familyNameClaim?: string | undefined;
    domains: string[];
}

export interface IntegrationInspectionListResponse {
    items: IntegrationInspectionItem[];
}

export interface IntegrationInspectionItem {
    id: number;
    siteName: string;
    siteNumber?: string | undefined;
    siteAddress?: string | undefined;
    clientName?: string | undefined;
    inspectionTypeName: string;
    state: string;
    scheduledStartAt?: Date | undefined;
    dueAt?: Date | undefined;
    completedAt?: Date | undefined;
    scopedDeviceCount: number;
    terminalDeviceCount: number;
    performUrl: string;
}

export interface IntegrationTokenResponse {
    id: number;
    instanceId: number;
    description?: string | undefined;
    isActive: boolean;
    lastUsedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface IntegrationTokenCreateResponse extends IntegrationTokenResponse {
    /** The raw token — shown exactly once at creation time. Not stored. */
    rawToken: string;
}

export interface IntegrationTokenCreateRequest {
    instanceId: number;
    description?: string | undefined;
}

export interface GetListResponseOfItemAssignmentSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ItemAssignmentSimpleResponse[] | undefined;
}

export interface ItemAssignmentSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    itemDefinitionId: number;
    itemDefinition?: ItemDefinitionSimpleResponse | undefined;
    serial?: string | undefined;
    description?: string | undefined;
    hasIssueCertificate?: boolean | undefined;
    assignedToUserId: number;
    assignedByUserId?: number | undefined;
    approverSupervisorUserId?: number | undefined;
    approverAdminUserId?: number | undefined;
    state: ItemAssignmentStateEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    assignedAt?: Date | undefined;
    expiresAt?: Date | undefined;
    closedAt?: Date | undefined;
    assignedByUser?: PersonnelSimpleResponse | undefined;
    assignedToUser?: PersonnelSimpleResponse | undefined;
}

export interface ItemDefinitionSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    renewsInDays?: number | undefined;
    state: ItemDefinitionStateEnum;
    active?: boolean | undefined;
    isRequestable?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata?: ItemDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
}

export enum ItemDefinitionStateEnum {
    Invalid = 0,
    Draft = 1,
    Published = 2,
}

export interface ItemDefinitionMetadata {
    isZFBootVoucher?: boolean | undefined;
    isZFGlassesVoucher?: boolean | undefined;
}

export enum ItemAssignmentStateEnum {
    Invalid = 0,
    Draft = 1,
    PendingSupervisorApproval = 2,
    PendingAdminApproval = 3,
    PendingAssignment = 4,
    Assigned = 5,
    Expired = 6,
    ClosedWithReturn = 7,
    ClosedWithoutReturn = 8,
    Rejected = 9,
}

export interface GetItemAssignmentListRequest extends GetListRequest {
    assignedToUserId?: number | undefined;
    itemDefinitionId?: number | undefined;
    states?: ItemAssignmentStateEnum[] | undefined;
    isPendingCurrentUserApproval?: boolean | undefined;
}

export interface GetItemAssignmentListRequestV2 extends GetListRequestV2 {
    assignedToUserId?: number | undefined;
    itemDefinitionId?: number | undefined;
    states?: ItemAssignmentStateEnum[] | undefined;
    isPendingCurrentUserApproval?: boolean | undefined;
}

export interface ProcessEmployeeRequestForItemsResponse {
    createdCount: number;
    expectedCount: number;
}

export interface ProcessEmployeeRequestForItemsRequest {
    requests: EmployeeRequestForItem[];
}

export interface EmployeeRequestForItem {
    itemDefinitionId: number;
    comment?: string | undefined;
}

export interface ItemAssignmentResponse {
    id: number;
    internalIdentifier?: string | undefined;
    itemDefinitionId: number;
    serial?: string | undefined;
    description?: string | undefined;
    requestNote?: string | undefined;
    hasIssueCertificate?: boolean | undefined;
    assignedToUserId: number;
    assignedByUserId?: number | undefined;
    approverSupervisorUserId?: number | undefined;
    approverAdminUserId?: number | undefined;
    state: ItemAssignmentStateEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    assignedAt?: Date | undefined;
    expiresAt?: Date | undefined;
    closedAt?: Date | undefined;
    metadata: ItemAssignmentMetadata;
    itemDefinition: ItemDefinitionResponse;
    assignedToUser?: PersonnelSimpleResponse | undefined;
    assignedByUser?: PersonnelSimpleResponse | undefined;
    approverSupervisorUser?: PersonnelSimpleResponse | undefined;
    approverAdminUser?: PersonnelSimpleResponse | undefined;
}

export interface ItemAssignmentMetadata {
}

export interface ItemDefinitionResponse {
    id?: number | undefined;
    internalIdentifier?: string | undefined;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    renewsInDays?: number | undefined;
    state: ItemDefinitionStateEnum;
    active?: boolean | undefined;
    isRequestable?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata: ItemDefinitionMetadata;
    creator?: PersonnelSimpleResponse | undefined;
    assignedTo: ItemAssignmentResponse[];
}

export interface ItemAssignmentRequest {
    id?: number | undefined;
    assignedToUserId?: number | undefined;
    itemDefinitionId: number;
    serial?: string | undefined;
    description?: string | undefined;
}

export interface IStateMachineOfItemAssignmentStateEnum {
    states: StateOfItemAssignmentStateEnum[];
    transitions: TransitionOfItemAssignmentStateEnum[];
}

export interface StateOfItemAssignmentStateEnum {
    id: ItemAssignmentStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfItemAssignmentStateEnum {
    name: string;
    from: ItemAssignmentStateEnum[];
    to: ItemAssignmentStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface GetListResponseOfItemDefinitionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ItemDefinitionSimpleResponse[] | undefined;
}

export interface GetItemDefinitionListRequest extends GetListRequest {
    states?: ItemDefinitionStateEnum[] | undefined;
    whitelistIds?: number[] | undefined;
    isRequestable?: boolean | undefined;
    createdByUserId?: number | undefined;
}

export interface GetItemDefinitionListRequestV2 extends GetListRequestV2 {
    createdByUserId?: number | undefined;
}

export interface ItemDefinitionRequest {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    renewsInDays?: number | undefined;
    active: boolean;
    isRequestable?: boolean | undefined;
    metadata: ItemDefinitionMetadata;
}

export interface ExportItemStatusReportRequest {
    itemDefinitionId?: number | undefined;
    userId?: number | undefined;
}

export interface HangfireOverviewResponse {
    enqueued: number;
    processing: number;
    scheduled: number;
    succeeded: number;
    failed: number;
    deleted: number;
    recurring: number;
    queues: HangfireQueueDepthResponse[];
    hourlySucceeded: { [key: string]: number; };
    hourlyFailed: { [key: string]: number; };
}

export interface HangfireQueueDepthResponse {
    queue: string;
    enqueued: number;
    fetched: number;
}

export interface HangfireServerResponse {
    name: string;
    workers: number;
    queues: string[];
    startedAt: Date;
    heartbeat: Date;
}

export interface GetListResponseOfHangfireJobSummary {
    filteredRecords: number;
    totalRecords: number;
    data?: HangfireJobSummary[] | undefined;
}

export interface HangfireJobSummary {
    id: string;
    method: string;
    state: string;
    queue?: string | undefined;
    enqueuedAt?: Date | undefined;
    scheduledAt?: Date | undefined;
    startedAt?: Date | undefined;
    succeededAt?: Date | undefined;
    failedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    exceptionMessage?: string | undefined;
    durationMs?: number | undefined;
}

export enum HangfireJobState {
    Enqueued = 0,
    Processing = 1,
    Scheduled = 2,
    Succeeded = 3,
    Failed = 4,
    Deleted = 5,
}

export interface HangfireJobDetailResponse {
    id: string;
    method: string;
    arguments?: string | undefined;
    state: string;
    exceptionMessage?: string | undefined;
    exceptionDetails?: string | undefined;
    history: HangfireJobStateHistoryEntry[];
    parameters: { [key: string]: string; };
    createdAt: Date;
}

export interface HangfireJobStateHistoryEntry {
    stateName: string;
    createdAt: Date;
    data: { [key: string]: string; };
}

export interface HangfireRecurringJobResponse {
    id: string;
    cron: string;
    queue: string;
    lastJobId?: string | undefined;
    lastJobState?: string | undefined;
    lastExecution?: Date | undefined;
    nextExecution?: Date | undefined;
    error?: string | undefined;
}

export interface JobHazardAnalysisResponse {
    id: number;
    internalIdentifier?: string | undefined;
    state: JobHazardAnalysisStateEnum;
    location?: string | undefined;
    riskAssessmentCodeId: number;
    workStartDate: Date;
    workFinishDate: Date;
    subjectName?: string | undefined;
    racBefore: number;
    racAfter: number;
    racWeighted: number;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    approverId?: number | undefined;
    safetyReviewerId?: number | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    approver?: PersonnelSimpleResponse | undefined;
    safetyReviewer?: PersonnelSimpleResponse | undefined;
    instance: InstanceSimpleResponse;
    riskAssessmentCode: RiskAssessmentCodeResponse;
    jobHazardAnalysisSteps: JobHazardAnalysisStepResponse[];
}

export enum JobHazardAnalysisStateEnum {
    Invalid = 0,
    Draft = 1,
    PendingManagerReview = 2,
    PendingSafetyReview = 3,
    Approved = 4,
}

export interface InstanceSimpleResponse {
    id: number;
    name: string;
    internalIdentifier?: string | undefined;
    activeFeatures: FeatureFlagEnum[];
    isAvatarRequiredEmployees?: boolean | undefined;
    isAvatarRequiredContractors?: boolean | undefined;
    logoUrl?: string | undefined;
    bannerMessage?: string | undefined;
}

export interface RiskAssessmentCodeResponse {
    id: number;
    internalIdentifier?: string | undefined;
    name?: string | undefined;
    lowName?: string | undefined;
    lowColor?: string | undefined;
    lowMinRange: number;
    lowMaxRange: number;
    midName?: string | undefined;
    midColor?: string | undefined;
    midMinRange: number;
    midMaxRange: number;
    highName?: string | undefined;
    highColor?: string | undefined;
    highMinRange: number;
    highMaxRange: number;
    probability?: RiskAssessmentMetaDataRequest | undefined;
    severity?: RiskAssessmentMetaDataRequest | undefined;
    area: RiskAssessmentCodeAreaEnum;
}

export interface RiskAssessmentMetaDataRequest {
    "1"?: string | undefined;
    "2"?: string | undefined;
    "3"?: string | undefined;
    "4"?: string | undefined;
    "5"?: string | undefined;
}

export enum RiskAssessmentCodeAreaEnum {
    Invalid = 0,
    HumanResources = 1,
    Operations = 2,
    Quality = 3,
    Safety = 4,
}

export interface JobHazardAnalysisStepResponse {
    id: number;
    jobHazardAnalysisId: number;
    name: string;
    potentialHazard?: string | undefined;
    percentOfOverallWork: number;
    racMatrix: number;
    racBeforeControls?: number | undefined;
    racAfterControls?: number | undefined;
    safetyControls: JobStepMetaDataRequest[];
    riskAfterProbability: number;
    riskAfterSeverity: number;
    riskBeforeProbability: number;
    riskBeforeSeverity: number;
    offlineId?: string | undefined;
}

export interface JobStepMetaDataRequest {
    id: number;
    safetyControlsTitle: string;
    safetyNotes: string;
}

export interface JobHazardAnalysisRequest {
    id?: number | undefined;
    location?: string | undefined;
    riskAssessmentCodeId: number;
    workStartDate: Date;
    workFinishDate: Date;
    subjectName?: string | undefined;
    racBefore: number;
    racAfter: number;
    racWeighted: number;
    targetJobHazardAnalysisSteps?: JobHazardAnalysisStepRequest[] | undefined;
}

export interface JobHazardAnalysisStepRequest {
    id?: number | undefined;
    name: string;
    potentialHazard?: string | undefined;
    percentOfOverallWork: number;
    racMatrix: number;
    racBeforeControls?: number | undefined;
    racAfterControls?: number | undefined;
    safetyControls: JobStepMetaDataRequest[];
    riskAfterProbability: number;
    riskAfterSeverity: number;
    riskBeforeProbability: number;
    riskBeforeSeverity: number;
}

export interface GetListResponseOfJobHazardAnalysisSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: JobHazardAnalysisSimpleResponse[] | undefined;
}

export interface JobHazardAnalysisSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    state: JobHazardAnalysisStateEnum;
    location?: string | undefined;
    workStartDate: Date;
    workFinishDate: Date;
    subjectName?: string | undefined;
    creatorName?: string | undefined;
    approverName?: string | undefined;
    safetyReviewerName?: string | undefined;
}

export interface GetJobHazardAnalysisListRequest extends GetListRequest {
    createdByMe?: boolean | undefined;
    states?: JobHazardAnalysisStateEnum[] | undefined;
}

export interface IStateMachineOfJobHazardAnalysisStateEnum {
    states: StateOfJobHazardAnalysisStateEnum[];
    transitions: TransitionOfJobHazardAnalysisStateEnum[];
}

export interface StateOfJobHazardAnalysisStateEnum {
    id: JobHazardAnalysisStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfJobHazardAnalysisStateEnum {
    name: string;
    from: JobHazardAnalysisStateEnum[];
    to: JobHazardAnalysisStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface GetListResponseOfKnowledgeArticleSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: KnowledgeArticleSimpleResponse[] | undefined;
}

export interface KnowledgeArticleSimpleResponse {
    id: number;
    instanceId?: number | undefined;
    isGlobal: boolean;
    creatorId?: number | undefined;
    title: string;
    tags?: string | undefined;
    published: boolean;
    updatedAt?: Date | undefined;
}

export interface GetKnowledgeArticleListRequestV2 extends GetListRequestV2 {
}

export interface KnowledgeArticleResponse extends KnowledgeArticleSimpleResponse {
    body: string;
    createdAt?: Date | undefined;
}

export interface KnowledgeArticleRequest {
    id?: number | undefined;
    title: string;
    body: string;
    tags?: string | undefined;
    published: boolean;
    isGlobal: boolean;
}

export interface InstanceSettingsResponse {
    name: string;
    logoUrl?: string | undefined;
    letterheadAddress?: string | undefined;
    letterheadPhone?: string | undefined;
    letterheadEmail?: string | undefined;
    letterheadWebsite?: string | undefined;
}

export interface InstanceSettingsRequest {
    letterheadAddress?: string | undefined;
    letterheadPhone?: string | undefined;
    letterheadEmail?: string | undefined;
    letterheadWebsite?: string | undefined;
}

export interface ModuleExtensionFormTabResponse {
    id: number;
    moduleExtensionId: number;
    module: ModuleEnum;
    formDefinitionId: number;
    formDefinitionVersion: number;
    formDefinitionName?: string | undefined;
    tabLabel: string;
    tabSlug: string;
    sortOrder: number;
    permissionOperationName?: string | undefined;
    isActive: boolean;
}

export enum ModuleEnum {
    Invalid = 0,
    ToolboxTalks = 1,
    AssignedForms = 2,
    Actions = 3,
    Training = 4,
    Forms = 5,
    ItemTrackerAssignments = 6,
    SafetyEvent = 7,
    Attachments = 8,
    Personnel = 9,
    Documents = 10,
    UserGroups = 11,
    NotificationRules = 12,
    Workflows = 13,
    Assets = 14,
    ItemTrackerDefinitions = 15,
    Approvals = 16,
    AuditLog = 17,
    Analytics = 18,
    Bulletins = 19,
    RiskAssessmentCodes = 20,
    Compliance = 21,
    Vendors = 22,
    Projects = 23,
    ModuleExtensions = 24,
    JobHazardAnalysises = 25,
    AttachmentClassifications = 26,
    Clients = 27,
    Inspections = 28,
    Assistant = 29,
    KnowledgeBase = 30,
    Osha = 31,
}

export interface ModuleExtensionFormTabRequest {
    id?: number | undefined;
    module: ModuleEnum;
    formDefinitionId: number;
    tabLabel: string;
    tabSlug: string;
    sortOrder: number;
    isActive: boolean;
}

export interface GetListResponseOfModuleExtensionFormTabResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ModuleExtensionFormTabResponse[] | undefined;
}

export interface GetModuleExtensionFormTabListRequest extends GetListRequest {
    module: ModuleEnum;
}

export interface ModuleExtensionActiveResponse {
    supportedModules: ModuleEnum[];
    extensions: ModuleExtensionActiveModule[];
}

export interface ModuleExtensionActiveModule {
    id: number;
    module: ModuleEnum;
    formTabs: ModuleExtensionActiveFormTab[];
}

export interface ModuleExtensionActiveFormTab {
    id: number;
    formDefinitionId: number;
    formDefinitionVersion: number;
    formDefinitionName?: string | undefined;
    tabLabel: string;
    tabSlug: string;
    sortOrder: number;
    permissionOperationName?: string | undefined;
}

export interface GetListResponseOfExtensionFormTabSubmissionResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ExtensionFormTabSubmissionResponse[] | undefined;
}

export interface ExtensionFormTabSubmissionResponse {
    id: number;
    internalIdentifier?: string | undefined;
    state: FormStateEnum;
    createdByName?: string | undefined;
    createdAt?: Date | undefined;
}

export interface ExtensionFormTabSubmissionsRequest extends GetListRequestV2 {
    moduleExtensionFormTabId: number;
    targetEntityId: number;
}

export interface GetListResponseOfNoteSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: NoteSimpleResponse[] | undefined;
}

export interface NoteSimpleResponse {
    id: number;
    content: string;
    isEditable: boolean;
    noteLinkId: number;
    noteType: string;
    creatorName: string;
    creatorAvatarUrl?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export interface GetNoteListRequest extends GetListRequest {
    entityId: number;
    noteType: NoteModuleEnum;
}

export enum NoteModuleEnum {
    Invalid = 0,
    User = 1,
    Vendor = 2,
    TaskAssignment = 3,
    ItemAssignment = 4,
    TaskDefinition = 5,
    ItemDefinition = 6,
    SafetyEvent = 7,
    Asset = 8,
}

export interface NoteResponse extends NoteSimpleResponse {
}

export interface NoteRequest {
    id?: number | undefined;
    noteType: NoteModuleEnum;
    entityId: number;
    content: string;
}

export interface GetListResponseOfNotificationSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: NotificationSimpleResponse[] | undefined;
}

export interface NotificationSimpleResponse {
    id: number;
    notificationType: string;
    module: NotificationModuleEnum;
    description?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    notificationRuleId: number;
    notificationRule: NotificationRuleSimpleResponse;
    updatedDateTime: Date;
    recipients: NotificationRecipientSimpleResponse[];
}

export enum NotificationModuleEnum {
    Invalid = 0,
    CourseAssignment = 1,
    CourseSessionContent = 2,
    CourseSession = 3,
    Form = 4,
    ItemAssignment = 5,
    SafetyEvent = 6,
    TaskAssignment = 7,
    TaskDefinition = 8,
    CourseDefinition = 9,
    Attachment = 10,
    Personnel = 11,
    SkillSignOff = 12,
    Inspection = 13,
}

export interface NotificationRuleSimpleResponse {
    id: number;
    active: boolean;
    name?: string | undefined;
    ruleType: NotificationRuleTypeEnum;
    module?: ModuleEnum | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export enum NotificationRuleTypeEnum {
    Invalid = 0,
    Reminder = 1,
    ChangeEvent = 2,
    Schedule = 3,
}

export interface NotificationRecipientSimpleResponse {
    id: number;
    recipientType: NotificationRecipientTypeEnum;
    description?: string | undefined;
    recipientId: number;
    recipient: PersonnelSimpleResponse;
    createdDateTime: Date;
    updatedDateTime: Date;
}

export enum NotificationRecipientTypeEnum {
    Invalid = 0,
    To = 1,
    Copy = 2,
    BlindCopy = 3,
}

export interface GetNotificationListRequest extends GetListRequest {
    module?: NotificationModuleEnum | undefined;
    notificationRuleId?: number | undefined;
    entityId?: number | undefined;
    recipientId?: number | undefined;
    /** If IncludeDescendents is True, related notifications that are logically below the given Module in hierarchy will be
included.
For example, if the Module is CourseAssignment and IncludeDescendents is True, CourseSession and
CourseSessionContent results are included.
             */
    includeDescendents?: boolean | undefined;
}

export interface NotificationResponse {
    id: number;
    notificationType: string;
    module: NotificationModuleEnum;
    description?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    notificationRuleId: number;
    notificationRule: NotificationRuleSimpleResponse;
    instanceId: number;
    createdAt: Date;
    updatedAt: Date;
}

export interface GetListResponseOfNotificationRecipientSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: NotificationRecipientSimpleResponse[] | undefined;
}

export interface GetNotificationRecipientListRequest extends GetListRequest {
    modules?: NotificationModuleEnum[] | undefined;
    notificationRuleId?: number | undefined;
    recipientId?: number | undefined;
}

export interface NotificationRecipientResponse {
    id: number;
    recipientType: NotificationRecipientTypeEnum;
    description?: string | undefined;
    notificationId: number;
    notificationResponse: NotificationSimpleResponse;
    recipientId: number;
    recipient: PersonnelSimpleResponse;
    createdDateTime: Date;
    updatedDateTime: Date;
}

export interface NotificationRuleResponse {
    id: number;
    active: boolean;
    name?: string | undefined;
    ruleType: NotificationRuleTypeEnum;
    module?: ModuleEnum | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    creatorId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata: NotificationRuleMetadata;
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export interface NotificationRuleMetadata {
    toUserGroupIds?: number[] | undefined;
    toUserAttributes?: NotificationAttributeEnum[] | undefined;
    module?: ModuleEnum | undefined;
    reminderConditions?: NotificationRuleReminderCondition[] | undefined;
    changeType?: NotificationRuleChangeTypeEnum | undefined;
    formDefinitionId?: number | undefined;
    formStateFilter?: FormStateEnum | undefined;
    formChangeConditions?: NotificationRuleFormChangeCondition[] | undefined;
    formFieldInvariantIds?: string[] | undefined;
    notificationVariableFormFieldInvariantIds?: string[] | undefined;
    formFieldPersonnelTargets?: NotificationRuleFormFieldPersonnelTarget[] | undefined;
    courseChangeType?: NotificationRuleCourseChangeTypeEnum | undefined;
    courseDefinitionId?: number | undefined;
    courseDefinitionContentInvariantId?: string | undefined;
    courseAssignmentChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    courseSessionChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    courseContentChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    itemDefinitionId?: number | undefined;
    itemAssignmentChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    taskDefinitionId?: number | undefined;
    taskAssignmentChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    safetyEventChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    personnelChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    attachmentChangeConditions?: NotificationRuleChangeCondition[] | undefined;
    inspectionChangeConditions?: NotificationRuleChangeCondition[] | undefined;
}

export interface NotificationRuleReminderCondition {
    property: NotificationRuleReminderConditionPropertyEnum;
    operator: RelationalOperatorEnum;
    value?: string | undefined;
}

export enum NotificationRuleReminderConditionPropertyEnum {
    Invalid = 0,
    DueDate = 1,
    DueInDays = 2,
    PastDueDays = 3,
    ExpiresInDays = 4,
    UnlocksInDays = 5,
    DaysInStatus = 6,
    Classification = 7,
    AttachmentType = 8,
}

export enum RelationalOperatorEnum {
    Invalid = 0,
    LessThan = 1,
    LessThanOrEqualTo = 2,
    EqualTo = 3,
    GreaterThanOrEqualTo = 4,
    GreaterThan = 5,
    NotEqualTo = 6,
}

export enum NotificationRuleChangeTypeEnum {
    Invalid = 0,
    FormChange = 1,
    CourseChange = 2,
    ItemAssignmentChange = 3,
    TaskAssignmentChange = 4,
    SafetyEventChange = 5,
    PersonnelChange = 6,
    AttachmentCreated = 7,
    AttachmentUpdated = 8,
    SkillSignOffRequested = 9,
    SkillSignOffEvaluated = 10,
    SkillSignOffExpiring = 11,
    InspectionChange = 12,
}

export interface NotificationRuleFormChangeCondition {
    property: NotificationRuleChangeConditionPropertyEnum;
    formFieldInvariantId?: string | undefined;
    operator: EqualityOperatorEnum;
    value?: string | undefined;
}

export enum NotificationRuleChangeConditionPropertyEnum {
    Invalid = 0,
    StatusChange = 1,
    InputValueChange = 2,
    TrainingEnrollmentChange = 3,
    PersonnelOperationType = 4,
    PersonnelUserType = 5,
    PersonnelRole = 6,
    PersonnelSuspended = 7,
    PersonnelLeaveOfAbsence = 8,
    PersonnelEligibility = 9,
    AttachmentClassification = 10,
    AttachmentType = 11,
    AssigneeChanged = 12,
    InspectionGenerated = 13,
    InspectionScheduleChanged = 14,
    PersonnelBannedOnProperty = 15,
}

export enum EqualityOperatorEnum {
    Invalid = 0,
    EqualTo = 1,
    NotEqualTo = 2,
}

export interface NotificationRuleFormFieldPersonnelTarget {
    formFieldInvariantId: string;
    attributes: NotificationAttributeEnum[];
    recipientType: NotificationRecipientTypeEnum;
}

export enum NotificationRuleCourseChangeTypeEnum {
    Invalid = 0,
    CourseSessionChange = 1,
    CourseContentChange = 2,
    CourseAssignmentChange = 3,
}

export interface NotificationRuleChangeCondition {
    property: NotificationRuleChangeConditionPropertyEnum;
    operator: EqualityOperatorEnum;
    value?: string | undefined;
}

export interface NotificationRuleRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    ruleType?: NotificationRuleTypeEnum | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    metadata?: NotificationRuleMetadata | undefined;
    projectId?: number | undefined;
}

export interface GetListResponseOfNotificationRuleSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: NotificationRuleSimpleResponse[] | undefined;
}

export interface GetNotificationRuleListRequest extends GetListRequest {
    activeStates?: boolean[] | undefined;
    ruleTypes?: NotificationRuleTypeEnum[] | undefined;
    modules?: ModuleEnum[] | undefined;
    formFieldInvariantId?: string | undefined;
    courseContentInvariantId?: string | undefined;
}

export interface GetNotificationRuleListRequestV2 extends GetListRequestV2 {
}

export interface GetNotificationVariablesResponse {
    variables: NotificationVariable[];
}

export interface NotificationVariable {
    type: NotificationVariableTypeEnum;
    variable: string;
    description: string;
    example: string;
    invariantId?: string | undefined;
    unavailable?: boolean | undefined;
    unavailableReason?: string | undefined;
}

export enum NotificationVariableTypeEnum {
    Invalid = 0,
    System = 1,
    Module = 2,
}

export interface GetNotificationVariablesRequest {
    ruleType: NotificationRuleTypeEnum;
    module: ModuleEnum;
    courseChangeType?: NotificationRuleCourseChangeTypeEnum | undefined;
    formDefinitionId?: number | undefined;
}

export interface OshaSummaryResponse {
    year: number;
    totalDeaths: number;
    totalCasesWithDaysAway: number;
    totalCasesWithRestriction: number;
    totalOtherRecordableCases: number;
    totalDaysAway: number;
    totalRestrictionDays: number;
    totalInjuries: number;
    totalSkinDisorders: number;
    totalRespiratoryConditions: number;
    totalPoisonings: number;
    totalHearingLoss: number;
    totalAllOtherIllnesses: number;
}

export interface OshaEstablishmentInformationResponse {
    establishmentName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    industryDescription?: string | undefined;
    sicCode?: string | undefined;
    naicsCode?: string | undefined;
}

export interface OshaEmploymentInformationResponse {
    id?: number | undefined;
    year: number;
    annualAverageEmployeeCount: number;
    totalHoursWorked: number;
}

export interface OshaEmploymentInformationRequest {
    projectId: number;
    year: number;
    annualAverageEmployeeCount: number;
    totalHoursWorked: number;
}

export interface PersonnelPermissionResponse {
    id: number;
    instanceId: number;
    modulePermissions: UserGroupModulePermissionResponse[];
    objectPermissions: UserGroupObjectPermissionResponse[];
    groups: UserGroupSimpleResponse[];
    projectAccess: ProjectAccessPermissionResponse[];
}

export interface UserGroupModulePermissionResponse {
    id: number;
    module: ModuleEnum;
    operation: PermissionOperationEnum;
    operationName?: string | undefined;
    userGroup?: UserGroupSimpleResponse | undefined;
}

export interface UserGroupObjectPermissionResponse {
    id: number;
    module: ModuleEnum;
    objectId: number;
    hasAccess?: boolean | undefined;
    userGroup?: UserGroupSimpleResponse | undefined;
}

export interface ProjectAccessPermissionResponse {
    project: ProjectSimpleResponse;
    rules: ProjectRosterRuleRef[];
}

export interface ProjectRosterRuleRef {
    ruleId: number;
    name?: string | undefined;
}

export interface PersonnelResponse {
    id: number;
    internalIdentifier?: string | undefined;
    roleId: RoleEnum;
    isSuspended: boolean;
    isLeaveOfAbsence: boolean;
    isEligible: boolean;
    isBannedOnProperty: boolean;
    isMilitaryVeteran: boolean;
    notificationEmailsEnabled: boolean;
    militaryServiceBranch?: string | undefined;
    email: string;
    accountEmail?: string | undefined;
    hasEmailMismatch: boolean;
    phoneNumber?: string | undefined;
    name: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    avatarUrl?: string | undefined;
    jobCode?: string | undefined;
    jobTitle?: string | undefined;
    userType: UserTypeEnum;
    active: UserStatusEnum;
    supervisorId?: number | undefined;
    departmentId?: number | undefined;
    vendorId?: number | undefined;
    primaryProjectId?: number | undefined;
    instanceId?: number | undefined;
    emailVerifiedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    employeeId?: string | undefined;
    hiredAt?: Date | undefined;
    serviceDateAt?: Date | undefined;
    terminationAt?: Date | undefined;
    rehiredAt?: Date | undefined;
    badgeExpirationAt?: Date | undefined;
    existingAccount: boolean;
    primaryInstanceId?: number | undefined;
    primaryInstanceName?: string | undefined;
    isPrimaryInstance: boolean;
    isSuperAdmin: boolean;
    department?: DepartmentSimpleResponse | undefined;
    supervisor?: PersonnelSimpleResponse | undefined;
    instance?: InstanceSimpleResponse | undefined;
    vendor?: VendorSimpleResponse | undefined;
    primaryProject?: ProjectSimpleResponse | undefined;
    assignedTasks: TaskAssignmentSimpleResponse[];
}

export interface TaskAssignmentSimpleResponse {
    id: number;
    taskId: number;
    sourceEntityId: number;
    assignedToUserId: number;
    internalIdentifier?: string | undefined;
    state: TaskAssignmentStateEnum;
    formSubmissionId?: number | undefined;
    formSubmissionState?: FormStateEnum | undefined;
    viewedAt?: Date | undefined;
    completedAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    dueAt?: Date | undefined;
    taskDefinition: TaskDefinitionSimpleResponse;
    assignedToUser: PersonnelSimpleResponse;
}

export interface TaskDefinitionSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    instanceId?: number | undefined;
    creatorId?: number | undefined;
    taskType: TaskTypeEnum;
    subject: string;
    dueInDays?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    dueAt?: Date | undefined;
    state: TaskDefinitionStateEnum;
    active: boolean;
    refresh: boolean;
    formDefinitionId?: number | undefined;
    formDefinitionVersion?: number | undefined;
    demonstrationId?: number | undefined;
    sourceFormId?: number | undefined;
    sourceFormIdentifier?: string | undefined;
    sourceFormDescription?: string | undefined;
    approvalState?: TaskAssignmentStateEnum | undefined;
    workflowId?: number | undefined;
    workflowActionId?: number | undefined;
    metadata?: TaskDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export interface GetPersonnelListRequest extends GetListRequest {
    userTypes: UserTypeEnum[];
    hasPendingAction: boolean;
    superviserOnly: boolean;
    active: UserStatusEnum[];
    vendorId?: number | undefined;
    crossInstance?: boolean | undefined;
    roles?: RoleEnum[] | undefined;
    whitelistIds?: number[] | undefined;
    projectIds?: number[] | undefined;
}

export interface GetPersonnelListRequestV2 extends GetListRequestV2 {
    userTypes?: UserTypeEnum[] | undefined;
    vendorId?: number | undefined;
    hasPendingAction?: boolean | undefined;
    projectIds?: number[] | undefined;
}

export interface GetPersonnelSelectOptionsRequest {
    start: number;
    length: number;
    search?: string | undefined;
    userTypes: UserTypeEnum[];
    active: UserStatusEnum[];
    superviserOnly: boolean;
}

export interface PersonnelRequest {
    id?: number | undefined;
    roleId: RoleEnum;
    isSuspended: boolean;
    isLeaveOfAbsence: boolean;
    isEligible: boolean;
    isBannedOnProperty: boolean;
    isMilitaryVeteran: boolean;
    militaryServiceBranch?: string | undefined;
    email: string;
    name: string;
    phoneNumber?: string | undefined;
    firstName: string;
    lastName: string;
    avatarUrl?: string | undefined;
    jobCode?: string | undefined;
    jobTitle?: string | undefined;
    userType: UserTypeEnum;
    supervisorId?: number | undefined;
    departmentId?: number | undefined;
    vendorId?: number | undefined;
    primaryProjectId?: number | undefined;
    employeeId?: string | undefined;
    hiredAt?: Date | undefined;
    serviceDateAt?: Date | undefined;
    terminationAt?: Date | undefined;
    rehiredAt?: Date | undefined;
}

export interface ConvertUserTypeRequest {
    targetUserType: UserTypeEnum;
    vendorId?: number | undefined;
    employeeId?: string | undefined;
    supervisorId?: number | undefined;
}

export interface ExtendBadgeExpirationRequest {
    days: number;
}

export interface SetBadgeExpirationRequest {
    badgeExpirationAt?: Date | undefined;
}

export interface PersonnelBadgeSimpleResponse {
    id: number;
    userId: number;
    badgeTemplateId: number;
    badgeTemplateName?: string | undefined;
    templateVersion: number;
    version: number;
    autoGenerated: boolean;
    generatedAt: Date;
    generatedById?: number | undefined;
    generatedByName?: string | undefined;
}

export interface PersonnelBadgeResponse extends PersonnelBadgeSimpleResponse {
    warnings: string[];
}

export interface GenerateBadgeRequest {
    badgeTemplateId?: number | undefined;
}

export interface PersonnelBadgeDetailResponse extends PersonnelBadgeSimpleResponse {
    downloadUrl: string;
    dataSnapshot?: BadgeDataSnapshot | undefined;
}

export interface BadgeDataSnapshot {
    templateName: string;
    templateVersion: number;
    autoGenerated: boolean;
    hasPhoto: boolean;
    photoHash?: string | undefined;
    personnelName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    employeeId?: string | undefined;
    companyName?: string | undefined;
    badgeExpirationDate?: string | undefined;
    instanceName?: string | undefined;
    generatedDate?: string | undefined;
    warnings: string[];
}

export interface BulkActivateUserRequest {
    ids: number[];
}

export interface SesSuppressionResponse {
    isSuppressed: boolean;
    reason?: string | undefined;
    suppressedAt?: Date | undefined;
}

export interface PersonnelImportColumnResponse {
    name: string;
    aliases: string[];
    required: boolean;
    acceptedValues: string;
    example: string;
    description: string;
}

export interface PersonnelImportPreviewResponse {
    headerMode: PersonnelImportHeaderModeEnum;
    fileIssues: PersonnelImportIssue[];
    counts: PersonnelImportCounts;
    rows: PersonnelImportPreviewRow[];
    truncated: boolean;
}

export enum PersonnelImportHeaderModeEnum {
    Named = 0,
    Positional = 1,
}

export interface PersonnelImportIssue {
    severity: PersonnelImportIssueSeverityEnum;
    field?: string | undefined;
    message: string;
}

export enum PersonnelImportIssueSeverityEnum {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface PersonnelImportCounts {
    total: number;
    create: number;
    update: number;
    deactivate: number;
    skip: number;
    reject: number;
    warnings: number;
}

export interface PersonnelImportPreviewRow {
    row: number;
    name?: string | undefined;
    email?: string | undefined;
    employeeId?: string | undefined;
    action: PersonnelImportRowActionEnum;
    supervisor: PersonnelImportPreviewSupervisor;
    issues: PersonnelImportIssue[];
}

export enum PersonnelImportRowActionEnum {
    Create = 0,
    Update = 1,
    Deactivate = 2,
    Skip = 3,
    Reject = 4,
}

export interface PersonnelImportPreviewSupervisor {
    status: PersonnelImportSupervisorStatusEnum;
    matchedBy: PersonnelImportSupervisorMatchEnum;
    name?: string | undefined;
}

export enum PersonnelImportSupervisorStatusEnum {
    Unchanged = 0,
    Cleared = 1,
    Matched = 2,
    NotFound = 3,
    Ambiguous = 4,
    Invalid = 5,
    VendorManager = 6,
}

export enum PersonnelImportSupervisorMatchEnum {
    None = 0,
    FileEmployeeId = 1,
    FileEmail = 2,
    DatabaseEmployeeId = 3,
    DatabaseEmail = 4,
    VendorManager = 5,
}

export interface PersonnelImportPreviewRequest {
    key: string;
    userType: UserTypeEnum;
    vendorId?: number | undefined;
    options: PersonnelImportOptions;
}

export interface PersonnelImportOptions {
    blankSupervisor: PersonnelImportBlankSupervisorEnum;
    supervisorNotFound: PersonnelImportSupervisorNotFoundEnum;
    rowsWithErrors: PersonnelImportRowErrorEnum;
}

export enum PersonnelImportBlankSupervisorEnum {
    KeepExisting = 0,
    Clear = 1,
}

export enum PersonnelImportSupervisorNotFoundEnum {
    KeepExisting = 0,
    RejectRow = 1,
}

export enum PersonnelImportRowErrorEnum {
    SkipRows = 0,
    CancelAll = 1,
}

export interface PersonnelImportRequest {
    key: string;
    userType: UserTypeEnum;
    vendorId?: number | undefined;
    options: PersonnelImportOptions;
}

export interface ProjectResponse {
    id: number;
    instanceId: number;
    name: string;
    code?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    timeZone?: string | undefined;
    active: boolean;
    regionId?: number | undefined;
    regionName?: string | undefined;
    oshaIndustryDescription?: string | undefined;
    oshaSicCode?: string | undefined;
    oshaNaicsCode?: string | undefined;
}

export interface ProjectRequest {
    id?: number | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    timeZone?: string | undefined;
    active?: boolean | undefined;
    regionId?: number | undefined;
    oshaIndustryDescription?: string | undefined;
    oshaSicCode?: string | undefined;
    oshaNaicsCode?: string | undefined;
}

export interface GetListResponseOfProjectSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ProjectSimpleResponse[] | undefined;
}

export interface GetProjectListRequest extends GetListRequest {
    active?: boolean | undefined;
}

export interface GetProjectListRequestV2 extends GetListRequestV2 {
}

export interface ProjectAssignmentRuleResponse {
    id: number;
    projectId: number;
    projectName?: string | undefined;
    name?: string | undefined;
    active: boolean;
    selectAllEntityType?: EntityTypeEnum | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    sourceEntities: SourceEntityRecord[];
    resolvedCount: number;
}

export interface ProjectAssignmentResponse {
    id: number;
    projectId: number;
    userId: number;
    userName?: string | undefined;
    active: boolean;
    assignedAt: Date;
}

export interface GetListResponseOfProjectRosterRowResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ProjectRosterRowResponse[] | undefined;
}

export interface ProjectRosterRowResponse {
    assignmentId: number;
    userId: number;
    userName?: string | undefined;
    departmentId?: number | undefined;
    departmentName?: string | undefined;
    vendorId?: number | undefined;
    vendorName?: string | undefined;
    assignedAt: Date;
    rules: ProjectRosterRuleRef[];
}

export interface ProjectAssignmentRuleCreateRequest {
    projectId: number;
    name?: string | undefined;
    active: boolean;
    selectAllEntityType?: EntityTypeEnum | undefined;
    sourceEntities: SourceEntityRecord[];
}

export interface ProjectAssignmentRuleUpdateRequest extends ProjectAssignmentRuleCreateRequest {
    id: number;
}

export interface ProjectAssignmentRulePreviewResponse {
    count: number;
    users: SelectOption[];
}

export interface ProjectAssignmentRulePreviewRequest {
    ruleId?: number | undefined;
    projectId?: number | undefined;
    selectAllEntityType?: EntityTypeEnum | undefined;
    sourceEntities?: SourceEntityRecord[] | undefined;
    start: number;
    length: number;
}

export interface ProjectAssignmentRuleExceptionResponse {
    id: number;
    ruleId: number;
    userId: number;
    userName?: string | undefined;
    reason: string;
    expiresAt?: Date | undefined;
    createdAt: Date;
}

export interface ProjectAssignmentRuleExceptionCreateRequest {
    ruleId: number;
    userId: number;
    reason: string;
    expiresAt?: Date | undefined;
}

export interface RegionResponse extends RegionSimpleResponse {
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface RegionRequest {
    id?: number | undefined;
    name?: string | undefined;
    notes?: string | undefined;
}

export interface GetListResponseOfRegionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: RegionSimpleResponse[] | undefined;
}

export interface GetRegionListRequestV2 extends GetListRequestV2 {
}

export interface GetListResponseOfReportSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ReportSimpleResponse[] | undefined;
}

export interface ReportSimpleResponse {
    dashboardId: string;
    name: string;
    arn: string;
    createdAt: Date;
    lastUpdatedAt: Date;
    lastPublishedAt: Date;
}

export interface GetListReportRequest extends GetListRequest {
}

export interface GetFindingsReportListRequest extends GetListRequest {
    type: ComplianceEventTypeEnum;
    grouping: ReportGroupingEnum;
    filterDepartmentId?: number | undefined;
    filterSupervisorId?: number | undefined;
}

export enum ReportGroupingEnum {
    Invalid = 0,
    Department = 1,
    Supervisor = 2,
    User = 3,
    None = 4,
}

export interface GetFindingsReportListRequestV2 extends GetListRequestV2 {
    type: ComplianceEventTypeEnum;
    grouping: ReportGroupingEnum;
    filterDepartmentId?: number | undefined;
    filterSupervisorId?: number | undefined;
}

export interface GetListResponseOfComplianceEventFlattenedResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ComplianceEventFlattenedResponse[] | undefined;
}

export interface ComplianceEventFlattenedResponse {
    id: number;
    type: ComplianceEventTypeEnum;
    standardLabel?: string | undefined;
    creatorName?: string | undefined;
    supervisorName?: string | undefined;
    formName?: string | undefined;
    fieldName?: string | undefined;
    eventAt?: Date | undefined;
    riskScore?: number | undefined;
}

export interface GetFindingsDetailReportListRequest extends GetFindingsReportListRequest {
    entityId?: number | undefined;
}

export interface GetCommunicationReportListRequest extends GetListRequest {
    grouping: ReportGroupingEnum;
    taskAssignmentStates?: TaskAssignmentStateEnum[] | undefined;
}

export interface GetListResponseOfCommunicationReportEventFlattenedResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: CommunicationReportEventFlattenedResponse[] | undefined;
}

export interface CommunicationReportEventFlattenedResponse {
    id?: string | undefined;
    type: ComplianceStandardTypeEnum;
    standardLabel: string;
    assigneeName: string;
    supervisorName: string;
    taskSubject: string;
    eventAt?: Date | undefined;
    taskType: TaskTypeEnum;
    assignmentStatus: TaskAssignmentStateEnum;
    riskScore?: number | undefined;
    supervisorId?: number | undefined;
    assignmentId: number;
    standardId: number;
}

export interface GetCommunicationDetailReportListRequest extends GetCommunicationReportListRequest {
    entityId?: number | undefined;
}

export interface GetPlanReportListRequest extends GetListRequest {
    grouping: ReportGroupingEnum;
}

export interface GetListResponseOfPlanReportEventFlattenedResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: PlanReportEventFlattenedResponse[] | undefined;
}

export interface PlanReportEventFlattenedResponse {
    id: number;
    standardId: number;
    type: ComplianceStandardTypeEnum;
    standardLabel: string;
    riskScore?: number | undefined;
}

export interface GetPlanDetailReportListRequest extends GetPlanReportListRequest {
    entityId?: number | undefined;
}

export interface TaskParticipationResponse {
    averageParticipation: number;
    groupId?: string | undefined;
    groupLabel?: string | undefined;
    criterionName?: string | undefined;
}

export interface TaskParticipationRequest {
    from?: Date | undefined;
    to?: Date | undefined;
    taskType: TaskTypeEnum;
    criterion?: TaskParticipationGroupingCriterion | undefined;
    departmentId?: number | undefined;
    supervisorId?: number | undefined;
}

export enum TaskParticipationGroupingCriterion {
    DepartmentId = 0,
    SupervisorId = 1,
    EmployeeId = 2,
}

export interface GetListResponseOfReportInstanceMembershipResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: ReportInstanceMembershipResponse[] | undefined;
}

export interface ReportInstanceMembershipRequest {
    id?: number | undefined;
    quicksightReportId: number;
    instanceId: number;
}

export interface ReportInstanceMembershipResponse extends ReportInstanceMembershipRequest {
    id: number;
    quicksightReport?: ReportSimpleResponse | undefined;
    instance: InstanceSimpleResponse;
}

export interface GetReportInstanceMembershipListRequest extends GetListRequest {
    instanceId: number;
}

export interface GetListPossibleReportOptionsRequest extends GetListRequest {
    instanceId: number;
}

export interface GetListResponseOfBoolean {
    filteredRecords: number;
    totalRecords: number;
    data?: boolean[] | undefined;
}

export interface MergeMembershipsRequest {
    memberships: ReportInstanceMembershipRequest[];
}

export interface RiskAssessmentCodeRequest {
    id?: number | undefined;
    name: string;
    lowName?: string | undefined;
    lowColor?: string | undefined;
    lowMinRange: number;
    lowMaxRange: number;
    midName?: string | undefined;
    midColor?: string | undefined;
    midMinRange: number;
    midMaxRange: number;
    highName?: string | undefined;
    highColor?: string | undefined;
    highMinRange: number;
    highMaxRange: number;
    probability?: RiskAssessmentMetaDataRequest | undefined;
    severity?: RiskAssessmentMetaDataRequest | undefined;
    area: RiskAssessmentCodeAreaEnum;
}

export interface GetListResponseOfRiskAssessmentCodeResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: RiskAssessmentCodeResponse[] | undefined;
}

export interface GetListResponseOfSafetyEventSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: SafetyEventSimpleResponse[] | undefined;
}

export interface GetSafetyEventListRequestV2 extends GetListRequestV2 {
    filterAssetId?: number | undefined;
}

export interface SafetyEventResponse {
    id: number;
    shortDescription?: string | undefined;
    internalIdentifier?: string | undefined;
    state: SafetyEventStateEnum;
    incidentAt: Date;
    day: number;
    month: number;
    quarter: number;
    year: number;
    time: string;
    timePeriod: number;
    shift: number;
    jobDescription: string;
    userType: UserTypeEnum;
    eventPersonId?: number | undefined;
    eventManagerId?: number | undefined;
    eventDepartmentId?: number | undefined;
    location: string;
    safetyEventType?: number | undefined;
    safetyInjuryType?: number | undefined;
    safetyBodyPart?: number | undefined;
    safetyBodySide?: number | undefined;
    safetyFrontBack?: number | undefined;
    safetyType?: number | undefined;
    oshaRecordable?: boolean | undefined;
    oshaGender?: number | undefined;
    oshaInsuranceClaimText?: string | undefined;
    oshaCostText?: string | undefined;
    oshaInjuryType?: number | undefined;
    oshaLostTime?: boolean | undefined;
    oshaLostTimeStartAt?: Date | undefined;
    oshaLostTimeEndAt?: Date | undefined;
    oshaLostTimeDaysDiff?: number | undefined;
    oshaRestrictionTime?: boolean | undefined;
    oshaRestrictionTimeStartAt?: Date | undefined;
    oshaRestrictionTimeEndAt?: Date | undefined;
    oshaRestrictionTimeDaysDiff?: number | undefined;
    oshaFatality?: boolean | undefined;
    oshaTreatingDoctor?: string | undefined;
    oshaFacilityName?: string | undefined;
    oshaEmergencyRoomTreatment?: boolean | undefined;
    oshaHospitalizedOvernight?: boolean | undefined;
    environmentEventNature?: number | undefined;
    environmentSituation?: number | undefined;
    environmentArea?: number | undefined;
    environmentMaterial?: number | undefined;
    environmentReleasePoint?: number | undefined;
    environmentSeverity?: number | undefined;
    environmentRemediationDamage?: number | undefined;
    environmentExpectedPenalties?: number | undefined;
    environmentImpact?: number | undefined;
    environmentAmountSpilled?: number | undefined;
    propertyDamageInterruption?: boolean | undefined;
    propertyDamageWorkStopAt?: Date | undefined;
    propertyDamageWorkResumeAt?: Date | undefined;
    propertyDamageCost?: number | undefined;
    claimCurrentIncidentStatus?: string | undefined;
    claimInLitigation?: boolean | undefined;
    claimEstimatedTotalCost?: number | undefined;
    claimFinanceAccrualsToDate?: number | undefined;
    claimProjectedAccrualNotes?: string | undefined;
    claimTotalCostPaidByCompany?: number | undefined;
    claimCostPaidByInsurance?: number | undefined;
    claimFollowUpActivityDate?: Date | undefined;
    createdAt: Date;
    updatedAt?: Date | undefined;
    publishedAt?: Date | undefined;
    assetId?: number | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;
    linkedFormId?: number | undefined;
    instanceId: number;
    creatorId?: number | undefined;
    safetyReviewerId?: number | undefined;
    eventPerson?: PersonnelSimpleResponse | undefined;
    eventManager?: PersonnelSimpleResponse | undefined;
    eventDepartment?: DepartmentSimpleResponse | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    safetyReviewer?: PersonnelSimpleResponse | undefined;
    linkedForm?: FormSimpleResponse | undefined;
}

export interface SafetyEventRequest {
    id?: number | undefined;
    shortDescription?: string | undefined;
    linkedFormId?: number | undefined;
    assetId?: number | undefined;
    projectId?: number | undefined;
    incidentAt: Date;
    time: string;
    timePeriod: number;
    shift: number;
    jobDescription: string;
    userType: UserTypeEnum;
    eventPersonId?: number | undefined;
    location: string;
    safetyEventType?: number | undefined;
    safetyInjuryType?: number | undefined;
    safetyBodyPart?: number | undefined;
    safetyBodySide?: number | undefined;
    safetyFrontBack?: number | undefined;
    safetyType?: number | undefined;
    oshaRecordable?: boolean | undefined;
    oshaGender?: number | undefined;
    oshaInsuranceClaimText?: string | undefined;
    oshaCostText?: string | undefined;
    oshaInjuryType?: number | undefined;
    oshaLostTime?: boolean | undefined;
    oshaLostTimeStartAt?: Date | undefined;
    oshaLostTimeEndAt?: Date | undefined;
    oshaRestrictionTime?: boolean | undefined;
    oshaRestrictionTimeStartAt?: Date | undefined;
    oshaRestrictionTimeEndAt?: Date | undefined;
    oshaFatality?: boolean | undefined;
    oshaTreatingDoctor?: string | undefined;
    oshaFacilityName?: string | undefined;
    oshaEmergencyRoomTreatment?: boolean | undefined;
    oshaHospitalizedOvernight?: boolean | undefined;
    environmentEventNature?: number | undefined;
    environmentSituation?: number | undefined;
    environmentArea?: number | undefined;
    environmentMaterial?: number | undefined;
    environmentReleasePoint?: number | undefined;
    environmentSeverity?: number | undefined;
    environmentRemediationDamage?: number | undefined;
    environmentExpectedPenalties?: number | undefined;
    environmentImpact?: number | undefined;
    environmentAmountSpilled?: number | undefined;
    propertyDamageInterruption?: boolean | undefined;
    propertyDamageWorkStopAt?: Date | undefined;
    propertyDamageWorkResumeAt?: Date | undefined;
    propertyDamageCost?: number | undefined;
    claimCurrentIncidentStatus?: string | undefined;
    claimInLitigation?: boolean | undefined;
    claimEstimatedTotalCost?: number | undefined;
    claimFinanceAccrualsToDate?: number | undefined;
    claimProjectedAccrualNotes?: string | undefined;
    claimTotalCostPaidByCompany?: number | undefined;
    claimCostPaidByInsurance?: number | undefined;
    claimFollowUpActivityDate?: Date | undefined;
}

export interface IStateMachineOfSafetyEventStateEnum {
    states: StateOfSafetyEventStateEnum[];
    transitions: TransitionOfSafetyEventStateEnum[];
}

export interface StateOfSafetyEventStateEnum {
    id: SafetyEventStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfSafetyEventStateEnum {
    name: string;
    from: SafetyEventStateEnum[];
    to: SafetyEventStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface FieldSet {
    type?: string | undefined;
    fields: Field[];
}

export interface Field {
    id: number;
    value?: string | undefined;
}

export interface SafetyEventCountResponse {
    eventCount: number;
    criterionName?: string | undefined;
    groupId?: string | undefined;
    groupLabel?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface SafetyEventCountRequest {
    /** For grouping
             */
    criterion: SafetyEventCountGroupingCriterion;
    from?: Date | undefined;
    to?: Date | undefined;
    instanceId: number;
    departmentId?: number | undefined;
    supervisorId?: number | undefined;
    safetyEventTypes?: number[] | undefined;
    safetyInjuryTypes?: number[] | undefined;
    oshaRecordableFlags?: boolean[] | undefined;
}

export enum SafetyEventCountGroupingCriterion {
    DepartmentId = 0,
    SupervisorId = 1,
    EmployeeId = 2,
}

export interface ScimUserResource {
    schemas: string[];
    id?: string | undefined;
    externalId?: string | undefined;
    userName?: string | undefined;
    displayName?: string | undefined;
    name?: ScimName | undefined;
    emails?: ScimMultiValue[] | undefined;
    phoneNumbers?: ScimMultiValue[] | undefined;
    active?: boolean | undefined;
    title?: string | undefined;
    userType?: string | undefined;
    "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"?: ScimEnterpriseExtension | undefined;
    meta?: ScimMeta | undefined;
}

export interface ScimName {
    formatted?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
}

export interface ScimMultiValue {
    value?: string | undefined;
    type?: string | undefined;
    primary: boolean;
}

export interface ScimEnterpriseExtension {
    employeeNumber?: string | undefined;
    department?: string | undefined;
    manager?: ScimManager | undefined;
}

export interface ScimManager {
    value?: string | undefined;
    displayName?: string | undefined;
}

export interface ScimMeta {
    resourceType?: string | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    location?: string | undefined;
    version?: string | undefined;
}

export interface ScimPatchRequest {
    schemas: string[];
    operations: ScimPatchOperation[];
}

export interface ScimPatchOperation {
    op: string;
    path?: string | undefined;
    value?: any | undefined;
}

export interface ScimGroupResource {
    schemas: string[];
    id?: string | undefined;
    externalId?: string | undefined;
    displayName?: string | undefined;
    members?: ScimMemberRef[] | undefined;
    meta?: ScimMeta | undefined;
}

export interface ScimMemberRef {
    value?: string | undefined;
    display?: string | undefined;
    $ref?: string | undefined;
}

export interface GlobalSearchResponse {
    groups: SearchResultGroup[];
}

export interface SearchResultGroup {
    entityType: SearchEntityTypeEnum;
    items: SearchResultItem[];
}

export enum SearchEntityTypeEnum {
    Users = 1,
    TaskDefinitions = 2,
    FormDefinitions = 3,
    Vendors = 4,
    CourseDefinitions = 5,
    SafetyEvents = 6,
    Assets = 7,
}

export interface SearchResultItem {
    entityType: SearchEntityTypeEnum;
    id: number;
    title: string;
    subtitle?: string | undefined;
    metadata: { [key: string]: string; };
}

export interface GlobalSearchRequest {
    query: string;
    perTypeLimit?: number | undefined;
}

export interface SiteRequest {
    id?: number | undefined;
    clientId?: number | undefined;
    name?: string | undefined;
    siteNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    timeZone?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    contacts?: ContactRequest[] | undefined;
}

export interface SiteResponse extends SiteRequest {
    id: number;
    active: boolean;
    instanceId: number;
    clientName?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    contacts?: ContactResponse[] | undefined;
}

export interface GetListResponseOfSiteSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: SiteSimpleResponse[] | undefined;
}

export interface SiteSimpleResponse {
    id: number;
    name?: string | undefined;
    siteNumber?: string | undefined;
    active: boolean;
    clientId?: number | undefined;
    clientName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    timeZone?: string | undefined;
}

export interface GetSiteListRequestV2 extends GetListRequestV2 {
    clientId?: number | undefined;
}

export interface GetListResponseOfSkillResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: SkillResponse[] | undefined;
}

export interface SkillResponse {
    id: number;
    name: string;
    description?: string | undefined;
    active: boolean;
    expiryPeriodDays?: number | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    criteria: SkillCriterionResponse[];
}

export interface SkillCriterionResponse {
    id: number;
    order: number;
    text: string;
    evidenceType: SkillCriterionEvidenceTypeEnum;
}

export interface SkillCreateRequest {
    name: string;
    description?: string | undefined;
    active: boolean;
    expiryPeriodDays?: number | undefined;
    criteria: SkillCriterionRequest[];
}

export interface SkillCriterionRequest {
    id?: number | undefined;
    order: number;
    text: string;
    evidenceType: SkillCriterionEvidenceTypeEnum;
}

export interface SkillUpdateRequest extends SkillCreateRequest {
    id: number;
}

export interface SkillSignOffPendingResponse {
    id: number;
    skillId: number;
    skillName: string;
    userId: number;
    userName: string;
    employeeId?: string | undefined;
    sessionId?: number | undefined;
    courseName?: string | undefined;
    requestedAt: Date;
    daysWaiting: number;
    suggestedEvaluatorUserId?: number | undefined;
    suggestedEvaluatorUserName?: string | undefined;
    suggestedEvaluatorUserGroupId?: number | undefined;
    suggestedEvaluatorUserGroupName?: string | undefined;
    criteria: SkillCriterionResponse[];
}

export interface SkillSignOffListRequest {
    start: number;
    length: number;
    search?: string | undefined;
    mineOnly: boolean;
}

export interface SkillSignOffResponse {
    id: number;
    skillId: number;
    skillName: string;
    userId: number;
    userName: string;
    employeeId?: string | undefined;
    signedOffById?: number | undefined;
    signedOffByName?: string | undefined;
    sessionId?: number | undefined;
    result?: SkillSignOffResultEnum | undefined;
    comment?: string | undefined;
    requestedAt: Date;
    signedOffAt?: Date | undefined;
    expiresAt?: Date | undefined;
    previousAttemptComment?: string | undefined;
    previousAttemptAt?: Date | undefined;
    previousAttemptById?: number | undefined;
    previousAttemptByName?: string | undefined;
    criterionResults: SkillSignOffCriterionResultResponse[];
}

export interface SkillSignOffCreateRequest {
    skillId: number;
    userId: number;
}

export interface SkillSignOffEvaluateRequest {
    signOffId: number;
    overallResult: SkillSignOffResultEnum;
    comment?: string | undefined;
    criterionResults: SkillSignOffCriterionResultRequest[];
}

export interface SkillSignOffCriterionResultRequest {
    criterionId: number;
    result: SkillSignOffCriterionResultEnum;
    note?: string | undefined;
}

export interface SkillMatrixResponse {
    filteredRecords: number;
    totalRecords: number;
    skills: SkillMatrixColumn[];
    rows: SkillMatrixRow[];
}

export interface SkillMatrixColumn {
    skillId: number;
    name: string;
}

export interface SkillMatrixRow {
    userId: number;
    userName: string;
    employeeId?: string | undefined;
    cells: SkillMatrixCell[];
}

export interface SkillMatrixCell {
    skillId: number;
    status: SkillMatrixStatusEnum;
    signedOffAt?: Date | undefined;
    expiresAt?: Date | undefined;
    signOffId?: number | undefined;
}

export enum SkillMatrixStatusEnum {
    Never = 0,
    SignedOff = 1,
    Expiring = 2,
    Expired = 3,
}

export interface SkillMatrixRequest {
    start: number;
    length: number;
    search?: string | undefined;
    departmentId?: number | undefined;
    vendorId?: number | undefined;
    expiringWithinDays: number;
}

export interface MySkillStatusResponse {
    skillId: number;
    skillName: string;
    status: SkillMatrixStatusEnum;
    signedOffAt?: Date | undefined;
    expiresAt?: Date | undefined;
}

export interface MySkillsRequest {
    expiringWithinDays: number;
}

export interface SkillSignOffMyHistoryRequest {
    start: number;
    length: number;
}

export interface GetListResponseOfTaskAssignmentSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: TaskAssignmentSimpleResponse[] | undefined;
}

export interface GetTaskAssignmentListRequest extends GetListRequest {
    taskId?: number | undefined;
    taskType?: TaskTypeEnum | undefined;
    assignedToUserId?: number | undefined;
    assignmentStates?: TaskAssignmentStateEnum[] | undefined;
    directReportsOnly?: boolean | undefined;
    filterFormId?: number | undefined;
}

export interface GetTaskAssignmentListRequestV2 extends GetListRequestV2 {
    taskId?: number | undefined;
    taskType?: TaskTypeEnum | undefined;
    assignedToUserId?: number | undefined;
    assignmentStates?: TaskAssignmentStateEnum[] | undefined;
    directReportsOnly?: boolean | undefined;
}

export interface TaskAssignmentViewResponse {
    actionCount: number;
    approvalCount: number;
    assignedFormCount: number;
    toolboxTalkCount: number;
}

export interface TaskAssignmentBatchStatusByTaskUpdateRequest {
    taskId: number;
    transition: string;
    selectedAll: boolean;
    taskAssignmentIds?: number[] | undefined;
}

export interface TaskAssignmentBatchStatusByUserUpdateRequest {
    userId: number;
    transition: string;
    selectedAll: boolean;
    taskAssignmentIds?: number[] | undefined;
    taskType?: TaskTypeEnum | undefined;
    states?: TaskAssignmentStateEnum[] | undefined;
    changedByUserId?: number | undefined;
    instanceId?: number | undefined;
}

export interface TaskOfflineBundleResponse {
    assignments: TaskAssignmentResponse[];
    actions: TaskBlendedResponse[];
    personnel?: OfflinePersonnelSection | undefined;
    complianceStandards: SelectOption[];
    projects: SelectOption[];
    scopeProjectId?: number | undefined;
}

export interface IStateMachineOfTaskAssignmentStateEnum {
    states: StateOfTaskAssignmentStateEnum[];
    transitions: TransitionOfTaskAssignmentStateEnum[];
}

export interface StateOfTaskAssignmentStateEnum {
    id: TaskAssignmentStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfTaskAssignmentStateEnum {
    name: string;
    from: TaskAssignmentStateEnum[];
    to: TaskAssignmentStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface GetListResponseOfTaskDefinitionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: TaskDefinitionSimpleResponse[] | undefined;
}

export interface GetTaskListRequest extends GetListRequest {
    taskType?: TaskTypeEnum | undefined;
    createdByUserId?: number | undefined;
    states?: TaskDefinitionStateEnum[] | undefined;
    filterAssetId?: number | undefined;
    filterFormId?: number | undefined;
    includeDemonstrationGenerated: boolean;
}

export interface GetTaskListRequestV2 extends GetListRequestV2 {
    taskType?: TaskTypeEnum | undefined;
    createdByUserId?: number | undefined;
    assignedToUserId?: number | undefined;
    filterAssetId?: number | undefined;
    filterFormId?: number | undefined;
    includeDemonstrationGenerated: boolean;
}

export interface IStateMachineOfTaskDefinitionStateEnum {
    states: StateOfTaskDefinitionStateEnum[];
    transitions: TransitionOfTaskDefinitionStateEnum[];
}

export interface StateOfTaskDefinitionStateEnum {
    id: TaskDefinitionStateEnum;
    name: string;
    title: string;
    default: boolean;
    complete: boolean;
    canFanOut?: boolean | undefined;
    isEditable?: boolean | undefined;
    isDeletable?: boolean | undefined;
    color?: string | undefined;
    editOverridePermission?: string | undefined;
}

export interface TransitionOfTaskDefinitionStateEnum {
    name: string;
    from: TaskDefinitionStateEnum[];
    to: TaskDefinitionStateEnum;
    title: string;
    description?: string | undefined;
    silentTransitionFailure: boolean;
    isVisible?: boolean | undefined;
    color: string;
    action: string;
    postTransitionAction: string;
    icon?: string | undefined;
    types?: number[] | undefined;
    acknowledgementRequired: boolean;
    acknowledgementText?: string | undefined;
    acknowledgementComment?: boolean | undefined;
    permissionOperation?: PermissionOperationEnum | undefined;
    permissionOperationName?: string | undefined;
    /** Contextual (entity-level) permissions required to perform this transition.
If multiple definitions are provided, they are combined using OR logic by default.
Set RequireAllContextualPermissions to true for AND logic. */
    contextualPermissions?: ContextualPermissionDef[] | undefined;
    /** If true, ALL contextual permissions must be satisfied (AND logic).
If false (default), ANY contextual permission satisfies the requirement (OR logic). */
    requireAllContextualPermissions: boolean;
}

export interface GetListResponseOfTaskAssignmentResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: TaskAssignmentResponse[] | undefined;
}

export interface GetTasksSupervisorApprovalListRequest extends GetListRequest {
    taskType?: TaskTypeEnum | undefined;
}

export interface GetListResponseOfUserActivitySummaryResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: UserActivitySummaryResponse[] | undefined;
}

export interface UserActivitySummaryResponse {
    userId: number;
    name: string;
    email: string;
    employeeId?: string | undefined;
    userType: UserTypeEnum;
    active: UserStatusEnum;
    vendorId?: number | undefined;
    lastActiveAt?: Date | undefined;
    daysActiveInPeriod: number;
}

export interface GetUserActivitySummaryRequest extends GetListRequestV2 {
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface UserActivityDetailResponse {
    activeDates: Date[];
}

export interface GetUserActivityDetailRequest {
    userId: number;
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface AvatarUrlRequest {
    avatarUrl: string;
}

export interface UserInstanceModel {
    id: number;
    name: string;
    active: boolean;
    logoUrl?: string | undefined;
    featureFlagsMetadata?: FeatureFlagsMetadata | undefined;
    activeFeatureFlags: FeatureFlagEnum[];
}

export interface ValidateSessionResponse {
    userStatus: UserStatusEnum;
    isCognitoUserMatched: boolean;
    user?: UserSessionResponse | undefined;
    instance?: InstanceSimpleResponse | undefined;
}

export interface UserSessionResponse {
    id: number;
    instanceId: number;
    name: string;
    email: string;
    roleId: RoleEnum;
    userType: UserTypeEnum;
    supervisorName?: string | undefined;
    departmentName?: string | undefined;
    jobTitle?: string | undefined;
    avatarUrl?: string | undefined;
    instanceName?: string | undefined;
    instanceLogoUrl?: string | undefined;
    permissions: UserGroupModulePermissionResponse[];
    isSuperAdmin: boolean;
    primaryInstanceId: number;
}

export interface SendMagicLinkResponse {
}

export interface SendMagicLinkRequest {
    email: string;
}

export interface ValidateMagicLinkResponse {
    valid: boolean;
}

export interface ValidateMagicLinkRequest {
    jwt: string;
    email?: string | undefined;
}

export interface CheckUserStatusResponse {
    status: UserValidationStatusEnum;
    mfaEnabled: boolean;
    domainAuth: TenantAuthConfigurationResponse;
}

export enum UserValidationStatusEnum {
    Valid = 0,
    DoesNotExist = 1,
    Inactive = 2,
    HasActiveMagicLink = 3,
    OAuthUnconfirmed = 4,
    OAuthArchived = 5,
    OAuthCompromised = 6,
    OAuthUnknown = 7,
    OAuthForcedChangePassword = 8,
    OAuthResetRequired = 9,
}

export interface TenantAuthConfigurationResponse {
    authType: AuthenticationTypeEnum;
    instanceId?: number | undefined;
    providerName?: string | undefined;
    appClientId?: string | undefined;
    selfRegistrationEnabled: boolean;
}

export interface CheckUserStatusRequest {
    email: string;
}

export interface UserGroupResponse {
    id: number;
    active?: boolean | undefined;
    name?: string | undefined;
    isIdpManaged: boolean;
    isNotificationGroup?: boolean | undefined;
    isPermissionGroup?: boolean | undefined;
    isDefaultEmployeeGroup?: boolean | undefined;
    isDefaultContractorGroup?: boolean | undefined;
    targetUsers?: SelectOption[] | undefined;
    modulePermissions: UserGroupModulePermissionResponse[];
    objectPermissions: UserGroupObjectPermissionResponse[];
}

export interface UserGroupRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    isNotificationGroup?: boolean | undefined;
    isPermissionGroup?: boolean | undefined;
    isDefaultEmployeeGroup?: boolean | undefined;
    isDefaultContractorGroup?: boolean | undefined;
    targetUsers?: number[] | undefined;
    modulePermissions?: UserGroupModulePermissionRequest[] | undefined;
    objectPermissions?: UserGroupObjectPermissionRequest[] | undefined;
}

export interface UserGroupModulePermissionRequest {
    id?: number | undefined;
    module: ModuleEnum;
    operation: PermissionOperationEnum;
    operationName?: string | undefined;
}

export interface UserGroupObjectPermissionRequest {
    id?: number | undefined;
    module: ModuleEnum;
    objectId: number;
    hasAccess?: boolean | undefined;
}

export interface GetListResponseOfUserGroupSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: UserGroupSimpleResponse[] | undefined;
}

export interface GetUserGroupListRequest extends GetListRequest {
    active?: boolean | undefined;
    showPermissionGroups?: boolean | undefined;
    showNotificationGroups?: boolean | undefined;
    whitelistIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    instanceId?: number | undefined;
}

export interface GetUserGroupListRequestV2 extends GetListRequestV2 {
    showPermissionGroups?: boolean | undefined;
    showNotificationGroups?: boolean | undefined;
    whitelistIds?: number[] | undefined;
    projectIds?: number[] | undefined;
}

export interface UserGroupModulePermissionSchemaResponse {
    modules: UserGroupPermissionSchemaModule[];
}

export interface UserGroupPermissionSchemaModule {
    name: string;
    module: ModuleEnum;
    operations: UserGroupPermissionSchemaModuleOperation[];
}

export interface UserGroupPermissionSchemaModuleOperation {
    label?: string | undefined;
    description?: string | undefined;
    operation: PermissionOperationEnum;
    operationName?: string | undefined;
}

export interface UserGroupObjectPermissionSchemaResponse {
    modules: UserGroupPermissionSchemaObject[];
}

export interface UserGroupPermissionSchemaObject {
    name: string;
    module: ModuleEnum;
    operations: UserGroupPermissionSchemaObjectOperation[];
}

export interface UserGroupPermissionSchemaObjectOperation {
    label?: string | undefined;
    description?: string | undefined;
    objectId?: number | undefined;
}

export interface GetListResponseOfUserGroupModulePermissionResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: UserGroupModulePermissionResponse[] | undefined;
}

export interface GetUserGroupPermissionListRequest extends GetListRequest {
    modules?: ModuleEnum[] | undefined;
    operations?: PermissionOperationEnum[] | undefined;
}

export interface AccountMembershipResponse {
    userId: number;
    instanceId: number;
    instanceName?: string | undefined;
    roleId: RoleEnum;
    active: UserStatusEnum;
    isPrimaryInstance: boolean;
    createdAt?: Date | undefined;
}

export interface TransferPrimaryRequest {
    accountId: number;
    targetInstanceId: number;
}

export interface SuperAdminResponse {
    accountId: number;
    email: string;
    primaryInstanceId: number;
    primaryInstanceName?: string | undefined;
    instanceMembershipCount: number;
    hasInstanceMembership: boolean;
    createdAt?: Date | undefined;
    lastActiveAt?: Date | undefined;
}

export interface PromoteSuperAdminRequest {
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface DemoteSuperAdminRequest {
    accountId: number;
    targetInstanceId?: number | undefined;
    roleId?: RoleEnum | undefined;
}

export interface ChangePrimaryInstanceRequest {
    accountId: number;
    targetInstanceId: number;
}

export interface VendorRequest {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    certificateOfInsuranceAttachmentUrl?: string | undefined;
    certificateOfInsuranceExpiresAt?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    managerId?: number | undefined;
    targetAutoUserGroupIds?: number[] | undefined;
}

export interface VendorResponse extends VendorRequest {
    id: number;
    active: boolean;
    internalIdentifier?: string | undefined;
    instanceId: number;
    signupCode?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    manager?: SupervisorSimpleResponse | undefined;
    autoUserGroupIds?: SelectOption[] | undefined;
}

export interface GetListResponseOfVendorSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: VendorSimpleResponse[] | undefined;
}

export interface GetVendorListRequest extends GetListRequest {
    active?: boolean | undefined;
}

export interface VendorSignupRequest {
    code: string;
    email: string;
    firstName: string;
    lastName: string;
}

export interface VendorSignupResponse extends VendorSignupRequest {
    outcome: VendorSignupOutcomeEnum;
}

/** Public outcome of a vendor-signup request. */
export enum VendorSignupOutcomeEnum {
    Invalid = 0,
    NewLoginCreated = 1,
    AddedWithExistingLogin = 2,
    AlreadyRegistered = 3,
    LoginRepaired = 4,
    InviteResent = 5,
    PasswordResetRequired = 6,
}

export interface GetListResponseOfWorkflowSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: WorkflowSimpleResponse[] | undefined;
}

export interface WorkflowSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    state: WorkflowStateEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    completedAt?: Date | undefined;
    workflowDefinitionId: number;
    workflowDefinitionVersion: number;
    workflowDefinition?: WorkflowDefinitionSimpleResponse | undefined;
}

export enum WorkflowStateEnum {
    Invalid = 0,
    Pending = 1,
    Waiting = 2,
    Active = 4,
    Completed = 5,
    Cancelled = 6,
}

export interface WorkflowDefinitionSimpleResponse {
    id: number;
    internalIdentifier?: string | undefined;
    name: string;
    active: boolean;
    creator: PersonnelSimpleResponse;
    project?: ProjectSimpleResponse | undefined;
}

export interface GetWorkflowListRequest extends GetListRequest {
    workflowDefinitionId?: number | undefined;
    states?: WorkflowStateEnum[] | undefined;
    taskDefinitionId?: number | undefined;
    taskAssignmentId?: number | undefined;
    formId?: number | undefined;
    itemAssignmentId?: number | undefined;
    courseSessionId?: number | undefined;
}

export interface WorkflowResponse {
    id: number;
    internalIdentifier?: string | undefined;
    workflowDefinitionId: number;
    state: WorkflowStateEnum;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    completedAt?: Date | undefined;
    workflowDefinition: WorkflowDefinitionSimpleResponse;
    phases: WorkflowPhaseResponse[];
    triggers: WorkflowTriggerResponse[];
}

export interface WorkflowPhaseResponse {
    id: number;
    name?: string | undefined;
    workflowId: number;
    definitionId: number;
    state: WorkflowStateEnum;
    definition: WorkflowDefinitionPhaseResponse;
    workflowActions: WorkflowActionResponse[];
}

export interface WorkflowDefinitionPhaseResponse {
    id?: number | undefined;
    name?: string | undefined;
    slug?: string | undefined;
    mutuallyExclusiveCompletion: boolean;
    workflowDefinitionId?: number | undefined;
    actions: WorkflowDefinitionActionResponse[];
}

export interface WorkflowDefinitionActionResponse {
    id?: number | undefined;
    type?: WorkflowDefinitionActionTypeEnum | undefined;
    metadata?: WorkflowDefinitionActionMetadata | undefined;
    workflowDefinitionPhaseId?: number | undefined;
}

export enum WorkflowDefinitionActionTypeEnum {
    Invalid = 0,
    CreateTask = 1,
    AssignTask = 2,
    Email = 3,
    ExtendBadgeExpiration = 4,
}

export interface WorkflowDefinitionActionMetadata {
    emailMetadata?: EmailActionMetadata | undefined;
    assignTaskMetadata?: AssignTaskMetadata | undefined;
    createTaskMetadata?: TaskMetadata | undefined;
    extendBadgeExpirationMetadata?: ExtendBadgeExpirationMetadata | undefined;
}

export interface EmailActionMetadata {
    toUserIds?: number[] | undefined;
    toTargetingAttributes?: NotificationAttributeEnum[] | undefined;
    toUserGroupIds?: number[] | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    emailPlaintext?: boolean | undefined;
    filterByTriggererPrimaryProject?: boolean | undefined;
}

export interface AssignTaskMetadata {
    taskDefinitionId?: number | undefined;
    sourceEntityRequest?: SourceEntityRequest | undefined;
    formFieldPersonnelTargets?: WorkflowFormFieldPersonnelTarget[] | undefined;
    filterByTriggererPrimaryProject?: boolean | undefined;
}

export interface ExtendBadgeExpirationMetadata {
    days: number;
}

export interface WorkflowActionResponse {
    id: number;
    phaseId: number;
    definitionId: number;
    metadata?: WorkflowActionMetadata | undefined;
    state: WorkflowActionStateEnum;
    createdTaskDefinitionId?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    completedAt?: Date | undefined;
    definition: WorkflowDefinitionActionResponse;
    createdTaskDefinition?: TaskDefinitionSimpleResponse | undefined;
}

export interface WorkflowActionMetadata {
    assigned: boolean;
    assignments?: number[] | undefined;
}

export enum WorkflowActionStateEnum {
    Invalid = 0,
    Pending = 1,
    Waiting = 2,
    Completed = 3,
    Cancelled = 4,
    Skipped = 5,
}

export interface WorkflowTriggerResponse {
    id: number;
    activated: boolean;
    metadata: WorkflowTriggerMetadata;
    triggeredDate?: Date | undefined;
    triggeredById?: number | undefined;
    triggeredFormId?: number | undefined;
    triggeredFormState?: FormStateEnum | undefined;
    triggeredTaskAssignmentId?: number | undefined;
    triggeredTrainingSessionId?: number | undefined;
    triggeredTrainingSessionEventType?: WorkflowTrainingEventTypeEnum | undefined;
    triggeredItemAssignmentId?: number | undefined;
    triggeredItemAssignmentState?: ItemAssignmentStateEnum | undefined;
    workflowId: number;
    workflowDefinitionTriggerId: number;
    triggerDefinition: WorkflowDefinitionTriggerResponse;
    triggeredBy?: PersonnelSimpleResponse | undefined;
    triggeredForm?: FormSimpleResponse | undefined;
    triggeredTaskAssignment?: TaskAssignmentSimpleResponse | undefined;
    triggeredTrainingSession?: CourseSessionSimpleResponse | undefined;
    triggeredItemAssignment?: ItemAssignmentSimpleResponse | undefined;
}

export interface WorkflowTriggerMetadata {
}

export enum WorkflowTrainingEventTypeEnum {
    Invalid = 0,
    Completed = 1,
    Failed = 2,
    Expired = 3,
    Assigned = 4,
    Timeout = 5,
    Lockout = 6,
}

export interface WorkflowDefinitionTriggerResponse {
    id: number;
    type: WorkflowDefinitionTriggerTypeEnum;
    scheduleIntervalType?: IntervalTypeEnum | undefined;
    scheduleStartDate?: Date | undefined;
    scheduleEndDate?: Date | undefined;
    scheduleNextProcessDate?: Date | undefined;
    scheduleHour?: number | undefined;
    scheduleDayOfWeek?: DayOfWeek | undefined;
    scheduleDayOfMonth?: number | undefined;
    scheduleIntervalDays?: number | undefined;
    triggerTaskDefinitionId?: number | undefined;
    triggerFormDefinitionId?: number | undefined;
    triggerFormDefinitionVersion?: number | undefined;
    triggerFormState?: FormStateEnum | undefined;
    triggerCourseDefinitionId?: number | undefined;
    triggerCourseDefinitionVersion?: number | undefined;
    triggerTrainingEventType?: WorkflowTrainingEventTypeEnum | undefined;
    triggerItemDefinitionId?: number | undefined;
    triggerItemAssignmentState?: ItemAssignmentStateEnum | undefined;
    metadata: WorkflowDefinitionTriggerMetadata;
    workflowDefinitionId: number;
    workflowDefinitionVersion: number;
    triggerTaskDefinition?: TaskDefinitionSimpleResponse | undefined;
    triggerFormDefinition?: FormDefinitionSimpleResponse | undefined;
    triggerCourseDefinition?: CourseDefinitionSimpleResponse | undefined;
}

export enum WorkflowDefinitionTriggerTypeEnum {
    Invalid = 0,
    Schedule = 1,
    TaskCompletion = 2,
    Training = 3,
    FormSubmission = 4,
    FormFieldValueSubmission = 5,
    Manual = 6,
    ItemTracker = 7,
}

export enum IntervalTypeEnum {
    Invalid = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Frequency = 4,
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export interface WorkflowDefinitionTriggerMetadata {
}

export interface GetListResponseOfWorkflowDefinitionSimpleResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: WorkflowDefinitionSimpleResponse[] | undefined;
}

export interface GetWorkflowDefinitionListRequest extends GetListRequest {
    createdBy?: number | undefined;
    active?: boolean | undefined;
    projectId?: number | undefined;
    formFieldInvariantId?: string | undefined;
    triggerFormDefinitionId?: number | undefined;
}

export interface WorkflowDefinitionResponse {
    id?: number | undefined;
    internalIdentifier?: string | undefined;
    name: string;
    active: boolean;
    creatorId?: number | undefined;
    version?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    metadata?: WorkflowDefinitionMetadata | undefined;
    creator?: PersonnelSimpleResponse | undefined;
    phases: WorkflowDefinitionPhaseResponse[];
    triggers: WorkflowDefinitionTriggerResponse[];
    projectId?: number | undefined;
    project?: ProjectSimpleResponse | undefined;
}

export interface WorkflowDefinitionMetadata {
    singleTriggerWorkflow: boolean;
    formFieldInvariantIds?: string[] | undefined;
}

export interface WorkflowDefinitionRequest {
    id?: number | undefined;
    version: number;
    name: string;
    active: boolean;
    metadata?: WorkflowDefinitionMetadata | undefined;
    targetPhases: WorkflowDefinitionPhaseRequest[];
    targetTriggers: WorkflowDefinitionTriggerRequest[];
    projectId?: number | undefined;
}

export interface WorkflowDefinitionPhaseRequest {
    name?: string | undefined;
    slug?: string | undefined;
    mutuallyExclusiveCompletion: boolean;
    targetActions: WorkflowDefinitionActionRequest[];
}

export interface WorkflowDefinitionActionRequest {
    type: WorkflowDefinitionActionTypeEnum;
    metadata?: WorkflowDefinitionActionMetadata | undefined;
}

export interface WorkflowDefinitionTriggerRequest {
    type: WorkflowDefinitionTriggerTypeEnum;
    scheduleIntervalType?: IntervalTypeEnum | undefined;
    scheduleStartDate?: Date | undefined;
    scheduleEndDate?: Date | undefined;
    scheduleNextProcessDate?: Date | undefined;
    scheduleHour?: number | undefined;
    scheduleDayOfWeek?: DayOfWeek | undefined;
    scheduleDayOfMonth?: number | undefined;
    scheduleIntervalDays?: number | undefined;
    triggerTaskDefinitionId?: number | undefined;
    triggerFormDefinitionId?: number | undefined;
    triggerFormDefinitionVersion?: number | undefined;
    triggerFormState?: FormStateEnum | undefined;
    triggerCourseDefinitionId?: number | undefined;
    triggerCourseDefinitionVersion?: number | undefined;
    triggerTrainingEventType?: WorkflowTrainingEventTypeEnum | undefined;
    triggerItemDefinitionId?: number | undefined;
    triggerItemAssignmentState?: ItemAssignmentStateEnum | undefined;
    metadata: WorkflowDefinitionTriggerMetadata;
    workflowDefinitionId: number;
    workflowDefinitionVersion: number;
}

export interface NexusGraphResponse {
    nodes: NexusNode[];
    edges: NexusEdge[];
    entryPoint?: string | undefined;
    traversalDepth: number;
    truncated: boolean;
}

export interface NexusNode {
    id: string;
    type: NexusNodeType;
    state?: string | undefined;
    visualState: NexusVisualState;
    workflowId?: number | undefined;
    workflowDefinitionId?: number | undefined;
    definitionName?: string | undefined;
    internalIdentifier?: string | undefined;
    completedAt?: Date | undefined;
    taskDefinitionId?: number | undefined;
    subject?: string | undefined;
    taskType?: string | undefined;
    formId?: number | undefined;
    formDefinitionId?: number | undefined;
    name?: string | undefined;
    submittedByName?: string | undefined;
    submittedAt?: Date | undefined;
    actionId?: number | undefined;
    recipientCount?: number | undefined;
    courseSessionId?: number | undefined;
    courseDefinitionId?: number | undefined;
    courseAssignmentId?: number | undefined;
    courseName?: string | undefined;
    traineeName?: string | undefined;
    itemAssignmentId?: number | undefined;
    itemDefinitionId?: number | undefined;
    itemName?: string | undefined;
    assigneeName?: string | undefined;
    triggerId?: number | undefined;
    intervalType?: string | undefined;
    lastFiredAt?: Date | undefined;
    nextProcessDate?: Date | undefined;
    badgeExtensionDays?: number | undefined;
    triggeredDate?: Date | undefined;
    triggeredByName?: string | undefined;
    atHorizon: boolean;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export enum NexusNodeType {
    Workflow = 0,
    Task = 1,
    Form = 2,
    Email = 3,
    TrainingSession = 4,
    ItemAssignment = 5,
    Schedule = 6,
    BadgeExtension = 7,
    Unknown = 8,
}

export enum NexusVisualState {
    Active = 0,
    Done = 1,
    Muted = 2,
    Cancelled = 3,
}

export interface NexusEdge {
    from: string;
    to: string;
    label: string;
    phaseName?: string | undefined;
    actionType?: string | undefined;
    mutuallyExclusiveCompletion?: boolean | undefined;
}

export interface NexusGraphRequest {
    entityType: string;
    entityId: number;
    maxDepth: number;
}

export interface GetListResponseOfNexusInFlightResponse {
    filteredRecords: number;
    totalRecords: number;
    data?: NexusInFlightResponse[] | undefined;
}

export interface NexusInFlightResponse {
    workflowId: number;
    workflowDefinitionId: number;
    definitionName?: string | undefined;
    internalIdentifier?: string | undefined;
    state: WorkflowStateEnum;
    currentPhaseName?: string | undefined;
    projectName?: string | undefined;
    blockingEntities: NexusBlockingEntity[];
    mutuallyExclusive: boolean;
    waitDurationHours?: number | undefined;
    waitingSince?: Date | undefined;
    createdAt?: Date | undefined;
}

export interface NexusBlockingEntity {
    entityType?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    assigneeName?: string | undefined;
    entityId?: number | undefined;
    scheduleNextProcessDate?: Date | undefined;
}

export interface NexusInFlightRequest extends GetListRequest {
    projectId?: number | undefined;
    workflowDefinitionId?: number | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
    states?: WorkflowStateEnum[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}